var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// scripts/react-shim.ts
import * as React from "react";
var init_react_shim = __esm({
  "scripts/react-shim.ts"() {
    "use strict";
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    init_react_shim();
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";
    init_react_shim();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"(exports, module) {
    init_react_shim();
    if (false) {
      ReactIs = null;
      throwOnDirectAccess = true;
      module.exports = null(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// src/main.ts
init_react_shim();

// src/components/index.ts
init_react_shim();

// src/components/alert/index.ts
init_react_shim();

// src/components/alert/Alert.tsx
init_react_shim();
import clsx from "clsx";
import {
  CheckCircleIcon,
  InformationCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon
} from "@heroicons/react/24/outline";
import { jsx, jsxs } from "react/jsx-runtime";
function Alert({
  type = "info",
  message,
  children,
  description,
  inline = false,
  interactive = false,
  className
}) {
  const cssClass = clsx(
    "flex rounded py-3",
    {
      ["align-middle"]: !inline && !description,
      ["px-4"]: !inline,
      ["border"]: !inline,
      ["border-succes-50 bg-success-40"]: type === "success" && !inline,
      ["border-neutral-60 bg-neutral-30"]: type === "info" && !inline,
      ["border-warning-50 bg-warning-40"]: type === "warning" && !inline,
      ["border-primary-50 bg-primary-40"]: type === "error" && !inline,
      ["text-success-60"]: type === "success",
      ["text-neutral-80"]: type === "info",
      ["text-warning-60"]: type === "warning",
      ["text-primary-60"]: type === "error"
    },
    className
  );
  const icons = {
    success: /* @__PURE__ */ jsx(CheckCircleIcon, { className: clsx(`text-success-50`, "w-5", "h-5") }),
    info: /* @__PURE__ */ jsx(
      InformationCircleIcon,
      {
        className: clsx(`text-neutral-70`, "w-5", "h-5")
      }
    ),
    warning: /* @__PURE__ */ jsx(
      ExclamationTriangleIcon,
      {
        className: clsx(`text-warning-50`, "w-5", "h-5")
      }
    ),
    error: /* @__PURE__ */ jsx(
      ExclamationCircleIcon,
      {
        className: clsx(`text-primary-50`, "w-5", "h-5")
      }
    )
  };
  const centered = ["flex", "justify-center", "items-center"];
  return /* @__PURE__ */ jsxs("section", { className: cssClass, role: interactive ? "alertdialog" : "alert", children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        className: clsx(centered, "h-5", {
          "mr-2": inline || !description,
          "mr-5": !inline && description
        }),
        children: icons[type] || null
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: clsx({ [centered.join(" ")]: inline || !description }), children: [
      /* @__PURE__ */ jsx("p", { className: "cap-sm", children: message || children }),
      !inline && description && /* @__PURE__ */ jsx("p", { className: "body-xs mt-2", children: description })
    ] })
  ] });
}

// src/components/badge/index.ts
init_react_shim();

// src/components/badge/Badge.tsx
init_react_shim();
import clsx2 from "clsx";
import { jsx as jsx2 } from "react/jsx-runtime";
function Badge({
  className,
  variant = "primaryDark",
  size = "md",
  children
}) {
  return /* @__PURE__ */ jsx2(
    "span",
    {
      className: clsx2(
        "inline-flex items-center justify-center",
        "rounded-full",
        {
          "px-0.25 min-w-[0.5rem] min-h-[0.5rem] text-xs ml-[2px] mr-[2px]": size === "xs",
          "px-0.5 min-w-[1.25rem] min-h-[1.25rem] text-xs": size === "sm",
          "px-1 min-w-[1.5rem] min-h-[1.5rem] text-sm": size === "md",
          "px-1.5 min-w-[2rem] min-h-[2rem] text-base": size === "lg",
          "bg-primary-50 text-neutral-0": variant === "primaryDark",
          "bg-primary-40 text-primary-60": variant === "primaryLight",
          "bg-secondary-50 text-neutral-0": variant === "secondaryDark",
          "bg-secondary-40 text-secondary-60": variant === "secondaryLight",
          "bg-neutral-0 text-neutral-80 border-1 border-neutral-80": variant === "outlineNeutral",
          "bg-neutral-80 text-neutral-0": variant === "neutralDark",
          "bg-neutral-40 text-neutral-80": variant === "neutralLight",
          "bg-success-50 text-neutral-0": variant === "successDark",
          "bg-success-40 text-success-60": variant === "successLight",
          "bg-warning-50": variant === "warningNeutral",
          "bg-primary-60": variant === "dangerNeutral"
        },
        className
      ),
      children
    }
  );
}

// src/components/buttons/index.ts
init_react_shim();

// src/components/buttons/button/index.ts
init_react_shim();

// src/components/buttons/button/Button.tsx
init_react_shim();
import { forwardRef as forwardRef2 } from "react";
import clsx4 from "clsx";

// src/components/buttons/ButtonWrapper.tsx
init_react_shim();
import { forwardRef } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var ButtonWrapper = forwardRef(function ButtonWrapper2({ children, ...props }, ref) {
  if (typeof props.href !== "undefined") {
    return /* @__PURE__ */ jsx3(
      "a",
      {
        ...props,
        ref,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx3(
    "button",
    {
      ...props,
      ref,
      children
    }
  );
});

// src/components/spinner/Spinner.tsx
init_react_shim();
import { jsx as jsx4 } from "react/jsx-runtime";
function Spinner({ size = "lg" }) {
  return /* @__PURE__ */ jsx4("span", { className: `flex justify-center items-center `, children: /* @__PURE__ */ jsx4(
    "span",
    {
      className: `
          spinner ease-linear rounded-full border-primary-lighten-40
          ${size === "sm" && "h-4 w-4 border-2 border-t-2"}
          ${size === "md" && "h-8 w-8 border-4 border-t-4"}
          ${size === "lg" && "h-16 w-16 border-4 border-t-4"}
        `,
      style: { borderTopColor: "#004f99ff" }
    }
  ) });
}

// src/components/buttons/utils.ts
init_react_shim();
import clsx3 from "clsx";
function resolveVariantClasses(variant) {
  switch (variant) {
    case "outline":
      return clsx3("bg-white", "text-neutral-80", "border-neutral-80");
    case "ghost":
      return clsx3("bg-neutral-0", "text-neutral-80", "border-neutral-80");
    case "ghost-dark":
      return clsx3("bg-transparent", "text-neutral-0", "border-neutral-0");
    case "ghost-muted":
      return clsx3("bg-neutral-40", "text-neutral-80", "border-neutral-40");
    case "link":
      return clsx3("bg-neutral-0", "text-neutral-80");
    case "rounded":
      return clsx3("bg-neutral-0", "text-neutral-80", "rounded-full");
    case "add-to-cart":
      return clsx3(
        "justify-center",
        "text-center",
        "bg-neutral-80",
        "text-neutral-0"
      );
  }
  return clsx3("bg-neutral-80", "text-neutral-0");
}

// ../../node_modules/.pnpm/tailwind-merge@2.5.2/node_modules/tailwind-merge/dist/bundle-mjs.mjs
init_react_shim();
var CLASS_PART_SEPARATOR = "-";
var createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
var getGroupRecursive = (classParts, classPartObject) => {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
};
var arbitraryPropertyRegex = /^\[(.+)\]$/;
var getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
};
var createClassMap = (config) => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
var processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
var getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
var isThemeGetter = (func2) => func2.isThemeGetter;
var getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};
var createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
var IMPORTANT_MODIFIER = "!";
var createParseClassName = (config) => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  const parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return (className) => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
var sortModifiers = (modifiers) => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
var createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
var SPLIT_CLASSES_REGEX = /\s+/;
var mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames2 = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames2.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames2[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string2 = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string2 && (string2 += " ");
        string2 += resolvedValue;
      }
    }
  }
  return string2;
}
var toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string2 = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string2 && (string2 += " ");
        string2 += resolvedValue;
      }
    }
  }
  return string2;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
var fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var fractionRegex = /^\d+\/\d+$/;
var stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
var shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var isLength = (value) => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
var isArbitraryLength = (value) => getIsArbitraryValue(value, "length", isLengthOnly);
var isNumber = (value) => Boolean(value) && !Number.isNaN(Number(value));
var isArbitraryNumber = (value) => getIsArbitraryValue(value, "number", isNumber);
var isInteger = (value) => Boolean(value) && Number.isInteger(Number(value));
var isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
var isArbitraryValue = (value) => arbitraryValueRegex.test(value);
var isTshirtSize = (value) => tshirtUnitRegex.test(value);
var sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
var isArbitrarySize = (value) => getIsArbitraryValue(value, sizeLabels, isNever);
var isArbitraryPosition = (value) => getIsArbitraryValue(value, "position", isNever);
var imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
var isArbitraryImage = (value) => getIsArbitraryValue(value, imageLabels, isImage);
var isArbitraryShadow = (value) => getIsArbitraryValue(value, "", isShadow);
var isAny = () => true;
var getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
var isLengthOnly = (value) => lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
var isNever = () => false;
var isShadow = (value) => shadowRegex.test(value);
var isImage = (value) => imageRegex.test(value);
var getDefaultConfig = () => {
  const colors = fromTheme("colors");
  const spacing = fromTheme("spacing");
  const blur = fromTheme("blur");
  const brightness = fromTheme("brightness");
  const borderColor = fromTheme("borderColor");
  const borderRadius = fromTheme("borderRadius");
  const borderSpacing = fromTheme("borderSpacing");
  const borderWidth = fromTheme("borderWidth");
  const contrast = fromTheme("contrast");
  const grayscale = fromTheme("grayscale");
  const hueRotate = fromTheme("hueRotate");
  const invert = fromTheme("invert");
  const gap = fromTheme("gap");
  const gradientColorStops = fromTheme("gradientColorStops");
  const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  const inset = fromTheme("inset");
  const margin = fromTheme("margin");
  const opacity = fromTheme("opacity");
  const padding = fromTheme("padding");
  const saturate = fromTheme("saturate");
  const scale = fromTheme("scale");
  const sepia = fromTheme("sepia");
  const skew = fromTheme("skew");
  const space = fromTheme("space");
  const translate = fromTheme("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber, isArbitraryValue];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      container: ["container"],
      columns: [{
        columns: [isTshirtSize]
      }],
      "break-after": [{
        "break-after": getBreaks()
      }],
      "break-before": [{
        "break-before": getBreaks()
      }],
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      box: [{
        box: ["border", "content"]
      }],
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      isolation: ["isolate", "isolation-auto"],
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      "object-position": [{
        object: [...getPositions(), isArbitraryValue]
      }],
      overflow: [{
        overflow: getOverflow()
      }],
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      overscroll: [{
        overscroll: getOverscroll()
      }],
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      inset: [{
        inset: [inset]
      }],
      "inset-x": [{
        "inset-x": [inset]
      }],
      "inset-y": [{
        "inset-y": [inset]
      }],
      start: [{
        start: [inset]
      }],
      end: [{
        end: [inset]
      }],
      top: [{
        top: [inset]
      }],
      right: [{
        right: [inset]
      }],
      bottom: [{
        bottom: [inset]
      }],
      left: [{
        left: [inset]
      }],
      visibility: ["visible", "invisible", "collapse"],
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      grow: [{
        grow: getZeroAndEmpty()
      }],
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      gap: [{
        gap: [gap]
      }],
      "gap-x": [{
        "gap-x": [gap]
      }],
      "gap-y": [{
        "gap-y": [gap]
      }],
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      p: [{
        p: [padding]
      }],
      px: [{
        px: [padding]
      }],
      py: [{
        py: [padding]
      }],
      ps: [{
        ps: [padding]
      }],
      pe: [{
        pe: [padding]
      }],
      pt: [{
        pt: [padding]
      }],
      pr: [{
        pr: [padding]
      }],
      pb: [{
        pb: [padding]
      }],
      pl: [{
        pl: [padding]
      }],
      m: [{
        m: [margin]
      }],
      mx: [{
        mx: [margin]
      }],
      my: [{
        my: [margin]
      }],
      ms: [{
        ms: [margin]
      }],
      me: [{
        me: [margin]
      }],
      mt: [{
        mt: [margin]
      }],
      mr: [{
        mr: [margin]
      }],
      mb: [{
        mb: [margin]
      }],
      ml: [{
        ml: [margin]
      }],
      "space-x": [{
        "space-x": [space]
      }],
      "space-x-reverse": ["space-x-reverse"],
      "space-y": [{
        "space-y": [space]
      }],
      "space-y-reverse": ["space-y-reverse"],
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, spacing]
      }],
      "min-w": [{
        "min-w": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      "max-w": [{
        "max-w": [isArbitraryValue, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      "min-h": [{
        "min-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      size: [{
        size: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      "font-style": ["italic", "not-italic"],
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      "font-family": [{
        font: [isAny]
      }],
      "fvn-normal": ["normal-nums"],
      "fvn-ordinal": ["ordinal"],
      "fvn-slashed-zero": ["slashed-zero"],
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      "placeholder-color": [{
        placeholder: [colors]
      }],
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      "text-color": [{
        text: [colors]
      }],
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      "text-decoration-color": [{
        decoration: [colors]
      }],
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      content: [{
        content: ["none", isArbitraryValue]
      }],
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      "bg-color": [{
        bg: [colors]
      }],
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      rounded: [{
        rounded: [borderRadius]
      }],
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      "border-w": [{
        border: [borderWidth]
      }],
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      "divide-x-reverse": ["divide-x-reverse"],
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      "divide-y-reverse": ["divide-y-reverse"],
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      "divide-style": [{
        divide: getLineStyles()
      }],
      "border-color": [{
        border: [borderColor]
      }],
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      "divide-color": [{
        divide: [borderColor]
      }],
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      "outline-color": [{
        outline: [colors]
      }],
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      "ring-w-inset": ["ring-inset"],
      "ring-color": [{
        ring: [colors]
      }],
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      "shadow-color": [{
        shadow: [isAny]
      }],
      opacity: [{
        opacity: [opacity]
      }],
      "mix-blend": [{
        "mix-blend": [...getBlendModes(), "plus-lighter", "plus-darker"]
      }],
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      filter: [{
        filter: ["", "none"]
      }],
      blur: [{
        blur: [blur]
      }],
      brightness: [{
        brightness: [brightness]
      }],
      contrast: [{
        contrast: [contrast]
      }],
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      grayscale: [{
        grayscale: [grayscale]
      }],
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      invert: [{
        invert: [invert]
      }],
      saturate: [{
        saturate: [saturate]
      }],
      sepia: [{
        sepia: [sepia]
      }],
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      caption: [{
        caption: ["top", "bottom"]
      }],
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      scale: [{
        scale: [scale]
      }],
      "scale-x": [{
        "scale-x": [scale]
      }],
      "scale-y": [{
        "scale-y": [scale]
      }],
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      "translate-x": [{
        "translate-x": [translate]
      }],
      "translate-y": [{
        "translate-y": [translate]
      }],
      "skew-x": [{
        "skew-x": [skew]
      }],
      "skew-y": [{
        "skew-y": [skew]
      }],
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      accent: [{
        accent: ["auto", colors]
      }],
      appearance: [{
        appearance: ["none", "auto"]
      }],
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      "caret-color": [{
        caret: [colors]
      }],
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      "touch-pz": ["touch-pinch-zoom"],
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      fill: [{
        fill: [colors, "none"]
      }],
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      stroke: [{
        stroke: [colors, "none"]
      }],
      sr: ["sr-only", "not-sr-only"],
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
};
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);

// src/components/buttons/button/Button.tsx
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var Button = forwardRef2(function Button2({
  className = "",
  children,
  size = "md",
  variant = "primary",
  loading,
  Icon,
  iconPlacement,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsxs2(
    ButtonWrapper,
    {
      "aria-busy": "false",
      className: clsx4(
        `relative`,
        `inline-flex items-center`,
        `font-medium`,
        {
          "rounded-sm border border-solid": variant !== "link" && variant !== "rounded",
          "cap-xs": size === "xs",
          "text-sm": size === "sm" || size === "md",
          "cap-base": size === "lg",
          "py-2 px-2.5": size === "xs" && variant !== "link",
          "py-1 px-2": size === "sm" && variant !== "link",
          "py-2 px-4": size === "md" && variant !== "link",
          "py-4 px-4": size === "lg" && variant !== "link",
          "p-0 underline": variant === "link"
        },
        resolveVariantClasses(variant),
        `disabled:opacity-25`,
        className
      ),
      ...rest,
      children: [
        typeof Icon !== "undefined" && iconPlacement === "left" && /* @__PURE__ */ jsx5(Icon, { className: clsx4("h-4 w-4", "mr-2 -ml-0.5"), "aria-hidden": "true" }),
        children,
        typeof Icon !== "undefined" && iconPlacement === "right" && /* @__PURE__ */ jsx5(Icon, { className: clsx4("h-4 w-4", "ml-2 -mr-0.5"), "aria-hidden": "true" }),
        loading && /* @__PURE__ */ jsx5(
          "div",
          {
            className: twMerge(
              clsx4(
                "absolute top-0 left-0",
                "h-full w-full",
                "flex justify-center items-center",
                "bg-primary-darken-20",
                "rounded-sm",
                resolveVariantClasses(variant)
              )
            ),
            children: /* @__PURE__ */ jsx5(Spinner, { size: "sm" })
          }
        )
      ]
    }
  );
});

// src/components/buttons/icon-button/index.ts
init_react_shim();

// src/components/buttons/icon-button/IconButton.tsx
init_react_shim();
import { forwardRef as forwardRef3 } from "react";
import clsx5 from "clsx";
import { jsx as jsx6 } from "react/jsx-runtime";
var IconButton = forwardRef3(function IconButton2({
  className,
  children,
  size = "base",
  variant = "primary",
  container = true,
  rounded = true,
  disabled,
  disabledReason,
  onClick,
  ...props
}, ref) {
  const cssClass = clsx5(
    "inline-flex justify-center items-center",
    rounded && "rounded-full",
    container && resolveVariantClasses(variant),
    {
      ["w-3 h-3 text-[0.5rem] p-0.5"]: size === "xxs",
      ["w-4 h-4 text-[0.5rem] p-1"]: size === "xs",
      ["w-5 h-5 text-xxs p-1"]: size === "sm",
      ["w-6 h-6 text-xs p-1.5"]: size === "base",
      ["w-8 h-8 text-base p-2"]: size === "md",
      ["w-10 h-10 text-md p-2"]: size === "lg",
      ["w-14 h-14 text-[1.75rem] p-3"]: size === "xl",
      ["w-16 h-16 text-xl p-3"]: size === "2xl",
      ["w-24 h-24 text-3xl p-4"]: size === "3xl"
    },
    className
  );
  function handleClick() {
    if (disabled) {
      console.warn("Button is disabled, click is ignored");
      return;
    }
    if (typeof onClick === "function") {
      onClick();
    }
  }
  return /* @__PURE__ */ jsx6(
    ButtonWrapper,
    {
      className: cssClass,
      ...props,
      ref,
      onClick: handleClick,
      title: props.title || (disabled && disabledReason ? disabledReason : void 0),
      "aria-disabled": disabled,
      children
    }
  );
});

// src/components/banners/index.tsx
init_react_shim();

// src/components/banners/topBanner.tsx
init_react_shim();
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import clsx7 from "clsx";

// src/components/countdown/index.tsx
init_react_shim();

// src/components/countdown/Countdown.tsx
init_react_shim();

// ../../node_modules/.pnpm/react-countdown@2.3.6_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-countdown/dist/index.es.js
init_react_shim();
var import_prop_types = __toESM(require_prop_types());
import { cloneElement, Component, createElement } from "react";
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter))
    return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0)
    return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : "";
  var suffix = match ? match[3] : "";
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function() {
    return "0";
  }).join("") + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$now = options.now, now = _options$now === void 0 ? Date.now : _options$now, _options$precision = options.precision, precision = _options$precision === void 0 ? 0 : _options$precision, controlled = options.controlled, _options$offsetTime = options.offsetTime, offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime, overtime = options.overtime;
  var startTimestamp;
  if (typeof date === "string") {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }
  if (!controlled) {
    startTimestamp += offsetTime;
  }
  var timeLeft = controlled ? startTimestamp : startTimestamp - now();
  var clampedPrecision = Math.min(20, Math.max(0, precision));
  var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1e3).toFixed(clampedPrecision)) * 1e3);
  var seconds = Math.abs(total) / 1e3;
  return {
    total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1e3).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(timeDelta, options) {
  var days = timeDelta.days, hours = timeDelta.hours, minutes = timeDelta.minutes, seconds = timeDelta.seconds;
  var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options), daysInHours = _Object$assign.daysInHours, zeroPadTime = _Object$assign.zeroPadTime, _Object$assign$zeroPa = _Object$assign.zeroPadDays, zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
  var zeroPadTimeLength = Math.min(2, zeroPadTime);
  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
  return {
    days: daysInHours ? "" : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, zeroPadTimeLength),
    seconds: zeroPad(seconds, zeroPadTimeLength)
  };
}
var Countdown = function(_React$Component) {
  _inherits(Countdown3, _React$Component);
  var _super = _createSuper(Countdown3);
  function Countdown3() {
    var _this;
    _classCallCheck(this, Countdown3);
    _this = _super.apply(this, arguments);
    _this.state = {
      count: _this.props.count || 3
    };
    _this.startCountdown = function() {
      _this.interval = window.setInterval(function() {
        var count = _this.state.count - 1;
        if (count === 0) {
          _this.stopCountdown();
          _this.props.onComplete && _this.props.onComplete();
        } else {
          _this.setState(function(prevState) {
            return {
              count: prevState.count - 1
            };
          });
        }
      }, 1e3);
    };
    _this.stopCountdown = function() {
      clearInterval(_this.interval);
    };
    _this.addTime = function(seconds) {
      _this.stopCountdown();
      _this.setState(function(prevState) {
        return {
          count: prevState.count + seconds
        };
      }, _this.startCountdown);
    };
    return _this;
  }
  _createClass(Countdown3, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? cloneElement(this.props.children, {
        count: this.state.count
      }) : null;
    }
  }]);
  return Countdown3;
}(Component);
Countdown.propTypes = {
  count: import_prop_types.number,
  children: import_prop_types.element,
  onComplete: import_prop_types.func
};
var Countdown$1 = function(_React$Component) {
  _inherits(Countdown$12, _React$Component);
  var _super = _createSuper(Countdown$12);
  function Countdown$12(props) {
    var _this;
    _classCallCheck(this, Countdown$12);
    _this = _super.call(this, props);
    _this.mounted = false;
    _this.initialTimestamp = _this.calcOffsetStartTimestamp();
    _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
    _this.offsetTime = 0;
    _this.legacyMode = false;
    _this.legacyCountdownRef = null;
    _this.tick = function() {
      var timeDelta2 = _this.calcTimeDelta();
      var callback = timeDelta2.completed && !_this.props.overtime ? void 0 : _this.props.onTick;
      _this.setTimeDeltaState(timeDelta2, void 0, callback);
    };
    _this.setLegacyCountdownRef = function(ref) {
      _this.legacyCountdownRef = ref;
    };
    _this.start = function() {
      if (_this.isStarted())
        return;
      var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
      _this.offsetStartTimestamp = 0;
      _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;
      var timeDelta2 = _this.calcTimeDelta();
      _this.setTimeDeltaState(timeDelta2, "STARTED", _this.props.onStart);
      if (!_this.props.controlled && (!timeDelta2.completed || _this.props.overtime)) {
        _this.clearTimer();
        _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
      }
    };
    _this.pause = function() {
      if (_this.isPaused())
        return;
      _this.clearTimer();
      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
    };
    _this.stop = function() {
      if (_this.isStopped())
        return;
      _this.clearTimer();
      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;
      _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
    };
    _this.isStarted = function() {
      return _this.isStatus("STARTED");
    };
    _this.isPaused = function() {
      return _this.isStatus("PAUSED");
    };
    _this.isStopped = function() {
      return _this.isStatus("STOPPED");
    };
    _this.isCompleted = function() {
      return _this.isStatus("COMPLETED");
    };
    if (props.date) {
      var timeDelta = _this.calcTimeDelta();
      _this.state = {
        timeDelta,
        status: timeDelta.completed ? "COMPLETED" : "STOPPED"
      };
    } else {
      _this.legacyMode = true;
    }
    return _this;
  }
  _createClass(Countdown$12, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.legacyMode) {
        return;
      }
      this.mounted = true;
      if (this.props.onMount)
        this.props.onMount(this.calcTimeDelta());
      if (this.props.autoStart)
        this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.legacyMode) {
        return;
      }
      if (this.props.date !== prevProps.date) {
        this.initialTimestamp = this.calcOffsetStartTimestamp();
        this.offsetStartTimestamp = this.initialTimestamp;
        this.offsetTime = 0;
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.legacyMode) {
        return;
      }
      this.mounted = false;
      this.clearTimer();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props, date = _this$props.date, now = _this$props.now, precision = _this$props.precision, controlled = _this$props.controlled, overtime = _this$props.overtime;
      return calcTimeDelta(date, {
        now,
        precision,
        controlled,
        offsetTime: this.offsetTime,
        overtime
      });
    }
  }, {
    key: "calcOffsetStartTimestamp",
    value: function calcOffsetStartTimestamp() {
      return Date.now();
    }
  }, {
    key: "addTime",
    value: function addTime(seconds) {
      this.legacyCountdownRef.addTime(seconds);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "isStatus",
    value: function isStatus(status) {
      return this.state.status === status;
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta, status, callback) {
      var _this2 = this;
      if (!this.mounted)
        return;
      var completing = timeDelta.completed && !this.state.timeDelta.completed;
      var completedOnStart = timeDelta.completed && status === "STARTED";
      if (completing && !this.props.overtime) {
        this.clearTimer();
      }
      var onDone = function onDone2() {
        if (callback)
          callback(_this2.state.timeDelta);
        if (_this2.props.onComplete && (completing || completedOnStart)) {
          _this2.props.onComplete(timeDelta, completedOnStart);
        }
      };
      return this.setState(function(prevState) {
        var newStatus = status || prevState.status;
        if (timeDelta.completed && !_this2.props.overtime) {
          newStatus = "COMPLETED";
        } else if (!status && newStatus === "COMPLETED") {
          newStatus = "STOPPED";
        }
        return {
          timeDelta,
          status: newStatus
        };
      }, onDone);
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        stop: this.stop,
        isStarted: this.isStarted,
        isPaused: this.isPaused,
        isStopped: this.isStopped,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props, daysInHours = _this$props2.daysInHours, zeroPadTime = _this$props2.zeroPadTime, zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign(Object.assign({}, timeDelta), {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours,
          zeroPadTime,
          zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.legacyMode) {
        var _this$props3 = this.props, count = _this$props3.count, _children = _this$props3.children, onComplete = _this$props3.onComplete;
        return createElement(Countdown, {
          ref: this.setLegacyCountdownRef,
          count,
          onComplete
        }, _children);
      }
      var _this$props4 = this.props, className = _this$props4.className, overtime = _this$props4.overtime, children = _this$props4.children, renderer = _this$props4.renderer;
      var renderProps = this.getRenderProps();
      if (renderer) {
        return renderer(renderProps);
      }
      if (children && this.state.timeDelta.completed && !overtime) {
        return cloneElement(children, {
          countdown: renderProps
        });
      }
      var _renderProps$formatte = renderProps.formatted, days = _renderProps$formatte.days, hours = _renderProps$formatte.hours, minutes = _renderProps$formatte.minutes, seconds = _renderProps$formatte.seconds;
      return createElement("span", {
        className
      }, renderProps.total < 0 ? "-" : "", days, days ? ":" : "", hours, ":", minutes, ":", seconds);
    }
  }]);
  return Countdown$12;
}(Component);
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
  controlled: false,
  intervalDelay: 1e3,
  precision: 0,
  autoStart: true
});
Countdown$1.propTypes = {
  date: (0, import_prop_types.oneOfType)([(0, import_prop_types.instanceOf)(Date), import_prop_types.string, import_prop_types.number]),
  daysInHours: import_prop_types.bool,
  zeroPadTime: import_prop_types.number,
  zeroPadDays: import_prop_types.number,
  controlled: import_prop_types.bool,
  intervalDelay: import_prop_types.number,
  precision: import_prop_types.number,
  autoStart: import_prop_types.bool,
  overtime: import_prop_types.bool,
  className: import_prop_types.string,
  children: import_prop_types.element,
  renderer: import_prop_types.func,
  now: import_prop_types.func,
  onMount: import_prop_types.func,
  onStart: import_prop_types.func,
  onPause: import_prop_types.func,
  onStop: import_prop_types.func,
  onTick: import_prop_types.func,
  onComplete: import_prop_types.func
};
var index_es_default = Countdown$1;

// src/components/countdown/Countdown.tsx
import clsx6 from "clsx";
import { useEffect, useState } from "react";
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var Countdown2 = ({
  countdownEnd,
  segmentValueClass,
  segmentTitleClass,
  className,
  size = "small"
}) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed
  }) => {
    const segments = [
      { title: "Dager", value: days },
      { title: "Timer", value: hours },
      { title: "Minutter", value: minutes },
      { title: "Sekunder", value: seconds }
    ];
    return /* @__PURE__ */ jsx7(
      "ul",
      {
        className: twMerge(clsx6("flex flex-row gap-0.5 lg:gap-2.5", className)),
        children: segments.map((segment) => /* @__PURE__ */ jsxs3(
          "li",
          {
            className: twMerge(
              clsx6("flex flex-col", {
                "gap-0.5 lg:gap-2.5": size === "small",
                "gap-0.5 lg:gap-1": size === "large"
              })
            ),
            children: [
              /* @__PURE__ */ jsx7(
                "div",
                {
                  className: twMerge(
                    clsx6(
                      "bg-white text-black flex items-center justify-center",
                      "font-heading font-500",
                      segmentValueClass,
                      {
                        "w-9 h-7 lg:w-24 lg:h-20 text-[18px] lg:text-[65px]": size === "small",
                        "w-14 h-11 lg:w-28 lg:h-24 text-[27px] lg:text-[78px]": size === "large"
                      }
                    )
                  ),
                  children: isClient && segment.value
                }
              ),
              /* @__PURE__ */ jsx7(
                "span",
                {
                  className: twMerge(
                    clsx6("font-sans font-bold", segmentTitleClass, {
                      "text-[7px] lg:text-base": size === "small",
                      "text-[9px] lg:cap-base": size === "large"
                    })
                  ),
                  children: segment.title
                }
              )
            ]
          }
        ))
      }
    );
  };
  return /* @__PURE__ */ jsx7("div", { children: /* @__PURE__ */ jsx7(index_es_default, { date: countdownEnd, renderer }) });
};

// src/components/banners/topBanner.tsx
import { Fragment, jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var BasicTopBanner = ({ title, cta }) => {
  return /* @__PURE__ */ jsxs4(Fragment, { children: [
    /* @__PURE__ */ jsx8("h2", { className: "hd-xl", children: title }),
    /* @__PURE__ */ jsxs4("div", { className: "md:absolute md:right-4 flex items-center cap-base mt-3 md:mt-0", children: [
      /* @__PURE__ */ jsx8("span", { className: "underline", children: cta }),
      /* @__PURE__ */ jsx8(ArrowRightIcon, { className: "ml-2 h-4" })
    ] })
  ] });
};
var CountdownTopBannerSmall = ({
  title,
  cta,
  theme,
  countdownEnd
}) => {
  if (!countdownEnd) {
    return null;
  }
  return /* @__PURE__ */ jsxs4("div", { className: "w-full flex flex-col gap-0 items-start", children: [
    /* @__PURE__ */ jsxs4("div", { className: "w-full flex flex-row gap-2 lg:gap-4 justify-between", children: [
      title && /* @__PURE__ */ jsxs4("div", { className: "flex flex-col items-start", children: [
        /* @__PURE__ */ jsx8(
          "h2",
          {
            className: twMerge(
              clsx7(
                "font-heading font-500 !h-[1.75rem] lg:!h-[5rem] flex items-center justify-start text-left",
                {
                  "text-[24px] lg:text-[60px] text-nowrap": title.length <= 15,
                  "text-[16px] lg:text-[43px]": title.length > 15
                }
              )
            ),
            children: title
          }
        ),
        /* @__PURE__ */ jsx8("span", { className: "underline font-heading text-xs block lg:hidden -mt-1", children: cta })
      ] }),
      /* @__PURE__ */ jsx8(
        Countdown2,
        {
          size: "small",
          countdownEnd,
          segmentValueClass: clsx7({
            "text-neutral-40 bg-neutral-80": theme === "neutral",
            "text-neutral-80 bg-neutral-0": theme === "neutralDark",
            "text-brown-30 bg-neutral-80": theme === "lightBrown",
            "text-tetiery-30 bg-neutral-80": theme === "lightYellow",
            "text-green-40 bg-neutral-80": theme === "lightGreen",
            "text-tetiery-60 bg-neutral-80": theme === "blackWeekYellow",
            "text-neutral-80 bg-tetiery-50": theme === "blackWeekBlack",
            "text-brown-70 bg-gold-40": theme === "nobel",
            "text-brown-70 bg-pink-60": theme === "garden",
            "text-primary-50 bg-neutral-0": theme === "red"
          }),
          segmentTitleClass: "text-inherit"
        }
      )
    ] }),
    /* @__PURE__ */ jsx8("span", { className: "font-heading underline text-lg hidden lg:block", children: cta })
  ] });
};
var CountdownTopBannerLarge = ({
  title,
  cta,
  theme,
  countdownEnd,
  countdownImage,
  NextImage
}) => {
  if (!countdownEnd) {
    return null;
  }
  return /* @__PURE__ */ jsxs4("div", { className: "w-full flex flex-col items-center gap-6 lg:gap-4 group", children: [
    title && /* @__PURE__ */ jsx8(
      "h2",
      {
        className: twMerge(clsx7("font-heading text-[40px] lg:text-[100px]")),
        children: title
      }
    ),
    /* @__PURE__ */ jsx8(
      Countdown2,
      {
        size: "large",
        countdownEnd,
        segmentValueClass: clsx7({
          "text-neutral-40 bg-neutral-80": theme === "neutral",
          "text-neutral-80 bg-neutral-0": theme === "neutralDark",
          "text-brown-30 bg-neutral-80": theme === "lightBrown",
          "text-tetiery-30 bg-neutral-80": theme === "lightYellow",
          "text-green-40 bg-neutral-80": theme === "lightGreen",
          "text-tetiery-60 bg-neutral-80": theme === "blackWeekYellow",
          "text-neutral-80 bg-tetiery-50": theme === "blackWeekBlack",
          "text-brown-70 bg-gold-40": theme === "nobel",
          "text-brown-70 bg-pink-60": theme === "garden",
          "text-primary-50 bg-neutral-0": theme === "red"
        }),
        segmentTitleClass: "text-inherit"
      }
    ),
    countdownImage && /* @__PURE__ */ jsx8("div", { className: "relative h-24 lg:h-56 aspect-video", children: /* @__PURE__ */ jsx8(
      NextImage,
      {
        src: countdownImage.croppedImageUrl,
        alt: countdownImage.alt || title || "Countdown image",
        className: "object-contain object-center",
        fill: true
      }
    ) }),
    /* @__PURE__ */ jsxs4(
      "div",
      {
        className: twMerge(
          clsx7("w-full flex flex-row justify-between items-center", {
            "-mt-4 lg:-mt-20": countdownImage
          })
        ),
        children: [
          /* @__PURE__ */ jsx8("span", { className: "font-heading text-lg group-hover:underline", children: cta }),
          /* @__PURE__ */ jsx8(IconButton, { variant: "ghost", size: "md", title: `G\xE5 til ${title}`, children: /* @__PURE__ */ jsx8(ArrowRightIcon, { className: "w-7 h-7" }) })
        ]
      }
    )
  ] });
};
var TopBanner = (props) => {
  const { theme = "neutral", type = "basic", countdownEnd } = props;
  return /* @__PURE__ */ jsxs4(
    "div",
    {
      className: clsx7(
        "flex items-center justify-center relative p-4 text-center flex-col",
        {
          "p-4": type === "basic",
          "p-4 lg:p-10": type === "countdown"
        },
        {
          "bg-neutral-40 text-neutral-80": theme === "neutral",
          "text-neutral-0 bg-neutral-80": theme === "neutralDark",
          "bg-brown-30 text-neutral-80": theme === "lightBrown",
          "bg-tetiery-30 text-neutral-80": theme === "lightYellow",
          "bg-green-40 text-neutral-80": theme === "lightGreen",
          "bg-tetiery-60 text-neutral-80": theme === "blackWeekYellow",
          "bg-neutral-80 text-tetiery-50": theme === "blackWeekBlack",
          "bg-brown-70 text-gold-40": theme === "nobel",
          "bg-brown-70 text-pink-60": theme === "garden",
          "bg-primary-50 text-neutral-0": theme === "red"
        }
      ),
      children: [
        type === "countdown" && countdownEnd && /* @__PURE__ */ jsx8(CountdownTopBannerSmall, { ...props }),
        type === "countdownLarge" && countdownEnd && /* @__PURE__ */ jsx8(CountdownTopBannerLarge, { ...props }),
        type === "basic" && /* @__PURE__ */ jsx8(BasicTopBanner, { ...props })
      ]
    }
  );
};

// src/components/banners/campaignBanner.tsx
init_react_shim();
import clsx8 from "clsx";
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
var CampaignBanner = ({
  theme = "neutral",
  title,
  cta,
  children
}) => {
  return /* @__PURE__ */ jsxs5(
    "div",
    {
      className: clsx8(
        "flex flex-col items-center justify-center relative p-16 text-center",
        {
          "bg-neutral-40 text-neutral-80": theme === "neutral",
          "text-neutral-0 bg-neutral-80": theme === "neutralDark",
          "bg-brown-30 text-neutral-80": theme === "lightBrown",
          "bg-tetiery-30 text-neutral-80": theme === "lightYellow",
          "bg-green-40 text-neutral-80": theme === "lightGreen",
          "bg-tetiery-60 text-neutral-80": theme === "blackWeekYellow",
          "bg-neutral-80 text-tetiery-50": theme === "blackWeekBlack",
          "bg-brown-70 text-gold-40": theme === "nobel",
          "bg-primary-50 text-neutral-0": theme === "red",
          "bg-brown-70 text-pink-60": theme === "garden"
        }
      ),
      children: [
        /* @__PURE__ */ jsx9("h2", { className: "hd-6xl font-bold pb-2 break-words", children: title }),
        /* @__PURE__ */ jsx9("p", { className: "pb-10 body-lg max-w-lg", children }),
        /* @__PURE__ */ jsx9(
          Button,
          {
            size: "lg",
            className: clsx8("p-4 border-none", {
              "!bg-neutral-80 !text-neutral-0": theme !== "blackWeekBlack" && theme !== "nobel" && theme !== "garden",
              "!bg-neutral-0 !text-neutral-80": theme === "blackWeekBlack" || theme === "nobel" || theme === "garden"
            }),
            children: cta
          }
        )
      ]
    }
  );
};

// src/components/cards/index.ts
init_react_shim();

// src/components/cards/CampaignCard/index.ts
init_react_shim();

// src/components/cards/CampaignCard/CampaignCard.tsx
init_react_shim();
import { forwardRef as forwardRef4 } from "react";
import { ArrowRightIcon as ArrowRightIcon2 } from "@heroicons/react/20/solid";
import clsx10 from "clsx";

// src/components/cards/CampaignCard/Badge.tsx
init_react_shim();
import clsx9 from "clsx";
import { jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var calculateBadgeMask = (blackweek, blackweekLogoLight, blackweekLogoDark, salgLogo, customBrandingLogo, topLeftBranding) => {
  if (blackweek && !blackweekLogoLight && !blackweekLogoDark) {
    return {
      backgroundImage: "url(/gfx/blackweek-bg.svg)",
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent"
    };
  }
  if (blackweekLogoLight) {
    return {
      backgroundImage: "url(/gfx/blackweek-logo-light.svg)",
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent"
    };
  }
  if (blackweekLogoDark) {
    return {
      backgroundImage: "url(/gfx/blackweek-logo-dark.svg)",
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent"
    };
  }
  if (salgLogo) {
    return {
      backgroundImage: "url(/gfx/salgsalgsalg.svg)",
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent"
    };
  }
  if (customBrandingLogo && topLeftBranding) {
    return {
      backgroundImage: `url(${topLeftBranding.croppedImageUrl})`,
      backgroundSize: "80% 80%",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent"
    };
  }
  return {};
};
var CampaignCardBadge = ({
  large,
  medium,
  small,
  withImage,
  badgeSale,
  badgePromotion,
  badgeNews,
  badgePreText,
  badgeText,
  blackweek,
  blackweekLogoLight,
  blackweekLogoDark,
  parentType,
  badgeSaleRed,
  badgeSalgLogo,
  customBrandingLogo,
  topLeftBranding,
  saleWithExtraBubble,
  smallBadgeText
}) => {
  const hideBadgeText = blackweekLogoLight || blackweekLogoDark || badgeSalgLogo || customBrandingLogo;
  const badgeTextLength = (badgeText == null ? void 0 : badgeText.length) || 0;
  return /* @__PURE__ */ jsxs6(
    "span",
    {
      style: calculateBadgeMask(
        blackweek,
        blackweekLogoLight,
        blackweekLogoDark,
        badgeSalgLogo,
        customBrandingLogo,
        topLeftBranding
      ),
      className: twMerge(
        clsx9(
          "absolute flex flex-col justify-center items-center top-2 left-2",
          {
            "tracking-tighter leading-negative size-16 font-heading font-medium text-black-friday-badge text-neutral-80 @xs:size-24 @xs:text-[2rem] @lg:size-40 @lg:text-[4rem]": blackweek || badgeSaleRed || badgeSalgLogo || customBrandingLogo,
            "top-8 left-3": saleWithExtraBubble,
            "rounded-full bg-primary-50 text-neutral-0 @xs:size-24 @xs:text-[2rem] @lg:size-32 @lg:text-[4rem]": badgeSaleRed,
            "text-[1rem] @xs:text-[1.5rem] @lg:text-[2.5rem]": (blackweek || badgeSaleRed || badgeSalgLogo || customBrandingLogo) && badgeTextLength > 3,
            "rounded-full size-16 hd-sm bg-neutral-80 text-neutral-0 @xs:size-20 @xs:hd-md @lg:size-36 @lg:hd-2xl": badgeSale || saleWithExtraBubble,
            "rounded-full size-16 hd-sm bg-secondary-60 text-neutral-0 @xs:size-20 @xs:hd-md @lg:size-36 @lg:hd-2xl": badgeNews,
            "rounded-full size-16 hd-lg bg-primary-50 text-neutral-0 promotion-text-shadow": badgePromotion,
            "origin-top-left scale-125 sm:scale-150": parentType === "v1" && (blackweek || badgeSaleRed || badgeSalgLogo || customBrandingLogo),
            "origin-top-left sm:scale-125 md:scale-[1.3] lg:scale-150": parentType === "v2" && (blackweek || badgeSaleRed || badgeSalgLogo || customBrandingLogo) && large
          }
        )
      ),
      children: [
        saleWithExtraBubble && smallBadgeText && /* @__PURE__ */ jsx10("span", { className: "-tracking-normal absolute -top-4 -right-4 @lg:-top-6 @lg:-right-6 size-3/6 bg-primary-50 text-neutral-0 text-sm @lg:text-lg rounded-full flex justify-center items-center", children: /* @__PURE__ */ jsx10(
          "span",
          {
            className: twMerge(
              clsx9({ "scale-75": smallBadgeText.length >= 6 })
            ),
            children: smallBadgeText
          }
        ) }),
        badgePreText && !hideBadgeText && /* @__PURE__ */ jsx10(
          "span",
          {
            className: twMerge(
              clsx9("block hd-base tracking-normal", {
                "text-xxxs @sm:text-xxs @lg:text-sm font-semibold self-end pr-3 @sm:pr-5 @lg:pr-10": blackweek || badgeSaleRed
              })
            ),
            children: badgePreText
          }
        ),
        badgeNews && "NYHET",
        badgePromotion && /* @__PURE__ */ jsxs6("div", { children: [
          /* @__PURE__ */ jsx10(
            "div",
            {
              className: "font-light text-sm md:text-md uppercase",
              style: { textShadow: "none" },
              children: "Medlems-"
            }
          ),
          "KUPP!"
        ] }),
        (badgeSale || blackweek || badgeSaleRed || saleWithExtraBubble) && !hideBadgeText && badgeText
      ]
    }
  );
};

// src/utils/processTitle.tsx
init_react_shim();
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
function processTitle(title) {
  if (title && title.startsWith("Nobel\xAE by Jensen - det lille ekstra")) {
    return /* @__PURE__ */ jsxs7("span", { className: "font-garamond tracking-wide", children: [
      /* @__PURE__ */ jsx11("span", { className: "font-semibold", children: "Nobel\xAE by Jensen" }),
      " - det lille ekstra!"
    ] });
  }
  return title;
}

// src/components/cards/CampaignCard/CampaignCard.tsx
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var CampaignCard = forwardRef4(function CampaignCard2({
  className = "",
  badgeType,
  badgeText,
  badgePreText,
  image,
  imagePosition = "before",
  subTitle,
  title = "",
  body,
  showButton = true,
  size = "lg",
  variant = "default",
  fill,
  theme = "neutralDark",
  centerBranding,
  topLeftBranding,
  includeTopBranding = false,
  topBranding,
  smallBadgeText,
  ...rest
}, ref) {
  const small = size === "sm";
  const medium = size === "md";
  const large = size === "lg";
  const withImage = !!image;
  const withOverlay = variant === "overlay";
  const horizontal = size === "lg" || withOverlay;
  const vertical = size !== "lg" && !withOverlay;
  const badgeSale = badgeType === "sale";
  const blackweek = badgeType === "blackweek" || badgeType === "blackweek-logo-light" || badgeType === "blackweek-logo-dark";
  const blackweekLogoLight = badgeType === "blackweek-logo-light";
  const blackweekLogoDark = badgeType === "blackweek-logo-dark";
  const badgeNews = badgeType === "news";
  const badgePromotion = badgeType === "promotion";
  const badgeSaleRed = badgeType === "sale-red";
  const badgeSalgLogo = badgeType === "salg-logo";
  const customBrandingLogo = badgeType === "customBrandingLogo";
  const saleWIthExtraBubble = badgeType === "sale-with-extra-bubble";
  const withBadge = badgeSale && badgeText || badgeNews || badgePromotion || badgeText && blackweek || blackweekLogoLight || blackweekLogoDark || badgeSaleRed || badgeSalgLogo || customBrandingLogo || saleWIthExtraBubble;
  const blockWithImage = /* @__PURE__ */ jsxs8(
    "div",
    {
      className: clsx10(
        "flex",
        "group",
        "relative",
        "h-full",
        "w-full",
        "@container",
        {
          "flex-col": vertical,
          "flex-row": horizontal,
          "h-full": size !== "lg",
          "text-neutral-0": withOverlay,
          "bg-neutral-80 text-neutral-0": theme === "neutralDark" && !withOverlay,
          "bg-neutral-40 text-neutral-80": theme === "neutral" && !withOverlay,
          "bg-green-40 text-neutral-80": theme === "lightGreen" && !withOverlay,
          "bg-brown-30 text-neutral-80": theme === "lightBrown" && !withOverlay,
          "bg-tetiery-30 text-neutral-80": theme === "lightYellow" && !withOverlay
        },
        className
      ),
      children: [
        /* @__PURE__ */ jsxs8(
          "div",
          {
            className: clsx10("overflow-hidden", "relative", {
              "w-full": withOverlay,
              "md:w-[70%]": size === "lg" && !withOverlay,
              "aspect-[16/9]": horizontal,
              "aspect-[16/11]": vertical,
              "h-full absolute": withOverlay
            }),
            children: [
              /* @__PURE__ */ jsx12(
                "figure",
                {
                  className: clsx10(
                    "w-full",
                    "h-full",
                    "object-cover-child-img",
                    "bg-neutral-60",
                    {
                      "overlay-after": withOverlay,
                      absolute: withOverlay
                    }
                  ),
                  children: typeof image === "string" ? /* @__PURE__ */ jsx12(
                    "img",
                    {
                      src: image,
                      alt: "Preview image",
                      style: { width: "100%", height: "100%" }
                    }
                  ) : image
                }
              ),
              withBadge && /* @__PURE__ */ jsx12(
                CampaignCardBadge,
                {
                  badgeNews,
                  badgePreText,
                  badgePromotion,
                  badgeSale,
                  blackweek,
                  blackweekLogoLight,
                  blackweekLogoDark,
                  badgeSaleRed,
                  badgeSalgLogo,
                  badgeText,
                  customBrandingLogo,
                  topLeftBranding,
                  saleWithExtraBubble: saleWIthExtraBubble,
                  smallBadgeText,
                  large,
                  medium,
                  small,
                  withImage,
                  parentType: "v1"
                }
              )
            ]
          }
        ),
        theme === "salgLogo" && /* @__PURE__ */ jsx12(
          "div",
          {
            className: "absolute h-1/2 lg:h-[65%] w-auto aspect-square top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
            style: {
              backgroundImage: "url(/gfx/salgsalgsalg.svg)",
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
              backgroundColor: "transparent"
            }
          }
        ),
        theme === "customBrandingLogo" && /* @__PURE__ */ jsx12(
          "div",
          {
            className: "absolute h-1/2 w-auto aspect-square top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
            style: {
              backgroundImage: `url(${centerBranding.croppedImageUrl})`,
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
              backgroundColor: "transparent"
            }
          }
        ),
        includeTopBranding && topBranding && /* @__PURE__ */ jsx12(
          "div",
          {
            className: "absolute flex flex-col justify-center items-center top-4 right-4 w-20 @lg:w-40 aspect-video",
            style: {
              backgroundImage: `url(${topBranding.croppedImageUrl})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundColor: "transparent",
              backgroundPosition: "top right"
            }
          }
        ),
        /* @__PURE__ */ jsxs8(
          "div",
          {
            className: clsx10("flex items-start", "min-h-max", {
              "absolute bottom-0 left-0 w-full h-full": withOverlay,
              relative: horizontal && !withOverlay,
              "flex-col": !withOverlay,
              "justify-between items-end": withOverlay,
              "justify-end": (small || medium) && withOverlay,
              "w-full": !(large && !withOverlay),
              "md:w-[33.5%]": large && !withOverlay,
              "p-4": true,
              "p-6": medium || large && !withOverlay,
              "md:p-12": large && withOverlay
            }),
            children: [
              /* @__PURE__ */ jsx12("header", { children: title && /* @__PURE__ */ jsx12(
                "h3",
                {
                  className: clsx10("group-hover:underline", {
                    "hd-md": small,
                    "hd-lg": medium,
                    "md:hd-xl": large
                  }),
                  children: processTitle(title)
                }
              ) }),
              body && large && !withOverlay && /* @__PURE__ */ jsx12(
                "div",
                {
                  className: clsx10("body-sm", "mb-4", "leading-loose", {
                    "mt-4": !withOverlay,
                    "lg:body-base": large
                  }),
                  children: body
                }
              ),
              showButton && /* @__PURE__ */ jsx12(
                IconButton,
                {
                  className: clsx10({
                    "invisible md:visible": horizontal && !withOverlay
                  }),
                  variant: theme === "neutralDark" ? "ghost" : "primary",
                  size: "md",
                  title: `G\xE5 til ${title}`,
                  children: /* @__PURE__ */ jsx12(ArrowRightIcon2, { className: "w-7 h-7" })
                }
              )
            ]
          }
        )
      ]
    }
  );
  const blockWithoutImage = /* @__PURE__ */ jsxs8(
    "div",
    {
      className: clsx10(
        "flex",
        "flex-col",
        "md:flex-row",
        "relative",
        "w-full",
        "min-h-max",
        "max-w-full",
        {
          "flex-col": !large,
          "h-[144px]": large,
          "h-[350px]": small || medium,
          "max-w-[640px]": medium,
          "max-w-[480px]": small,
          "text-neutral-0": withOverlay,
          "bg-neutral-80 text-neutral-0": theme === "neutralDark" && !withOverlay,
          "bg-neutral-40 text-neutral-80": theme === "neutral" && !withOverlay,
          "bg-green-40 text-neutral-80": theme === "lightGreen" && !withOverlay,
          "bg-brown-30 text-neutral-80": theme === "lightBrown" && !withOverlay,
          "bg-tetiery-30 text-neutral-80": theme === "lightYellow" && !withOverlay
        },
        className
      ),
      children: [
        /* @__PURE__ */ jsx12("div", { className: clsx10("overflow-hidden"), children: withBadge && /* @__PURE__ */ jsx12(
          CampaignCardBadge,
          {
            badgeNews,
            badgePreText,
            badgePromotion,
            badgeSale,
            blackweek,
            blackweekLogoLight,
            blackweekLogoDark,
            badgeSaleRed,
            badgeSalgLogo,
            badgeText,
            large,
            medium,
            small,
            withImage,
            parentType: "v1"
          }
        ) }),
        /* @__PURE__ */ jsxs8(
          "div",
          {
            className: clsx10(
              "flex items-start",
              "min-h-max",
              "justify-between",
              "p-4",
              {
                "flex-col": !large,
                "items-center": large,
                "w-full": !large,
                "p-6": medium,
                "md:pl-32 pr-6 py-6": large
              }
            ),
            children: [
              /* @__PURE__ */ jsxs8("div", { className: clsx10(""), children: [
                /* @__PURE__ */ jsx12("header", { children: title && /* @__PURE__ */ jsx12(
                  "h3",
                  {
                    className: clsx10({
                      "hd-md": small,
                      "hd-lg": medium,
                      "md:hd-xl": large
                    }),
                    children: title
                  }
                ) }),
                body && /* @__PURE__ */ jsx12("div", { className: clsx10("body-sm", "mb-4", "leading-loose", "mt-4"), children: body })
              ] }),
              /* @__PURE__ */ jsx12(IconButton, { variant: "ghost", size: "lg", title: `G\xE5 til ${title}`, children: /* @__PURE__ */ jsx12(ArrowRightIcon2, { className: "w-5 h-5" }) })
            ]
          }
        )
      ]
    }
  );
  return withImage ? blockWithImage : blockWithoutImage;
});

// src/components/cards/CampaignCard/CampaignCardV2.tsx
init_react_shim();
import { forwardRef as forwardRef5 } from "react";
import clsx11 from "clsx";
import { jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var CampaignCardV2 = forwardRef5(function CampaignCard3({
  className = "",
  badgeType,
  badgeText,
  image,
  headerText,
  bigText,
  title,
  buttonText,
  footerText,
  size,
  theme = "neutral",
  fullWidth = false,
  ...rest
}, ref) {
  const badgeSale = badgeType === "sale";
  const blackweek = badgeType === "blackweek" || badgeType === "blackweek-logo-light" || badgeType === "blackweek-logo-dark";
  const blackweekLogoLight = badgeType === "blackweek-logo-light";
  const blackweekLogoDark = badgeType === "blackweek-logo-dark";
  const badgeNews = badgeType === "news";
  const badgePromotion = badgeType === "promotion";
  return /* @__PURE__ */ jsxs9("div", { className: "w-full h-full relative group underline-offset-4 @container", children: [
    image,
    /* @__PURE__ */ jsxs9(
      "div",
      {
        className: clsx11(
          "absolute top-0 left-0 w-full h-full bg-neutral-80 bg-opacity-30 transition-all flex flex-col items-center justify-center text-center text-neutral-0"
        ),
        children: [
          badgeType && /* @__PURE__ */ jsx13(
            CampaignCardBadge,
            {
              badgeNews,
              badgePromotion,
              badgeSale,
              blackweek,
              blackweekLogoLight,
              blackweekLogoDark,
              badgeText,
              large: true,
              withImage: true,
              parentType: "v2"
            }
          ),
          /* @__PURE__ */ jsxs9("div", { className: "absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center text-center text-neutral-0", children: [
            headerText && theme !== "blackWeekLogo" && theme !== "salgLogo" && /* @__PURE__ */ jsx13("div", { className: "hd-md @xs:hd-lg", children: headerText }),
            theme === "blackWeekLogo" && /* @__PURE__ */ jsx13(
              "div",
              {
                className: "h-1/2 lg:h-[65%] w-auto aspect-square",
                style: {
                  backgroundImage: "url(/gfx/blackweek-logo-light.svg)",
                  backgroundSize: "100% 100%",
                  backgroundRepeat: "no-repeat",
                  backgroundColor: "transparent"
                }
              }
            ),
            theme === "salgLogo" && /* @__PURE__ */ jsx13(
              "div",
              {
                className: "h-1/2 lg:h-[65%] w-auto aspect-square",
                style: {
                  backgroundImage: "url(/gfx/salgsalgsalg.svg)",
                  backgroundSize: "100% 100%",
                  backgroundRepeat: "no-repeat",
                  backgroundColor: "transparent"
                }
              }
            ),
            bigText && theme !== "blackWeekLogo" && theme !== "salgLogo" && /* @__PURE__ */ jsx13(
              "div",
              {
                className: clsx11(
                  "group-hover:underline",
                  {
                    "text-neutral-0": theme === "neutral",
                    "text-tetiery-40": theme === "lightYellow",
                    "text-pink-60": theme === "garden",
                    "text-tetiery-60": theme === "blackWeekYellow" || theme === "blackWeekBlack",
                    "hd-xl @md:hd-5xl @lg:hd-8xl": size === "md" || size === "lg",
                    "hd-xl @md:hd-2xl @sm:hd-5xl": size === "sm"
                  },
                  "!font-bold"
                ),
                children: bigText
              }
            ),
            title && /* @__PURE__ */ jsx13(
              "div",
              {
                className: clsx11("max-w-[10em]", {
                  "hd-md @md:hd-xl @lg:hd-7xl": size === "lg",
                  "group-hover:underline": !bigText,
                  "hd-md @md:hd-3xl": size === "md",
                  "hd-md @md:hd-lg": size === "sm"
                }),
                children: title
              }
            ),
            buttonText && /* @__PURE__ */ jsx13(
              "div",
              {
                className: clsx11("bg-neutral-0 text-neutral-80 px-3 py-2 mt-4", {
                  hidden: size !== "lg"
                }),
                children: buttonText
              }
            )
          ] }),
          footerText && theme !== "blackWeekLogo" && /* @__PURE__ */ jsx13(
            "div",
            {
              className: clsx11("mt-auto", {
                "hd-md lg:hd-lg pb-4 md:pb-4 lg:pb-4 xl:pb-8": size === "lg",
                "pb-4 md:pb-4 lg:pb-4 md:hd-md lg:hd-lg": size === "md",
                "pb-2 sm:pb-4 md:pb-4 lg:pb-4": size === "sm"
              }),
              children: footerText
            }
          )
        ]
      }
    )
  ] });
});

// src/components/cards/ContentCard/index.ts
init_react_shim();

// src/components/cards/ContentCard/ContentCard.tsx
init_react_shim();
import { forwardRef as forwardRef6 } from "react";
import { ArrowRightIcon as ArrowRightIcon3 } from "@heroicons/react/20/solid";
import clsx12 from "clsx";
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var ContentCard = forwardRef6(function ContentCard2({
  className = "",
  buttonText,
  image,
  imagePosition = "before",
  title = "",
  pretitle,
  body,
  href,
  size = "lg",
  theme = "neutral",
  onClick,
  ...rest
}, ref) {
  const small = size === "sm";
  const large = size === "lg" || size == "md";
  const withImage = !!image;
  const block = /* @__PURE__ */ jsxs10(
    "article",
    {
      className: clsx12(
        "flex",
        "group",
        "relative",
        "w-full",
        "flex-col",
        {
          "bg-neutral-40 text-neutral-80": theme === "neutral",
          "text-neutral-0 bg-neutral-80": theme === "neutralDark",
          "bg-brown-30 text-neutral-80": theme === "lightBrown",
          "bg-tetiery-30 text-neutral-80": theme === "lightYellow",
          "bg-green-40 text-neutral-80": theme === "lightGreen",
          "bg-tetiery-60 text-neutral-80": theme === "blackWeekYellow",
          "bg-neutral-80 text-tetiery-50": theme === "blackWeekBlack",
          "bg-brown-70 text-gold-40": theme === "nobel",
          "bg-brown-70 text-pink-60": theme === "garden",
          "md:flex-row": large,
          "max-w-[480px]": small,
          "md:flex-row-reverse": imagePosition === "after" && large,
          "flex-col": imagePosition === "before" && small
        },
        className
      ),
      children: [
        /* @__PURE__ */ jsx14(
          "div",
          {
            className: clsx12("relative h-[350px]", {
              "md:w-[50%]": large,
              "md:h-[500px]": large,
              "h-[350px]": small
            }),
            children: withImage && /* @__PURE__ */ jsx14(
              "figure",
              {
                className: clsx12("w-full", "h-full", "object-cover-child-img"),
                children: typeof image === "string" ? /* @__PURE__ */ jsx14("img", { src: image, alt: "Preview image" }) : image
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs10(
          "div",
          {
            className: clsx12("flex", "justify-between", "flex-col", {
              "w-full": !large,
              "md:w-[50%]": large,
              "p-4": small,
              "p-10": large
            }),
            children: [
              /* @__PURE__ */ jsxs10(
                "div",
                {
                  className: clsx12({
                    "pb-4": small
                  }),
                  children: [
                    /* @__PURE__ */ jsxs10("header", { children: [
                      /* @__PURE__ */ jsx14("div", { className: "empty:hidden hd-md lg:hd-lg xl:hd-2xl font-normal", children: pretitle }),
                      title && /* @__PURE__ */ jsx14("h3", { className: "hd-lg sm:hd-xl md:hd-xl lg:hd-3xl xl:hd-5xl 2xl:hd-6xl mb-3 break-words group-hover:underline", children: title })
                    ] }),
                    body && /* @__PURE__ */ jsx14("div", { className: "body-md mb-10", children: body })
                  ]
                }
              ),
              href && (!buttonText || small) && /* @__PURE__ */ jsx14(
                IconButton,
                {
                  size: small ? "base" : "md",
                  variant: theme === "neutralDark" || theme === "nobel" || theme === "garden" || theme === "blackWeekBlack" ? "ghost" : void 0,
                  children: /* @__PURE__ */ jsx14(ArrowRightIcon3, {})
                }
              ),
              (href || onClick) && buttonText && !small && /* @__PURE__ */ jsxs10(Button, { className: "inline-block max-w-fit pl-4", onClick, children: [
                buttonText,
                /* @__PURE__ */ jsx14(ArrowRightIcon3, { className: "h-5 w-5 ml-2" })
              ] })
            ]
          }
        )
      ]
    }
  );
  return block;
});

// src/components/cards/TextboxCard/index.ts
init_react_shim();

// src/components/cards/TextboxCard/TextboxCard.tsx
init_react_shim();
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var TextboxCard = ({ title, subtitle, body }) => {
  return /* @__PURE__ */ jsxs11("article", { className: "bg-neutral-80 text-neutral-0 text-center p-3 sm:p-12", children: [
    /* @__PURE__ */ jsx15("div", { className: "cap-xs sm:cap-sm", children: subtitle }),
    /* @__PURE__ */ jsx15("h1", { className: "body-base sm:body-lg my-2", children: title }),
    /* @__PURE__ */ jsx15("p", { className: "body-xs sm:body-sm", children: body })
  ] });
};

// src/components/cards/ArticleCard/index.ts
init_react_shim();

// src/components/cards/ArticleCard/ArticleCard.tsx
init_react_shim();
import clsx13 from "clsx";
import { jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var ArticleCard = ({
  linkText = "Les artikkel",
  image,
  title = "",
  body,
  href,
  size = "lg",
  direction = "horizontal",
  ...rest
}) => {
  return /* @__PURE__ */ jsxs12(
    "article",
    {
      className: clsx13(
        "flex",
        "group",
        "relative",
        "w-full",
        "flex-col",
        "max-w-full",
        "overflow-hidden",
        {
          "md:flex-row": direction === "horizontal"
        }
      ),
      children: [
        /* @__PURE__ */ jsx16(
          "div",
          {
            className: clsx13("aspect-[16/9] w-full", {
              "max-w-xl": size === "lg" && direction === "horizontal",
              "max-w-xs": size === "md" && direction === "horizontal",
              "aspect-square max-w-[80px]": size === "sm" && direction === "horizontal"
            }),
            children: /* @__PURE__ */ jsx16("figure", { className: clsx13("w-full", "h-full", "object-cover-child-img"), children: typeof image === "string" ? /* @__PURE__ */ jsx16("img", { src: image, alt: "Preview image" }) : image })
          }
        ),
        /* @__PURE__ */ jsxs12(
          "div",
          {
            className: clsx13("flex", "justify-between", "flex-col", {
              "p-10": size === "lg" && direction === "horizontal",
              "py-5": size === "lg" && direction === "vertical",
              "p-6": size === "md" && direction === "horizontal",
              "px-4 py-1": size === "sm",
              "px-0": direction === "vertical"
            }),
            children: [
              /* @__PURE__ */ jsx16(
                "h3",
                {
                  className: clsx13("break-words", "group-hover:underline", {
                    "hd-2xl": size === "lg" && direction === "horizontal",
                    "hd-lg": size === "md" && direction === "horizontal" || size === "lg" && direction === "vertical",
                    "hd-base": size === "sm" && direction === "horizontal" || size === "md" && direction === "vertical" || size === "sm" && direction === "vertical",
                    "pt-4 pb-2": size === "md" && direction === "vertical"
                  }),
                  children: title
                }
              ),
              /* @__PURE__ */ jsx16(
                "p",
                {
                  className: clsx13("text-neutral-70", {
                    "body-md": size === "lg",
                    "body-sm": size === "md",
                    "mb-5": size === "lg",
                    "mb-2": size === "md",
                    hidden: size === "sm"
                  }),
                  children: body
                }
              )
            ]
          }
        )
      ]
    }
  );
};

// src/components/cards/ProductCollectionCard/index.ts
init_react_shim();

// src/components/cards/ProductCollectionCard/ProductCollectionCard.tsx
init_react_shim();
import { ArrowRightIcon as ArrowRightIcon4 } from "@heroicons/react/20/solid";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var ProductCollectionCard = (props) => {
  const {
    title,
    subtitle,
    href,
    readMoreText = "Se alle produkter",
    className,
    children
  } = props;
  return /* @__PURE__ */ jsxs13("article", { className, children: [
    /* @__PURE__ */ jsxs13("div", { className: "flex justify-between flex-col md:flex-row", children: [
      /* @__PURE__ */ jsxs13("div", { className: "mb-2", children: [
        /* @__PURE__ */ jsx17("h2", { className: "hd-xl", children: title }),
        /* @__PURE__ */ jsx17("div", { className: "body-base", children: subtitle })
      ] }),
      href && /* @__PURE__ */ jsxs13(
        "a",
        {
          className: "underline underline-offset-2 flex items-center",
          href,
          children: [
            readMoreText,
            " ",
            /* @__PURE__ */ jsx17(ArrowRightIcon4, { className: "h-5 ml-1" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx17("ul", { className: "grid gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 mt-2", children })
  ] });
};

// src/components/cards/CategoryCollection/index.ts
init_react_shim();

// src/components/cards/CategoryCollection/CategoryCollectionCard.tsx
init_react_shim();

// src/components/cards/CategoryCollection/CategoryCard.tsx
init_react_shim();
import { ArrowRightIcon as ArrowRightIcon5 } from "@heroicons/react/20/solid";
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var CategoryCard = ({ title, imageUrl, href }) => {
  return /* @__PURE__ */ jsx18("a", { href, className: "group", children: /* @__PURE__ */ jsxs14("article", { className: "bg-neutral-40 aspect-square p-5 flex justify-between flex-col", children: [
    /* @__PURE__ */ jsxs14("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ jsx18("div", { className: "h-10", children: imageUrl && /* @__PURE__ */ jsx18("img", { src: imageUrl, width: "", className: "h-10 w-10", alt: title }) }),
      /* @__PURE__ */ jsx18(
        IconButton,
        {
          rounded: true,
          className: "h-10 w-10",
          variant: "ghost",
          title: `G\xE5 til kategorien ${title}`,
          children: /* @__PURE__ */ jsx18(ArrowRightIcon5, { className: "h-4" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx18("h2", { className: "group-hover:underline", children: title })
  ] }) });
};
var CategoryCard_default = CategoryCard;

// src/components/cards/CategoryCollection/CategoryCollectionCard.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
import { createElement as createElement2 } from "react";
var CategoryCollectionCard = ({
  categories = [],
  getHref
}) => {
  return /* @__PURE__ */ jsx19("div", { className: "grid gap-5 grid-cols-2 lg:grid-cols-3 xl:grid-cols-6", children: categories.map((category) => {
    var _a, _b, _c;
    if (!category.productCategoryEnrichment)
      return null;
    const algoliaProductCategorySlug = category.productCategoryEnrichment.algoliaProductCategorySlug;
    const href = algoliaProductCategorySlug && getHref(algoliaProductCategorySlug);
    return /* @__PURE__ */ createElement2(
      CategoryCard_default,
      {
        ...category,
        imageUrl: (_c = (_b = (_a = category.productCategoryEnrichment) == null ? void 0 : _a.icon) == null ? void 0 : _b.asset) == null ? void 0 : _c.url,
        href,
        key: category.productCategoryEnrichment._id
      }
    );
  }) });
};

// src/components/cards/ImageAndText/index.ts
init_react_shim();

// src/components/cards/ImageAndText/ImageAndText.tsx
init_react_shim();
import clsx14 from "clsx";
import { jsx as jsx20, jsxs as jsxs15 } from "react/jsx-runtime";
var ImageAndText = ({
  className = "",
  image,
  imagePosition = "before",
  title = "",
  body
}) => {
  const block = /* @__PURE__ */ jsxs15(
    "article",
    {
      className: clsx14("sm:flex", "relative", "w-full", className, {
        "sm:flex-row-reverse": imagePosition === "after"
      }),
      children: [
        /* @__PURE__ */ jsx20("div", { className: clsx14("sm:w-2/5"), children: /* @__PURE__ */ jsx20(
          "figure",
          {
            className: clsx14(
              "w-full",
              "object-cover-child-img",
              "relative",
              "aspect-square"
            ),
            children: typeof image === "string" ? /* @__PURE__ */ jsx20("img", { src: image, alt: "Preview image", className: "h-full w-full" }) : image
          }
        ) }),
        /* @__PURE__ */ jsx20(
          "div",
          {
            className: clsx14(
              "p-4",
              "sm:w-3/5",
              "sm:px-20",
              "flex",
              "flex-col",
              "justify-center"
            ),
            children: /* @__PURE__ */ jsxs15("div", { children: [
              /* @__PURE__ */ jsx20("header", { children: title && /* @__PURE__ */ jsx20("h3", { className: "hd-lg sm:hd-xl md:hd-xl mb-3 break-words", children: title }) }),
              body && /* @__PURE__ */ jsx20("div", { className: "body-base md:body-md space-y-4", children: body })
            ] })
          }
        )
      ]
    }
  );
  return block;
};

// src/components/category-hero/index.ts
init_react_shim();

// src/components/category-hero/CategoryHero.tsx
init_react_shim();
import clsx15 from "clsx";
import { jsx as jsx21, jsxs as jsxs16 } from "react/jsx-runtime";
function CategoryHero({
  image,
  title,
  subTitle,
  description
}) {
  return /* @__PURE__ */ jsxs16(
    "div",
    {
      className: clsx15({
        "aspect-[21/9] relative overflow-hidden rounded-lg overlay-after": image
      }),
      children: [
        image && /* @__PURE__ */ jsx21(
          "figure",
          {
            className: clsx15({
              "w-full h-full overflow-hidden [&_img]:absolute [&_img]:inset-0 [&_img]:h-full [&_img]:w-full [&_img]:rounded [&_img]:object-cover": image
            }),
            children: image || /* @__PURE__ */ jsx21("div", { className: "absolute w-full h-full bg-grey-base" })
          }
        ),
        /* @__PURE__ */ jsxs16(
          "div",
          {
            className: clsx15("text-center", {
              "text-neutral-0 absolute bottom-8 w-full z-10": image
            }),
            children: [
              /* @__PURE__ */ jsx21("h1", { className: "mb-2 hd-2xl lg:hd-3xl", children: processTitle(title) }),
              subTitle && /* @__PURE__ */ jsx21("p", { className: "leading-6", children: subTitle }),
              description && /* @__PURE__ */ jsx21("div", { className: "leading-6", children: description })
            ]
          }
        )
      ]
    }
  );
}

// src/components/content-blocks/index.ts
init_react_shim();

// src/components/content-blocks/image-collection/index.tsx
init_react_shim();
import { jsx as jsx22, jsxs as jsxs17 } from "react/jsx-runtime";
var ImageCollectionBlock = ({ block }) => {
  return /* @__PURE__ */ jsxs17("div", { children: [
    /* @__PURE__ */ jsx22("h1", { children: "Image collection block" }),
    /* @__PURE__ */ jsx22("pre", { children: JSON.stringify(block, null, 2) })
  ] });
};

// src/components/chip/index.ts
init_react_shim();

// src/components/chip/Chip.tsx
init_react_shim();
import clsx16 from "clsx";
import { jsx as jsx23, jsxs as jsxs18 } from "react/jsx-runtime";
function resolveVariantClasses2(variant) {
  switch (variant) {
    case "light":
      return clsx16("bg-neutral-40", "text-neutral-80");
    case "outline":
      return clsx16("ring-secondary-60", "text-neutral-80", "ring-2");
  }
  return clsx16("bg-neutral-80", "text-neutral-0");
}
function Chip({
  variant = "primary",
  label,
  onClick,
  size = "md",
  Icon,
  title,
  iconPlacement = "left"
}) {
  const Component2 = onClick ? "button" : "div";
  return /* @__PURE__ */ jsxs18(
    Component2,
    {
      onClick,
      title,
      className: clsx16(
        "inline-flex items-center whitespace-nowrap",
        "rounded-full px-3",
        "group",
        resolveVariantClasses2(variant),
        size === "sm" && "text-xs",
        size === "md" && "text-sm leading-loose px-4 py-1",
        size === "lg" && "text-base leading-loose px-6 py-2"
      ),
      children: [
        Icon && iconPlacement == "left" && /* @__PURE__ */ jsx23(Icon, { className: "h-3 w-4 mr-2 ", "aria-hidden": "true" }),
        label,
        onClick && /* @__PURE__ */ jsx23(
          "span",
          {
            className: clsx16(
              "inline-flex items-center justify-center",
              "flex-shrink-0",
              "h-4 w-4",
              "rounded-full",
              size === "lg" ? "ml-2" : "ml-1",
              variant === "light" && "bg-neutral-80 text-neutral-0",
              "focus:outline-none",
              "group-hover:bg-text-danger group-hover:text-neutral-0"
            ),
            children: /* @__PURE__ */ jsx23(
              "svg",
              {
                className: "h-2 w-2",
                stroke: "currentColor",
                fill: "none",
                viewBox: "0 0 8 8",
                children: /* @__PURE__ */ jsx23(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M1 1l6 6m0-6L1 7"
                  }
                )
              }
            )
          }
        ),
        Icon && iconPlacement == "right" && /* @__PURE__ */ jsx23(Icon, { className: "h-3 w-4 ml-2 ", "aria-hidden": "true" })
      ]
    }
  );
}

// src/components/forms/index.ts
init_react_shim();

// src/components/forms/checkbox/index.ts
init_react_shim();

// src/components/forms/checkbox/Checkbox.tsx
init_react_shim();
import { forwardRef as forwardRef7, useRef, useId } from "react";
import clsx17 from "clsx";
import { CheckIcon } from "@heroicons/react/24/outline";

// src/utils/index.ts
init_react_shim();
function combineAriaBy(type, params) {
  const p = params.map((item) => {
    let out = item;
    if (typeof item === "object" && typeof item[type] !== "undefined" && params.includes(item[type])) {
      return null;
    }
    if (typeof item === "object" && typeof item[type] !== "undefined") {
      out = item[type];
    }
    if (typeof out !== "string") {
      return null;
    }
    return out;
  });
  const result = p.filter(Boolean).join(" ");
  if (result === "") {
    return void 0;
  }
  return result;
}
function combineDescribedBy(...params) {
  return combineAriaBy("aria-describedby", params);
}
function mergeRefs(...refs) {
  return (value) => {
    refs.flat().forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref !== null) {
        ref.current = value;
      }
    });
  };
}

// src/components/forms/checkbox/Checkbox.tsx
import { Fragment as Fragment2, jsx as jsx24, jsxs as jsxs19 } from "react/jsx-runtime";
var Checkbox = forwardRef7(function Checkbox2({
  name,
  label,
  subLabel,
  disabled,
  error,
  resetField,
  className,
  ...props
}, ref) {
  const inputRef = useRef(null);
  const id = useId();
  return /* @__PURE__ */ jsxs19(Fragment2, { children: [
    /* @__PURE__ */ jsxs19(
      "div",
      {
        className: clsx17(
          "flex",
          "flex-row-reverse",
          "items-center",
          "justify-end",
          className
        ),
        children: [
          label && /* @__PURE__ */ jsxs19(
            "label",
            {
              htmlFor: props.id || id,
              className: clsx17("cap-base", "text-neutral-80"),
              children: [
                /* @__PURE__ */ jsx24("span", { children: label }),
                subLabel && /* @__PURE__ */ jsx24(
                  "span",
                  {
                    className: clsx17("block", "mt-1", "cap-xs", "text-neutral-70"),
                    children: subLabel
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs19(
            "span",
            {
              className: clsx17(
                "relative",
                "flex",
                "justify-center",
                "items-center",
                "self-start",
                "mr-3",
                "h-6 min-h-[1.5rem]",
                "w-6 min-w-[1.5rem]"
              ),
              children: [
                /* @__PURE__ */ jsx24(
                  "input",
                  {
                    ref: mergeRefs(ref, inputRef),
                    id,
                    name,
                    type: "checkbox",
                    "aria-invalid": !!error,
                    disabled,
                    className: clsx17(
                      "absolute",
                      "top-0",
                      "left-0",
                      "w-full",
                      "h-full",
                      "appearance-none",
                      "rounded",
                      "bg-neutral-0",
                      "border-1.5",
                      "border-neutral-80",
                      "outline-none",
                      "checked:bg-neutral-80",
                      "focus:ring-2 focus:ring-offset-2 focus:ring-focus",
                      "active:ring-2 active:ring-offset-2 active:ring-focus",
                      "disabled:checked:bg-neutral-50 disabled:border-neutral-50",
                      {
                        ["hover:border-neutral-70 hover:ring-4 hover:ring-neutral-50 hover:checked:bg-neutral-70"]: !disabled && !error,
                        ["border-neutral-70 ring-2 ring-offset-2 ring-warning-50"]: !!error
                      },
                      "peer"
                    ),
                    ...props
                  }
                ),
                /* @__PURE__ */ jsx24(
                  CheckIcon,
                  {
                    className: clsx17(
                      "absolute",
                      "text-neutral-0",
                      "pointer-events-none",
                      "opacity-0",
                      "peer-checked:opacity-100",
                      "top-0 left-0"
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    error && /* @__PURE__ */ jsx24(Alert, { type: "warning", message: error, inline: true })
  ] });
});

// src/components/forms/double-range-slider/index.ts
init_react_shim();

// src/components/forms/double-range-slider/DoubleRangeSlider.tsx
init_react_shim();
import * as Slider from "@radix-ui/react-slider";
import clsx18 from "clsx";
import { jsx as jsx25, jsxs as jsxs20 } from "react/jsx-runtime";
function DoubleRangeSlider({
  value,
  defaultValue,
  minValue,
  maxValue,
  onValueChange,
  onValueCommit,
  disabled
}) {
  return /* @__PURE__ */ jsxs20(
    Slider.Root,
    {
      className: clsx18(
        "relative flex h-4 w-full touch-none select-none items-center",
        {
          "pointer-events-none opacity-25": disabled
        }
      ),
      value,
      min: minValue,
      max: maxValue,
      defaultValue,
      minStepsBetweenThumbs: 1,
      onValueChange: (v) => !disabled && onValueChange && onValueChange(v),
      onValueCommit: (v) => !disabled && onValueCommit && onValueCommit(v),
      disabled,
      children: [
        /* @__PURE__ */ jsx25(Slider.Track, { className: "relative h-1 flex-grow rounded-full bg-neutral-50", children: /* @__PURE__ */ jsx25(Slider.Range, { className: "absolute h-full rounded-full bg-neutral-80" }) }),
        /* @__PURE__ */ jsx25(
          Slider.Thumb,
          {
            className: "block h-4 w-4 rounded-full border bg-neutral-80 bg-grey-base focus:outline-none focus:ring",
            "aria-label": "Minimum"
          }
        ),
        /* @__PURE__ */ jsx25(
          Slider.Thumb,
          {
            className: "block h-4 w-4 rounded-full border bg-neutral-80 focus:outline-none focus:ring",
            "aria-label": "Maksimum"
          }
        )
      ]
    }
  );
}

// src/components/forms/input/index.ts
init_react_shim();

// src/components/forms/input/Input.tsx
init_react_shim();
import { forwardRef as forwardRef8, useState as useState2, useRef as useRef2, useId as useId2, isValidElement } from "react";
import clsx19 from "clsx";
import { EyeIcon, EyeSlashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { jsx as jsx26, jsxs as jsxs21 } from "react/jsx-runtime";
var Input = forwardRef8(function Input2({
  name,
  label,
  type: initialType = "text",
  icon,
  helperText,
  error,
  resetField,
  className,
  inputClassName,
  ...props
}, ref) {
  const id = useId2();
  const inputRef = useRef2(null);
  const [type, setType] = useState2(initialType);
  const [hasValue, setHasValue] = useState2(
    !!(props.value || props.defaultValue)
  );
  function showPasswordHandler(event) {
    event.preventDefault();
    setType(type === "password" ? "text" : "password");
  }
  function resetHandler(event) {
    event.preventDefault();
    if (typeof resetField === "function") {
      resetField(name, {
        keepDirty: true,
        keepTouched: true
      });
    } else if (inputRef.current instanceof HTMLInputElement) {
      inputRef.current.value === "";
    }
  }
  function changeHandler(event) {
    if (!hasValue && event.currentTarget.value) {
      setHasValue(true);
    }
    if (hasValue && !event.currentTarget.value) {
      setHasValue(false);
    }
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
  }
  const centeredContent = clsx19("flex justify-center items-center");
  return /* @__PURE__ */ jsxs21("div", { className: clsx19("text-neutral-80", className), children: [
    label && /* @__PURE__ */ jsx26("label", { htmlFor: props.id || id, className: clsx19("cap-sm"), children: label }),
    /* @__PURE__ */ jsxs21("div", { className: clsx19("relative", "my-2"), children: [
      /* @__PURE__ */ jsx26(
        "input",
        {
          ref: mergeRefs(ref, inputRef),
          id,
          name,
          type,
          "aria-invalid": !!error,
          className: clsx19(
            !icon ? "pl-4" : "pl-12",
            {
              "pr-10": type !== "date" && initialType !== "password",
              "pr-20": initialType === "password",
              "pr-4": type === "date"
            },
            "h-14",
            "w-full",
            "rounded-lg",
            "bg-neutral-0",
            "border-1.5",
            "border-neutral-60",
            "elevation-neutral-sm",
            "outline-none",
            "focus:border-neutral-80",
            "focus:ring-2 focus:ring-offset-2 focus:ring-focus",
            {
              ["hover:border-neutral-70 hover:ring-4 hover:ring-neutral-50 hover:checked:bg-neutral-70"]: !error,
              ["border-neutral-30 ring-2 ring-offset-2 ring-warning-50"]: !!error
            },
            inputClassName
          ),
          ...props,
          onChange: changeHandler
        }
      ),
      isValidElement(icon) && /* @__PURE__ */ jsx26(
        "span",
        {
          className: clsx19(
            "absolute",
            "top-0",
            "left-0",
            "w-12",
            "h-full",
            centeredContent
          ),
          children: icon
        }
      ),
      hasValue && typeof resetHandler === "function" && /* @__PURE__ */ jsx26(
        "button",
        {
          onClick: (event) => {
            setHasValue(false);
            resetHandler(event);
          },
          className: clsx19(
            "absolute",
            "top-0",
            initialType !== "password" ? "right-0" : "right-12",
            initialType !== "password" ? "w-12" : "w-8",
            "h-full",
            centeredContent
          ),
          children: /* @__PURE__ */ jsx26(XMarkIcon, { className: clsx19("w-5", "h-5") })
        }
      ),
      initialType === "password" && /* @__PURE__ */ jsx26(
        "button",
        {
          onClick: showPasswordHandler,
          className: clsx19(
            "absolute",
            "top-0",
            "right-3",
            "w-9",
            "h-full",
            centeredContent
          ),
          children: type === "text" ? /* @__PURE__ */ jsx26(EyeSlashIcon, { className: clsx19("w-5", "h-5") }) : /* @__PURE__ */ jsx26(EyeIcon, { className: clsx19("w-5", "h-5") })
        }
      )
    ] }),
    helperText && /* @__PURE__ */ jsx26("p", { className: clsx19("cap-xs", "text-neutral-70"), children: helperText }),
    error && /* @__PURE__ */ jsx26(Alert, { type: "warning", message: error, inline: true })
  ] });
});

// src/components/forms/number-stepper/index.ts
init_react_shim();

// src/components/forms/number-stepper/NumberStepper.tsx
init_react_shim();
import { useRef as useRef3, useState as useState3 } from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { jsx as jsx27, jsxs as jsxs22 } from "react/jsx-runtime";
function StepperButton({ Icon, disabled, ...rest }) {
  return /* @__PURE__ */ jsx27(
    "button",
    {
      ...rest,
      disabled,
      className: `flex justify-between items-center  text-neutral-0 bg-grey-base rounded-full p-2 my-1 hover:bg-grey-base ${disabled ? "opacity-20" : ""}`,
      children: /* @__PURE__ */ jsx27(Icon, { className: "h-3 w-3" })
    }
  );
}
function NumberStepper({
  onDecrement,
  onIncrement,
  onChange,
  disabled,
  value = 1
}) {
  const [optimisticValue, setOptimisticValue] = useState3(1);
  const inputRef = useRef3(null);
  const handleDecrement = () => {
    setOptimisticValue((old) => old - 1);
    onDecrement();
  };
  const handleIncrement = () => {
    setOptimisticValue((old) => old + 1);
    onIncrement();
  };
  const handleChange = (e) => {
    if (onChange) {
      const value2 = Number(e.target.value);
      setOptimisticValue(value2);
      onChange(value2);
    }
  };
  const handleSelect = () => {
    const input = inputRef.current;
    if (input) {
      input.select();
    }
  };
  return /* @__PURE__ */ jsxs22("div", { className: "inline-flex bg-neutral-80 rounded-md mt-5 items-center px-1 focus-within:ring-2 ring-text-primary border-2 border-white", children: [
    /* @__PURE__ */ jsx27(
      StepperButton,
      {
        onClick: handleDecrement,
        title: "En mindre",
        Icon: MinusIcon,
        disabled: value < 1
      }
    ),
    /* @__PURE__ */ jsx27(
      "input",
      {
        type: "number",
        value,
        className: "bg-neutral-80 text-neutral-0 appearance-none w-6 text-center border-none outline-none mx-1",
        onChange: handleChange,
        onClick: handleSelect,
        disabled,
        ref: inputRef,
        min: 0,
        style: {
          MozAppearance: "textfield"
        }
      }
    ),
    /* @__PURE__ */ jsx27(StepperButton, { onClick: handleIncrement, title: "En mer", Icon: PlusIcon })
  ] });
}

// src/components/forms/radio/index.ts
init_react_shim();

// src/components/forms/radio/Radio.tsx
init_react_shim();
import { forwardRef as forwardRef9, useRef as useRef4, useId as useId3 } from "react";
import clsx20 from "clsx";
import { Fragment as Fragment3, jsx as jsx28, jsxs as jsxs23 } from "react/jsx-runtime";
var Radio = forwardRef9(function Radio2({
  name,
  size = "lg",
  label,
  suppressErrorMessage,
  subLabel,
  error,
  resetField,
  disabled,
  className,
  ...props
}, ref) {
  const id = useId3();
  const inputRef = useRef4(null);
  return /* @__PURE__ */ jsxs23(Fragment3, { children: [
    /* @__PURE__ */ jsxs23(
      "div",
      {
        className: clsx20(
          "flex",
          "flex-row-reverse",
          "items-center",
          "justify-end",
          className
        ),
        children: [
          label && /* @__PURE__ */ jsxs23(
            "label",
            {
              htmlFor: props.id || id,
              className: clsx20("cap-base", "text-neutral-80"),
              children: [
                /* @__PURE__ */ jsx28("span", { children: label }),
                subLabel && /* @__PURE__ */ jsx28(
                  "span",
                  {
                    className: clsx20("block", "mt-1", "cap-xs", "text-neutral-70"),
                    children: subLabel
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs23(
            "span",
            {
              className: clsx20(
                "relative",
                "flex",
                "justify-center",
                "items-center",
                "self-start",
                {
                  "mr-3": !!label,
                  "h-6 min-h-[1.5rem] w-6 min-w-[1.5rem]": size === "lg",
                  "h-4 min-h-[1rem] w-4 min-w-[1rem]": size === "sm"
                }
              ),
              children: [
                /* @__PURE__ */ jsx28(
                  "input",
                  {
                    ref: mergeRefs(ref, inputRef),
                    id,
                    name,
                    type: "radio",
                    "aria-invalid": !!error,
                    disabled,
                    className: clsx20(
                      "absolute",
                      "top-0",
                      "left-0",
                      "w-full",
                      "h-full",
                      "appearance-none",
                      "rounded-full",
                      "bg-neutral-0",
                      "border-1.5",
                      "border-neutral-80",
                      "outline-none",
                      "checked:bg-neutral-80",
                      "focus:ring-2 focus:ring-offset-2 focus:ring-focus",
                      "active:ring-2 active:ring-offset-2 active:ring-focus",
                      "disabled:checked:bg-neutral-50 disabled:border-neutral-50",
                      {
                        ["hover:border-neutral-70 hover:checked:bg-neutral-70"]: !disabled && !error,
                        ["border-neutral-70 ring-2 ring-offset-2 ring-warning-50"]: !!error
                      },
                      "peer"
                    ),
                    ...props
                  }
                ),
                /* @__PURE__ */ jsx28(
                  "span",
                  {
                    className: clsx20(
                      "relative",
                      "bg-neutral-0",
                      "rounded-full",
                      "pointer-events-none",
                      {
                        "w-3 h-3": size === "lg",
                        "w-2 h-2": size === "sm"
                      },
                      "opacity-0",
                      "peer-checked:opacity-100"
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    error && !suppressErrorMessage && /* @__PURE__ */ jsx28(Alert, { type: "warning", message: error, inline: true })
  ] });
});

// src/components/forms/range/index.ts
init_react_shim();

// src/components/forms/range/Range.tsx
init_react_shim();
import { useState as useState4 } from "react";
import { jsx as jsx29 } from "react/jsx-runtime";
function RangeInput({
  label,
  min,
  max,
  value,
  onChange
}) {
  const [currentValue, setValue] = useState4(value || 0);
  const handleChange = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };
  return /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29("label", { children: label || "Range input" }) });
}

// src/components/forms/select/index.ts
init_react_shim();

// src/components/forms/select/Select.tsx
init_react_shim();
import { forwardRef as forwardRef10, useState as useState5, useRef as useRef5, useId as useId4, isValidElement as isValidElement2 } from "react";
import clsx21 from "clsx";
import { XMarkIcon as XMarkIcon2, ChevronDownIcon } from "@heroicons/react/24/outline";
import { jsx as jsx30, jsxs as jsxs24 } from "react/jsx-runtime";
var Select = forwardRef10(function Select2({
  name,
  label,
  icon,
  helperText,
  error,
  resetField,
  className,
  children,
  ...props
}, ref) {
  const id = useId4();
  const inputRef = useRef5(null);
  const [hasValue, setHasValue] = useState5(
    !!(props.value || props.defaultValue)
  );
  function resetHandler(event) {
    event.preventDefault();
    if (typeof resetField === "function") {
      resetField(name, {
        keepDirty: true,
        keepTouched: true
      });
    } else if (inputRef.current instanceof HTMLSelectElement) {
      inputRef.current.value === "";
      setHasValue(false);
    }
  }
  function changeHandler(event) {
    if (!hasValue && event.currentTarget.value) {
      setHasValue(true);
    }
    if (hasValue && !event.currentTarget.value) {
      setHasValue(false);
    }
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
  }
  const centeredContent = clsx21("flex justify-center items-center");
  return /* @__PURE__ */ jsxs24("div", { className: clsx21("text-neutral-80", className), children: [
    label && /* @__PURE__ */ jsx30("label", { htmlFor: props.id || id, className: clsx21("cap-base"), children: label }),
    /* @__PURE__ */ jsxs24("div", { className: clsx21("relative", "my-2"), children: [
      /* @__PURE__ */ jsxs24(
        "select",
        {
          ref: mergeRefs(ref, inputRef),
          id,
          name,
          "aria-invalid": !!error,
          className: clsx21(
            "appearance-none",
            !icon ? "pl-4" : "pl-12",
            "pr-12",
            "h-14",
            "w-full",
            "rounded-lg",
            "bg-neutral-0",
            "border-1.5",
            "border-neutral-60",
            "elevation-neutral-sm",
            "outline-none",
            "focus:border-neutral-80",
            "focus:ring-2 focus:ring-offset-2 focus:ring-focus",
            {
              ["hover:border-neutral-70 hover:ring-4 hover:ring-neutral-50 hover:checked:bg-neutral-70"]: !error,
              ["border-neutral-30 ring-2 ring-offset-2 ring-warning-50"]: !!error
            }
          ),
          ...props,
          onChange: changeHandler,
          children: [
            props.placeholder && /* @__PURE__ */ jsx30("option", { hidden: true, value: "", children: props.placeholder }),
            children
          ]
        }
      ),
      isValidElement2(icon) && /* @__PURE__ */ jsx30(
        "span",
        {
          className: clsx21(
            "absolute",
            "top-0",
            "left-0",
            "w-12",
            "h-full",
            centeredContent
          ),
          children: icon
        }
      ),
      hasValue && typeof resetHandler === "function" && /* @__PURE__ */ jsx30(
        "button",
        {
          onClick: (event) => {
            setHasValue(false);
            resetHandler(event);
          },
          className: clsx21(
            "absolute",
            "top-0",
            "right-10",
            "w-12",
            "h-full",
            centeredContent
          ),
          children: /* @__PURE__ */ jsx30(XMarkIcon2, { className: clsx21("w-5", "h-5") })
        }
      ),
      /* @__PURE__ */ jsx30(
        "span",
        {
          className: clsx21(
            "absolute",
            "top-0",
            "right-3",
            "w-9",
            "h-full",
            "pointer-events-none",
            centeredContent
          ),
          children: /* @__PURE__ */ jsx30(ChevronDownIcon, { className: clsx21("w-5", "h-5") })
        }
      )
    ] }),
    helperText && /* @__PURE__ */ jsx30("p", { className: clsx21("cap-xs", "text-neutral-70"), children: helperText }),
    error && /* @__PURE__ */ jsx30(Alert, { type: "warning", message: error, inline: true })
  ] });
});

// src/components/forms/switch/index.ts
init_react_shim();

// src/components/forms/switch/Switch.tsx
init_react_shim();
import { Switch as HeadlessUiSwitch } from "@headlessui/react";
import { jsx as jsx31, jsxs as jsxs25 } from "react/jsx-runtime";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function Switch({ checked, onChange, title, disabled }) {
  return /* @__PURE__ */ jsxs25(
    HeadlessUiSwitch,
    {
      checked,
      disabled,
      onChange,
      className: classNames(
        checked ? "bg-neutral-80 border-neutral-80" : "bg-neutral-50 border-neutral-50",
        disabled ? "opacity-30" : "opacity-100",
        "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-80"
      ),
      children: [
        /* @__PURE__ */ jsx31("span", { className: "sr-only", children: title }),
        /* @__PURE__ */ jsx31(
          "span",
          {
            "aria-hidden": "true",
            className: classNames(
              checked ? "translate-x-5" : "translate-x-0",
              "pointer-events-none inline-block h-5 w-5 rounded-full bg-neutral-0 shadow transform ring-0 transition ease-in-out duration-200"
            )
          }
        )
      ]
    }
  );
}

// src/components/loading/index.ts
init_react_shim();

// src/components/loading/Loading.tsx
init_react_shim();

// src/components/spinner/index.ts
init_react_shim();

// src/components/loading/Loading.tsx
import { jsx as jsx32, jsxs as jsxs26 } from "react/jsx-runtime";
function Loading({ fullscreen, cover, showBackground }) {
  return /* @__PURE__ */ jsxs26(
    "div",
    {
      className: `
      ${fullscreen ? "top-0 left-0 fixed h-screen w-screen z-50" : ""}
      ${cover ? "top-0 left-0 fixed h-full w-full z-50" : ""}
      flex items-center justify-center text-center
      ${showBackground ? " bg-black/30" : ""}
    `,
      children: [
        /* @__PURE__ */ jsx32(
          "div",
          {
            className: `
        ${fullscreen ? "top-0 left-0 fixed h-screen w-screen z-50" : ""}
        ${cover ? "top-0 left-0 fixed h-full w-full z-50" : ""}
        flex items-center justify-center text-center
        ${showBackground ? "bg-primary-lighten-60 opacity-20" : ""}
      `
          }
        ),
        /* @__PURE__ */ jsx32(Spinner, {})
      ]
    }
  );
}

// src/components/logo/index.ts
init_react_shim();

// src/components/logo/icon/index.ts
init_react_shim();

// src/components/logo/icon/Icon.tsx
init_react_shim();
import { jsx as jsx33, jsxs as jsxs27 } from "react/jsx-runtime";
function LogoIcon({ className }) {
  return /* @__PURE__ */ jsxs27(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 666.7 666.7",
      className: `icon ${className || ""}`,
      children: [
        /* @__PURE__ */ jsx33("path", { fill: "currentColor", d: "M666.7 666.7H0V0h666.7v666.7" }),
        /* @__PURE__ */ jsx33(
          "path",
          {
            fill: "#fff",
            d: "M432.3 165.2H153.8c-3.7 0-5.8 1.8-5.8 5.8v325.3c0 2.9 1 5.4 5 5.4h211.1c3.6 0 5.4-2.5 5.4-5.6V304.9h-14c-2.7 0-2.8-3-2.8-3v-36.4s0-2.6 2.7-2.6h14c0-39.6 16.6-81.6 63.1-94 2-.7 1.7-3.7-.2-3.7"
          }
        ),
        /* @__PURE__ */ jsx33(
          "path",
          {
            fill: "#fff",
            d: "M508.7 301.9v-36.2c-.1-.6-.5-2.8-3-2.8h-32c0-43 27-50.4 42.7-51 .3 0 2.3.2 2.3-1.9v-43.2c0-1.9-1.9-1.8-2.3-1.8-45.3.7-90 32.6-90 98h-18.7c-3.3 0-3 3.1-3 3.1v36s0 2.8 3 2.8h18.7v192.8s.2 4 4.4 4h38c4.9 0 5-4.4 5-4.4V305h31.5c2.2 0 3.4-1.4 3.4-3"
          }
        )
      ]
    }
  );
}
function SuccessIcon({ className, ...props }) {
  return /* @__PURE__ */ jsxs27(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      className: `icon ${className || ""}`,
      ...props,
      children: [
        /* @__PURE__ */ jsx33("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }),
        /* @__PURE__ */ jsx33(
          "path",
          {
            fill: "#fff",
            d: "M8.6 13.3l-.4-.2-2.5-2.5a.6.6 0 010-.8c.2-.2.5-.2.8 0l2 2 5-4.9c.3-.2.6-.2.9 0 .2.2.2.6 0 .8L9 13.1l-.4.2z"
          }
        )
      ]
    }
  );
}

// src/components/logo/logo/index.ts
init_react_shim();

// src/components/logo/logo/Logo.tsx
init_react_shim();
import { jsx as jsx34 } from "react/jsx-runtime";
function Logo({ className = "", ...props }) {
  return /* @__PURE__ */ jsx34(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 77 16",
      className,
      ...props,
      children: /* @__PURE__ */ jsx34(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.641 3.643c.017-.93.417-1.614 1.664-1.614h.5V0H4.87C2.66 0 1.462 1.33 1.462 3.658v.576H0v1.697h1.463V12H3.64V5.92h1.697V4.224H3.64v-.581zm8.3 1.612c-.517-.798-1.515-1.23-2.528-1.23-1.98 0-3.776 1.712-3.776 4.09 0 2.512 1.83 4.075 3.741 4.075 1.033 0 2.046-.515 2.562-1.313v1.113h2.179V4.224H11.94v1.031zm-2.08 4.906a2.054 2.054 0 11-.084-4.106 2.054 2.054 0 01.085 4.106zm9.296-6.136c.881 0 1.929.363 2.495 1.13v-.93h2.175v6.802c0 3.391-1.714 4.973-4.457 4.973a4.108 4.108 0 01-3.771-2.38l1.811-.781a2.2 2.2 0 001.964 1.214c1.395 0 2.278-.783 2.278-2.794v-.22c-.566.767-1.63 1.15-2.495 1.15-1.996 0-3.808-1.594-3.808-4.09 0-2.494 1.812-4.074 3.808-4.074zm-1.013 5.518c.377.386.89.608 1.43.618A2.013 2.013 0 1017.56 8.1a2.051 2.051 0 00.584 1.443zm16.844-5.518c-.798 0-1.994.384-2.593 1.512-.45-.946-1.344-1.512-2.495-1.512-.864 0-1.962.532-2.196 1.597V4.225h-2.178v7.765h2.178V7.9c0-1.397.798-1.83 1.58-1.83.733 0 1.364.533 1.364 1.763v4.157h2.179V7.883c.05-1.18.666-1.83 1.535-1.812.768 0 1.398.514 1.398 1.727v4.19h2.19V7.733c0-2.328-1.016-3.708-2.962-3.708zm11.608-.033l.714.699-.82.835c.59.734.908 1.65.899 2.593 0 2.445-1.964 4.075-4.175 4.075a4.32 4.32 0 01-2.478-.768l-.88.913-.717-.713.855-.866a4.075 4.075 0 01-.949-2.645c0-2.46 1.962-4.09 4.175-4.09.913 0 1.803.285 2.545.816l.831-.849zm-3.382 2.062c-1.08 0-1.963.848-1.963 2.061a2.19 2.19 0 00.267 1.065l2.76-2.81a1.988 1.988 0 00-1.064-.316zm-.98 3.842c.297.174.636.266.98.265h.006c1.08 0 1.962-.848 1.956-2.046a2.148 2.148 0 00-.232-.996l-2.71 2.777zm11.08-5.871c-.881 0-1.946.35-2.495 1.13V0H48.64v11.99h2.179v-.96c.549.799 1.614 1.164 2.495 1.164 1.996 0 3.808-1.595 3.808-4.09 0-2.496-1.812-4.08-3.808-4.08zm-.416 6.142a2.054 2.054 0 110-4.108 2.013 2.013 0 011.996 2.046 2.039 2.039 0 01-1.996 2.056v.006zM58.337 0h2.178v11.99h-2.178V0zm7.531 4.025c-2.228 0-4.124 1.58-4.124 4.09 0 2.395 1.746 4.075 4.124 4.075 1.365 0 2.728-.576 3.455-1.563L68.047 9.34a2.736 2.736 0 01-2.037.92c-1.047 0-1.779-.53-2.011-1.446h5.854c.005-.101.01-.195.013-.283.01-.216.02-.394.02-.548.007-2.378-1.806-3.958-4.018-3.958zM64.007 7.4c.232-1.048 1.013-1.497 1.894-1.497.983 0 1.747.576 1.814 1.497h-3.708zm9.228-1.514c.432-1.296 1.319-1.862 2.278-1.862a2.77 2.77 0 011.23.255l-.498 2.079a2.251 2.251 0 00-1.114-.282c-1.111 0-1.879 1.051-1.879 3.263v2.65h-2.178V4.224h2.161v1.663z",
          clipRule: "evenodd"
        }
      )
    }
  );
}

// src/components/modals/index.ts
init_react_shim();

// src/components/modals/drawer/index.ts
init_react_shim();

// src/components/modals/drawer/Drawer.tsx
init_react_shim();
import { Fragment as Fragment4, useEffect as useEffect2 } from "react";
import { Transition } from "@headlessui/react";
import { XMarkIcon as XMarkIcon3 } from "@heroicons/react/24/outline";
import { jsx as jsx35, jsxs as jsxs28 } from "react/jsx-runtime";
function DrawerModal({
  title,
  description,
  position = "right",
  isOpen,
  children,
  onClose,
  unmount,
  hideHeader = false,
  className = "",
  closeOnEscape
}) {
  const handleKeyDown = (event) => {
    event.code === "Escape" && onClose();
  };
  useEffect2(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, closeOnEscape]);
  return /* @__PURE__ */ jsx35(Transition.Root, { show: isOpen, as: Fragment4, unmount, children: /* @__PURE__ */ jsx35("div", { className: "fixed inset-0 overflow-hidden z-50", onClick: onClose, children: /* @__PURE__ */ jsxs28("div", { className: `absolute inset-0 overflow-hidden`, children: [
    /* @__PURE__ */ jsx35(
      Transition.Child,
      {
        as: Fragment4,
        enter: "ease-in-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-70",
        leave: "ease-in-out duration-300",
        leaveFrom: "opacity-70",
        leaveTo: "opacity-0",
        unmount,
        children: /* @__PURE__ */ jsx35("div", { className: "absolute inset-0 h-screen w-screen bg-neutral-70 opacity-50" })
      }
    ),
    /* @__PURE__ */ jsx35(
      "div",
      {
        onClick: (event) => event.stopPropagation(),
        className: `
              fixed inset-y-0 max-w-full flex
              ${position === "left" ? "left-0" : "right-0"}
              ${className}
          `,
        children: /* @__PURE__ */ jsx35(
          Transition.Child,
          {
            as: Fragment4,
            unmount,
            enter: "transform transition ease-in-out duration-150",
            enterFrom: position === "right" ? "translate-x-full" : "-translate-x-full",
            enterTo: "translate-x-0",
            leave: "transform transition ease-in-out duration-300",
            leaveFrom: "translate-x-0",
            leaveTo: position === "right" ? "translate-x-full" : "-translate-x-full",
            children: /* @__PURE__ */ jsx35("div", { className: "w-[calc(100vw-4rem)] max-w-[450px]", children: /* @__PURE__ */ jsxs28("div", { className: "h-full flex flex-col bg-white shadow-xl overflow-hidden overflow-y-scroll scrollbar-hide", children: [
              !hideHeader && title && /* @__PURE__ */ jsxs28("div", { className: "p-4 md:p-6 border-b border-neutral-40", children: [
                /* @__PURE__ */ jsxs28("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ jsx35("h3", { className: "hd-md -mb-1.5", children: title }),
                  /* @__PURE__ */ jsx35("div", { className: "h-7 w-7 flex items-center", children: /* @__PURE__ */ jsxs28(
                    IconButton,
                    {
                      size: "md",
                      onClick: onClose,
                      variant: "ghost-muted",
                      children: [
                        /* @__PURE__ */ jsx35("span", { className: "sr-only", children: "Lukk" }),
                        /* @__PURE__ */ jsx35(XMarkIcon3, { className: "h-4 w-4", "aria-hidden": "true" })
                      ]
                    }
                  ) })
                ] }),
                /* @__PURE__ */ jsx35("div", { className: "mt-1", children: description })
              ] }),
              !hideHeader && !title && /* @__PURE__ */ jsx35("div", { className: "flex justify-end items-center min-h-[4rem]", children: /* @__PURE__ */ jsxs28(
                IconButton,
                {
                  size: "md",
                  onClick: onClose,
                  className: "mr-5",
                  variant: "ghost-muted",
                  children: [
                    /* @__PURE__ */ jsx35("span", { className: "sr-only", children: "Lukk" }),
                    /* @__PURE__ */ jsx35(XMarkIcon3, { className: "h-4 w-4", "aria-hidden": "true" })
                  ]
                }
              ) }),
              /* @__PURE__ */ jsx35("div", { className: "relative flex-1", children })
            ] }) })
          }
        )
      }
    )
  ] }) }) });
}

// src/components/modals/modal/index.ts
init_react_shim();

// src/components/modals/modal/Modal.tsx
init_react_shim();
import { Fragment as Fragment5 } from "react";
import { XMarkIcon as XMarkIcon4 } from "@heroicons/react/24/outline";

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/RSPContexts.mjs
init_react_shim();
import { createContext as $95phC$createContext } from "react";
var $4e85f108e88277b8$export$b085522c77523c51 = (0, $95phC$createContext)(null);
var $4e85f108e88277b8$export$ebe63fadcdce34ed = (0, $95phC$createContext)(null);
var $4e85f108e88277b8$export$44644b8a16031b5b = (0, $95phC$createContext)(null);
var $4e85f108e88277b8$export$717b2c0a523a0b53 = (0, $95phC$createContext)(null);
var $4e85f108e88277b8$export$265015d6dc85bf21 = (0, $95phC$createContext)(null);
var $4e85f108e88277b8$export$d688439359537581 = (0, $95phC$createContext)({});

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/utils.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useId.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useLayoutEffect.mjs
init_react_shim();
import $HgANd$react from "react";
var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, $HgANd$react).useLayoutEffect : () => {
};

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useValueEffect.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useEffectEvent.mjs
init_react_shim();
import { useRef as $lmaYr$useRef, useCallback as $lmaYr$useCallback } from "react";
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
  const ref = (0, $lmaYr$useRef)(null);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    ref.current = fn;
  }, [
    fn
  ]);
  return (0, $lmaYr$useCallback)((...args) => {
    const f = ref.current;
    return f === null || f === void 0 ? void 0 : f(...args);
  }, []);
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useValueEffect.mjs
import { useState as $fCAlL$useState, useRef as $fCAlL$useRef } from "react";
function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
  let [value, setValue] = (0, $fCAlL$useState)(defaultValue);
  let effect = (0, $fCAlL$useRef)(null);
  let nextRef = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)(() => {
    if (!effect.current)
      return;
    let newValue = effect.current.next();
    if (newValue.done) {
      effect.current = null;
      return;
    }
    if (value === newValue.value)
      nextRef();
    else
      setValue(newValue.value);
  });
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (effect.current)
      nextRef();
  });
  let queue = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)((fn) => {
    effect.current = fn(value);
    nextRef();
  });
  return [
    value,
    queue
  ];
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useId.mjs
import { useState as $eKkEp$useState, useRef as $eKkEp$useRef, useCallback as $eKkEp$useCallback, useEffect as $eKkEp$useEffect } from "react";

// ../../node_modules/.pnpm/@react-aria+ssr@3.9.7_react@18.3.1/node_modules/@react-aria/ssr/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+ssr@3.9.7_react@18.3.1/node_modules/@react-aria/ssr/dist/SSRProvider.mjs
init_react_shim();
import $670gB$react, { useContext as $670gB$useContext, useState as $670gB$useState, useMemo as $670gB$useMemo, useLayoutEffect as $670gB$useLayoutEffect, useRef as $670gB$useRef } from "react";
var $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
};
var $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */ (0, $670gB$react).createContext($b5e257d569688ac6$var$defaultContext);
var $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */ (0, $670gB$react).createContext(false);
var $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $b5e257d569688ac6$var$componentIds = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
  let ctx = (0, $670gB$useContext)($b5e257d569688ac6$var$SSRContext);
  let ref = (0, $670gB$useRef)(null);
  if (ref.current === null && !isDisabled) {
    var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, $670gB$react).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
    if (currentOwner) {
      let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
      if (prevComponentValue == null)
        $b5e257d569688ac6$var$componentIds.set(currentOwner, {
          id: ctx.current,
          state: currentOwner.memoizedState
        });
      else if (currentOwner.memoizedState !== prevComponentValue.state) {
        ctx.current = prevComponentValue.id;
        $b5e257d569688ac6$var$componentIds.delete(currentOwner);
      }
    }
    ref.current = ++ctx.current;
  }
  return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
  let ctx = (0, $670gB$useContext)($b5e257d569688ac6$var$SSRContext);
  if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM)
    console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
  let prefix = ctx === $b5e257d569688ac6$var$defaultContext && false ? "react-aria" : `react-aria${ctx.prefix}`;
  return defaultId || `${prefix}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
  let id = (0, $670gB$react).useId();
  let [didSSR] = (0, $670gB$useState)($b5e257d569688ac6$export$535bd6ca7f90a273());
  let prefix = didSSR || false ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return defaultId || `${prefix}-${id}`;
}
var $b5e257d569688ac6$export$619500959fc48b26 = typeof (0, $670gB$react)["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return true;
}
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  if (typeof (0, $670gB$react)["useSyncExternalStore"] === "function")
    return (0, $670gB$react)["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
  return (0, $670gB$useContext)($b5e257d569688ac6$var$IsSSRContext);
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useId.mjs
var $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $bdb11010cef70236$var$idsUpdaterMap = /* @__PURE__ */ new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  let [value, setValue] = (0, $eKkEp$useState)(defaultId);
  let nextId = (0, $eKkEp$useRef)(null);
  let res = (0, $b5e257d569688ac6$export$619500959fc48b26)(value);
  let updateValue = (0, $eKkEp$useCallback)((val) => {
    nextId.current = val;
  }, []);
  if ($bdb11010cef70236$var$canUseDOM) {
    if ($bdb11010cef70236$var$idsUpdaterMap.has(res) && !$bdb11010cef70236$var$idsUpdaterMap.get(res).includes(updateValue))
      $bdb11010cef70236$var$idsUpdaterMap.set(res, [
        ...$bdb11010cef70236$var$idsUpdaterMap.get(res),
        updateValue
      ]);
    else
      $bdb11010cef70236$var$idsUpdaterMap.set(res, [
        updateValue
      ]);
  }
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let r = res;
    return () => {
      $bdb11010cef70236$var$idsUpdaterMap.delete(r);
    };
  }, [
    res
  ]);
  (0, $eKkEp$useEffect)(() => {
    let newId = nextId.current;
    if (newId) {
      nextId.current = null;
      setValue(newId);
    }
  });
  return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB)
    return idA;
  let setIdsA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
  if (setIdsA) {
    setIdsA.forEach((fn) => fn(idB));
    return idB;
  }
  let setIdsB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
  if (setIdsB) {
    setIdsB.forEach((fn) => fn(idA));
    return idA;
  }
  return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(depArray = []) {
  let id = $bdb11010cef70236$export$f680877a34711e37();
  let [resolvedId, setResolvedId] = (0, $1dbecbe27a04f9af$export$14d238f342723f25)(id);
  let updateId = (0, $eKkEp$useCallback)(() => {
    setResolvedId(function* () {
      yield id;
      yield document.getElementById(id) ? id : void 0;
    });
  }, [
    id,
    setResolvedId
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(updateId, [
    id,
    updateId,
    ...depArray
  ]);
  return resolvedId;
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/chain.mjs
init_react_shim();
function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
  return (...args) => {
    for (let callback of callbacks)
      if (typeof callback === "function")
        callback(...args);
  };
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/domHelpers.mjs
init_react_shim();
var $431fbd86ca7dc216$export$b204af158042fbac = (el) => {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
var $431fbd86ca7dc216$export$f21a1ffae260145a = (el) => {
  if (el && "window" in el && el.window === el)
    return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
};

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/mergeProps.mjs
init_react_shim();
import $7jXr9$clsx from "clsx";
function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
  let result = {
    ...args[0]
  };
  for (let i = 1; i < args.length; i++) {
    let props = args[i];
    for (let key in props) {
      let a = result[key];
      let b = props[key];
      if (typeof a === "function" && typeof b === "function" && key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= 65 && key.charCodeAt(2) <= 90)
        result[key] = (0, $ff5963eb1fccf552$export$e08e3b67e392101e)(a, b);
      else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string")
        result[key] = (0, $7jXr9$clsx)(a, b);
      else if (key === "id" && a && b)
        result.id = (0, $bdb11010cef70236$export$cd8c9cb68f842629)(a, b);
      else
        result[key] = b !== void 0 ? b : a;
    }
  }
  return result;
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/mergeRefs.mjs
init_react_shim();
function $5dc95899b306f630$export$c9058316764c140e(...refs) {
  if (refs.length === 1 && refs[0])
    return refs[0];
  return (value) => {
    for (let ref of refs) {
      if (typeof ref === "function")
        ref(value);
      else if (ref != null)
        ref.current = value;
    }
  };
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/filterDOMProps.mjs
init_react_shim();
var $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]);
var $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]);
var $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]);
var $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {}) {
  let { labelable, isLink, propNames } = opts;
  let filteredProps = {};
  for (const prop in props)
    if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop)))
      filteredProps[prop] = props[prop];
  return filteredProps;
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/focusWithoutScrolling.mjs
init_react_shim();
function $7215afc6de606d6b$export$de79e2c695e052f3(element2) {
  if ($7215afc6de606d6b$var$supportsPreventScroll())
    element2.focus({
      preventScroll: true
    });
  else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element2);
    element2.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}
var $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;
    try {
      let focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element2) {
  let parent = element2.parentNode;
  let scrollableElements = [];
  let rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth)
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement)
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  for (let { element: element2, scrollTop, scrollLeft } of scrollableElements) {
    element2.scrollTop = scrollTop;
    element2.scrollLeft = scrollLeft;
  }
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/platform.mjs
init_react_shim();
function $c87311424ea30a05$var$testUserAgent(re) {
  var _window_navigator_userAgentData;
  if (typeof window === "undefined" || window.navigator == null)
    return false;
  return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand) => re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
  var _window_navigator_userAgentData;
  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$var$cached(fn) {
  let res = null;
  return () => {
    if (res == null)
      res = fn();
    return res;
  };
}
var $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
});
var $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
var $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
var $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
});
var $c87311424ea30a05$export$e1865c3bedcd822b = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
});
var $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
});
var $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
var $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
});
var $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
});

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/runAfterTransition.mjs
init_react_shim();
var $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map();
var $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === "undefined")
    return;
  function isTransitionEvent(event) {
    return "propertyName" in event;
  }
  let onTransitionStart = (e) => {
    if (!isTransitionEvent(e) || !e.target)
      return;
    let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!transitions) {
      transitions = /* @__PURE__ */ new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
      e.target.addEventListener("transitioncancel", onTransitionEnd, {
        once: true
      });
    }
    transitions.add(e.propertyName);
  };
  let onTransitionEnd = (e) => {
    if (!isTransitionEvent(e) || !e.target)
      return;
    let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!properties)
      return;
    properties.delete(e.propertyName);
    if (properties.size === 0) {
      e.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
    }
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks)
        cb();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
  if (document.readyState !== "loading")
    $bbed8b41f857bcc0$var$setupGlobalEvents();
  else
    document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  requestAnimationFrame(() => {
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0)
      fn();
    else
      $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useLabels.mjs
init_react_shim();
function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
  let { id, "aria-label": label, "aria-labelledby": labelledBy } = props;
  id = (0, $bdb11010cef70236$export$f680877a34711e37)(id);
  if (labelledBy && label) {
    let ids = /* @__PURE__ */ new Set([
      id,
      ...labelledBy.trim().split(/\s+/)
    ]);
    labelledBy = [
      ...ids
    ].join(" ");
  } else if (labelledBy)
    labelledBy = labelledBy.trim().split(/\s+/).join(" ");
  if (!label && !labelledBy && defaultLabel)
    label = defaultLabel;
  return {
    id,
    "aria-label": label,
    "aria-labelledby": labelledBy
  };
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useObjectRef.mjs
init_react_shim();
import { useRef as $gbmns$useRef, useMemo as $gbmns$useMemo } from "react";
function $df56164dff5785e2$export$4338b53315abf666(forwardedRef) {
  const objRef = (0, $gbmns$useRef)(null);
  return (0, $gbmns$useMemo)(() => ({
    get current() {
      return objRef.current;
    },
    set current(value) {
      objRef.current = value;
      if (typeof forwardedRef === "function")
        forwardedRef(value);
      else if (forwardedRef)
        forwardedRef.current = value;
    }
  }), [
    forwardedRef
  ]);
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/getScrollParent.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/isScrollable.mjs
init_react_shim();
function $cc38e7bd3fc7b213$export$2bb74740c4e19def(node, checkForOverflow) {
  if (!node)
    return false;
  let style = window.getComputedStyle(node);
  let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
  if (isScrollable && checkForOverflow)
    isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
  return isScrollable;
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/getScrollParent.mjs
function $62d8ded9296f3872$export$cfa2225e87938781(node, checkForOverflow) {
  let scrollableNode = node;
  if ((0, $cc38e7bd3fc7b213$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))
    scrollableNode = scrollableNode.parentElement;
  while (scrollableNode && !(0, $cc38e7bd3fc7b213$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))
    scrollableNode = scrollableNode.parentElement;
  return scrollableNode || document.scrollingElement || document.documentElement;
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/useViewportSize.mjs
init_react_shim();
import { useState as $fuDHA$useState, useEffect as $fuDHA$useEffect } from "react";
var $5df64b3807dc15ee$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $5df64b3807dc15ee$export$d699905dd57c73ca() {
  let isSSR = (0, $b5e257d569688ac6$export$535bd6ca7f90a273)();
  let [size, setSize] = (0, $fuDHA$useState)(() => isSSR ? {
    width: 0,
    height: 0
  } : $5df64b3807dc15ee$var$getViewportSize());
  (0, $fuDHA$useEffect)(() => {
    let onResize = () => {
      setSize((size2) => {
        let newSize = $5df64b3807dc15ee$var$getViewportSize();
        if (newSize.width === size2.width && newSize.height === size2.height)
          return size2;
        return newSize;
      });
    };
    if (!$5df64b3807dc15ee$var$visualViewport)
      window.addEventListener("resize", onResize);
    else
      $5df64b3807dc15ee$var$visualViewport.addEventListener("resize", onResize);
    return () => {
      if (!$5df64b3807dc15ee$var$visualViewport)
        window.removeEventListener("resize", onResize);
      else
        $5df64b3807dc15ee$var$visualViewport.removeEventListener("resize", onResize);
    };
  }, []);
  return size;
}
function $5df64b3807dc15ee$var$getViewportSize() {
  return {
    width: $5df64b3807dc15ee$var$visualViewport && ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
    height: $5df64b3807dc15ee$var$visualViewport && ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
  };
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/isVirtualEvent.mjs
init_react_shim();
function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.mozInputSource === 0 && event.isTrusted)
    return true;
  if ((0, $c87311424ea30a05$export$a11b0059900ceec8)() && event.pointerType)
    return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}

// ../../node_modules/.pnpm/@react-aria+utils@3.27.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/utils/dist/animation.mjs
init_react_shim();
import { flushSync as $jJMAe$flushSync } from "react-dom";
import { useState as $jJMAe$useState, useCallback as $jJMAe$useCallback } from "react";
function $d3f049242431219c$export$6d3443f2c48bfc20(ref, isReady = true) {
  let [isEntering, setEntering] = (0, $jJMAe$useState)(true);
  let isAnimationReady = isEntering && isReady;
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (isAnimationReady && ref.current && "getAnimations" in ref.current) {
      for (let animation of ref.current.getAnimations())
        if (animation instanceof CSSTransition)
          animation.cancel();
    }
  }, [
    ref,
    isAnimationReady
  ]);
  $d3f049242431219c$var$useAnimation(ref, isAnimationReady, (0, $jJMAe$useCallback)(() => setEntering(false), []));
  return isAnimationReady;
}
function $d3f049242431219c$export$45fda7c47f93fd48(ref, isOpen) {
  let [exitState, setExitState] = (0, $jJMAe$useState)(isOpen ? "open" : "closed");
  switch (exitState) {
    case "open":
      if (!isOpen)
        setExitState("exiting");
      break;
    case "closed":
    case "exiting":
      if (isOpen)
        setExitState("open");
      break;
  }
  let isExiting = exitState === "exiting";
  $d3f049242431219c$var$useAnimation(ref, isExiting, (0, $jJMAe$useCallback)(() => {
    setExitState((state) => state === "exiting" ? "closed" : state);
  }, []));
  return isExiting;
}
function $d3f049242431219c$var$useAnimation(ref, isActive, onEnd) {
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (isActive && ref.current) {
      if (!("getAnimations" in ref.current)) {
        onEnd();
        return;
      }
      let animations = ref.current.getAnimations();
      if (animations.length === 0) {
        onEnd();
        return;
      }
      let canceled = false;
      Promise.all(animations.map((a) => a.finished)).then(() => {
        if (!canceled)
          (0, $jJMAe$flushSync)(() => {
            onEnd();
          });
      }).catch(() => {
      });
      return () => {
        canceled = true;
      };
    }
  }, [
    ref,
    isActive,
    onEnd
  ]);
}

// ../../node_modules/.pnpm/@react-stately+utils@3.10.5_react@18.3.1/node_modules/@react-stately/utils/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-stately+utils@3.10.5_react@18.3.1/node_modules/@react-stately/utils/dist/useControlledState.mjs
init_react_shim();
import { useState as $3whtM$useState, useRef as $3whtM$useRef, useEffect as $3whtM$useEffect, useCallback as $3whtM$useCallback } from "react";
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
  let [stateValue, setStateValue] = (0, $3whtM$useState)(value || defaultValue);
  let isControlledRef = (0, $3whtM$useRef)(value !== void 0);
  let isControlled = value !== void 0;
  (0, $3whtM$useEffect)(() => {
    let wasControlled = isControlledRef.current;
    if (wasControlled !== isControlled)
      console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    isControlledRef.current = isControlled;
  }, [
    isControlled
  ]);
  let currentValue = isControlled ? value : stateValue;
  let setValue = (0, $3whtM$useCallback)((value2, ...args) => {
    let onChangeCaller = (value3, ...onChangeArgs) => {
      if (onChange) {
        if (!Object.is(currentValue, value3))
          onChange(value3, ...onChangeArgs);
      }
      if (!isControlled)
        currentValue = value3;
    };
    if (typeof value2 === "function") {
      console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
      let updateFunction = (oldValue, ...functionArgs) => {
        let interceptedValue = value2(isControlled ? currentValue : oldValue, ...functionArgs);
        onChangeCaller(interceptedValue, ...args);
        if (!isControlled)
          return interceptedValue;
        return oldValue;
      };
      setStateValue(updateFunction);
    } else {
      if (!isControlled)
        setStateValue(value2);
      onChangeCaller(value2, ...args);
    }
  }, [
    isControlled,
    currentValue,
    onChange
  ]);
  return [
    currentValue,
    setValue
  ];
}

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/utils.mjs
import $iETbY$react, { useMemo as $iETbY$useMemo, useContext as $iETbY$useContext, useState as $iETbY$useState, useRef as $iETbY$useRef, useCallback as $iETbY$useCallback } from "react";
var $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol("default");
function $64fa3d84918910a7$export$2881499e37b75b9a({ values, children }) {
  for (let [Context, value] of values)
    children = /* @__PURE__ */ (0, $iETbY$react).createElement(Context.Provider, {
      value
    }, children);
  return children;
}
function $64fa3d84918910a7$export$4d86445c2cf5e3(props) {
  let { className, style, children, defaultClassName, defaultChildren, defaultStyle, values } = props;
  return (0, $iETbY$useMemo)(() => {
    let computedClassName;
    let computedStyle;
    let computedChildren;
    if (typeof className === "function")
      computedClassName = className({
        ...values,
        defaultClassName
      });
    else
      computedClassName = className;
    if (typeof style === "function")
      computedStyle = style({
        ...values,
        defaultStyle: defaultStyle || {}
      });
    else
      computedStyle = style;
    if (typeof children === "function")
      computedChildren = children({
        ...values,
        defaultChildren
      });
    else if (children == null)
      computedChildren = defaultChildren;
    else
      computedChildren = children;
    return {
      className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
      style: computedStyle || defaultStyle ? {
        ...defaultStyle,
        ...computedStyle
      } : void 0,
      children: computedChildren !== null && computedChildren !== void 0 ? computedChildren : defaultChildren,
      "data-rac": ""
    };
  }, [
    className,
    style,
    children,
    defaultClassName,
    defaultChildren,
    defaultStyle,
    values
  ]);
}
function $64fa3d84918910a7$export$fabf2dc03a41866e(context, slot) {
  let ctx = (0, $iETbY$useContext)(context);
  if (slot === null)
    return null;
  if (ctx && typeof ctx === "object" && "slots" in ctx && ctx.slots) {
    let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p) => `"${p}"`));
    if (!slot && !ctx.slots[$64fa3d84918910a7$export$c62b8e45d58ddad9])
      throw new Error(`A slot prop is required. Valid slot names are ${availableSlots}.`);
    let slotKey = slot || $64fa3d84918910a7$export$c62b8e45d58ddad9;
    if (!ctx.slots[slotKey])
      throw new Error(`Invalid slot "${slot}". Valid slot names are ${availableSlots}.`);
    return ctx.slots[slotKey];
  }
  return ctx;
}
function $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, context) {
  let ctx = $64fa3d84918910a7$export$fabf2dc03a41866e(context, props.slot) || {};
  let { ref: contextRef, ...contextProps } = ctx;
  let mergedRef = (0, $df56164dff5785e2$export$4338b53315abf666)((0, $iETbY$useMemo)(() => (0, $5dc95899b306f630$export$c9058316764c140e)(ref, contextRef), [
    ref,
    contextRef
  ]));
  let mergedProps = (0, $3ef42575df84b30b$export$9d1611c77c2fe928)(contextProps, props);
  if ("style" in contextProps && contextProps.style && "style" in props && props.style) {
    if (typeof contextProps.style === "function" || typeof props.style === "function")
      mergedProps.style = (renderProps) => {
        let contextStyle = typeof contextProps.style === "function" ? contextProps.style(renderProps) : contextProps.style;
        let defaultStyle = {
          ...renderProps.defaultStyle,
          ...contextStyle
        };
        let style = typeof props.style === "function" ? props.style({
          ...renderProps,
          defaultStyle
        }) : props.style;
        return {
          ...defaultStyle,
          ...style
        };
      };
    else
      mergedProps.style = {
        ...contextProps.style,
        ...props.style
      };
  }
  return [
    mergedProps,
    mergedRef
  ];
}

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/Button.mjs
init_react_shim();

// ../../node_modules/.pnpm/react-aria@3.37.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+focus@3.19.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/focus/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+focus@3.19.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/focus/dist/FocusScope.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+focus@3.19.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/focus/dist/focusSafely.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/context.mjs
init_react_shim();
import $3aeG1$react from "react";
var $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, $3aeG1$react).createContext({
  register: () => {
  }
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/PressResponder.mjs
init_react_shim();
import $87RPk$react, { useRef as $87RPk$useRef, useContext as $87RPk$useContext, useEffect as $87RPk$useEffect, useMemo as $87RPk$useMemo } from "react";
function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea({ children }) {
  let context = (0, $87RPk$useMemo)(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ (0, $87RPk$react).createElement((0, $ae1eeba8b9eafd08$export$5165eccb35aaadb5).Provider, {
    value: context
  }, children);
}

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/utils.mjs
init_react_shim();
import { useRef as $6dfIe$useRef, useCallback as $6dfIe$useCallback } from "react";
var $8a9cb279dc87e130$export$905e7fc544a71f36 = class {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = true;
    this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation();
    this.isPropagationStopped = () => true;
  }
  isPropagationStopped() {
    return false;
  }
  persist() {
  }
  constructor(type, nativeEvent) {
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }
};
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = (0, $6dfIe$useRef)({
    isFocused: false,
    observer: null
  });
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  let dispatchBlur = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)((e) => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  });
  return (0, $6dfIe$useCallback)((e) => {
    if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e.target;
      let onBlurHandler = (e2) => {
        stateRef.current.isFocused = false;
        if (target.disabled)
          dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e2));
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          var _stateRef_current_observer;
          (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
          let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
          target.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: relatedTargetEl
          }));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true,
            relatedTarget: relatedTargetEl
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    dispatchBlur
  ]);
}

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/useFocusVisible.mjs
init_react_shim();
import { useState as $28AnR$useState, useEffect as $28AnR$useEffect } from "react";
var $507fabe10e71c6fb$var$currentModality = null;
var $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set();
var $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map();
var $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers)
    handler(modality, e);
}
function $507fabe10e71c6fb$var$isValidKey(e) {
  return !(e.metaKey || !(0, $c87311424ea30a05$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if ($507fabe10e71c6fb$var$isValidKey(e)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
  $507fabe10e71c6fb$var$currentModality = "pointer";
  if (e.type === "mousedown" || e.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
  if ((0, $6a7db85432448f7f$export$60278871457622de)(e)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
  if (e.target === window || e.target === document)
    return;
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element2) {
  if (typeof window === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get((0, $431fbd86ca7dc216$export$f21a1ffae260145a)(element2)))
    return;
  const windowObject = (0, $431fbd86ca7dc216$export$f21a1ffae260145a)(element2);
  const documentObject = (0, $431fbd86ca7dc216$export$b204af158042fbac)(element2);
  let focus = windowObject.HTMLElement.prototype.focus;
  windowObject.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  windowObject.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element2);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
    focus
  });
}
var $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element2, loadListener) => {
  const windowObject = (0, $431fbd86ca7dc216$export$f21a1ffae260145a)(element2);
  const documentObject = (0, $431fbd86ca7dc216$export$b204af158042fbac)(element2);
  if (loadListener)
    documentObject.removeEventListener("DOMContentLoaded", loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject))
    return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
  documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element2) {
  const documentObject = (0, $431fbd86ca7dc216$export$b204af158042fbac)(element2);
  let loadListener;
  if (documentObject.readyState !== "loading")
    $507fabe10e71c6fb$var$setupGlobalFocusEvents(element2);
  else {
    loadListener = () => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents(element2);
    };
    documentObject.addEventListener("DOMContentLoaded", loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element2, loadListener);
}
if (typeof document !== "undefined")
  $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/useFocusWithin.mjs
init_react_shim();
import { useRef as $3b9Q0$useRef, useCallback as $3b9Q0$useCallback } from "react";
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let { isDisabled, onBlurWithin, onFocusWithin, onFocusWithinChange } = props;
  let state = (0, $3b9Q0$useRef)({
    isFocusWithin: false
  });
  let onBlur = (0, $3b9Q0$useCallback)((e) => {
    if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
      state.current.isFocusWithin = false;
      if (onBlurWithin)
        onBlurWithin(e);
      if (onFocusWithinChange)
        onFocusWithinChange(false);
    }
  }, [
    onBlurWithin,
    onFocusWithinChange,
    state
  ]);
  let onSyntheticFocus = (0, $8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
  let onFocus = (0, $3b9Q0$useCallback)((e) => {
    if (!state.current.isFocusWithin && document.activeElement === e.target) {
      if (onFocusWithin)
        onFocusWithin(e);
      if (onFocusWithinChange)
        onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e);
    }
  }, [
    onFocusWithin,
    onFocusWithinChange,
    onSyntheticFocus
  ]);
  if (isDisabled)
    return {
      focusWithinProps: {
        onFocus: void 0,
        onBlur: void 0
      }
    };
  return {
    focusWithinProps: {
      onFocus,
      onBlur
    }
  };
}

// ../../node_modules/.pnpm/@react-aria+interactions@3.23.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/interactions/dist/useInteractOutside.mjs
init_react_shim();
import { useRef as $ispOf$useRef, useEffect as $ispOf$useEffect } from "react";
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
  let { ref, onInteractOutside, isDisabled, onInteractOutsideStart } = props;
  let stateRef = (0, $ispOf$useRef)({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  let onPointerDown = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)((e) => {
    if (onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
      if (onInteractOutsideStart)
        onInteractOutsideStart(e);
      stateRef.current.isPointerDown = true;
    }
  });
  let triggerInteractOutside = (0, $8ae05eaa5c114e9c$export$7f54fc3180508a52)((e) => {
    if (onInteractOutside)
      onInteractOutside(e);
  });
  (0, $ispOf$useEffect)(() => {
    let state = stateRef.current;
    if (isDisabled)
      return;
    const element2 = ref.current;
    const documentObject = (0, $431fbd86ca7dc216$export$b204af158042fbac)(element2);
    if (typeof PointerEvent !== "undefined") {
      let onPointerUp = (e) => {
        if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref))
          triggerInteractOutside(e);
        state.isPointerDown = false;
      };
      documentObject.addEventListener("pointerdown", onPointerDown, true);
      documentObject.addEventListener("pointerup", onPointerUp, true);
      return () => {
        documentObject.removeEventListener("pointerdown", onPointerDown, true);
        documentObject.removeEventListener("pointerup", onPointerUp, true);
      };
    } else {
      let onMouseUp = (e) => {
        if (state.ignoreEmulatedMouseEvents)
          state.ignoreEmulatedMouseEvents = false;
        else if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref))
          triggerInteractOutside(e);
        state.isPointerDown = false;
      };
      let onTouchEnd = (e) => {
        state.ignoreEmulatedMouseEvents = true;
        if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref))
          triggerInteractOutside(e);
        state.isPointerDown = false;
      };
      documentObject.addEventListener("mousedown", onPointerDown, true);
      documentObject.addEventListener("mouseup", onMouseUp, true);
      documentObject.addEventListener("touchstart", onPointerDown, true);
      documentObject.addEventListener("touchend", onTouchEnd, true);
      return () => {
        documentObject.removeEventListener("mousedown", onPointerDown, true);
        documentObject.removeEventListener("mouseup", onMouseUp, true);
        documentObject.removeEventListener("touchstart", onPointerDown, true);
        documentObject.removeEventListener("touchend", onTouchEnd, true);
      };
    }
  }, [
    ref,
    isDisabled,
    onPointerDown,
    triggerInteractOutside
  ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
  if (event.button > 0)
    return false;
  if (event.target) {
    const ownerDocument = event.target.ownerDocument;
    if (!ownerDocument || !ownerDocument.documentElement.contains(event.target))
      return false;
    if (event.target.closest("[data-react-aria-top-layer]"))
      return false;
  }
  return ref.current && !ref.current.contains(event.target);
}

// ../../node_modules/.pnpm/@react-aria+focus@3.19.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/focus/dist/focusSafely.mjs
function $6a99195332edec8b$export$80f3e147d781571c(element2) {
  const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(element2);
  if ((0, $507fabe10e71c6fb$export$630ff653c5ada6a9)() === "virtual") {
    let lastFocusedElement = ownerDocument.activeElement;
    (0, $bbed8b41f857bcc0$export$24490316f764c430)(() => {
      if (ownerDocument.activeElement === lastFocusedElement && element2.isConnected)
        (0, $7215afc6de606d6b$export$de79e2c695e052f3)(element2);
    });
  } else
    (0, $7215afc6de606d6b$export$de79e2c695e052f3)(element2);
}

// ../../node_modules/.pnpm/@react-aria+focus@3.19.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/focus/dist/isElementVisible.mjs
init_react_shim();
function $645f2e67b85a24c9$var$isStyleVisible(element2) {
  const windowObject = (0, $431fbd86ca7dc216$export$f21a1ffae260145a)(element2);
  if (!(element2 instanceof windowObject.HTMLElement) && !(element2 instanceof windowObject.SVGElement))
    return false;
  let { display, visibility } = element2.style;
  let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
  if (isVisible) {
    const { getComputedStyle } = element2.ownerDocument.defaultView;
    let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element2);
    isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
  }
  return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element2, childElement) {
  return !element2.hasAttribute("hidden") && !element2.hasAttribute("data-react-aria-prevent-focus") && (element2.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element2.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element2, childElement) {
  return element2.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element2) && $645f2e67b85a24c9$var$isAttributeVisible(element2, childElement) && (!element2.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element2.parentElement, element2));
}

// ../../node_modules/.pnpm/@react-aria+focus@3.19.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/focus/dist/FocusScope.mjs
import $cgawC$react, { useRef as $cgawC$useRef, useContext as $cgawC$useContext, useMemo as $cgawC$useMemo, useEffect as $cgawC$useEffect } from "react";
var $9bf71ea28793e738$var$FocusContext = /* @__PURE__ */ (0, $cgawC$react).createContext(null);
var $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
var $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
  let { children, contain, restoreFocus, autoFocus } = props;
  let startRef = (0, $cgawC$useRef)(null);
  let endRef = (0, $cgawC$useRef)(null);
  let scopeRef = (0, $cgawC$useRef)([]);
  let { parentNode } = (0, $cgawC$useContext)($9bf71ea28793e738$var$FocusContext) || {};
  let node = (0, $cgawC$useMemo)(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef
  }), [
    scopeRef
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let parent = parentNode || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
      let activeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      if (activeNode)
        parent = activeNode;
    }
    parent.addChild(node);
    $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
  }, [
    node,
    parentNode
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let node2 = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (node2)
      node2.contain = !!contain;
  }, [
    contain
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    var _startRef_current;
    let node2 = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
    let nodes = [];
    let stopPropagation = (e) => e.stopPropagation();
    while (node2 && node2 !== endRef.current) {
      nodes.push(node2);
      node2.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
      node2 = node2.nextSibling;
    }
    scopeRef.current = nodes;
    return () => {
      for (let node3 of nodes)
        node3.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
    };
  }, [
    children
  ]);
  $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
  $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
  (0, $cgawC$useEffect)(() => {
    const activeElement = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : void 0).activeElement;
    let scope = null;
    if ($9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
      for (let node2 of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse())
        if (node2.scopeRef && $9bf71ea28793e738$var$isElementInScope(activeElement, node2.scopeRef.current))
          scope = node2;
      if (scope === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef))
        $9bf71ea28793e738$var$activeScope = scope.scopeRef;
    }
  }, [
    scopeRef
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    return () => {
      var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
      var _focusScopeTree_getTreeNode_parent_scopeRef;
      let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
      if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope)))
        $9bf71ea28793e738$var$activeScope = parentScope;
      $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
    };
  }, [
    scopeRef
  ]);
  let focusManager = (0, $cgawC$useMemo)(() => $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
  let value = (0, $cgawC$useMemo)(() => ({
    focusManager,
    parentNode: node
  }), [
    node,
    focusManager
  ]);
  return /* @__PURE__ */ (0, $cgawC$react).createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value
  }, /* @__PURE__ */ (0, $cgawC$react).createElement("span", {
    "data-focus-scope-start": true,
    hidden: true,
    ref: startRef
  }), children, /* @__PURE__ */ (0, $cgawC$react).createElement("span", {
    "data-focus-scope-end": true,
    hidden: true,
    ref: endRef
  }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
  return {
    focusNext(opts = {}) {
      let scope = scopeRef.current;
      let { from, tabbable, wrap, accept } = opts;
      let node = from || (0, $431fbd86ca7dc216$export$b204af158042fbac)(scope[0]).activeElement;
      let sentinel = scope[0].previousElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
      let nextNode = walker.nextNode();
      if (!nextNode && wrap) {
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
      }
      if (nextNode)
        $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusPrevious(opts = {}) {
      let scope = scopeRef.current;
      let { from, tabbable, wrap, accept } = opts;
      let node = from || (0, $431fbd86ca7dc216$export$b204af158042fbac)(scope[0]).activeElement;
      let sentinel = scope[scope.length - 1].nextElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
      let previousNode = walker.previousNode();
      if (!previousNode && wrap) {
        walker.currentNode = sentinel;
        previousNode = walker.previousNode();
      }
      if (previousNode)
        $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    },
    focusFirst(opts = {}) {
      let scope = scopeRef.current;
      let { tabbable, accept } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = scope[0].previousElementSibling;
      let nextNode = walker.nextNode();
      if (nextNode)
        $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusLast(opts = {}) {
      let scope = scopeRef.current;
      let { tabbable, accept } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = scope[scope.length - 1].nextElementSibling;
      let previousNode = walker.previousNode();
      if (previousNode)
        $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    }
  };
}
var $9bf71ea28793e738$var$focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
];
var $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
var $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
  return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.contain)
      return false;
    scope = scope.parent;
  }
  return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
  let focusedNode = (0, $cgawC$useRef)(void 0);
  let raf = (0, $cgawC$useRef)(void 0);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let scope = scopeRef.current;
    if (!contain) {
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = void 0;
      }
      return;
    }
    const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scope ? scope[0] : void 0);
    let onKeyDown = (e) => {
      if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing)
        return;
      let focusedElement = ownerDocument.activeElement;
      let scope2 = scopeRef.current;
      if (!scope2 || !$9bf71ea28793e738$var$isElementInScope(focusedElement, scope2))
        return;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope2);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: true
      }, scope2);
      if (!focusedElement)
        return;
      walker.currentNode = focusedElement;
      let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nextElement) {
        walker.currentNode = e.shiftKey ? scope2[scope2.length - 1].nextElementSibling : scope2[0].previousElementSibling;
        nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      }
      e.preventDefault();
      if (nextElement)
        $9bf71ea28793e738$var$focusElement(nextElement, true);
    };
    let onFocus = (e) => {
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
        $9bf71ea28793e738$var$activeScope = scopeRef;
        focusedNode.current = e.target;
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
        if (focusedNode.current)
          focusedNode.current.focus();
        else if ($9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current)
          $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef))
        focusedNode.current = e.target;
    };
    let onBlur = (e) => {
      if (raf.current)
        cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        let modality = (0, $507fabe10e71c6fb$export$630ff653c5ada6a9)();
        let shouldSkipFocusRestore = (modality === "virtual" || modality === null) && (0, $c87311424ea30a05$export$a11b0059900ceec8)() && (0, $c87311424ea30a05$export$6446a186d09e379e)();
        if (!shouldSkipFocusRestore && ownerDocument.activeElement && $9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
          $9bf71ea28793e738$var$activeScope = scopeRef;
          if (ownerDocument.body.contains(e.target)) {
            var _focusedNode_current;
            focusedNode.current = e.target;
            (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 ? void 0 : _focusedNode_current.focus();
          } else if ($9bf71ea28793e738$var$activeScope.current)
            $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
        }
      });
    };
    ownerDocument.addEventListener("keydown", onKeyDown, false);
    ownerDocument.addEventListener("focusin", onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.addEventListener("focusin", onFocus, false));
    scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.addEventListener("focusout", onBlur, false));
    return () => {
      ownerDocument.removeEventListener("keydown", onKeyDown, false);
      ownerDocument.removeEventListener("focusin", onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.removeEventListener("focusin", onFocus, false));
      scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.removeEventListener("focusout", onBlur, false));
    };
  }, [
    scopeRef,
    contain
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    return () => {
      if (raf.current)
        cancelAnimationFrame(raf.current);
    };
  }, [
    raf
  ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element2) {
  return $9bf71ea28793e738$var$isElementInChildScope(element2);
}
function $9bf71ea28793e738$var$isElementInScope(element2, scope) {
  if (!element2)
    return false;
  if (!scope)
    return false;
  return scope.some((node) => node.contains(element2));
}
function $9bf71ea28793e738$var$isElementInChildScope(element2, scope = null) {
  if (element2 instanceof Element && element2.closest("[data-react-aria-top-layer]"))
    return true;
  for (let { scopeRef: s } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))) {
    if (s && $9bf71ea28793e738$var$isElementInScope(element2, s.current))
      return true;
  }
  return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element2) {
  return $9bf71ea28793e738$var$isElementInChildScope(element2, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
  var _focusScopeTree_getTreeNode;
  let parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
  while (parent) {
    if (parent.scopeRef === ancestor)
      return true;
    parent = parent.parent;
  }
  return false;
}
function $9bf71ea28793e738$var$focusElement(element2, scroll = false) {
  if (element2 != null && !scroll)
    try {
      (0, $6a99195332edec8b$export$80f3e147d781571c)(element2);
    } catch {
    }
  else if (element2 != null)
    try {
      element2.focus();
    } catch {
    }
}
function $9bf71ea28793e738$var$getFirstInScope(scope, tabbable = true) {
  let sentinel = scope[0].previousElementSibling;
  let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
  let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
    tabbable
  }, scope);
  walker.currentNode = sentinel;
  let nextNode = walker.nextNode();
  if (tabbable && !nextNode) {
    scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
    walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
      tabbable: false
    }, scope);
    walker.currentNode = sentinel;
    nextNode = walker.nextNode();
  }
  return nextNode;
}
function $9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
  $9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
  const autoFocusRef = (0, $cgawC$react).useRef(autoFocus);
  (0, $cgawC$useEffect)(() => {
    if (autoFocusRef.current) {
      $9bf71ea28793e738$var$activeScope = scopeRef;
      const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : void 0);
      if (!$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $9bf71ea28793e738$var$activeScope.current) && scopeRef.current)
        $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
    }
    autoFocusRef.current = false;
  }, [
    scopeRef
  ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (restore || contain)
      return;
    let scope = scopeRef.current;
    const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scope ? scope[0] : void 0);
    let onFocus = (e) => {
      let target = e.target;
      if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current))
        $9bf71ea28793e738$var$activeScope = scopeRef;
      else if (!$9bf71ea28793e738$var$isElementInAnyScope(target))
        $9bf71ea28793e738$var$activeScope = null;
    };
    ownerDocument.addEventListener("focusin", onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.addEventListener("focusin", onFocus, false));
    return () => {
      ownerDocument.removeEventListener("focusin", onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.removeEventListener("focusin", onFocus, false));
    };
  }, [
    scopeRef,
    restore,
    contain
  ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.nodeToRestore)
      return false;
    scope = scope.parent;
  }
  return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
  const nodeToRestoreRef = (0, $cgawC$useRef)(typeof document !== "undefined" ? (0, $431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : void 0).activeElement : null);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let scope = scopeRef.current;
    const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scope ? scope[0] : void 0);
    if (!restoreFocus || contain)
      return;
    let onFocus = () => {
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current))
        $9bf71ea28793e738$var$activeScope = scopeRef;
    };
    ownerDocument.addEventListener("focusin", onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.addEventListener("focusin", onFocus, false));
    return () => {
      ownerDocument.removeEventListener("focusin", onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element2) => element2.removeEventListener("focusin", onFocus, false));
    };
  }, [
    scopeRef,
    contain
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : void 0);
    if (!restoreFocus)
      return;
    let onKeyDown = (e) => {
      if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing)
        return;
      let focusedElement = ownerDocument.activeElement;
      if (!$9bf71ea28793e738$var$isElementInChildScope(focusedElement, scopeRef) || !$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))
        return;
      let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode)
        return;
      let nodeToRestore = treeNode.nodeToRestore;
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body, {
        tabbable: true
      });
      walker.currentNode = focusedElement;
      let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
        nodeToRestore = void 0;
        treeNode.nodeToRestore = void 0;
      }
      if ((!nextElement || !$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
        walker.currentNode = nodeToRestore;
        do
          nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
        while ($9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef));
        e.preventDefault();
        e.stopPropagation();
        if (nextElement)
          $9bf71ea28793e738$var$focusElement(nextElement, true);
        else if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore))
          focusedElement.blur();
        else
          $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
      }
    };
    if (!contain)
      ownerDocument.addEventListener("keydown", onKeyDown, true);
    return () => {
      if (!contain)
        ownerDocument.removeEventListener("keydown", onKeyDown, true);
    };
  }, [
    scopeRef,
    restoreFocus,
    contain
  ]);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    const ownerDocument = (0, $431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : void 0);
    if (!restoreFocus)
      return;
    let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (!treeNode)
      return;
    var _nodeToRestoreRef_current;
    treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : void 0;
    return () => {
      let treeNode2 = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode2)
        return;
      let nodeToRestore = treeNode2.nodeToRestore;
      if (restoreFocus && nodeToRestore && (ownerDocument.activeElement && $9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef) || ownerDocument.activeElement === ownerDocument.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
        let clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
        requestAnimationFrame(() => {
          if (ownerDocument.activeElement === ownerDocument.body) {
            let treeNode3 = clonedTree.getTreeNode(scopeRef);
            while (treeNode3) {
              if (treeNode3.nodeToRestore && treeNode3.nodeToRestore.isConnected) {
                $9bf71ea28793e738$var$restoreFocusToElement(treeNode3.nodeToRestore);
                return;
              }
              treeNode3 = treeNode3.parent;
            }
            treeNode3 = clonedTree.getTreeNode(scopeRef);
            while (treeNode3) {
              if (treeNode3.scopeRef && treeNode3.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode3.scopeRef)) {
                let node = $9bf71ea28793e738$var$getFirstInScope(treeNode3.scopeRef.current, true);
                $9bf71ea28793e738$var$restoreFocusToElement(node);
                return;
              }
              treeNode3 = treeNode3.parent;
            }
          }
        });
      }
    };
  }, [
    scopeRef,
    restoreFocus
  ]);
}
function $9bf71ea28793e738$var$restoreFocusToElement(node) {
  if (node.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
    bubbles: true,
    cancelable: true
  })))
    $9bf71ea28793e738$var$focusElement(node);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
  let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
  let walker = (0, $431fbd86ca7dc216$export$b204af158042fbac)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node) {
      var _opts_from;
      if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node))
        return NodeFilter.FILTER_REJECT;
      if (node.matches(selector) && (0, $645f2e67b85a24c9$export$e989c0fffaa6b27a)(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node)))
        return NodeFilter.FILTER_ACCEPT;
      return NodeFilter.FILTER_SKIP;
    }
  });
  if (opts === null || opts === void 0 ? void 0 : opts.from)
    walker.currentNode = opts.from;
  return walker;
}
var $9bf71ea28793e738$var$Tree = class {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(data) {
    return this.fastMap.get(data);
  }
  addTreeNode(scopeRef, parent, nodeToRestore) {
    let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
    if (!parentNode)
      return;
    let node = new $9bf71ea28793e738$var$TreeNode({
      scopeRef
    });
    parentNode.addChild(node);
    node.parent = parentNode;
    this.fastMap.set(scopeRef, node);
    if (nodeToRestore)
      node.nodeToRestore = nodeToRestore;
  }
  addNode(node) {
    this.fastMap.set(node.scopeRef, node);
  }
  removeTreeNode(scopeRef) {
    if (scopeRef === null)
      return;
    let node = this.fastMap.get(scopeRef);
    if (!node)
      return;
    let parentNode = node.parent;
    for (let current of this.traverse())
      if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current))
        current.nodeToRestore = node.nodeToRestore;
    let children = node.children;
    if (parentNode) {
      parentNode.removeChild(node);
      if (children.size > 0)
        children.forEach((child) => parentNode && parentNode.addChild(child));
    }
    this.fastMap.delete(node.scopeRef);
  }
  *traverse(node = this.root) {
    if (node.scopeRef != null)
      yield node;
    if (node.children.size > 0)
      for (let child of node.children)
        yield* this.traverse(child);
  }
  clone() {
    var _node_parent;
    let newTree = new $9bf71ea28793e738$var$Tree();
    var _node_parent_scopeRef;
    for (let node of this.traverse())
      newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
    return newTree;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }
};
var $9bf71ea28793e738$var$TreeNode = class {
  addChild(node) {
    this.children.add(node);
    node.parent = this;
  }
  removeChild(node) {
    this.children.delete(node);
    node.parent = void 0;
  }
  constructor(props) {
    this.children = /* @__PURE__ */ new Set();
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }
};
var $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/context.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/utils.mjs
init_react_shim();
var $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]);
var $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
  if (Intl.Locale) {
    let locale = new Intl.Locale(localeString).maximize();
    let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
    if (textInfo)
      return textInfo.direction === "rtl";
    if (locale.script)
      return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
  }
  let lang = localeString.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/useDefaultLocale.mjs
init_react_shim();
import { useState as $ffhGL$useState, useEffect as $ffhGL$useEffect } from "react";
var $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let locale = typeof window !== "undefined" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      locale
    ]);
  } catch {
    locale = "en-US";
  }
  return {
    locale,
    direction: (0, $148a7a147e38ea7f$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
  };
}
var $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
var $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */ new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let listener of $1e5a04cdaf7d1af8$var$listeners)
    listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let isSSR = (0, $b5e257d569688ac6$export$535bd6ca7f90a273)();
  let [defaultLocale, setDefaultLocale] = (0, $ffhGL$useState)($1e5a04cdaf7d1af8$var$currentLocale);
  (0, $ffhGL$useEffect)(() => {
    if ($1e5a04cdaf7d1af8$var$listeners.size === 0)
      window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
    return () => {
      $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
      if ($1e5a04cdaf7d1af8$var$listeners.size === 0)
        window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    };
  }, []);
  if (isSSR)
    return {
      locale: "en-US",
      direction: "ltr"
    };
  return defaultLocale;
}

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/context.mjs
import $h9FiU$react, { useContext as $h9FiU$useContext } from "react";
var $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */ (0, $h9FiU$react).createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let defaultLocale = (0, $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a)();
  let context = (0, $h9FiU$useContext)($18f2051aff69b9bf$var$I18nContext);
  return context || defaultLocale;
}

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/useLocalizedStringFormatter.mjs
init_react_shim();

// ../../node_modules/.pnpm/@internationalized+string@3.2.5/node_modules/@internationalized/string/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@internationalized+string@3.2.5/node_modules/@internationalized/string/dist/LocalizedStringDictionary.mjs
init_react_shim();
var $5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
var $5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
var $5b160d28a433310d$var$cachedGlobalStrings = void 0;
var $5b160d28a433310d$export$c17fa47878dc55b6 = class {
  getStringForLocale(key, locale) {
    let strings = this.getStringsForLocale(locale);
    let string2 = strings[key];
    if (!string2)
      throw new Error(`Could not find intl message ${key} in ${locale} locale`);
    return string2;
  }
  getStringsForLocale(locale) {
    let strings = this.strings[locale];
    if (!strings) {
      strings = $5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
      this.strings[locale] = strings;
    }
    return strings;
  }
  static getGlobalDictionaryForPackage(packageName) {
    if (typeof window === "undefined")
      return null;
    let locale = window[$5b160d28a433310d$var$localeSymbol];
    if ($5b160d28a433310d$var$cachedGlobalStrings === void 0) {
      let globalStrings = window[$5b160d28a433310d$var$stringsSymbol];
      if (!globalStrings)
        return null;
      $5b160d28a433310d$var$cachedGlobalStrings = {};
      for (let pkg in globalStrings)
        $5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $5b160d28a433310d$export$c17fa47878dc55b6({
          [locale]: globalStrings[pkg]
        }, locale);
    }
    let dictionary = $5b160d28a433310d$var$cachedGlobalStrings === null || $5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $5b160d28a433310d$var$cachedGlobalStrings[packageName];
    if (!dictionary)
      throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return dictionary;
  }
  constructor(messages, defaultLocale = "en-US") {
    this.strings = Object.fromEntries(Object.entries(messages).filter(([, v]) => v));
    this.defaultLocale = defaultLocale;
  }
};
function $5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
  if (strings[locale])
    return strings[locale];
  let language = $5b160d28a433310d$var$getLanguage(locale);
  if (strings[language])
    return strings[language];
  for (let key in strings) {
    if (key.startsWith(language + "-"))
      return strings[key];
  }
  return strings[defaultLocale];
}
function $5b160d28a433310d$var$getLanguage(locale) {
  if (Intl.Locale)
    return new Intl.Locale(locale).language;
  return locale.split("-")[0];
}

// ../../node_modules/.pnpm/@internationalized+string@3.2.5/node_modules/@internationalized/string/dist/LocalizedStringFormatter.mjs
init_react_shim();
var $6db58dc88e78b024$var$pluralRulesCache = /* @__PURE__ */ new Map();
var $6db58dc88e78b024$var$numberFormatCache = /* @__PURE__ */ new Map();
var $6db58dc88e78b024$export$2f817fcdc4b89ae0 = class {
  format(key, variables) {
    let message = this.strings.getStringForLocale(key, this.locale);
    return typeof message === "function" ? message(variables, this) : message;
  }
  plural(count, options, type = "cardinal") {
    let opt = options["=" + count];
    if (opt)
      return typeof opt === "function" ? opt() : opt;
    let key = this.locale + ":" + type;
    let pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
    if (!pluralRules) {
      pluralRules = new Intl.PluralRules(this.locale, {
        type
      });
      $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
    }
    let selected = pluralRules.select(count);
    opt = options[selected] || options.other;
    return typeof opt === "function" ? opt() : opt;
  }
  number(value) {
    let numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
    if (!numberFormat) {
      numberFormat = new Intl.NumberFormat(this.locale);
      $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
    }
    return numberFormat.format(value);
  }
  select(options, value) {
    let opt = options[value] || options.other;
    return typeof opt === "function" ? opt() : opt;
  }
  constructor(locale, strings) {
    this.locale = locale;
    this.strings = strings;
  }
};

// ../../node_modules/.pnpm/@react-aria+i18n@3.12.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/i18n/dist/useLocalizedStringFormatter.mjs
import { useMemo as $6ksNp$useMemo } from "react";
var $fca6afa0e843324b$var$cache = /* @__PURE__ */ new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(strings) {
  let dictionary = $fca6afa0e843324b$var$cache.get(strings);
  if (!dictionary) {
    dictionary = new (0, $5b160d28a433310d$export$c17fa47878dc55b6)(strings);
    $fca6afa0e843324b$var$cache.set(strings, dictionary);
  }
  return dictionary;
}
function $fca6afa0e843324b$export$87b761675e8eaa10(strings, packageName) {
  return packageName && (0, $5b160d28a433310d$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings, packageName) {
  let { locale } = (0, $18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
  let dictionary = $fca6afa0e843324b$export$87b761675e8eaa10(strings, packageName);
  return (0, $6ksNp$useMemo)(() => new (0, $6db58dc88e78b024$export$2f817fcdc4b89ae0)(locale, dictionary), [
    locale,
    dictionary
  ]);
}

// ../../node_modules/.pnpm/@react-aria+visually-hidden@3.8.19_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/visually-hidden/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+visually-hidden@3.8.19_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/visually-hidden/dist/VisuallyHidden.mjs
init_react_shim();
import $7JYt2$react, { useState as $7JYt2$useState, useMemo as $7JYt2$useMemo } from "react";
var $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(props = {}) {
  let { style, isFocusable } = props;
  let [isFocused, setFocused] = (0, $7JYt2$useState)(false);
  let { focusWithinProps } = (0, $9ab94262bd0047c7$export$420e68273165f4ec)({
    isDisabled: !isFocusable,
    onFocusWithinChange: (val) => setFocused(val)
  });
  let combinedStyles = (0, $7JYt2$useMemo)(() => {
    if (isFocused)
      return style;
    else if (style)
      return {
        ...$5c3e21d68f1c4674$var$styles,
        ...style
      };
    else
      return $5c3e21d68f1c4674$var$styles;
  }, [
    isFocused
  ]);
  return {
    visuallyHiddenProps: {
      ...focusWithinProps,
      style: combinedStyles
    }
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
  let { children, elementType: Element2 = "div", isFocusable, style, ...otherProps } = props;
  let { visuallyHiddenProps } = $5c3e21d68f1c4674$export$a966af930f325cab(props);
  return /* @__PURE__ */ (0, $7JYt2$react).createElement(Element2, (0, $3ef42575df84b30b$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/useOverlay.mjs
init_react_shim();
import { useEffect as $jtpZv$useEffect } from "react";
var $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(props, ref) {
  let { onClose, shouldCloseOnBlur, isOpen, isDismissable = false, isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside } = props;
  (0, $jtpZv$useEffect)(() => {
    if (isOpen)
      $a11501f3d1d39e6c$var$visibleOverlays.push(ref);
    return () => {
      let index = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
      if (index >= 0)
        $a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
    };
  }, [
    isOpen,
    ref
  ]);
  let onHide = () => {
    if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose)
      onClose();
  };
  let onInteractOutsideStart = (e) => {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
      if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  };
  let onInteractOutside = (e) => {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
      if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
        e.stopPropagation();
        e.preventDefault();
      }
      onHide();
    }
  };
  let onKeyDown = (e) => {
    if (e.key === "Escape" && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
      e.stopPropagation();
      e.preventDefault();
      onHide();
    }
  };
  (0, $e0b6e0b68ec7f50f$export$872b660ac5a1ff98)({
    ref,
    onInteractOutside: isDismissable && isOpen ? onInteractOutside : void 0,
    onInteractOutsideStart
  });
  let { focusWithinProps } = (0, $9ab94262bd0047c7$export$420e68273165f4ec)({
    isDisabled: !shouldCloseOnBlur,
    onBlurWithin: (e) => {
      if (!e.relatedTarget || (0, $9bf71ea28793e738$export$1258395f99bf9cbf)(e.relatedTarget))
        return;
      if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget))
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  });
  let onPointerDownUnderlay = (e) => {
    if (e.target === e.currentTarget)
      e.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown,
      ...focusWithinProps
    },
    underlayProps: {
      onPointerDown: onPointerDownUnderlay
    }
  };
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/usePreventScroll.mjs
init_react_shim();
var $49c51c25361d4cd2$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
var $49c51c25361d4cd2$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
var $49c51c25361d4cd2$var$preventScrollCount = 0;
var $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(options = {}) {
  let { isDisabled } = options;
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (isDisabled)
      return;
    $49c51c25361d4cd2$var$preventScrollCount++;
    if ($49c51c25361d4cd2$var$preventScrollCount === 1) {
      if ((0, $c87311424ea30a05$export$fedb369cb70207f1)())
        $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari();
      else
        $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard();
    }
    return () => {
      $49c51c25361d4cd2$var$preventScrollCount--;
      if ($49c51c25361d4cd2$var$preventScrollCount === 0)
        $49c51c25361d4cd2$var$restore();
    };
  }, [
    isDisabled
  ]);
}
function $49c51c25361d4cd2$var$preventScrollStandard() {
  return (0, $ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
  let scrollable;
  let restoreScrollableStyles;
  let onTouchStart = (e) => {
    scrollable = (0, $62d8ded9296f3872$export$cfa2225e87938781)(e.target, true);
    if (scrollable === document.documentElement && scrollable === document.body)
      return;
    if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === "auto")
      restoreScrollableStyles = $49c51c25361d4cd2$var$setStyle(scrollable, "overscrollBehavior", "contain");
  };
  let onTouchMove = (e) => {
    if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
      e.preventDefault();
      return;
    }
    if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth)
      e.preventDefault();
  };
  let onTouchEnd = () => {
    if (restoreScrollableStyles)
      restoreScrollableStyles();
  };
  let onFocus = (e) => {
    let target = e.target;
    if ($49c51c25361d4cd2$var$willOpenKeyboard(target)) {
      setupStyles();
      target.style.transform = "translateY(-2000px)";
      requestAnimationFrame(() => {
        target.style.transform = "";
        if ($49c51c25361d4cd2$var$visualViewport) {
          if ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight)
            requestAnimationFrame(() => {
              $49c51c25361d4cd2$var$scrollIntoView(target);
            });
          else
            $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", () => $49c51c25361d4cd2$var$scrollIntoView(target), {
              once: true
            });
        }
      });
    }
  };
  let restoreStyles = null;
  let setupStyles = () => {
    if (restoreStyles)
      return;
    let onWindowScroll = () => {
      window.scrollTo(0, 0);
    };
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    restoreStyles = (0, $ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll), $49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`), () => {
      window.scrollTo(scrollX, scrollY);
    });
    window.scrollTo(0, 0);
  };
  let removeEvents = (0, $ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true));
  return () => {
    restoreScrollableStyles === null || restoreScrollableStyles === void 0 ? void 0 : restoreScrollableStyles();
    restoreStyles === null || restoreStyles === void 0 ? void 0 : restoreStyles();
    removeEvents();
  };
}
function $49c51c25361d4cd2$var$setStyle(element2, style, value) {
  let cur = element2.style[style];
  element2.style[style] = value;
  return () => {
    element2.style[style] = cur;
  };
}
function $49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
  target.addEventListener(event, handler, options);
  return () => {
    target.removeEventListener(event, handler, options);
  };
}
function $49c51c25361d4cd2$var$scrollIntoView(target) {
  let root = document.scrollingElement || document.documentElement;
  let nextTarget = target;
  while (nextTarget && nextTarget !== root) {
    let scrollable = (0, $62d8ded9296f3872$export$cfa2225e87938781)(nextTarget);
    if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
      let scrollableTop = scrollable.getBoundingClientRect().top;
      let targetTop = nextTarget.getBoundingClientRect().top;
      if (targetTop > scrollableTop + nextTarget.clientHeight)
        scrollable.scrollTop += targetTop - scrollableTop;
    }
    nextTarget = scrollable.parentElement;
  }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(target) {
  return target instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/DismissButton.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/intlStrings.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/ar-AE.mjs
init_react_shim();
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
  "dismiss": `\u062A\u062C\u0627\u0647\u0644`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/bg-BG.mjs
init_react_shim();
var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
  "dismiss": `\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/cs-CZ.mjs
init_react_shim();
var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
  "dismiss": `Odstranit`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/da-DK.mjs
init_react_shim();
var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
  "dismiss": `Luk`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/de-DE.mjs
init_react_shim();
var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
  "dismiss": `Schlie\xDFen`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/el-GR.mjs
init_react_shim();
var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
  "dismiss": `\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/en-US.mjs
init_react_shim();
var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
  "dismiss": `Dismiss`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/es-ES.mjs
init_react_shim();
var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
  "dismiss": `Descartar`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/et-EE.mjs
init_react_shim();
var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
  "dismiss": `L\xF5peta`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/fi-FI.mjs
init_react_shim();
var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
  "dismiss": `Hylk\xE4\xE4`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/fr-FR.mjs
init_react_shim();
var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
  "dismiss": `Rejeter`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/he-IL.mjs
init_react_shim();
var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
  "dismiss": `\u05D4\u05EA\u05E2\u05DC\u05DD`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/hr-HR.mjs
init_react_shim();
var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
  "dismiss": `Odbaci`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/hu-HU.mjs
init_react_shim();
var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
  "dismiss": `Elutas\xEDt\xE1s`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/it-IT.mjs
init_react_shim();
var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
  "dismiss": `Ignora`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/ja-JP.mjs
init_react_shim();
var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
  "dismiss": `\u9589\u3058\u308B`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/ko-KR.mjs
init_react_shim();
var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
  "dismiss": `\uBB34\uC2DC`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/lt-LT.mjs
init_react_shim();
var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
  "dismiss": `Atmesti`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/lv-LV.mjs
init_react_shim();
var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
  "dismiss": `Ner\u0101d\u012Bt`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/nb-NO.mjs
init_react_shim();
var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
  "dismiss": `Lukk`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/nl-NL.mjs
init_react_shim();
var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
  "dismiss": `Negeren`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/pl-PL.mjs
init_react_shim();
var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
  "dismiss": `Zignoruj`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/pt-BR.mjs
init_react_shim();
var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
  "dismiss": `Descartar`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/pt-PT.mjs
init_react_shim();
var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
  "dismiss": `Dispensar`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/ro-RO.mjs
init_react_shim();
var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
  "dismiss": `Revocare`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/ru-RU.mjs
init_react_shim();
var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
  "dismiss": `\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/sk-SK.mjs
init_react_shim();
var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
  "dismiss": `Zru\u0161i\u0165`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/sl-SI.mjs
init_react_shim();
var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
  "dismiss": `Opusti`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/sr-SP.mjs
init_react_shim();
var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
  "dismiss": `Odbaci`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/sv-SE.mjs
init_react_shim();
var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
  "dismiss": `Avvisa`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/tr-TR.mjs
init_react_shim();
var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
  "dismiss": `Kapat`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/uk-UA.mjs
init_react_shim();
var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
  "dismiss": `\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/zh-CN.mjs
init_react_shim();
var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
  "dismiss": `\u53D6\u6D88`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/zh-TW.mjs
init_react_shim();
var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
  "dismiss": `\u95DC\u9589`
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/intlStrings.mjs
var $a2f21f5f14f60553$exports = {};
$a2f21f5f14f60553$exports = {
  "ar-AE": $773d5888b972f1cf$exports,
  "bg-BG": $d11f19852b941573$exports,
  "cs-CZ": $b983974c2ee1efb3$exports,
  "da-DK": $5809cc9d4e92de73$exports,
  "de-DE": $c68c2e4fc74398d1$exports,
  "el-GR": $0898b4c153db2b77$exports,
  "en-US": $6d74810286a15183$exports,
  "es-ES": $309d73dc65f78055$exports,
  "et-EE": $44ad94f7205cf593$exports,
  "fi-FI": $7c28f5687f0779a9$exports,
  "fr-FR": $e6d75df4b68bd73a$exports,
  "he-IL": $87505c9dab186d0f$exports,
  "hr-HR": $553439c3ffb3e492$exports,
  "hu-HU": $74cf411061b983a2$exports,
  "it-IT": $e933f298574dc435$exports,
  "ja-JP": $ac91fc9fe02f71f6$exports,
  "ko-KR": $52b96f86422025af$exports,
  "lt-LT": $c0d724c3e51dafa6$exports,
  "lv-LV": $c92899672a3fe72e$exports,
  "nb-NO": $9f576b39d8e7a9d6$exports,
  "nl-NL": $9d025808aeec81a7$exports,
  "pl-PL": $fce709921e2c0fa6$exports,
  "pt-BR": $2599cf0c4ab37f59$exports,
  "pt-PT": $3c220ae7ef8a35fd$exports,
  "ro-RO": $93562b5094072f54$exports,
  "ru-RU": $cd9e2abd0d06c7b4$exports,
  "sk-SK": $45375701f409adf1$exports,
  "sl-SI": $27fab53a576de9dd$exports,
  "sr-SP": $4438748d9952e7c7$exports,
  "sv-SE": $0936d7347ef4da4c$exports,
  "tr-TR": $29700c92185d38f8$exports,
  "uk-UA": $662ccaf2be4c25b3$exports,
  "zh-CN": $d80a27deda7cdb3c$exports,
  "zh-TW": $2b2734393847c884$exports
};

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/DismissButton.mjs
import $iYaQO$react from "react";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $86ea4cb521eb2e37$export$2317d149ed6f78c4(props) {
  let { onDismiss, ...otherProps } = props;
  let stringFormatter = (0, $fca6afa0e843324b$export$f12b703ca79dfbb1)((0, $parcel$interopDefault($a2f21f5f14f60553$exports)), "@react-aria/overlays");
  let labels = (0, $313b98861ee5dd6c$export$d6875122194c7b44)(otherProps, stringFormatter.format("dismiss"));
  let onClick = () => {
    if (onDismiss)
      onDismiss();
  };
  return /* @__PURE__ */ (0, $iYaQO$react).createElement((0, $5c3e21d68f1c4674$export$439d29a4e110a164), null, /* @__PURE__ */ (0, $iYaQO$react).createElement("button", {
    ...labels,
    tabIndex: -1,
    onClick,
    style: {
      width: 1,
      height: 1
    }
  }));
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/ariaHideOutside.mjs
init_react_shim();
var $5e3802645cc19319$var$refCountMap = /* @__PURE__ */ new WeakMap();
var $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(targets, root = document.body) {
  let visibleNodes = new Set(targets);
  let hiddenNodes = /* @__PURE__ */ new Set();
  let walk = (root2) => {
    for (let element2 of root2.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))
      visibleNodes.add(element2);
    let acceptNode = (node) => {
      if (visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let target of visibleNodes) {
        if (node.contains(target))
          return NodeFilter.FILTER_SKIP;
      }
      return NodeFilter.FILTER_ACCEPT;
    };
    let walker = document.createTreeWalker(root2, NodeFilter.SHOW_ELEMENT, {
      acceptNode
    });
    let acceptRoot = acceptNode(root2);
    if (acceptRoot === NodeFilter.FILTER_ACCEPT)
      hide(root2);
    if (acceptRoot !== NodeFilter.FILTER_REJECT) {
      let node = walker.nextNode();
      while (node != null) {
        hide(node);
        node = walker.nextNode();
      }
    }
  };
  let hide = (node) => {
    var _refCountMap_get;
    let refCount = (_refCountMap_get = $5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
    if (node.getAttribute("aria-hidden") === "true" && refCount === 0)
      return;
    if (refCount === 0)
      node.setAttribute("aria-hidden", "true");
    hiddenNodes.add(node);
    $5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
  };
  if ($5e3802645cc19319$var$observerStack.length)
    $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect();
  walk(root);
  let observer = new MutationObserver((changes) => {
    for (let change of changes) {
      if (change.type !== "childList" || change.addedNodes.length === 0)
        continue;
      if (![
        ...visibleNodes,
        ...hiddenNodes
      ].some((node) => node.contains(change.target))) {
        for (let node of change.removedNodes)
          if (node instanceof Element) {
            visibleNodes.delete(node);
            hiddenNodes.delete(node);
          }
        for (let node of change.addedNodes) {
          if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true"))
            visibleNodes.add(node);
          else if (node instanceof Element)
            walk(node);
        }
      }
    }
  });
  observer.observe(root, {
    childList: true,
    subtree: true
  });
  let observerWrapper = {
    observe() {
      observer.observe(root, {
        childList: true,
        subtree: true
      });
    },
    disconnect() {
      observer.disconnect();
    }
  };
  $5e3802645cc19319$var$observerStack.push(observerWrapper);
  return () => {
    observer.disconnect();
    for (let node of hiddenNodes) {
      let count = $5e3802645cc19319$var$refCountMap.get(node);
      if (count == null)
        continue;
      if (count === 1) {
        node.removeAttribute("aria-hidden");
        $5e3802645cc19319$var$refCountMap.delete(node);
      } else
        $5e3802645cc19319$var$refCountMap.set(node, count - 1);
    }
    if (observerWrapper === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1]) {
      $5e3802645cc19319$var$observerStack.pop();
      if ($5e3802645cc19319$var$observerStack.length)
        $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe();
    } else
      $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
  };
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/useModalOverlay.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/Overlay.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/PortalProvider.mjs
init_react_shim();
import $7yuSY$react, { createContext as $7yuSY$createContext, useContext as $7yuSY$useContext } from "react";
var $96b38030c423d352$export$60d741e20e0aa309 = /* @__PURE__ */ (0, $7yuSY$createContext)({});
function $96b38030c423d352$export$574e9b0fb070c3b0() {
  var _useContext;
  return (_useContext = (0, $7yuSY$useContext)($96b38030c423d352$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/Overlay.mjs
import $1CM7W$react, { useState as $1CM7W$useState, useMemo as $1CM7W$useMemo, useContext as $1CM7W$useContext } from "react";
import $1CM7W$reactdom from "react-dom";
var $337b884510726a0d$export$a2200b96afd16271 = /* @__PURE__ */ (0, $1CM7W$react).createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(props) {
  let isSSR = (0, $b5e257d569688ac6$export$535bd6ca7f90a273)();
  let { portalContainer = isSSR ? null : document.body, isExiting } = props;
  let [contain, setContain] = (0, $1CM7W$useState)(false);
  let contextValue = (0, $1CM7W$useMemo)(() => ({
    contain,
    setContain
  }), [
    contain,
    setContain
  ]);
  let { getContainer } = (0, $96b38030c423d352$export$574e9b0fb070c3b0)();
  if (!props.portalContainer && getContainer)
    portalContainer = getContainer();
  if (!portalContainer)
    return null;
  let contents = props.children;
  if (!props.disableFocusManagement)
    contents = /* @__PURE__ */ (0, $1CM7W$react).createElement((0, $9bf71ea28793e738$export$20e40289641fbbb6), {
      restoreFocus: true,
      contain: contain && !isExiting
    }, contents);
  contents = /* @__PURE__ */ (0, $1CM7W$react).createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
    value: contextValue
  }, /* @__PURE__ */ (0, $1CM7W$react).createElement((0, $f1ab8c75478c6f73$export$cf75428e0b9ed1ea), null, contents));
  return /* @__PURE__ */ (0, $1CM7W$reactdom).createPortal(contents, portalContainer);
}
function $337b884510726a0d$export$14c98a7594375490() {
  let ctx = (0, $1CM7W$useContext)($337b884510726a0d$export$a2200b96afd16271);
  let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    setContain === null || setContain === void 0 ? void 0 : setContain(true);
  }, [
    setContain
  ]);
}

// ../../node_modules/.pnpm/@react-aria+overlays@3.25.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/overlays/dist/useModalOverlay.mjs
import { useEffect as $7Dhkr$useEffect } from "react";
function $8ac8429251c45e4b$export$dbc0f175b25fb0fb(props, state, ref) {
  let { overlayProps, underlayProps } = (0, $a11501f3d1d39e6c$export$ea8f71083e90600f)({
    ...props,
    isOpen: state.isOpen,
    onClose: state.close
  }, ref);
  (0, $49c51c25361d4cd2$export$ee0f7cc6afcd1c18)({
    isDisabled: !state.isOpen
  });
  (0, $337b884510726a0d$export$14c98a7594375490)();
  (0, $7Dhkr$useEffect)(() => {
    if (state.isOpen && ref.current)
      return (0, $5e3802645cc19319$export$1c3ebcada18427bf)([
        ref.current
      ]);
  }, [
    state.isOpen,
    ref
  ]);
  return {
    modalProps: (0, $3ef42575df84b30b$export$9d1611c77c2fe928)(overlayProps),
    underlayProps
  };
}

// ../../node_modules/.pnpm/@react-aria+dialog@3.5.21_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/dialog/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-aria+dialog@3.5.21_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@react-aria/dialog/dist/useDialog.mjs
init_react_shim();
import { useRef as $i6df2$useRef, useEffect as $i6df2$useEffect } from "react";
function $40df3f8667284809$export$d55e7ee900f34e93(props, ref) {
  let { role = "dialog" } = props;
  let titleId = (0, $bdb11010cef70236$export$b4cc09c592e8fdb8)();
  titleId = props["aria-label"] ? void 0 : titleId;
  let isRefocusing = (0, $i6df2$useRef)(false);
  (0, $i6df2$useEffect)(() => {
    if (ref.current && !ref.current.contains(document.activeElement)) {
      (0, $6a99195332edec8b$export$80f3e147d781571c)(ref.current);
      let timeout = setTimeout(() => {
        if (document.activeElement === ref.current) {
          isRefocusing.current = true;
          if (ref.current) {
            ref.current.blur();
            (0, $6a99195332edec8b$export$80f3e147d781571c)(ref.current);
          }
          isRefocusing.current = false;
        }
      }, 500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [
    ref
  ]);
  (0, $337b884510726a0d$export$14c98a7594375490)();
  return {
    dialogProps: {
      ...(0, $65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
      }),
      role,
      tabIndex: -1,
      "aria-labelledby": props["aria-labelledby"] || titleId,
      onBlur: (e) => {
        if (isRefocusing.current)
          e.stopPropagation();
      }
    },
    titleProps: {
      id: titleId
    }
  };
}

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/Button.mjs
import $fM325$react, { createContext as $fM325$createContext, useRef as $fM325$useRef, useEffect as $fM325$useEffect } from "react";
var $d2b4bc8c273e7be6$export$24d547caef80ccd1 = /* @__PURE__ */ (0, $fM325$createContext)({});

// ../../node_modules/.pnpm/react-stately@3.35.0_react@18.3.1/node_modules/react-stately/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-stately+overlays@3.6.13_react@18.3.1/node_modules/@react-stately/overlays/dist/import.mjs
init_react_shim();

// ../../node_modules/.pnpm/@react-stately+overlays@3.6.13_react@18.3.1/node_modules/@react-stately/overlays/dist/useOverlayTriggerState.mjs
init_react_shim();
import { useCallback as $hnMvi$useCallback } from "react";
function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
  let [isOpen, setOpen] = (0, $458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
  const open = (0, $hnMvi$useCallback)(() => {
    setOpen(true);
  }, [
    setOpen
  ]);
  const close = (0, $hnMvi$useCallback)(() => {
    setOpen(false);
  }, [
    setOpen
  ]);
  const toggle = (0, $hnMvi$useCallback)(() => {
    setOpen(!isOpen);
  }, [
    setOpen,
    isOpen
  ]);
  return {
    isOpen,
    setOpen,
    open,
    close,
    toggle
  };
}

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/Dialog.mjs
init_react_shim();
import $6IYYA$react, { createContext as $6IYYA$createContext, useRef as $6IYYA$useRef, forwardRef as $6IYYA$forwardRef, useContext as $6IYYA$useContext } from "react";
var $de32f1b87079253c$export$8b93a07348a7730c = /* @__PURE__ */ (0, $6IYYA$createContext)(null);
var $de32f1b87079253c$export$d2f961adcb0afbe = /* @__PURE__ */ (0, $6IYYA$createContext)(null);
var $de32f1b87079253c$export$3ddf2d174ce01153 = /* @__PURE__ */ (0, $6IYYA$forwardRef)(function Dialog(props, ref) {
  let originalAriaLabelledby = props["aria-labelledby"];
  [props, ref] = (0, $64fa3d84918910a7$export$29f1550f4b0d4415)(props, ref, $de32f1b87079253c$export$8b93a07348a7730c);
  let { dialogProps, titleProps } = (0, $40df3f8667284809$export$d55e7ee900f34e93)({
    ...props,
    "aria-labelledby": originalAriaLabelledby
  }, ref);
  let state = (0, $6IYYA$useContext)($de32f1b87079253c$export$d2f961adcb0afbe);
  if (!dialogProps["aria-label"] && !dialogProps["aria-labelledby"]) {
    if (props["aria-labelledby"])
      dialogProps["aria-labelledby"] = props["aria-labelledby"];
    else
      console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.');
  }
  let renderProps = (0, $64fa3d84918910a7$export$4d86445c2cf5e3)({
    defaultClassName: "react-aria-Dialog",
    className: props.className,
    style: props.style,
    children: props.children,
    values: {
      close: (state === null || state === void 0 ? void 0 : state.close) || (() => {
      })
    }
  });
  return /* @__PURE__ */ (0, $6IYYA$react).createElement("section", {
    ...(0, $65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props),
    ...dialogProps,
    ...renderProps,
    ref,
    slot: props.slot || void 0
  }, /* @__PURE__ */ (0, $6IYYA$react).createElement((0, $64fa3d84918910a7$export$2881499e37b75b9a), {
    values: [
      [
        (0, $4e85f108e88277b8$export$d688439359537581),
        {
          slots: {
            [(0, $64fa3d84918910a7$export$c62b8e45d58ddad9)]: {},
            title: {
              ...titleProps,
              level: 2
            }
          }
        }
      ],
      [
        (0, $d2b4bc8c273e7be6$export$24d547caef80ccd1),
        {
          slots: {
            [(0, $64fa3d84918910a7$export$c62b8e45d58ddad9)]: {},
            close: {
              onPress: () => state === null || state === void 0 ? void 0 : state.close()
            }
          }
        }
      ]
    ]
  }, renderProps.children));
});

// ../../node_modules/.pnpm/react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-aria-components/dist/Modal.mjs
init_react_shim();
import $daTMi$react, { createContext as $daTMi$createContext, forwardRef as $daTMi$forwardRef, useContext as $daTMi$useContext, useRef as $daTMi$useRef, useMemo as $daTMi$useMemo } from "react";
var $f3f84453ead64de5$export$ab57792b9b6974a6 = /* @__PURE__ */ (0, $daTMi$createContext)(null);
var $f3f84453ead64de5$var$InternalModalContext = /* @__PURE__ */ (0, $daTMi$createContext)(null);
var $f3f84453ead64de5$export$2b77a92f1a5ad772 = /* @__PURE__ */ (0, $daTMi$forwardRef)(function Modal(props, ref) {
  let ctx = (0, $daTMi$useContext)($f3f84453ead64de5$var$InternalModalContext);
  if (ctx)
    return /* @__PURE__ */ (0, $daTMi$react).createElement($f3f84453ead64de5$var$ModalContent, {
      ...props,
      modalRef: ref
    }, props.children);
  let { isDismissable, isKeyboardDismissDisabled, isOpen, defaultOpen, onOpenChange, children, isEntering, isExiting, UNSTABLE_portalContainer, shouldCloseOnInteractOutside, ...otherProps } = props;
  return /* @__PURE__ */ (0, $daTMi$react).createElement($f3f84453ead64de5$export$8948f78d83984c69, {
    isDismissable,
    isKeyboardDismissDisabled,
    isOpen,
    defaultOpen,
    onOpenChange,
    isEntering,
    isExiting,
    UNSTABLE_portalContainer,
    shouldCloseOnInteractOutside
  }, /* @__PURE__ */ (0, $daTMi$react).createElement($f3f84453ead64de5$var$ModalContent, {
    ...otherProps,
    modalRef: ref
  }, children));
});
function $f3f84453ead64de5$var$ModalOverlayWithForwardRef(props, ref) {
  [props, ref] = (0, $64fa3d84918910a7$export$29f1550f4b0d4415)(props, ref, $f3f84453ead64de5$export$ab57792b9b6974a6);
  let contextState = (0, $daTMi$useContext)((0, $de32f1b87079253c$export$d2f961adcb0afbe));
  let localState = (0, $fc909762b330b746$export$61c6a8c84e605fb6)(props);
  let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
  let objectRef = (0, $df56164dff5785e2$export$4338b53315abf666)(ref);
  let modalRef = (0, $daTMi$useRef)(null);
  let isOverlayExiting = (0, $d3f049242431219c$export$45fda7c47f93fd48)(objectRef, state.isOpen);
  let isModalExiting = (0, $d3f049242431219c$export$45fda7c47f93fd48)(modalRef, state.isOpen);
  let isExiting = isOverlayExiting || isModalExiting || props.isExiting || false;
  let isSSR = (0, $b5e257d569688ac6$export$535bd6ca7f90a273)();
  if (!state.isOpen && !isExiting || isSSR)
    return null;
  return /* @__PURE__ */ (0, $daTMi$react).createElement($f3f84453ead64de5$var$ModalOverlayInner, {
    ...props,
    state,
    isExiting,
    overlayRef: objectRef,
    modalRef
  });
}
var $f3f84453ead64de5$export$8948f78d83984c69 = /* @__PURE__ */ (0, $daTMi$forwardRef)($f3f84453ead64de5$var$ModalOverlayWithForwardRef);
function $f3f84453ead64de5$var$ModalOverlayInner({ UNSTABLE_portalContainer, ...props }) {
  let modalRef = props.modalRef;
  let { state } = props;
  let { modalProps, underlayProps } = (0, $8ac8429251c45e4b$export$dbc0f175b25fb0fb)(props, state, modalRef);
  let entering = (0, $d3f049242431219c$export$6d3443f2c48bfc20)(props.overlayRef) || props.isEntering || false;
  let renderProps = (0, $64fa3d84918910a7$export$4d86445c2cf5e3)({
    ...props,
    defaultClassName: "react-aria-ModalOverlay",
    values: {
      isEntering: entering,
      isExiting: props.isExiting,
      state
    }
  });
  let viewport = (0, $5df64b3807dc15ee$export$d699905dd57c73ca)();
  let style = {
    ...renderProps.style,
    "--visual-viewport-height": viewport.height + "px"
  };
  return /* @__PURE__ */ (0, $daTMi$react).createElement((0, $337b884510726a0d$export$c6fdb837b070b4ff), {
    isExiting: props.isExiting,
    portalContainer: UNSTABLE_portalContainer
  }, /* @__PURE__ */ (0, $daTMi$react).createElement("div", {
    ...(0, $3ef42575df84b30b$export$9d1611c77c2fe928)((0, $65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props), underlayProps),
    ...renderProps,
    style,
    ref: props.overlayRef,
    "data-entering": entering || void 0,
    "data-exiting": props.isExiting || void 0
  }, /* @__PURE__ */ (0, $daTMi$react).createElement((0, $64fa3d84918910a7$export$2881499e37b75b9a), {
    values: [
      [
        $f3f84453ead64de5$var$InternalModalContext,
        {
          modalProps,
          modalRef,
          isExiting: props.isExiting,
          isDismissable: props.isDismissable
        }
      ],
      [
        (0, $de32f1b87079253c$export$d2f961adcb0afbe),
        state
      ]
    ]
  }, renderProps.children)));
}
function $f3f84453ead64de5$var$ModalContent(props) {
  let { modalProps, modalRef, isExiting, isDismissable } = (0, $daTMi$useContext)($f3f84453ead64de5$var$InternalModalContext);
  let state = (0, $daTMi$useContext)((0, $de32f1b87079253c$export$d2f961adcb0afbe));
  let mergedRefs = (0, $daTMi$useMemo)(() => (0, $5dc95899b306f630$export$c9058316764c140e)(props.modalRef, modalRef), [
    props.modalRef,
    modalRef
  ]);
  let ref = (0, $df56164dff5785e2$export$4338b53315abf666)(mergedRefs);
  let entering = (0, $d3f049242431219c$export$6d3443f2c48bfc20)(ref);
  let renderProps = (0, $64fa3d84918910a7$export$4d86445c2cf5e3)({
    ...props,
    defaultClassName: "react-aria-Modal",
    values: {
      isEntering: entering,
      isExiting,
      state
    }
  });
  return /* @__PURE__ */ (0, $daTMi$react).createElement("div", {
    ...(0, $3ef42575df84b30b$export$9d1611c77c2fe928)((0, $65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props), modalProps),
    ...renderProps,
    ref,
    "data-entering": entering || void 0,
    "data-exiting": isExiting || void 0
  }, isDismissable && /* @__PURE__ */ (0, $daTMi$react).createElement((0, $86ea4cb521eb2e37$export$2317d149ed6f78c4), {
    onDismiss: state.close
  }), renderProps.children);
}

// ../../node_modules/.pnpm/client-only@0.0.1/node_modules/client-only/index.js
init_react_shim();

// src/components/modals/modal/Modal.tsx
import { jsx as jsx36, jsxs as jsxs29 } from "react/jsx-runtime";
function DefaultModal({
  title,
  isOpen = false,
  onClose,
  afterLeave,
  unmount,
  children
}) {
  return /* @__PURE__ */ jsx36(
    $f3f84453ead64de5$export$8948f78d83984c69,
    {
      isOpen,
      onOpenChange: (isOpen2) => !isOpen2 && onClose(),
      className: "fixed inset-0 transition-opacity bg-black/30 z-40 outline-0",
      children: /* @__PURE__ */ jsx36($f3f84453ead64de5$export$2b77a92f1a5ad772, { className: "outline-0", children: /* @__PURE__ */ jsx36(
        $de32f1b87079253c$export$3ddf2d174ce01153,
        {
          className: "fixed inset-0 z-50 flex items-center justify-center outline-0",
          "aria-label": title,
          children: /* @__PURE__ */ jsx36(
            "div",
            {
              className: "flex justify-center items-center p-4 md:p-6",
              style: { fontSize: 0 },
              children: /* @__PURE__ */ jsx36(Fragment5, { children: /* @__PURE__ */ jsx36("div", { className: "flex text-base text-left transform transition w-[calc(100vw-2rem)] max-w-xl", children: /* @__PURE__ */ jsxs29("div", { className: "w-full h-full flex flex-col bg-white shadow-xl overflow-hidden overflow-y-scroll scrollbar-hide p-4 md:p-6 max-h-[95svh] rounded-lg", children: [
                title && /* @__PURE__ */ jsx36("div", { className: "border-b border-neutral-40 pb-4 md:pb-6", children: /* @__PURE__ */ jsxs29("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ jsx36("h3", { className: "hd-md -mb-1.5", children: title }),
                  /* @__PURE__ */ jsx36("div", { className: "ml-3 h-7 flex items-center", children: /* @__PURE__ */ jsxs29(
                    IconButton,
                    {
                      size: "md",
                      onClick: onClose,
                      className: "mr-2",
                      variant: "ghost-muted",
                      children: [
                        /* @__PURE__ */ jsx36("span", { className: "sr-only", children: "Lukk" }),
                        /* @__PURE__ */ jsx36(XMarkIcon4, { className: "h-4 w-4", "aria-hidden": "true" })
                      ]
                    }
                  ) })
                ] }) }),
                !title && /* @__PURE__ */ jsx36("div", { className: "flex justify-end items-center min-h-[4rem] max-h-screen overflow-scroll", children: /* @__PURE__ */ jsxs29(
                  IconButton,
                  {
                    size: "md",
                    onClick: onClose,
                    className: "mr-5",
                    variant: "ghost-muted",
                    children: [
                      /* @__PURE__ */ jsx36("span", { className: "sr-only", children: "Lukk" }),
                      /* @__PURE__ */ jsx36(XMarkIcon4, { className: "h-4 w-4", "aria-hidden": "true" })
                    ]
                  }
                ) }),
                children
              ] }) }) })
            }
          )
        }
      ) })
    }
  );
}

// src/components/price/index.ts
init_react_shim();

// src/components/price/Price.tsx
init_react_shim();
import clsx24 from "clsx";

// src/components/sticker/index.ts
init_react_shim();

// src/components/sticker/Sticker.tsx
init_react_shim();
import clsx22 from "clsx";
import { jsx as jsx37 } from "react/jsx-runtime";
function Sticker({
  variant = "neutralDark",
  size = "base",
  children,
  className = ""
}) {
  return /* @__PURE__ */ jsx37(
    "span",
    {
      className: clsx22(
        `mr-1 px-2 font-semibold whitespace-nowrap inline-block mb-1 border`,
        {
          "text-xxs sm:py-1": size === "xs",
          "text-xxs sm:text-xs sm:py-1 ": size === "sm",
          "text-xxs sm:text-sm sm:py-1": size === "base" || size === "md",
          "text-xl py-2": size === "lg",
          "bg-primary-50 text-neutral-0 border-primary-50": variant === "primaryDark",
          "bg-primary-40 text-primary-60 border-primary-40": variant === "primaryLight",
          "bg-secondary-50 text-neutral-0 border-secondary-50": variant === "secondaryDark",
          "bg-secondary-40 text-secondary-60 border-secondary-40": variant === "secondaryLight",
          "bg-neutral-80 text-neutral-0 border-neutral-80": variant === "neutralDark",
          "bg-neutral-40 text-neutral-80 border-neutral-40": variant === "neutralLight",
          "bg-success-60 text-neutral-0 border-success-60": variant === "successDark",
          "bg-success-40 text-success-60 border-success-40": variant === "successLight",
          "bg-warning-60 text-neutral-0 border-warning-60": variant === "warningDark",
          "bg-warning-40 text-warning-60 border-warning-40": variant === "warningLight",
          "bg-neutral-0 text-neutral-80 border box-border capitalize": variant === "boxed"
        },
        className
      ),
      children
    }
  );
}

// src/components/price/PriceBlackFriday.tsx
init_react_shim();
import clsx23 from "clsx";
import { Fragment as Fragment6, jsx as jsx38, jsxs as jsxs30 } from "react/jsx-runtime";
function formatPrice(price) {
  const decimal = price % 1;
  const priceString = Math.floor(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (decimal > 0) {
    return /* @__PURE__ */ jsxs30("span", { children: [
      `${priceString}`,
      ",",
      Math.round(decimal * 100)
    ] });
  }
  return priceString;
}
function calculatePercentOff(before, after) {
  return Math.round(100 - after / before * 100);
}
function calculateDiscount(before, after) {
  return before - after;
}
var PriceAmount = ({
  price,
  size,
  className = ""
}) => {
  return /* @__PURE__ */ jsx38(
    "span",
    {
      className: `
        block font-bold whitespace-nowrap leading-none
        ${size === "sm" ? "hd-lg" : ""}
        ${size === "md" ? "hd-xl" : ""}
        ${size === "lg" ? "hd-xl" : ""}
        ${className}
      `,
      children: formatPrice(price)
    }
  );
};
function PriceTitle({ size, children }) {
  return /* @__PURE__ */ jsx38(
    "span",
    {
      className: clsx23("block font-medium text-xs whitespace-nowrap", {
        "mt-0 text-xxs": size === "xs",
        "mt-2": size !== "xs"
      }),
      children
    }
  );
}
function PriceBlackFirday({
  price,
  priceText,
  memberPrice,
  campaignPrice,
  memberPriceText = "Medlemspris",
  normalPriceText = "Ikke medlemspris",
  campaignPriceText = "F\xF8r",
  discountPercentOverride,
  discountAmountOverride,
  withStickers = true,
  size = "md",
  children
}) {
  if (!price) {
    return null;
  }
  if (campaignPrice && price && campaignPrice !== price) {
    const discountPercent = discountPercentOverride || calculatePercentOff(price, campaignPrice);
    const discountAmount = discountAmountOverride || calculateDiscount(price, campaignPrice);
    return /* @__PURE__ */ jsxs30(Fragment6, { children: [
      /* @__PURE__ */ jsxs30("span", { className: clsx23({ block: size === "xs" }), children: [
        /* @__PURE__ */ jsxs30("span", { className: "block text-promotion-base", children: [
          /* @__PURE__ */ jsx38(PriceTitle, { size, children: "Medlemspris" }),
          /* @__PURE__ */ jsxs30("div", { className: "flex flex-wrap gap-2 items-center", children: [
            /* @__PURE__ */ jsx38(
              PriceAmount,
              {
                price: campaignPrice,
                size,
                className: "text-primary-50"
              }
            ),
            memberPrice && /* @__PURE__ */ jsx38(
              PriceAmount,
              {
                price: memberPrice,
                size: "sm",
                className: "text-neutral-70 line-through font-normal text-sm"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs30("span", { className: "block text-xxs font-medium", children: [
          "Ikke medlemspris ",
          /* @__PURE__ */ jsx38("span", { children: formatPrice(price) })
        ] })
      ] }),
      size !== "sm" && withStickers && /* @__PURE__ */ jsxs30("div", { children: [
        /* @__PURE__ */ jsx38(Sticker, { variant: "neutralLight", size: "sm", className: "px-1", children: /* @__PURE__ */ jsxs30("strong", { children: [
          "-",
          discountPercent,
          "%"
        ] }) }),
        /* @__PURE__ */ jsxs30(Sticker, { variant: "neutralDark", size: "sm", className: "pr-2", children: [
          "Spar ",
          formatPrice(discountAmount)
        ] })
      ] })
    ] });
  }
  if (memberPrice && price && memberPrice !== price) {
    const discountPercent = discountPercentOverride || calculatePercentOff(price, memberPrice);
    const discountAmount = discountAmountOverride || calculateDiscount(price, memberPrice);
    return /* @__PURE__ */ jsxs30("div", { className: clsx23("inline-block", { flex: size === "xs" }), children: [
      /* @__PURE__ */ jsxs30("span", { className: clsx23({ block: size === "xs" }), children: [
        /* @__PURE__ */ jsx38(PriceTitle, { size, children: memberPriceText }),
        /* @__PURE__ */ jsx38(
          PriceAmount,
          {
            price: memberPrice,
            size,
            className: "block text-primary-50"
          }
        ),
        /* @__PURE__ */ jsxs30("div", { className: "text-xxs", children: [
          normalPriceText,
          " ",
          /* @__PURE__ */ jsx38("span", { children: formatPrice(price) })
        ] })
      ] }),
      size !== "sm" && withStickers && /* @__PURE__ */ jsxs30("div", { className: "mt-2", children: [
        /* @__PURE__ */ jsx38(Sticker, { variant: "neutralLight", size: "sm", children: /* @__PURE__ */ jsxs30("strong", { className: "font-medium", children: [
          "-",
          discountPercent,
          "%"
        ] }) }),
        /* @__PURE__ */ jsxs30(Sticker, { variant: "neutralDark", size: "sm", className: "pr-3", children: [
          "Spar ",
          formatPrice(discountAmount)
        ] })
      ] })
    ] });
  }
  if (campaignPrice == price) {
    return /* @__PURE__ */ jsxs30("div", { children: [
      /* @__PURE__ */ jsx38(PriceTitle, { size, children: priceText }),
      /* @__PURE__ */ jsx38(PriceAmount, { price, size, className: "text-primary-50" }),
      /* @__PURE__ */ jsx38("div", { className: "mt-1", children })
    ] });
  }
  return /* @__PURE__ */ jsxs30("div", { children: [
    /* @__PURE__ */ jsx38(PriceTitle, { size, children: priceText }),
    /* @__PURE__ */ jsx38(PriceAmount, { price, size }),
    /* @__PURE__ */ jsx38("div", { className: "mt-1", children })
  ] });
}
var PriceBlackFriday_default = PriceBlackFirday;

// src/components/price/Price.tsx
import { Fragment as Fragment7, jsx as jsx39, jsxs as jsxs31 } from "react/jsx-runtime";
function formatPrice2(price) {
  const decimal = price % 1;
  const priceString = Math.floor(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (decimal > 0) {
    return /* @__PURE__ */ jsxs31("span", { children: [
      `${priceString}`,
      ",",
      Math.round(decimal * 100)
    ] });
  }
  return priceString;
}
function calculatePercentOff2(before, after) {
  return Math.round(100 - after / before * 100);
}
function calculateDiscount2(before, after) {
  return before - after;
}
var PriceAmount2 = ({
  price,
  size,
  className = ""
}) => {
  return /* @__PURE__ */ jsx39(
    "span",
    {
      className: `
        block font-bold whitespace-nowrap leading-none
        ${size === "sm" ? "hd-lg" : ""}
        ${size === "md" ? "hd-xl" : ""}
        ${size === "lg" ? "hd-xl" : ""}
        ${className}
      `,
      children: formatPrice2(price)
    }
  );
};
function PriceTitle2({ size, isSearch, children }) {
  return /* @__PURE__ */ jsx39(
    "span",
    {
      className: twMerge(
        clsx24("block font-medium text-xs whitespace-nowrap", {
          "mt-0 text-xxs": size === "xs",
          "mt-2": size !== "xs",
          "font-bold": isSearch
        })
      ),
      children
    }
  );
}
function Price(props) {
  const {
    price,
    priceText,
    memberPrice,
    campaignPrice,
    memberPriceText = "Medlemspris",
    normalPriceText = "Ikke medlemspris",
    campaignPriceText = "F\xF8r",
    discountPercentOverride,
    discountAmountOverride,
    withStickers = true,
    size = "md",
    children,
    isBlackFriday = false,
    isSearch = false,
    className
  } = props;
  if (isBlackFriday) {
    return /* @__PURE__ */ jsx39(PriceBlackFriday_default, { ...props });
  }
  if (!price) {
    return null;
  }
  if (campaignPrice && price && campaignPrice !== price) {
    const discountPercent = discountPercentOverride || calculatePercentOff2(price, campaignPrice);
    const discountAmount = discountAmountOverride || calculateDiscount2(price, campaignPrice);
    return /* @__PURE__ */ jsxs31(Fragment7, { children: [
      /* @__PURE__ */ jsxs31(
        "span",
        {
          className: clsx24({
            block: size === "xs",
            "flex flex-col gap-[3px] items-end": isSearch
          }),
          children: [
            /* @__PURE__ */ jsx39("span", { className: "block text-promotion-base", children: /* @__PURE__ */ jsx39(PriceTitle2, { size, isSearch, children: "Tilbudspris" }) }),
            /* @__PURE__ */ jsx39("span", { className: "block text-promotion-base", children: /* @__PURE__ */ jsx39(
              PriceAmount2,
              {
                price: campaignPrice,
                size,
                className: "text-primary-50"
              }
            ) }),
            /* @__PURE__ */ jsxs31("span", { className: "block text-xxs font-medium", children: [
              campaignPriceText,
              " ",
              /* @__PURE__ */ jsx39("span", { children: formatPrice2(price) })
            ] })
          ]
        }
      ),
      size !== "sm" && withStickers && /* @__PURE__ */ jsxs31("div", { children: [
        /* @__PURE__ */ jsx39(Sticker, { variant: "neutralLight", size: "sm", className: "px-1", children: /* @__PURE__ */ jsxs31("strong", { children: [
          "-",
          discountPercent,
          "%"
        ] }) }),
        /* @__PURE__ */ jsxs31(Sticker, { variant: "neutralDark", size: "sm", className: "pr-2", children: [
          "Spar ",
          formatPrice2(discountAmount)
        ] })
      ] })
    ] });
  }
  if (memberPrice && price && memberPrice !== price) {
    const discountPercent = discountPercentOverride || calculatePercentOff2(price, memberPrice);
    const discountAmount = discountAmountOverride || calculateDiscount2(price, memberPrice);
    return /* @__PURE__ */ jsxs31("div", { className: clsx24("inline-block", { flex: size === "xs" }), children: [
      /* @__PURE__ */ jsxs31(
        "span",
        {
          className: clsx24({
            block: size === "xs",
            "flex flex-col gap-[3px] items-end": isSearch
          }),
          children: [
            /* @__PURE__ */ jsx39(PriceTitle2, { size, isSearch, children: memberPriceText }),
            /* @__PURE__ */ jsx39(
              PriceAmount2,
              {
                price: memberPrice,
                size,
                className: "block text-primary-50"
              }
            ),
            /* @__PURE__ */ jsxs31("div", { className: "text-xxs", children: [
              normalPriceText,
              " ",
              /* @__PURE__ */ jsx39("span", { children: formatPrice2(price) })
            ] })
          ]
        }
      ),
      size !== "sm" && withStickers && /* @__PURE__ */ jsxs31("div", { className: "mt-2", children: [
        /* @__PURE__ */ jsx39(Sticker, { variant: "neutralLight", size: "sm", children: /* @__PURE__ */ jsxs31("strong", { className: "font-medium", children: [
          "-",
          discountPercent,
          "%"
        ] }) }),
        /* @__PURE__ */ jsxs31(Sticker, { variant: "neutralDark", size: "sm", className: "pr-3", children: [
          "Spar ",
          formatPrice2(discountAmount)
        ] })
      ] })
    ] });
  }
  if (campaignPrice == price) {
    return /* @__PURE__ */ jsxs31(
      "div",
      {
        className: clsx24({
          "flex flex-col gap-[3px] items-end": isSearch,
          className
        }),
        children: [
          /* @__PURE__ */ jsx39(PriceTitle2, { size, isSearch, children: priceText }),
          /* @__PURE__ */ jsx39(PriceAmount2, { price, size, className: "text-primary-50" }),
          /* @__PURE__ */ jsx39("div", { className: "mt-1", children })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs31(
    "div",
    {
      className: clsx24({
        "flex flex-col gap-[3px] items-end": isSearch
      }),
      children: [
        /* @__PURE__ */ jsx39(PriceTitle2, { size, isSearch, children: priceText }),
        /* @__PURE__ */ jsx39(PriceAmount2, { price, size }),
        /* @__PURE__ */ jsx39("div", { className: "mt-1", children })
      ]
    }
  );
}

// src/components/promotion/index.ts
init_react_shim();

// src/components/promotion/Promotion.tsx
init_react_shim();
import clsx25 from "clsx";
import { jsx as jsx40, jsxs as jsxs32 } from "react/jsx-runtime";
function Promotion({
  className = "",
  innerClassName = "",
  percent,
  size = "sm"
}) {
  if (!percent)
    return null;
  return /* @__PURE__ */ jsx40("div", { className, children: /* @__PURE__ */ jsxs32(
    "div",
    {
      className: twMerge(
        clsx25(
          "rounded-full relative  bg-neutral-80 text-neutral-0 flex items-center justify-center",
          "[print-color-adjust:exact]",
          {
            "size-10 hd-sm": size === "xs",
            "size-10 hd-sm sm:size-14 sm:hd-md": size === "sm",
            "h-20 w-20 hd-lg md:h-24 md:w-24 md:hd-lg lg:h-28 lg:w-28 lg:hd-xl": size === "lg"
          },
          innerClassName
        )
      ),
      children: [
        percent,
        "%"
      ]
    }
  ) });
}

// src/components/filter/index.ts
init_react_shim();

// src/components/filter/FilterSwitch.tsx
init_react_shim();
import clsx26 from "clsx";
import { jsx as jsx41, jsxs as jsxs33 } from "react/jsx-runtime";
var FilterSwitch = (props) => {
  const { title, children, classNames: classNames2, ...rest } = props;
  return /* @__PURE__ */ jsxs33(
    "div",
    {
      className: clsx26(
        "flex justify-between items-center",
        classNames2 == null ? void 0 : classNames2.container
      ),
      children: [
        /* @__PURE__ */ jsx41(
          "h3",
          {
            className: clsx26(
              "hd-md py-5 self-start cursor-pointer",
              classNames2 == null ? void 0 : classNames2.title
            ),
            onClick: () => props.onChange(!props.checked),
            children: title
          }
        ),
        children ? /* @__PURE__ */ jsxs33("div", { className: "flex", children: [
          /* @__PURE__ */ jsx41("div", { className: "pr-10", children: /* @__PURE__ */ jsx41("div", { className: "text-grey-base", children }) }),
          /* @__PURE__ */ jsx41("div", { className: "ml-auto flex items-center", children: /* @__PURE__ */ jsx41(Switch, { ...rest, title }) })
        ] }) : /* @__PURE__ */ jsx41(Switch, { ...rest, title })
      ]
    }
  );
};

// src/components/product-list/index.ts
init_react_shim();

// src/components/product-list/ProducListGridItem.tsx
init_react_shim();
import clsx27 from "clsx";
import { useRef as useRef6 } from "react";
import { jsx as jsx42, jsxs as jsxs34 } from "react/jsx-runtime";
var ProductListGridItem = ({
  product,
  tags,
  store,
  size,
  image,
  showImage = true,
  inventory,
  onStoreClick
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const productTagsRef = useRef6(null);
  const {
    posterName,
    posterDescription,
    images,
    price,
    campaignPrice,
    memberPrice,
    stock,
    deliveryTimeText
  } = product;
  const productStock = inventory || {
    display: (store == null ? void 0 : store.id) && stock && stock[`${store.id}Display`] || 0,
    stock: (store == null ? void 0 : store.id) && stock && stock[`${store.id}Stock`] || 0
  };
  const discountInPercent = (((_a = product == null ? void 0 : product.tags) == null ? void 0 : _a.includes("nyhet")) || ((_b = product == null ? void 0 : product.tags) == null ? void 0 : _b.includes("salg")) || ((_c = product == null ? void 0 : product.tags) == null ? void 0 : _c.includes("kupp")) || ((_d = product == null ? void 0 : product.tags) == null ? void 0 : _d.includes("outlet")) || ((_e = product == null ? void 0 : product.tags) == null ? void 0 : _e.includes("KUPP!")) || ((_f = product == null ? void 0 : product.tags) == null ? void 0 : _f.includes("BLACK WEEK")) || ((_g = product == null ? void 0 : product.tags) == null ? void 0 : _g.includes("Medlemstilbud"))) && !((_h = product == null ? void 0 : product.tags) == null ? void 0 : _h.includes("BLACK WEEK MEDLEM")) && price && (campaignPrice && calculatePercentOff2(price, campaignPrice) || memberPrice && calculatePercentOff2(price, memberPrice)) || 0;
  const calculateOffset = () => {
    if (productTagsRef.current) {
      return productTagsRef.current.clientHeight + productTagsRef.current.offsetTop * 2;
    }
    return 45;
  };
  return /* @__PURE__ */ jsxs34("div", { className: "relative w-full max-w-sm group", children: [
    showImage && /* @__PURE__ */ jsxs34(
      "div",
      {
        className: clsx27(
          "overflow-hidden relative group-hover:bg-neutral-40 block",
          "w-full lg:h-50 aspect-square",
          "bg-neutral-30 rounded-[4px]",
          "outline-offset-8 focus:outline-4"
        ),
        children: [
          /* @__PURE__ */ jsx42(
            ProductTags,
            {
              tags,
              variant: "plp",
              size: "xs",
              ref: productTagsRef
            }
          ),
          /* @__PURE__ */ jsx42(
            ProductListGridItemImage,
            {
              images,
              image,
              size: "md",
              topOffset: calculateOffset()
            }
          ),
          discountInPercent > 0 && /* @__PURE__ */ jsx42(
            Promotion,
            {
              className: "absolute bottom-2 right-2 z-10",
              size: "sm",
              innerClassName: ((_i = product == null ? void 0 : product.tags) == null ? void 0 : _i.includes("BLACK WEEK")) ? "bg-[#F4A933] text-neutral-80" : "",
              percent: discountInPercent
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs34("div", { className: "my-4 flex justify-between flex-col gap-4", children: [
      /* @__PURE__ */ jsxs34("h2", { className: "hd-base mb-0 pb-0 text-neutral-80", children: [
        posterName && posterName.replace(new RegExp(String.fromCharCode(160), "g"), " "),
        /* @__PURE__ */ jsx42("span", { className: "block body-xs text-neutral-70", children: posterDescription })
      ] }),
      (store == null ? void 0 : store.id) && /* @__PURE__ */ jsx42(
        StockIndicators,
        {
          stock: productStock,
          store,
          onStoreClick,
          notAvailable: (_j = product.tags) == null ? void 0 : _j.includes("outlet"),
          deliveryTime: deliveryTimeText,
          algoliaProduct: product
        }
      ),
      /* @__PURE__ */ jsx42(
        Price,
        {
          size: "sm",
          price,
          memberPrice,
          campaignPrice,
          withStickers: false,
          isBlackFriday: ((_k = product == null ? void 0 : product.tags) == null ? void 0 : _k.includes("BLACK WEEK MEDLEM")) || false
        }
      )
    ] })
  ] });
};

// src/components/product-list/ProductListGridItemImage.tsx
init_react_shim();
import clsx28 from "clsx";

// src/components/icons/ChevronLeft.tsx
init_react_shim();
import { jsx as jsx43 } from "react/jsx-runtime";
var ChevronLeft = (props) => /* @__PURE__ */ jsx43(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx43(
      "path",
      {
        d: "M14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L9.41421 12L14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289Z",
        fill: "#071114"
      }
    )
  }
);
var ChevronLeft_default = ChevronLeft;

// src/components/icons/ChevronRight.tsx
init_react_shim();
import { jsx as jsx44 } from "react/jsx-runtime";
var ChevronRight = (props) => /* @__PURE__ */ jsx44(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx44(
      "path",
      {
        d: "M9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071Z",
        fill: "#071114"
      }
    )
  }
);
var ChevronRight_default = ChevronRight;

// src/components/product-list/ProductListGridItemImage.tsx
import { useState as useState6, useRef as useRef7 } from "react";
import { Fragment as Fragment8, jsx as jsx45, jsxs as jsxs35 } from "react/jsx-runtime";
var ProductListGridItemImage = ({
  images,
  image,
  size,
  topOffset = 0
}) => {
  const [currentGalleryImage, setCurrentGalleryImage] = useState6(0);
  const hasGallery = images && images.length > 0;
  const touchStartX = useRef7(0);
  const touchEndX = useRef7(0);
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const swipeDistance = touchEndX.current - touchStartX.current;
    const minSwipeDistance = 50;
    if (Math.abs(swipeDistance) > minSwipeDistance && hasGallery) {
      if (swipeDistance > 0) {
        setCurrentGalleryImage(
          (state) => state - 1 < 0 ? images.length - 1 : state - 1
        );
      } else {
        setCurrentGalleryImage(
          (state) => state + 1 >= images.length ? 0 : state + 1
        );
      }
    }
  };
  return /* @__PURE__ */ jsxs35(Fragment8, { children: [
    /* @__PURE__ */ jsx45(
      "div",
      {
        className: "mix-blend-multiply overflow-hidden absolute top-0 left-0 size-full",
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        children: hasGallery ? /* @__PURE__ */ jsx45("div", { className: "relative w-full h-full", children: /* @__PURE__ */ jsx45(
          "div",
          {
            className: "absolute top-0 left-0 w-full h-full transition-transform duration-500 flex",
            style: {
              transform: `translateX(-${currentGalleryImage * 100}%)`
            },
            children: images.map((img, index) => /* @__PURE__ */ jsx45(
              "img",
              {
                src: img.url,
                alt: "",
                style: img.type === "single" ? { paddingTop: `${topOffset}px` } : {},
                className: twMerge(
                  clsx28("w-full h-full min-w-full object-cover", {
                    "pb-8 px-8 object-contain": img.type === "single"
                  })
                ),
                draggable: false
              },
              index
            ))
          }
        ) }) : image ? /* @__PURE__ */ jsx45(
          "div",
          {
            className: "w-full h-full pb-8 px-8",
            style: { paddingTop: `${topOffset}px` },
            children: /* @__PURE__ */ jsx45("div", { className: "w-full h-full relative", children: image })
          }
        ) : /* @__PURE__ */ jsx45(ImageMissing, { size: size || "md" })
      }
    ),
    hasGallery && /* @__PURE__ */ jsx45("div", { className: "flex gap-2 justify-self-center absolute bottom-2 left-0 w-full justify-center", children: images.map((img, index) => /* @__PURE__ */ jsx45(
      "div",
      {
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          setCurrentGalleryImage(index);
        },
        className: twMerge(
          clsx28(
            "size-2 rounded-full bg-neutral-50 hover:bg-neutral-70 cursor-pointer",
            {
              "bg-neutral-70": index === currentGalleryImage
            }
          )
        )
      },
      index
    )) }),
    hasGallery && /* @__PURE__ */ jsx45(
      "div",
      {
        className: "w-6 absolute h-full top-0 left-0 cursor-pointer hidden lg:group-hover:flex justify-center items-center",
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          setCurrentGalleryImage((state) => {
            return state - 1 < 0 ? images.length - 1 : state - 1;
          });
        },
        children: /* @__PURE__ */ jsx45(ChevronLeft_default, { className: "w-6 h-6 text-neutral-0" })
      }
    ),
    hasGallery && /* @__PURE__ */ jsx45(
      "div",
      {
        className: "w-6 absolute h-full top-0 right-0 cursor-pointer hidden lg:group-hover:flex justify-center items-center",
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          setCurrentGalleryImage((state) => {
            return state + 1 >= images.length ? 0 : state + 1;
          });
        },
        children: /* @__PURE__ */ jsx45(ChevronRight_default, { className: "w-6 h-6 text-neutral-0" })
      }
    )
  ] });
};

// src/components/product-tags/index.ts
init_react_shim();

// src/components/product-tags/ProductTags.tsx
init_react_shim();
import clsx29 from "clsx";
import { forwardRef as forwardRef11 } from "react";
import { jsx as jsx46 } from "react/jsx-runtime";
var ProductTags = forwardRef11(
  ({ tags, variant, size = "md" }, ref) => {
    if (!tags)
      return null;
    return /* @__PURE__ */ jsx46(
      "div",
      {
        className: clsx29({
          "absolute top-2 left-2 z-10 flex items-start flex-wrap min-h-[29px]": variant === "plp",
          "flex mb-1 print:hidden": variant === "pdp"
        }),
        ref,
        children: tags.map((tag) => /* @__PURE__ */ jsx46(Sticker, { variant: tag.variant, size, children: tag.label }, tag.label))
      }
    );
  }
);

// src/components/stock-indicators/index.ts
init_react_shim();

// src/components/stock-indicators/StockIndicators.tsx
init_react_shim();
import clsx30 from "clsx";

// src/components/icons/index.tsx
init_react_shim();

// src/components/icons/StoreIcon.tsx
init_react_shim();
import { jsx as jsx47, jsxs as jsxs36 } from "react/jsx-runtime";
var StoreIcon = (props) => /* @__PURE__ */ jsxs36(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx47(
        "path",
        {
          d: "M3 9v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9",
          stroke: "currentColor",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          d: "M20.485 3h-3.992l.5 5s1 1 2.5 1a3.23 3.23 0 0 0 2.14-.806.503.503 0 0 0 .15-.465L21.075 3.5a.6.6 0 0 0-.59-.5Z",
          stroke: "currentColor",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          d: "m16.493 3 .5 5s-1 1-2.5 1-2.5-1-2.5-1V3h4.5Z",
          stroke: "currentColor",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          d: "M11.993 3v5s-1 1-2.5 1-2.5-1-2.5-1l.5-5h4.5Z",
          stroke: "currentColor",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          d: "M7.493 3h-3.99a.6.6 0 0 0-.593.501L2.205 7.73a.506.506 0 0 0 .15.465c.328.29 1.061.806 2.138.806 1.5 0 2.5-1 2.5-1L7.493 3Z",
          stroke: "currentColor",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          d: "M14.5 15h-5v6h5v-6Z",
          stroke: "currentColor",
          strokeWidth: 1.5,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);

// src/components/icons/EyeIcon.tsx
init_react_shim();
import { jsx as jsx48, jsxs as jsxs37 } from "react/jsx-runtime";
var EyeIcon2 = (props) => /* @__PURE__ */ jsxs37(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx48("path", { fill: "currentColor", d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }),
      /* @__PURE__ */ jsx48(
        "path",
        {
          fill: "currentColor",
          d: "M21.894 11.553C19.736 7.236 15.904 5 12 5c-3.903 0-7.736 2.236-9.894 6.553a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19c3.903 0 7.736-2.236 9.894-6.553a1 1 0 0 0 0-.894ZM12 17c-2.969 0-6.002-1.62-7.87-5C5.998 8.62 9.03 7 12 7c2.969 0 6.002 1.62 7.87 5-1.868 3.38-4.901 5-7.87 5Z"
        }
      )
    ]
  }
);

// src/components/icons/LocationIcon.tsx
init_react_shim();
import { jsx as jsx49, jsxs as jsxs38 } from "react/jsx-runtime";
var LocationIcon = (props) => /* @__PURE__ */ jsxs38(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx49(
        "path",
        {
          fill: "currentColor",
          d: "M10 7.375a3.125 3.125 0 1 0 0 6.25 3.125 3.125 0 0 0 0-6.25Z"
        }
      ),
      /* @__PURE__ */ jsx49(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1.542a.625.625 0 0 1 .625.625v1.068a7.293 7.293 0 0 1 6.64 6.64h1.068a.625.625 0 0 1 0 1.25h-1.068a7.293 7.293 0 0 1-6.64 6.64v1.068a.625.625 0 1 1-1.25 0v-1.068a7.293 7.293 0 0 1-6.64-6.64H1.667a.625.625 0 1 1 0-1.25h1.068a7.293 7.293 0 0 1 6.64-6.64V2.167A.625.625 0 0 1 10 1.542ZM3.958 10.5a6.042 6.042 0 1 0 12.084 0 6.042 6.042 0 0 0-12.084 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);

// src/components/icons/LocationPinIcon.tsx
init_react_shim();
import { jsx as jsx50, jsxs as jsxs39 } from "react/jsx-runtime";
var LocationPinIcon = (props) => /* @__PURE__ */ jsxs39(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx50(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.5 8.672C4.5 4.679 7.894 1.5 12 1.5s7.5 3.18 7.5 7.172c0 2.25-1.217 5.036-2.55 7.444-1.354 2.443-2.912 4.644-3.747 5.773a1.489 1.489 0 0 1-2.406 0c-.835-1.13-2.393-3.332-3.747-5.775C5.717 13.706 4.5 10.92 4.5 8.672ZM12 3C8.652 3 6 5.577 6 8.672c0 1.829 1.033 4.314 2.363 6.715 1.306 2.359 2.819 4.5 3.637 5.605.818-1.105 2.331-3.244 3.637-5.603C16.967 12.988 18 10.502 18 8.672 18 5.577 15.348 3 12 3Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx50(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.879 6.879a3 3 0 1 1 4.242 4.243A3 3 0 0 1 9.88 6.879ZM12 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Armchair.tsx
init_react_shim();
import { jsx as jsx51, jsxs as jsxs40 } from "react/jsx-runtime";
var Armchair = (props) => /* @__PURE__ */ jsxs40(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx51(
        "path",
        {
          d: "M21.625 25.8438H10.375C8.13795 25.8414 5.99318 24.9517 4.41134 23.3699C2.82951 21.7881 1.93982 19.6433 1.9375 17.4063C1.9375 16.6603 2.23382 15.945 2.76126 15.4175C3.28871 14.8901 4.00408 14.5938 4.75 14.5938C5.49592 14.5938 6.21129 14.8901 6.73874 15.4175C7.26618 15.945 7.5625 16.6603 7.5625 17.4063C7.56316 18.152 7.85969 18.867 8.38699 19.3943C8.9143 19.9216 9.62928 20.2181 10.375 20.2188H21.625C22.3707 20.2181 23.0857 19.9216 23.613 19.3943C24.1403 18.867 24.4368 18.152 24.4375 17.4063C24.4375 16.6603 24.7338 15.945 25.2613 15.4175C25.7887 14.8901 26.5041 14.5938 27.25 14.5938C27.9959 14.5938 28.7113 14.8901 29.2387 15.4175C29.7662 15.945 30.0625 16.6603 30.0625 17.4063C30.0602 19.6433 29.1705 21.7881 27.5887 23.3699C26.0068 24.9517 23.8621 25.8414 21.625 25.8438Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx51(
        "path",
        {
          d: "M5.6875 27.7189L6.9825 25.1301",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx51(
        "path",
        {
          d: "M26.3126 27.7189L25.0176 25.1301",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx51(
        "path",
        {
          d: "M25.93 14.9237L24.93 7.46125C24.7938 6.57569 24.345 5.76816 23.665 5.18485C22.9849 4.60154 22.1184 4.28099 21.2225 4.28125H10.78C9.88423 4.28129 9.01808 4.60197 8.33827 5.18526C7.65845 5.76854 7.20988 6.57591 7.07373 7.46125L6.07373 14.9237",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Armrest.tsx
init_react_shim();
import { jsx as jsx52, jsxs as jsxs41 } from "react/jsx-runtime";
var Armrest = (props) => /* @__PURE__ */ jsxs41(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsxs41("g", { "clip-path": "url(#clip0_4454_84541)", children: [
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M7.14723 28.9801C6.90624 28.9801 6.89178 28.9705 6.85322 28.956C6.75201 28.9078 6.69899 28.8018 6.71827 28.6958L7.39304 24.9074C7.41714 24.7773 7.53763 24.6905 7.67259 24.7146C7.80272 24.7387 7.88948 24.864 7.86538 24.9942L7.23881 28.503C7.42196 28.503 7.66777 28.503 7.9184 28.4933L9.31131 24.864C9.35951 24.7387 9.49928 24.6761 9.6246 24.7243C9.74991 24.7725 9.81257 24.9122 9.76437 25.0375L8.31362 28.8163C8.27988 28.9078 8.19312 28.9705 8.09191 28.9705C7.60511 28.9753 7.32074 28.9801 7.14723 28.9801Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M6.47781 10.7231C6.34285 10.7231 6.23682 10.6171 6.23682 10.4821V7.19983C6.23682 5.32975 7.75505 3.81152 9.62512 3.81152H24.3447C24.4797 3.81152 24.5857 3.91756 24.5857 4.05251C24.5857 4.18747 24.4797 4.2935 24.3447 4.2935H9.62512C8.02496 4.2935 6.72361 5.59484 6.72361 7.19501V10.4773C6.72361 10.6122 6.61758 10.7183 6.48263 10.7183L6.47781 10.7231Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M24.3443 23.7944L4.4145 23.7847C4.18797 23.7847 4 23.5967 4 23.3702V14.1162C4 12.839 5.03625 11.8027 6.3135 11.8027H6.65088C7.92812 11.8027 8.96438 12.839 8.96438 14.1162V19.4373H26.759C26.894 19.4373 27 19.5433 27 19.6783C27 19.8132 26.894 19.9192 26.759 19.9192H8.71857C8.58361 19.9192 8.47758 19.8132 8.47758 19.6783V14.1162C8.47758 13.1089 7.65821 12.2847 6.64606 12.2847H6.30868C5.30134 12.2847 4.47716 13.1041 4.47716 14.1162V23.3027L24.3395 23.3124C24.4744 23.3124 24.5805 23.4184 24.5805 23.5534C24.5805 23.6883 24.4744 23.7944 24.3395 23.7944H24.3443Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsxs41("g", { opacity: "0.2", children: [
          /* @__PURE__ */ jsx52(
            "mask",
            {
              id: "mask0_4454_84541",
              style: { maskType: "luminance" },
              maskUnits: "userSpaceOnUse",
              x: "3",
              y: "11",
              width: "7",
              height: "13",
              children: /* @__PURE__ */ jsx52(
                "path",
                {
                  d: "M8.74289 12.0388H4.24121V23.5388H8.74289V12.0388Z",
                  fill: "white",
                  stroke: "white",
                  "stroke-width": "0.8"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx52("g", { mask: "url(#mask0_4454_84541)", children: /* @__PURE__ */ jsx52(
            "path",
            {
              d: "M8.71873 19.6734V14.1113C8.71873 12.969 7.79333 12.0388 6.64622 12.0388H6.30883C5.16655 12.0388 4.23633 12.9642 4.23633 14.1113V23.3653C4.23633 23.4617 4.31344 23.5388 4.40984 23.5388H8.68017C8.68017 23.5388 8.7862 19.6011 8.71873 19.6734Z",
              fill: "#071114",
              stroke: "#071114",
              "stroke-width": "0.8"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M26.6678 17.0899H10.7625C10.6275 17.0899 10.5215 16.9839 10.5215 16.8489C10.5215 16.7139 10.6275 16.6079 10.7625 16.6079H26.6726C26.8075 16.6079 26.9136 16.7139 26.9136 16.8489C26.9136 16.9839 26.8075 17.0899 26.6726 17.0899H26.6678Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M22.3147 19.7844C22.1798 19.7844 22.0737 19.6784 22.0737 19.5435V6.51076C22.0737 6.37581 22.1798 6.26978 22.3147 6.26978C22.4497 6.26978 22.5557 6.37581 22.5557 6.51076V19.5435C22.5557 19.6784 22.4497 19.7844 22.3147 19.7844Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M8.71853 23.7654C8.58357 23.7654 8.47754 23.6593 8.47754 23.5244V19.6734C8.47754 19.5384 8.58357 19.4324 8.71853 19.4324C8.85348 19.4324 8.95952 19.5384 8.95952 19.6734V23.5244C8.95952 23.6593 8.85348 23.7654 8.71853 23.7654Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        )
      ] }),
      /* @__PURE__ */ jsx52("defs", { children: /* @__PURE__ */ jsx52("clipPath", { id: "clip0_4454_84541", children: /* @__PURE__ */ jsx52("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/Backrest.tsx
init_react_shim();
import { jsx as jsx53, jsxs as jsxs42 } from "react/jsx-runtime";
var Backrest = (props) => /* @__PURE__ */ jsxs42(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx53(
        "path",
        {
          d: "M8.01052 28.0747C7.78462 28.0747 7.77079 28.0655 7.73391 28.0516C7.63709 28.0055 7.58638 27.9041 7.60482 27.8027L8.25025 24.179C8.2733 24.0546 8.39317 23.967 8.51764 23.9946C8.64212 24.0177 8.7251 24.1375 8.70205 24.262L8.10272 27.6183C8.27791 27.6183 8.51303 27.6183 8.75277 27.609L10.0851 24.1375C10.1312 24.0177 10.2649 23.9624 10.3848 24.0038C10.5047 24.0499 10.5646 24.1836 10.5185 24.3035L9.1308 27.9179C9.09853 28.0055 9.01094 28.0655 8.91873 28.0655C8.44849 28.0701 8.17649 28.0747 8.01052 28.0747Z",
          fill: "#35383A",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx53(
        "path",
        {
          d: "M7.36967 10.6111C7.24059 10.6111 7.13916 10.5096 7.13916 10.3806V7.24099C7.13916 5.45222 8.59138 4 10.3801 4H24.4598C24.5889 4 24.6903 4.10142 24.6903 4.23051C24.6903 4.3596 24.5889 4.46102 24.4598 4.46102H10.3801C8.84955 4.46102 7.60479 5.70578 7.60479 7.23638V10.3759C7.60479 10.505 7.50337 10.6065 7.37428 10.6065L7.36967 10.6111Z",
          fill: "#35383A",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx53(
        "path",
        {
          d: "M24.4598 23.114L5.39648 23.1048C5.1798 23.1048 5 22.925 5 22.7083V13.8567C5 12.635 5.9912 11.6438 7.21291 11.6438H7.53562C8.75733 11.6438 9.74853 12.635 9.74853 13.8567V18.9464H26.7695C26.8986 18.9464 27 19.0478 27 19.1769C27 19.306 26.8986 19.4074 26.7695 19.4074H9.51341C9.38433 19.4074 9.2829 19.306 9.2829 19.1769V13.8567C9.2829 12.8932 8.49916 12.1048 7.53101 12.1048H7.2083C6.24476 12.1048 5.45641 12.8886 5.45641 13.8567V22.6438L24.4552 22.653C24.5842 22.653 24.6857 22.7544 24.6857 22.8835C24.6857 23.0126 24.5842 23.114 24.4552 23.114H24.4598Z",
          fill: "#35383A",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx53(
        "path",
        {
          d: "M22.5191 19.2784C22.39 19.2784 22.2886 19.177 22.2886 19.0479V6.58183C22.2886 6.45274 22.39 6.35132 22.5191 6.35132C22.6482 6.35132 22.7496 6.45274 22.7496 6.58183V19.0479C22.7496 19.177 22.6482 19.2784 22.5191 19.2784Z",
          fill: "#35383A",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsxs42("g", { opacity: "0.2", children: [
        /* @__PURE__ */ jsx53(
          "mask",
          {
            id: "mask0_4454_84538",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "6",
            y: "3",
            width: "17",
            height: "17",
            children: /* @__PURE__ */ jsx53(
              "path",
              {
                d: "M22.5418 4.17065H7.36035V19.1723H22.5418V4.17065Z",
                fill: "white",
                stroke: "white",
                "stroke-width": "0.8"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx53("g", { mask: "url(#mask0_4454_84538)", children: /* @__PURE__ */ jsx53(
          "path",
          {
            d: "M7.36035 9.87353V11.8467C7.36035 11.8467 8.51752 11.6761 9.11685 12.6627C9.71618 13.6493 9.5456 14.5944 9.5456 14.5944L9.51333 19.177L22.5188 19.0525L22.5418 4.17529H10.191C10.191 4.17529 7.76605 4.2214 7.36957 7.2457L7.36035 9.88275V9.87353Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx53(
        "path",
        {
          d: "M26.6819 16.7013H11.3252C11.1962 16.7013 11.0947 16.5998 11.0947 16.4707C11.0947 16.3417 11.1962 16.2402 11.3252 16.2402H26.6819C26.811 16.2402 26.9124 16.3417 26.9124 16.4707C26.9124 16.5998 26.811 16.7013 26.6819 16.7013Z",
          fill: "#35383A",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Bed.tsx
init_react_shim();
import { jsx as jsx54, jsxs as jsxs43 } from "react/jsx-runtime";
var Bed = (props) => /* @__PURE__ */ jsxs43(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx54(
        "path",
        {
          d: "M4.75 1.9375H27.25C27.25 1.9375 29.125 1.9375 29.125 3.8125V28.1875C29.125 28.1875 29.125 30.0625 27.25 30.0625H4.75C4.75 30.0625 2.875 30.0625 2.875 28.1875V3.8125C2.875 3.8125 2.875 1.9375 4.75 1.9375Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx54(
        "path",
        {
          d: "M8.5 5.6875H12.25C12.25 5.6875 14.125 5.6875 14.125 7.5625V9.4375C14.125 9.4375 14.125 11.3125 12.25 11.3125H8.5C8.5 11.3125 6.625 11.3125 6.625 9.4375V7.5625C6.625 7.5625 6.625 5.6875 8.5 5.6875Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx54(
        "path",
        {
          d: "M19.75 5.6875H23.5C23.5 5.6875 25.375 5.6875 25.375 7.5625V9.4375C25.375 9.4375 25.375 11.3125 23.5 11.3125H19.75C19.75 11.3125 17.875 11.3125 17.875 9.4375V7.5625C17.875 7.5625 17.875 5.6875 19.75 5.6875Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx54(
        "path",
        {
          d: "M2.875 11.3125H29.125",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx54(
        "path",
        {
          d: "M2.875 16.9375H29.125",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/BedOpen.tsx
init_react_shim();
import { jsx as jsx55, jsxs as jsxs44 } from "react/jsx-runtime";
var BedOpen = (props) => /* @__PURE__ */ jsxs44(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsxs44("g", { "clip-path": "url(#clip0_4454_84548)", children: [
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M27.2243 19.6537H2.62423C2.51552 19.6537 2.42234 19.5864 2.38092 19.488C2.33951 19.3897 2.36539 19.2758 2.44304 19.2033L6.9779 14.9791C7.02449 14.9325 7.07108 14.9066 7.15909 14.9118L20.6342 15.036C20.7792 15.036 20.8931 15.1551 20.8931 15.2948C20.8931 15.4346 20.774 15.5537 20.6342 15.5537L7.26262 15.4294L3.28686 19.1308H27.2295C27.3744 19.1308 27.4883 19.2447 27.4883 19.3897C27.4831 19.5398 27.3692 19.6537 27.2243 19.6537Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M29.4293 24.2868H2.62392C2.47897 24.2868 2.36508 24.1729 2.36508 24.0279V19.4361C2.36508 19.2912 2.47897 19.1773 2.62392 19.1773C2.76887 19.1773 2.88276 19.2912 2.88276 19.4361V23.7691H29.1704V20.6889C29.1704 20.544 29.2843 20.4301 29.4293 20.4301C29.5742 20.4301 29.6881 20.544 29.6881 20.6889V24.0279C29.6881 24.1729 29.5742 24.2868 29.4293 24.2868Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M30.8942 17.0497C30.8476 17.0497 30.7958 17.0342 30.7544 17.0083L8.13191 2.62202C8.03355 2.55989 7.99214 2.44083 8.0232 2.33212C8.05426 2.2234 8.14226 2.15611 8.27168 2.14575L12.8117 2.15611C12.8635 2.15611 12.9101 2.17164 12.9515 2.19752L28.5905 12.3388C28.6268 12.3595 28.6527 12.3906 28.6734 12.4268L31.1116 16.6614C31.1738 16.765 31.153 16.8944 31.065 16.9772C31.0236 17.0238 30.9563 17.0497 30.8942 17.0497ZM9.16727 2.66343L30.1436 16.004L28.2644 12.7374L12.7341 2.67378L9.16727 2.66343Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M29.393 19.2808C29.3464 19.2808 29.2998 19.2653 29.2532 19.2394L6.63586 4.8531C6.57891 4.81686 6.5375 4.75474 6.52197 4.68744C6.50644 4.62015 6.52197 4.54767 6.5582 4.49073L8.03359 2.29577C8.11124 2.17671 8.27172 2.14565 8.39078 2.2233C8.50985 2.30095 8.54091 2.46143 8.46326 2.5805L7.13283 4.55803L29.3153 18.6647L30.6509 16.6769C30.7286 16.5578 30.8891 16.5267 31.0081 16.6044C31.1272 16.682 31.1583 16.8425 31.0806 16.9616L29.6052 19.1565C29.5586 19.2394 29.4758 19.2808 29.393 19.2808Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M27.9182 28.2987C27.794 28.2987 27.6853 28.2107 27.6646 28.0865L27.2245 25.6223C27.1986 25.4825 27.2918 25.348 27.4316 25.3221C27.5714 25.3014 27.706 25.3894 27.7319 25.5291L28.1719 27.9933C28.1978 28.1331 28.1046 28.2677 27.9648 28.2935C27.9493 28.2935 27.9337 28.2987 27.9182 28.2987Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M3.88721 28.2989C3.87168 28.2989 3.85615 28.2989 3.84062 28.2937C3.70085 28.2678 3.60767 28.1332 3.63355 27.9934L4.07358 25.5293C4.09946 25.3895 4.23406 25.2963 4.37383 25.3222C4.5136 25.3481 4.60678 25.4827 4.5809 25.6225L4.14087 28.0866C4.12017 28.2108 4.01145 28.2989 3.88721 28.2989Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M7.08633 19.5034C6.94138 19.5034 6.82749 19.3895 6.82749 19.2445V15.3982C6.82749 15.2532 6.94138 15.1394 7.08633 15.1394C7.23128 15.1394 7.34517 15.2532 7.34517 15.3982V19.2445C7.34517 19.3895 7.23128 19.5034 7.08633 19.5034Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M4.72034 13.3069C4.71516 13.3069 4.70998 13.3069 4.70481 13.3069C4.55986 13.3018 4.45114 13.1775 4.4615 13.0326C4.60645 10.2785 6.69787 8.54429 6.78587 8.47182C6.89458 8.38381 7.06024 8.39934 7.14825 8.50806C7.23625 8.61677 7.22072 8.78243 7.11201 8.87043C7.0913 8.88596 5.11377 10.5374 4.97918 13.0584C4.96882 13.1982 4.85493 13.3069 4.72034 13.3069Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M7.13333 11.0394C6.98838 11.0394 6.87449 10.9255 6.87449 10.7806L6.86931 8.66844L4.75719 8.67361C4.60706 8.68914 4.49835 8.55972 4.49835 8.41477C4.49835 8.26982 4.61224 8.15593 4.75719 8.15593L7.12815 8.15076C7.19545 8.15076 7.26275 8.17664 7.30934 8.22841C7.35593 8.275 7.38699 8.3423 7.38699 8.4096L7.39217 10.7806C7.39217 10.9203 7.2731 11.0394 7.13333 11.0394Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M27.2243 19.6537H2.62423C2.51552 19.6537 2.42234 19.5864 2.38092 19.488C2.33951 19.3897 2.36539 19.2758 2.44304 19.2033L6.9779 14.9791C7.02449 14.9325 7.07108 14.9066 7.15909 14.9118L20.6342 15.036C20.7792 15.036 20.8931 15.1551 20.8931 15.2948C20.8931 15.4346 20.774 15.5537 20.6342 15.5537L7.26262 15.4294L3.28686 19.1308H27.2295C27.3744 19.1308 27.4883 19.2447 27.4883 19.3897C27.4831 19.5398 27.3692 19.6537 27.2243 19.6537Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M29.4293 24.2868H2.62392C2.47897 24.2868 2.36508 24.1729 2.36508 24.0279V19.4361C2.36508 19.2912 2.47897 19.1773 2.62392 19.1773C2.76887 19.1773 2.88276 19.2912 2.88276 19.4361V23.7691H29.1704V20.6889C29.1704 20.544 29.2843 20.4301 29.4293 20.4301C29.5742 20.4301 29.6881 20.544 29.6881 20.6889V24.0279C29.6881 24.1729 29.5742 24.2868 29.4293 24.2868Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M30.8942 17.0497C30.8476 17.0497 30.7958 17.0342 30.7544 17.0083L8.13191 2.62202C8.03355 2.55989 7.99214 2.44083 8.0232 2.33212C8.05426 2.2234 8.14226 2.15611 8.27168 2.14575L12.8117 2.15611C12.8635 2.15611 12.9101 2.17164 12.9515 2.19752L28.5905 12.3388C28.6268 12.3595 28.6527 12.3906 28.6734 12.4268L31.1116 16.6614C31.1738 16.765 31.153 16.8944 31.065 16.9772C31.0236 17.0238 30.9563 17.0497 30.8942 17.0497ZM9.16727 2.66343L30.1436 16.004L28.2644 12.7374L12.7341 2.67378L9.16727 2.66343Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M29.393 19.2808C29.3464 19.2808 29.2998 19.2653 29.2532 19.2394L6.63586 4.8531C6.57891 4.81686 6.5375 4.75474 6.52197 4.68744C6.50644 4.62015 6.52197 4.54767 6.5582 4.49073L8.03359 2.29577C8.11124 2.17671 8.27172 2.14565 8.39078 2.2233C8.50985 2.30095 8.54091 2.46143 8.46326 2.5805L7.13283 4.55803L29.3153 18.6647L30.6509 16.6769C30.7286 16.5578 30.8891 16.5267 31.0081 16.6044C31.1272 16.682 31.1583 16.8425 31.0806 16.9616L29.6052 19.1565C29.5586 19.2394 29.4758 19.2808 29.393 19.2808Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M27.9182 28.2987C27.794 28.2987 27.6853 28.2107 27.6646 28.0865L27.2245 25.6223C27.1986 25.4825 27.2918 25.348 27.4316 25.3221C27.5714 25.3014 27.706 25.3894 27.7319 25.5291L28.1719 27.9933C28.1978 28.1331 28.1046 28.2677 27.9648 28.2935C27.9493 28.2935 27.9337 28.2987 27.9182 28.2987Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M3.88721 28.2989C3.87168 28.2989 3.85615 28.2989 3.84062 28.2937C3.70085 28.2678 3.60767 28.1332 3.63355 27.9934L4.07358 25.5293C4.09946 25.3895 4.23406 25.2963 4.37383 25.3222C4.5136 25.3481 4.60678 25.4827 4.5809 25.6225L4.14087 28.0866C4.12017 28.2108 4.01145 28.2989 3.88721 28.2989Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M7.08633 19.5034C6.94138 19.5034 6.82749 19.3895 6.82749 19.2445V15.3982C6.82749 15.2532 6.94138 15.1394 7.08633 15.1394C7.23128 15.1394 7.34517 15.2532 7.34517 15.3982V19.2445C7.34517 19.3895 7.23128 19.5034 7.08633 19.5034Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M4.72034 13.3069C4.71516 13.3069 4.70998 13.3069 4.70481 13.3069C4.55986 13.3018 4.45114 13.1775 4.4615 13.0326C4.60645 10.2785 6.69787 8.54429 6.78587 8.47182C6.89458 8.38381 7.06024 8.39934 7.14825 8.50806C7.23625 8.61677 7.22072 8.78243 7.11201 8.87043C7.0913 8.88596 5.11377 10.5374 4.97918 13.0584C4.96882 13.1982 4.85493 13.3069 4.72034 13.3069Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx55(
          "path",
          {
            d: "M7.13333 11.0394C6.98838 11.0394 6.87449 10.9255 6.87449 10.7806L6.86931 8.66844L4.75719 8.67361C4.60706 8.68914 4.49835 8.55972 4.49835 8.41477C4.49835 8.26982 4.61224 8.15593 4.75719 8.15593L7.12815 8.15076C7.19545 8.15076 7.26275 8.17664 7.30934 8.22841C7.35593 8.275 7.38699 8.3423 7.38699 8.4096L7.39217 10.7806C7.39217 10.9203 7.2731 11.0394 7.13333 11.0394Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        )
      ] }),
      /* @__PURE__ */ jsx55("defs", { children: /* @__PURE__ */ jsx55("clipPath", { id: "clip0_4454_84548", children: /* @__PURE__ */ jsx55("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/Box.tsx
init_react_shim();
import { jsx as jsx56, jsxs as jsxs45 } from "react/jsx-runtime";
var Box = (props) => /* @__PURE__ */ jsxs45(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx56(
        "path",
        {
          d: "M16 1.9375L1.9375 7.5625L16 13.1875L30.0625 7.5625L16 1.9375Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx56(
        "path",
        {
          d: "M1.9375 7.5625V24.4375L16 30.0625V13.1875L1.9375 7.5625Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx56(
        "path",
        {
          d: "M30.0625 7.5625V24.4375L16 30.0625V13.1875L30.0625 7.5625Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx56(
        "path",
        {
          d: "M23.7339 10.0938L9.67139 4.46875",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx56(
        "path",
        {
          d: "M26.7812 21.625L24.4375 22.5625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Chair.tsx
init_react_shim();
import { jsx as jsx57, jsxs as jsxs46 } from "react/jsx-runtime";
var Chair = (props) => /* @__PURE__ */ jsxs46(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx57("g", { "clip-path": "url(#clip0_4454_84565)", children: /* @__PURE__ */ jsx57(
        "path",
        {
          d: "M24.3389 21.5667C24.3389 20.2939 23.4973 19.3132 22.2384 18.9446C22.3149 18.4926 22.3984 18.0127 22.4888 17.4841C23.1148 13.8605 23.9633 8.90142 24.318 5.61166C24.4571 4.27628 24.0885 3.14257 23.2191 2.24536C21.8629 0.840403 19.5051 0.30488 17.5716 0.110115L17.5785 0.0336301C17.5021 0.0266532 16.883 -0.00810068 15.9928 0.00578784C15.1095 -0.0150775 14.4975 0.0266532 14.4209 0.0336301L14.4279 0.110115C12.4944 0.30488 10.1366 0.840403 8.78033 2.24536C7.91097 3.14955 7.5423 4.28319 7.68145 5.61166C8.07789 9.31873 9.04467 15.328 9.64977 18.9655C8.44655 19.355 7.65367 20.3218 7.65367 21.5598C7.65367 21.7197 7.67453 21.8798 7.70238 22.0327C7.67453 22.1023 7.65367 22.1788 7.65367 22.2553V31.2761C7.65367 31.6238 7.90405 31.9368 8.24488 31.9855C8.67607 32.0481 9.04474 31.7143 9.04474 31.297V23.9036C9.47593 24.1332 9.95584 24.2792 10.4427 24.314C10.4427 24.3279 10.4357 24.3348 10.4357 24.3487V29.1965C10.4357 29.5442 10.6861 29.8572 11.027 29.9059C11.4581 29.9685 11.8268 29.6346 11.8268 29.2173V24.3487H20.173V29.1965C20.173 29.5442 20.4234 29.8572 20.7642 29.9059C21.1954 29.9685 21.564 29.6346 21.564 29.2173V24.3487C21.564 24.3348 21.5571 24.3279 21.5571 24.314C22.0439 24.2722 22.5238 24.1332 22.955 23.8967V31.283C22.955 31.6307 23.2054 31.9437 23.5462 31.9924C23.9774 32.055 24.3461 31.7212 24.3461 31.3039V22.2622C24.3391 22.1718 24.3252 22.0883 24.2905 22.0049C24.318 21.8588 24.3319 21.7128 24.3389 21.5667ZM9.05843 5.46561C8.96108 4.55451 9.19751 3.81724 9.77483 3.21215C11.1798 1.75157 14.1844 1.44556 15.9927 1.40383C17.808 1.44556 20.8056 1.75157 22.2106 3.21215C22.7879 3.81026 23.0244 4.54753 22.927 5.46561C22.5793 8.71363 21.7307 13.6448 21.1117 17.2476C21.0144 17.804 20.9309 18.3047 20.8474 18.7777H11.0198C10.4147 15.161 9.4479 9.14489 9.05843 5.46561ZM21.1395 22.9578H10.839C9.9696 22.9578 9.03065 22.5196 9.03065 21.5668C9.03065 20.6139 9.9696 20.1758 10.839 20.1758H21.1395C22.0089 20.1758 22.9478 20.6139 22.9478 21.5668C22.9478 22.5196 22.0089 22.9578 21.1395 22.9578Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.2"
        }
      ) }),
      /* @__PURE__ */ jsx57("defs", { children: /* @__PURE__ */ jsx57("clipPath", { id: "clip0_4454_84565", children: /* @__PURE__ */ jsx57("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/ChristmasBells.tsx
init_react_shim();
import { jsx as jsx58, jsxs as jsxs47 } from "react/jsx-runtime";
var ChristmasBells = (props) => /* @__PURE__ */ jsxs47(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M15.5127 11.2956C15.5127 12.029 15.803 12.7324 16.3198 13.251C16.8366 13.7696 17.5376 14.0609 18.2685 14.0609C18.9993 14.0609 19.7003 13.7696 20.2171 13.251C20.7339 12.7324 21.0242 12.029 21.0242 11.2956C21.0242 10.5622 20.7339 9.85882 20.2171 9.34022C19.7003 8.82162 18.9993 8.53027 18.2685 8.53027C17.5376 8.53027 16.8366 8.82162 16.3198 9.34022C15.803 9.85882 15.5127 10.5622 15.5127 11.2956Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M18.1592 26.868L27.206 23.2527C27.522 23.1278 27.7931 22.9056 27.9824 22.6161C28.1717 22.3266 28.2701 21.984 28.2641 21.6348C28.2581 21.2856 28.148 20.9468 27.9489 20.6644C27.7498 20.382 27.4712 20.1698 27.1511 20.0567C26.7069 19.8763 26.306 19.5984 25.9761 19.2422C25.6463 18.8861 25.3954 18.4602 25.2407 17.994L24.033 14.798C23.4758 13.3419 22.3992 12.1617 21.0247 11.5",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M24.1321 24.4766C24.3432 25.0386 24.3294 25.6643 24.0936 26.2158C23.8578 26.7674 23.4195 27.1996 22.875 27.4176C22.3305 27.6355 21.7244 27.6212 21.1901 27.3778C20.6558 27.1345 20.237 26.682 20.0259 26.1199",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M19.2129 8.70062L21.0135 6.71729",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M15.9852 12.8378C15.6752 13.1439 15.3036 13.3755 14.8968 13.516C14.49 13.6565 14.0582 13.7023 13.6322 13.6504C13.2062 13.5984 12.7966 13.4498 12.4328 13.2153C12.069 12.9808 11.7599 12.6661 11.5276 12.2938C11.343 11.979 11.2227 11.6284 11.1742 11.2637C11.1257 10.8991 11.15 10.528 11.2457 10.1734C11.3413 9.8188 11.5063 9.48816 11.7304 9.20184C11.9544 8.91551 12.2329 8.67956 12.5487 8.50851C13.1704 8.15876 13.8935 8.05216 14.5852 8.2083C15.277 8.36443 15.891 8.77281 16.3145 9.35851",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M11.1431 10.7747L9.27663 10.2193C9.03915 10.1508 8.83094 10.0017 8.68555 9.7961C8.54015 9.59051 8.46604 9.34037 8.47515 9.086V7.95267C8.47817 7.75516 8.43112 7.56027 8.33868 7.38732C8.24624 7.21437 8.11162 7.06936 7.94815 6.96667L6.85024 6.37733C6.68269 6.27748 6.54368 6.1337 6.44728 5.96055C6.35088 5.78741 6.30051 5.59104 6.30128 5.39133V4.13333C6.30128 3.83275 6.41695 3.54449 6.62285 3.33195C6.82875 3.1194 7.10801 3 7.39919 3H9.34251C9.52848 3.00699 9.70967 3.06267 9.86907 3.16179C10.0285 3.26091 10.1609 3.40023 10.2538 3.56667L10.8686 4.53C10.9583 4.67244 11.0779 4.79223 11.2186 4.8805C11.3592 4.96878 11.5173 5.02329 11.6811 5.04L13.0535 5.176C13.2858 5.1998 13.5048 5.29944 13.6785 5.46044C13.8522 5.62145 13.9717 5.83544 14.0196 6.07133L14.4588 8.236",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M11.6813 12.5205C10.799 12.686 9.96947 13.0721 9.26514 13.6451C8.56081 14.218 8.00318 14.9604 7.641 15.8072L6.19175 19.2072C6.01701 19.6657 5.7478 20.0795 5.40277 20.42C5.05775 20.7605 4.64515 21.0196 4.19354 21.1792C3.96329 21.247 3.75039 21.3664 3.57008 21.529C3.38977 21.6917 3.2465 21.8934 3.15052 22.1198C3.0592 22.3249 3.00835 22.5467 3.00094 22.7723C2.99354 22.9979 3.02973 23.2227 3.1074 23.4337C3.18508 23.6447 3.30267 23.8376 3.45334 24.0012C3.604 24.1648 3.78472 24.2958 3.98494 24.3865L14.0309 28.9198C14.3381 29.079 14.6861 29.1342 15.0255 29.0776C15.3648 29.021 15.6783 28.8555 15.9213 28.6046C16.1644 28.3537 16.3247 28.0301 16.3795 27.6798C16.4344 27.3295 16.3809 26.9703 16.2267 26.6532C16.0363 26.2007 15.9436 25.7109 15.955 25.2177C15.9663 24.7245 16.0815 24.2398 16.2926 23.7972L17.632 20.6692C18.2078 19.3834 18.3137 17.9261 17.9303 16.566C17.547 15.2059 16.7001 14.0347 15.546 13.2685",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M11.0228 27.5484C10.7869 28.0985 10.3491 28.5293 9.80548 28.7461C9.26191 28.9629 8.65717 28.9479 8.1243 28.7044C7.59143 28.4609 7.17408 28.0089 6.96406 27.4478C6.75405 26.8867 6.76856 26.2625 7.00442 25.7124",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M12.4716 8.55329L10.8027 6.71729",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          d: "M20.9258 10.5593L22.0237 10.2193C22.2592 10.1487 22.4649 9.99868 22.6082 9.79328C22.7515 9.58789 22.824 9.3389 22.8142 9.086V7.95267C22.8154 7.75488 22.8667 7.56086 22.963 7.38987C23.0593 7.21888 23.1973 7.07689 23.3632 6.978L24.4172 6.37733C24.5831 6.27844 24.7211 6.13645 24.8174 5.96546C24.9137 5.79448 24.965 5.60045 24.9662 5.40267V4.13333C24.9662 3.83275 24.8505 3.54449 24.6446 3.33195C24.4387 3.1194 24.1594 3 23.8682 3H22.0237C21.8397 3.00887 21.6607 3.06543 21.5034 3.16446C21.346 3.26349 21.2154 3.40181 21.1234 3.56667L20.5416 4.51867C20.4507 4.66252 20.3294 4.78317 20.1867 4.87152C20.0441 4.95987 19.8838 5.01361 19.7181 5.02867L18.4226 5.16467C18.1902 5.18846 17.9713 5.2881 17.7975 5.44911C17.6238 5.61012 17.5043 5.82411 17.4564 6.06L16.8745 8.97267",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/ColorPallete.tsx
init_react_shim();
import { jsx as jsx59, jsxs as jsxs48 } from "react/jsx-runtime";
var ColorPallete = (props) => /* @__PURE__ */ jsxs48(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M27.5557 21.6745C27.5557 21.6745 27.5179 21.6745 27.499 21.6745C27.329 21.6434 27.2157 21.4818 27.2472 21.314L30.358 3.95829L22.9776 2.67199L22.1212 7.43814C22.0897 7.60592 21.9259 7.72399 21.7559 7.69292C21.5859 7.66185 21.4725 7.50028 21.4977 7.3325L22.4045 2.25565C22.4171 2.17487 22.4675 2.1003 22.5368 2.0568C22.6061 2.00709 22.6879 1.98845 22.7698 2.00709L30.7736 3.40524C30.8555 3.41767 30.9311 3.46739 30.9751 3.53574C31.0255 3.60409 31.0444 3.68488 31.0255 3.76566L27.858 21.4259C27.8328 21.575 27.7006 21.6807 27.5494 21.6807L27.5557 21.6745Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M29.9612 7.91663C29.9612 7.91663 29.936 7.91663 29.9171 7.91663L22.0014 6.53091C21.8755 6.50605 21.7873 6.38798 21.8125 6.2637C21.8377 6.13942 21.9637 6.05243 22.0833 6.07728L29.999 7.46301C30.1249 7.48787 30.2131 7.60593 30.1879 7.73021C30.169 7.84206 30.0683 7.92285 29.9549 7.92285L29.9612 7.91663Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M29.2496 11.9061C29.2496 11.9061 29.2244 11.9061 29.2055 11.9061L23.0531 10.8311C22.9271 10.8063 22.839 10.6882 22.8641 10.5639C22.8893 10.4396 23.0153 10.3526 23.1349 10.3775L29.2874 11.4525C29.4133 11.4774 29.5015 11.5954 29.4763 11.7197C29.4574 11.8316 29.3567 11.9123 29.2433 11.9123L29.2496 11.9061Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M28.5317 15.8893C28.5317 15.8893 28.5065 15.8893 28.4876 15.8893L24.8855 15.2617C24.7596 15.2368 24.6714 15.1188 24.6966 14.9945C24.7218 14.8702 24.8478 14.7832 24.9674 14.8081L28.5695 15.4357C28.6954 15.4605 28.7836 15.5786 28.7584 15.7029C28.7395 15.8147 28.6387 15.8955 28.5254 15.8955L28.5317 15.8893Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M25.1248 19.4623C25.0052 19.4623 24.8918 19.3939 24.8352 19.2821L17.461 3.23127L10.6348 6.28857L12.6625 10.7005C12.7318 10.8559 12.6625 11.0423 12.5051 11.1106C12.3476 11.179 12.1587 11.1106 12.0894 10.9553L9.92948 6.26371C9.86021 6.10836 9.92948 5.92194 10.0869 5.85359L17.4862 2.5353C17.5618 2.50423 17.65 2.49802 17.7255 2.52909C17.8011 2.56016 17.8641 2.61609 17.9018 2.69066L25.4082 19.0273C25.4775 19.1827 25.4082 19.3691 25.2508 19.4374C25.2067 19.4561 25.1626 19.4623 25.1185 19.4623H25.1248Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M11.9509 10.0387C11.8628 10.0387 11.7746 9.98894 11.7368 9.90187C11.6801 9.78371 11.7368 9.64689 11.8565 9.59092L19.1802 6.30726C19.2999 6.25129 19.4384 6.30726 19.4951 6.42542C19.5518 6.54359 19.4951 6.6804 19.3754 6.73638L12.0517 10.02C12.0202 10.0325 11.9887 10.0387 11.9572 10.0387H11.9509Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M15.2823 12.9936C15.1941 12.9936 15.1059 12.9439 15.0682 12.8569C15.0115 12.7388 15.0682 12.6021 15.1878 12.5462L20.8743 9.99843C20.9939 9.9425 21.1324 9.99843 21.1891 10.1165C21.2458 10.2346 21.1891 10.3713 21.0695 10.4272L15.383 12.9749C15.3515 12.9874 15.32 12.9936 15.2886 12.9936H15.2823Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M19.3315 15.6221C19.2433 15.6221 19.1552 15.5723 19.1174 15.4854C19.0607 15.3673 19.1174 15.2306 19.237 15.1747L22.5683 13.6833C22.6879 13.6274 22.8265 13.6833 22.8832 13.8014C22.9398 13.9194 22.8832 14.0561 22.7635 14.1121L19.4322 15.6034C19.4008 15.6158 19.3693 15.6221 19.3378 15.6221H19.3315Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M21.8188 19.4996C21.7621 19.4996 21.7054 19.4871 21.6488 19.4499L6.54787 10.0481L2.54909 16.3056L6.699 18.8906C6.84384 18.9838 6.88792 19.1764 6.79976 19.3194C6.7053 19.4623 6.51008 19.5058 6.36525 19.4188L1.95085 16.6722C1.80601 16.579 1.76193 16.3864 1.85009 16.2434L6.18262 9.46394C6.22671 9.39558 6.29598 9.34587 6.37784 9.32723C6.45971 9.30859 6.54157 9.32723 6.61714 9.36451L21.9888 18.9341C22.1337 19.0273 22.1777 19.2199 22.0896 19.3629C22.0266 19.4561 21.9258 19.5058 21.8251 19.5058L21.8188 19.4996Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M5.60956 18.7601C5.56548 18.7601 5.5214 18.7477 5.48362 18.7228C5.37656 18.6545 5.33878 18.5115 5.40805 18.3997L9.6965 11.6886C9.76577 11.5829 9.91061 11.5456 10.024 11.614C10.131 11.6823 10.1688 11.8253 10.0995 11.9371L5.81108 18.6482C5.76699 18.7166 5.69143 18.7539 5.60956 18.7539V18.7601Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M10.0365 19.4251C9.99244 19.4251 9.94836 19.4126 9.91058 19.3878C9.80352 19.3194 9.76574 19.1765 9.83501 19.0647L13.1663 13.8511C13.2355 13.7455 13.3804 13.7082 13.4937 13.7765C13.6008 13.8449 13.6386 13.9878 13.5693 14.0997L10.238 19.3132C10.194 19.3816 10.1184 19.4189 10.0365 19.4189V19.4251Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M14.8856 19.4188C14.8415 19.4188 14.7974 19.4064 14.7596 19.3815C14.6526 19.3132 14.6148 19.1702 14.684 19.0584L16.6362 16.0073C16.7055 15.9017 16.8503 15.8644 16.9637 15.9327C17.0707 16.0011 17.1085 16.144 17.0392 16.2559L15.0871 19.307C15.043 19.3753 14.9674 19.4126 14.8856 19.4126V19.4188Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M22.8705 29.1376H1.31486C1.13854 29.1376 1 29.0009 1 28.8269V20.8108C1 20.6368 1.13854 20.5001 1.31486 20.5001H22.8705C25.2823 20.5001 27.2471 22.4389 27.2471 24.8188C27.2471 27.1988 25.2823 29.1376 22.8705 29.1376ZM1.62973 28.5162H22.8705C24.936 28.5162 26.6174 26.857 26.6174 24.8188C26.6174 22.7806 24.936 21.1215 22.8705 21.1215H1.62973V28.5162Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M22.713 26.7327C21.6424 26.7327 20.7734 25.8751 20.7734 24.8188C20.7734 23.7624 21.6424 22.9048 22.713 22.9048C23.7835 22.9048 24.6525 23.7624 24.6525 24.8188C24.6525 25.8751 23.7835 26.7327 22.713 26.7327ZM22.713 23.52C21.9888 23.52 21.4031 24.1042 21.4031 24.8126C21.4031 25.5209 21.9951 26.1051 22.713 26.1051C23.4309 26.1051 24.0228 25.5209 24.0228 24.8126C24.0228 24.1042 23.4309 23.52 22.713 23.52Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M5.42064 29.0132C5.2884 29.0132 5.18134 28.9076 5.18134 28.7771V20.8418C5.18134 20.7113 5.2884 20.6057 5.42064 20.6057C5.55288 20.6057 5.65994 20.7113 5.65994 20.8418V28.7771C5.65994 28.9076 5.55288 29.0132 5.42064 29.0132Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M9.5265 29.0132C9.39426 29.0132 9.28721 28.9076 9.28721 28.7771V20.8418C9.28721 20.7113 9.39426 20.6057 9.5265 20.6057C9.65875 20.6057 9.7658 20.7113 9.7658 20.8418V28.7771C9.7658 28.9076 9.65875 29.0132 9.5265 29.0132Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M13.626 29.0132C13.4938 29.0132 13.3868 28.9076 13.3868 28.7771V20.8418C13.3868 20.7113 13.4938 20.6057 13.626 20.6057C13.7583 20.6057 13.8653 20.7113 13.8653 20.8418V28.7771C13.8653 28.9076 13.7583 29.0132 13.626 29.0132Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M17.7256 29.0132C17.5934 29.0132 17.4863 28.9076 17.4863 28.7771V20.8418C17.4863 20.7113 17.5934 20.6057 17.7256 20.6057C17.8578 20.6057 17.9649 20.7113 17.9649 20.8418V28.7771C17.9649 28.9076 17.8578 29.0132 17.7256 29.0132Z",
          fill: "#35383A"
        }
      ),
      /* @__PURE__ */ jsx59("path", { d: "M9.57059 20.873H5.43328V28.6902H9.57059V20.873Z", fill: "#071114" }),
      /* @__PURE__ */ jsx59("path", { d: "M9.57059 20.873H5.43328V28.6902H9.57059V20.873Z", fill: "#35383A" }),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M13.5883 20.8543H9.45103V28.6715H13.5883V20.8543Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M13.5883 20.8543H9.45103V28.6715H13.5883V20.8543Z",
          fill: "#696B6D"
        }
      ),
      /* @__PURE__ */ jsx59("path", { d: "M17.7571 20.8107H13.5694V28.628H17.7571V20.8107Z", fill: "#071114" }),
      /* @__PURE__ */ jsx59("path", { d: "M17.7571 20.8107H13.5694V28.628H17.7571V20.8107Z", fill: "#AAABAC" }),
      /* @__PURE__ */ jsx59(
        "path",
        {
          d: "M29.9613 7.68672L22.0456 6.30099M29.2497 11.6699L23.0972 10.5949M28.5318 15.6594L24.936 15.0318M19.2747 6.52472L11.951 9.80572M20.9687 10.2096L15.2823 12.7574M22.6628 13.9008L19.3315 15.386M9.89819 11.8191L5.60973 18.5302M13.368 13.9754L10.0367 19.189M16.8378 16.1378L14.8856 19.1889M27.5557 21.6745C27.5557 21.6745 27.5179 21.6745 27.499 21.6745C27.329 21.6434 27.2157 21.4818 27.2472 21.314L30.358 3.95829L22.9776 2.67199L22.1212 7.43814C22.0897 7.60592 21.9259 7.72399 21.7559 7.69292C21.5859 7.66185 21.4725 7.50028 21.4977 7.3325L22.4045 2.25565C22.4171 2.17487 22.4675 2.1003 22.5368 2.0568C22.6061 2.00709 22.6879 1.98845 22.7698 2.00709L30.7736 3.40524C30.8555 3.41767 30.9311 3.46739 30.9751 3.53574C31.0255 3.60409 31.0444 3.68488 31.0255 3.76566L27.858 21.4259C27.8328 21.575 27.7006 21.6807 27.5494 21.6807L27.5557 21.6745ZM29.9612 7.91663C29.9612 7.91663 29.936 7.91663 29.9171 7.91663L22.0014 6.53091C21.8755 6.50605 21.7873 6.38798 21.8125 6.2637C21.8377 6.13942 21.9637 6.05243 22.0833 6.07728L29.999 7.46301C30.1249 7.48787 30.2131 7.60593 30.1879 7.73021C30.169 7.84206 30.0683 7.92285 29.9549 7.92285L29.9612 7.91663ZM29.2496 11.9061C29.2496 11.9061 29.2244 11.9061 29.2055 11.9061L23.0531 10.8311C22.9271 10.8063 22.839 10.6882 22.8641 10.5639C22.8893 10.4396 23.0153 10.3526 23.1349 10.3775L29.2874 11.4525C29.4133 11.4774 29.5015 11.5954 29.4763 11.7197C29.4574 11.8316 29.3567 11.9123 29.2433 11.9123L29.2496 11.9061ZM28.5317 15.8893C28.5317 15.8893 28.5065 15.8893 28.4876 15.8893L24.8855 15.2617C24.7596 15.2368 24.6714 15.1188 24.6966 14.9945C24.7218 14.8702 24.8478 14.7832 24.9674 14.8081L28.5695 15.4357C28.6954 15.4605 28.7836 15.5786 28.7584 15.7029C28.7395 15.8147 28.6387 15.8955 28.5254 15.8955L28.5317 15.8893ZM25.1248 19.4623C25.0052 19.4623 24.8918 19.3939 24.8352 19.2821L17.461 3.23127L10.6348 6.28857L12.6625 10.7005C12.7318 10.8559 12.6625 11.0423 12.5051 11.1106C12.3476 11.179 12.1587 11.1106 12.0894 10.9553L9.92948 6.26371C9.86021 6.10836 9.92948 5.92194 10.0869 5.85359L17.4862 2.5353C17.5618 2.50423 17.65 2.49802 17.7255 2.52909C17.8011 2.56016 17.8641 2.61609 17.9018 2.69066L25.4082 19.0273C25.4775 19.1827 25.4082 19.3691 25.2508 19.4374C25.2067 19.4561 25.1626 19.4623 25.1185 19.4623H25.1248ZM11.9509 10.0387C11.8628 10.0387 11.7746 9.98894 11.7368 9.90187C11.6801 9.78371 11.7368 9.64689 11.8565 9.59092L19.1802 6.30726C19.2999 6.25129 19.4384 6.30726 19.4951 6.42542C19.5518 6.54359 19.4951 6.6804 19.3754 6.73638L12.0517 10.02C12.0202 10.0325 11.9887 10.0387 11.9572 10.0387H11.9509ZM15.2823 12.9936C15.1941 12.9936 15.1059 12.9439 15.0682 12.8569C15.0115 12.7388 15.0682 12.6021 15.1878 12.5462L20.8743 9.99843C20.9939 9.9425 21.1324 9.99843 21.1891 10.1165C21.2458 10.2346 21.1891 10.3713 21.0695 10.4272L15.383 12.9749C15.3515 12.9874 15.32 12.9936 15.2886 12.9936H15.2823ZM19.3315 15.6221C19.2433 15.6221 19.1552 15.5723 19.1174 15.4854C19.0607 15.3673 19.1174 15.2306 19.237 15.1747L22.5683 13.6833C22.6879 13.6274 22.8265 13.6833 22.8832 13.8014C22.9398 13.9194 22.8832 14.0561 22.7635 14.1121L19.4322 15.6034C19.4008 15.6158 19.3693 15.6221 19.3378 15.6221H19.3315ZM21.8188 19.4996C21.7621 19.4996 21.7054 19.4871 21.6488 19.4499L6.54787 10.0481L2.54909 16.3056L6.699 18.8906C6.84384 18.9838 6.88792 19.1764 6.79976 19.3194C6.7053 19.4623 6.51008 19.5058 6.36525 19.4188L1.95085 16.6722C1.80601 16.579 1.76193 16.3864 1.85009 16.2434L6.18262 9.46394C6.22671 9.39558 6.29598 9.34587 6.37784 9.32723C6.45971 9.30859 6.54157 9.32723 6.61714 9.36451L21.9888 18.9341C22.1337 19.0273 22.1777 19.2199 22.0896 19.3629C22.0266 19.4561 21.9258 19.5058 21.8251 19.5058L21.8188 19.4996ZM5.60956 18.7601C5.56548 18.7601 5.5214 18.7477 5.48362 18.7228C5.37656 18.6545 5.33878 18.5115 5.40805 18.3997L9.6965 11.6886C9.76577 11.5829 9.91061 11.5456 10.024 11.614C10.131 11.6823 10.1688 11.8253 10.0995 11.9371L5.81108 18.6482C5.76699 18.7166 5.69143 18.7539 5.60956 18.7539V18.7601ZM10.0365 19.4251C9.99244 19.4251 9.94836 19.4126 9.91058 19.3878C9.80352 19.3194 9.76574 19.1765 9.83501 19.0647L13.1663 13.8511C13.2355 13.7455 13.3804 13.7082 13.4937 13.7765C13.6008 13.8449 13.6386 13.9878 13.5693 14.0997L10.238 19.3132C10.194 19.3816 10.1184 19.4189 10.0365 19.4189V19.4251ZM14.8856 19.4188C14.8415 19.4188 14.7974 19.4064 14.7596 19.3815C14.6526 19.3132 14.6148 19.1702 14.684 19.0584L16.6362 16.0073C16.7055 15.9017 16.8503 15.8644 16.9637 15.9327C17.0707 16.0011 17.1085 16.144 17.0392 16.2559L15.0871 19.307C15.043 19.3753 14.9674 19.4126 14.8856 19.4126V19.4188ZM22.8705 29.1376H1.31486C1.13854 29.1376 1 29.0009 1 28.8269V20.8108C1 20.6368 1.13854 20.5001 1.31486 20.5001H22.8705C25.2823 20.5001 27.2471 22.4389 27.2471 24.8188C27.2471 27.1988 25.2823 29.1376 22.8705 29.1376ZM1.62973 28.5162H22.8705C24.936 28.5162 26.6174 26.857 26.6174 24.8188C26.6174 22.7806 24.936 21.1215 22.8705 21.1215H1.62973V28.5162ZM22.713 26.7327C21.6424 26.7327 20.7734 25.8751 20.7734 24.8188C20.7734 23.7624 21.6424 22.9048 22.713 22.9048C23.7835 22.9048 24.6525 23.7624 24.6525 24.8188C24.6525 25.8751 23.7835 26.7327 22.713 26.7327ZM22.713 23.52C21.9888 23.52 21.4031 24.1042 21.4031 24.8126C21.4031 25.5209 21.9951 26.1051 22.713 26.1051C23.4309 26.1051 24.0228 25.5209 24.0228 24.8126C24.0228 24.1042 23.4309 23.52 22.713 23.52ZM5.42064 29.0132C5.2884 29.0132 5.18134 28.9076 5.18134 28.7771V20.8418C5.18134 20.7113 5.2884 20.6057 5.42064 20.6057C5.55288 20.6057 5.65994 20.7113 5.65994 20.8418V28.7771C5.65994 28.9076 5.55288 29.0132 5.42064 29.0132ZM9.5265 29.0132C9.39426 29.0132 9.28721 28.9076 9.28721 28.7771V20.8418C9.28721 20.7113 9.39426 20.6057 9.5265 20.6057C9.65875 20.6057 9.7658 20.7113 9.7658 20.8418V28.7771C9.7658 28.9076 9.65875 29.0132 9.5265 29.0132ZM13.626 29.0132C13.4938 29.0132 13.3868 28.9076 13.3868 28.7771V20.8418C13.3868 20.7113 13.4938 20.6057 13.626 20.6057C13.7583 20.6057 13.8653 20.7113 13.8653 20.8418V28.7771C13.8653 28.9076 13.7583 29.0132 13.626 29.0132ZM17.7256 29.0132C17.5934 29.0132 17.4863 28.9076 17.4863 28.7771V20.8418C17.4863 20.7113 17.5934 20.6057 17.7256 20.6057C17.8578 20.6057 17.9649 20.7113 17.9649 20.8418V28.7771C17.9649 28.9076 17.8578 29.0132 17.7256 29.0132ZM5.43328 20.873H9.57059V28.6902H5.43328V20.873ZM9.45103 20.8543H13.5883V28.6715H9.45103V20.8543ZM13.5694 20.8107H17.7571V28.628H13.5694V20.8107Z",
          stroke: "#071114",
          "stroke-width": "0.6"
        }
      )
    ]
  }
);

// src/components/icons/furniture/CustomerClub.tsx
init_react_shim();
import { jsx as jsx60, jsxs as jsxs49 } from "react/jsx-runtime";
var CustomerClub = (props) => /* @__PURE__ */ jsxs49(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M24.6493 10.2868C24.4977 10.2868 24.3785 10.1656 24.3785 10.0112V6.57177C24.3785 4.90715 23.0462 3.5512 21.4106 3.5512H10.5843C8.94873 3.5512 7.61643 4.90715 7.61643 6.57177V10.0112C7.61643 10.1656 7.49728 10.2868 7.34563 10.2868C7.19399 10.2868 7.07484 10.1656 7.07484 10.0112V6.57177C7.07484 4.60399 8.65086 3 10.5843 3H21.416C23.3495 3 24.9255 4.60399 24.9255 6.57177V10.0112C24.9255 10.1656 24.8064 10.2868 24.6547 10.2868H24.6493Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M12.5611 16.2232C12.507 16.2232 12.4474 16.2067 12.4041 16.1681C12.3228 16.1075 12.2795 16.0027 12.2957 15.898L12.924 12.1333L10.2377 9.47102C10.1619 9.39936 10.1348 9.28912 10.1673 9.18991C10.1998 9.09069 10.281 9.01904 10.3839 9.0025L14.0938 8.4513L15.7511 5.02836C15.7944 4.93465 15.8919 4.87402 15.9948 4.87402C16.0977 4.87402 16.1897 4.93465 16.2385 5.02836L17.9012 8.4513L21.611 8.99699C21.7139 9.01352 21.8006 9.08518 21.8277 9.1844C21.8602 9.28361 21.8277 9.39385 21.7573 9.46551L19.0764 12.1333L19.7155 15.8925C19.7317 15.9972 19.6938 16.1019 19.6072 16.1626C19.5259 16.2232 19.4122 16.2342 19.3201 16.1846L16.0002 14.4098L12.6857 16.1901C12.6478 16.2122 12.6044 16.2232 12.5611 16.2232ZM11.0068 9.47102L13.406 11.8412C13.471 11.9018 13.4981 11.9955 13.4818 12.0837L12.9186 15.4405L15.8756 13.853C15.9569 13.809 16.0489 13.809 16.1302 13.853L19.0927 15.435L18.524 12.0837C18.5077 11.9955 18.5402 11.9018 18.5998 11.8412L20.9936 9.46551L17.6845 8.98045C17.5979 8.96943 17.5221 8.9088 17.4787 8.83163L15.9948 5.7835L14.5162 8.83714C14.4783 8.91982 14.4025 8.97494 14.3104 8.98596L11.0014 9.47653L11.0068 9.47102Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M7.3942 28.9945C7.3942 28.9945 7.3617 28.9945 7.34545 28.9945C7.19923 28.9669 7.10174 28.8236 7.12882 28.6748L7.82747 24.7062C7.85455 24.5573 7.99536 24.4581 8.14159 24.4857C8.28781 24.5132 8.3853 24.6566 8.35822 24.8054L7.65957 28.774C7.63791 28.9063 7.52418 29 7.3942 29V28.9945Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M24.6006 28.9945C24.4706 28.9945 24.3569 28.9008 24.3353 28.7685L23.6366 24.7999C23.6095 24.6511 23.707 24.5078 23.8532 24.4802C23.9995 24.4527 24.1403 24.5519 24.1674 24.7007L24.866 28.6693C24.8931 28.8182 24.7956 28.9615 24.6494 28.989C24.6331 28.989 24.6169 28.989 24.6006 28.989V28.9945Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M5.05474 24.0282C4.90309 24.0282 4.78394 23.907 4.78394 23.7526V14.0074C4.78394 12.5688 5.93211 11.4003 7.34565 11.4003C8.75918 11.4003 9.90735 12.5688 9.90735 14.0074V18.8139H22.093V14.0074C22.093 12.5688 23.2412 11.4003 24.6547 11.4003C26.0683 11.4003 27.2164 12.5688 27.2164 14.0074V23.7526C27.2164 23.907 27.0973 24.0282 26.9456 24.0282H5.05474ZM5.32553 23.477H26.6694V14.0074C26.6694 12.872 25.765 11.9515 24.6493 11.9515C23.5337 11.9515 22.6292 12.872 22.6292 14.0074V19.0895C22.6292 19.2438 22.5101 19.3651 22.3584 19.3651H9.63655C9.48491 19.3651 9.36576 19.2438 9.36576 19.0895V14.0074C9.36576 12.872 8.46131 11.9515 7.34565 11.9515C6.22998 11.9515 5.32553 12.872 5.32553 14.0074V23.477Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M2.2058 9.16787C2.09207 9.16787 2 9.07417 2 8.95842C2 8.84266 2.09207 8.74896 2.2058 8.74896H5.28743C5.40116 8.74896 5.49323 8.84266 5.49323 8.95842C5.49323 9.07417 5.40116 9.16787 5.28743 9.16787H2.2058Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M29.7942 9.16787H26.7126C26.5988 9.16787 26.5068 9.07417 26.5068 8.95842C26.5068 8.84266 26.5988 8.74896 26.7126 8.74896H29.7942C29.9079 8.74896 30 8.84266 30 8.95842C30 9.07417 29.9079 9.16787 29.7942 9.16787Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M5.78047 5.90481C5.78047 5.90481 5.73714 5.90481 5.71548 5.89379L3.72244 5.20479C3.61412 5.1662 3.55996 5.05045 3.59246 4.94021C3.63037 4.82997 3.7441 4.77485 3.85242 4.80793L5.84546 5.49692C5.95377 5.53551 6.00793 5.65126 5.97544 5.7615C5.94836 5.84969 5.86712 5.8993 5.78047 5.8993V5.90481Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M26.2197 5.89375C26.1331 5.89375 26.0573 5.83863 26.0248 5.75595C25.9868 5.64571 26.0464 5.52996 26.1547 5.49138L28.1478 4.80789C28.2561 4.76931 28.3698 4.82994 28.4077 4.94018C28.4456 5.05042 28.3861 5.16617 28.2778 5.20475L26.2847 5.88824C26.2847 5.88824 26.2414 5.89926 26.2197 5.89926V5.89375Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M24.6493 10.2868C24.4977 10.2868 24.3785 10.1656 24.3785 10.0112V6.57177C24.3785 4.90715 23.0462 3.5512 21.4106 3.5512H10.5843C8.94873 3.5512 7.61643 4.90715 7.61643 6.57177V10.0112C7.61643 10.1656 7.49728 10.2868 7.34563 10.2868C7.19399 10.2868 7.07484 10.1656 7.07484 10.0112V6.57177C7.07484 4.60399 8.65086 3 10.5843 3H21.416C23.3495 3 24.9255 4.60399 24.9255 6.57177V10.0112C24.9255 10.1656 24.8064 10.2868 24.6547 10.2868H24.6493Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M12.5611 16.2232C12.507 16.2232 12.4474 16.2067 12.4041 16.1681C12.3228 16.1075 12.2795 16.0027 12.2957 15.898L12.924 12.1333L10.2377 9.47102C10.1619 9.39936 10.1348 9.28912 10.1673 9.18991C10.1998 9.09069 10.281 9.01904 10.3839 9.0025L14.0938 8.4513L15.7511 5.02836C15.7944 4.93465 15.8919 4.87402 15.9948 4.87402C16.0977 4.87402 16.1897 4.93465 16.2385 5.02836L17.9012 8.4513L21.611 8.99699C21.7139 9.01352 21.8006 9.08518 21.8277 9.1844C21.8602 9.28361 21.8277 9.39385 21.7573 9.46551L19.0764 12.1333L19.7155 15.8925C19.7317 15.9972 19.6938 16.1019 19.6072 16.1626C19.5259 16.2232 19.4122 16.2342 19.3201 16.1846L16.0002 14.4098L12.6857 16.1901C12.6478 16.2122 12.6044 16.2232 12.5611 16.2232ZM11.0068 9.47102L13.406 11.8412C13.471 11.9018 13.4981 11.9955 13.4818 12.0837L12.9186 15.4405L15.8756 13.853C15.9569 13.809 16.0489 13.809 16.1302 13.853L19.0927 15.435L18.524 12.0837C18.5077 11.9955 18.5402 11.9018 18.5998 11.8412L20.9936 9.46551L17.6845 8.98045C17.5979 8.96943 17.5221 8.9088 17.4787 8.83163L15.9948 5.7835L14.5162 8.83714C14.4783 8.91982 14.4025 8.97494 14.3104 8.98596L11.0014 9.47653L11.0068 9.47102Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M7.3942 28.9945C7.3942 28.9945 7.3617 28.9945 7.34545 28.9945C7.19923 28.9669 7.10174 28.8236 7.12882 28.6748L7.82747 24.7062C7.85455 24.5573 7.99536 24.4581 8.14159 24.4857C8.28781 24.5132 8.3853 24.6566 8.35822 24.8054L7.65957 28.774C7.63791 28.9063 7.52418 29 7.3942 29V28.9945Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M24.6006 28.9945C24.4706 28.9945 24.3569 28.9008 24.3353 28.7685L23.6366 24.7999C23.6095 24.6511 23.707 24.5078 23.8532 24.4802C23.9995 24.4527 24.1403 24.5519 24.1674 24.7007L24.866 28.6693C24.8931 28.8182 24.7956 28.9615 24.6494 28.989C24.6331 28.989 24.6169 28.989 24.6006 28.989V28.9945Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M5.05474 24.0282C4.90309 24.0282 4.78394 23.907 4.78394 23.7526V14.0074C4.78394 12.5688 5.93211 11.4003 7.34565 11.4003C8.75918 11.4003 9.90735 12.5688 9.90735 14.0074V18.8139H22.093V14.0074C22.093 12.5688 23.2412 11.4003 24.6547 11.4003C26.0683 11.4003 27.2164 12.5688 27.2164 14.0074V23.7526C27.2164 23.907 27.0973 24.0282 26.9456 24.0282H5.05474ZM5.32553 23.477H26.6694V14.0074C26.6694 12.872 25.765 11.9515 24.6493 11.9515C23.5337 11.9515 22.6292 12.872 22.6292 14.0074V19.0895C22.6292 19.2438 22.5101 19.3651 22.3584 19.3651H9.63655C9.48491 19.3651 9.36576 19.2438 9.36576 19.0895V14.0074C9.36576 12.872 8.46131 11.9515 7.34565 11.9515C6.22998 11.9515 5.32553 12.872 5.32553 14.0074V23.477Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M2.2058 9.16787C2.09207 9.16787 2 9.07417 2 8.95842C2 8.84266 2.09207 8.74896 2.2058 8.74896H5.28743C5.40116 8.74896 5.49323 8.84266 5.49323 8.95842C5.49323 9.07417 5.40116 9.16787 5.28743 9.16787H2.2058Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M29.7942 9.16787H26.7126C26.5988 9.16787 26.5068 9.07417 26.5068 8.95842C26.5068 8.84266 26.5988 8.74896 26.7126 8.74896H29.7942C29.9079 8.74896 30 8.84266 30 8.95842C30 9.07417 29.9079 9.16787 29.7942 9.16787Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M5.78047 5.90481C5.78047 5.90481 5.73714 5.90481 5.71548 5.89379L3.72244 5.20479C3.61412 5.1662 3.55996 5.05045 3.59246 4.94021C3.63037 4.82997 3.7441 4.77485 3.85242 4.80793L5.84546 5.49692C5.95377 5.53551 6.00793 5.65126 5.97544 5.7615C5.94836 5.84969 5.86712 5.8993 5.78047 5.8993V5.90481Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      ),
      /* @__PURE__ */ jsx60(
        "path",
        {
          d: "M26.2197 5.89375C26.1331 5.89375 26.0573 5.83863 26.0248 5.75595C25.9868 5.64571 26.0464 5.52996 26.1547 5.49138L28.1478 4.80789C28.2561 4.76931 28.3698 4.82994 28.4077 4.94018C28.4456 5.05042 28.3861 5.16617 28.2778 5.20475L26.2847 5.88824C26.2847 5.88824 26.2414 5.89926 26.2197 5.89926V5.89375Z",
          stroke: "#071114",
          "stroke-width": "0.8"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Discount.tsx
init_react_shim();
import { jsx as jsx61, jsxs as jsxs50 } from "react/jsx-runtime";
var Discount = (props) => /* @__PURE__ */ jsxs50(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx61(
        "path",
        {
          d: "M14.5363 5H6.875C6.37773 5 5.9008 5.19754 5.54918 5.54917C5.19755 5.9008 5 6.37771 5 6.875V14.535C4.99989 14.7812 5.04829 15.0251 5.14245 15.2527C5.2366 15.4802 5.37466 15.6871 5.54875 15.8612L17 27.315C17.2219 27.5368 17.4958 27.6993 17.7968 27.7878C18.0978 27.8763 18.4161 27.888 18.7226 27.8215C19.0292 27.7551 19.3142 27.6128 19.5516 27.4077C19.789 27.2026 19.9711 26.9412 20.0812 26.6475L21.875 21.875L26.6488 20.0837C26.9425 19.9736 27.2039 19.7915 27.409 19.5541C27.6141 19.3167 27.7564 19.0317 27.8228 18.7252C27.8893 18.4186 27.8776 18.1002 27.7891 17.7992C27.7006 17.4983 27.538 17.2243 27.3162 17.0025L15.8612 5.54875C15.5097 5.19747 15.0332 5.0001 14.5363 5Z",
          stroke: "#071114",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx61(
        "path",
        {
          d: "M10.625 11.0938C10.3661 11.0938 10.1562 10.8839 10.1562 10.625C10.1562 10.3661 10.3661 10.1562 10.625 10.1562",
          stroke: "#071114",
          "stroke-width": "1.5"
        }
      ),
      /* @__PURE__ */ jsx61(
        "path",
        {
          d: "M10.625 11.0938C10.8839 11.0938 11.0938 10.8839 11.0938 10.625C11.0938 10.3661 10.8839 10.1562 10.625 10.1562",
          stroke: "#071114",
          "stroke-width": "1.5"
        }
      )
    ]
  }
);

// src/components/icons/furniture/DoubleBed.tsx
init_react_shim();
import { jsx as jsx62, jsxs as jsxs51 } from "react/jsx-runtime";
var DoubleBed = (props) => /* @__PURE__ */ jsxs51(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx62(
        "path",
        {
          d: "M4.75 15.0625V12.25C4.75 11.7527 4.94754 11.2758 5.29917 10.9242C5.65081 10.5725 6.12772 10.375 6.625 10.375H14.125C14.6223 10.375 15.0992 10.5725 15.4508 10.9242C15.8025 11.2758 16 11.7527 16 12.25V15.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx62(
        "path",
        {
          d: "M16 15.0625V12.25C16 11.7527 16.1975 11.2758 16.5492 10.9242C16.9008 10.5725 17.3777 10.375 17.875 10.375H25.375C25.8723 10.375 26.3492 10.5725 26.7008 10.9242C27.0525 11.2758 27.25 11.7527 27.25 12.25V15.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx62(
        "path",
        {
          d: "M4.4375 15.0625H27.5625C28.2255 15.0625 28.8614 15.3259 29.3303 15.7947C29.7991 16.2636 30.0625 16.8995 30.0625 17.5625V23.5H1.9375V17.5625C1.9375 16.8995 2.20089 16.2636 2.66973 15.7947C3.13857 15.3259 3.77446 15.0625 4.4375 15.0625Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx62(
        "path",
        {
          d: "M1.9375 23.5V27.25",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx62(
        "path",
        {
          d: "M30.0625 23.5V27.25",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx62(
        "path",
        {
          d: "M27.25 15.0625V6.625C27.25 6.12772 27.0525 5.65081 26.7008 5.29917C26.3492 4.94754 25.8723 4.75 25.375 4.75H6.625C6.12772 4.75 5.65081 4.94754 5.29917 5.29917C4.94754 5.65081 4.75 6.12772 4.75 6.625V15.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/ExpressDelivery.tsx
init_react_shim();
import { jsx as jsx63, jsxs as jsxs52 } from "react/jsx-runtime";
var ExpressDelivery = (props) => /* @__PURE__ */ jsxs52(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsxs52("g", { "clip-path": "url(#clip0_4454_84545)", children: [
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M31.1693 23.0003C31.1538 23.0003 31.1383 23.0003 31.1228 22.9952C30.983 22.9693 30.8898 22.8347 30.9157 22.6949L31.4178 19.8839L29.7354 13.941L25.3092 13.9617C25.1643 13.9617 25.0504 13.8478 25.0504 13.7028C25.0504 13.5579 25.1643 13.444 25.3092 13.444L29.9321 13.4233C30.046 13.4233 30.1495 13.501 30.1806 13.6097L31.9355 19.8011C31.9459 19.8373 31.9459 19.8787 31.9407 19.915L31.4282 22.7881C31.4023 22.9123 31.2936 23.0003 31.1693 23.0003Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M6.36257 24.4445H4.27115C4.1935 24.4445 4.12103 24.4083 4.07443 24.3513C4.02267 24.2944 4.00714 24.2168 4.01749 24.1391L4.79918 19.7751C4.82507 19.6353 4.95966 19.5369 5.09944 19.568C5.23921 19.5939 5.33239 19.7285 5.30651 19.8683L4.58176 23.9269H6.36257C6.50752 23.9269 6.62141 24.0407 6.62141 24.1857C6.62141 24.3306 6.50752 24.4445 6.36257 24.4445Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M23.2906 24.4448H13.9517C13.8068 24.4448 13.6929 24.3309 13.6929 24.1859C13.6929 24.041 13.8068 23.9271 13.9517 23.9271H23.0784L25.9153 8.07578H7.41345L6.83883 11.0887C6.81294 11.2284 6.67317 11.3216 6.53857 11.2957C6.3988 11.2699 6.30562 11.1353 6.3315 10.9955L6.94754 7.77035C6.97342 7.64611 7.07696 7.55811 7.2012 7.55811H26.2207C26.2983 7.55811 26.3708 7.59434 26.4174 7.65129C26.4692 7.70823 26.4847 7.78588 26.4743 7.86354L23.5443 24.2325C23.5236 24.3568 23.4149 24.4448 23.2906 24.4448Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M10.1104 27.0536C8.57807 27.0536 7.33564 25.8112 7.33564 24.2789C7.33564 22.7465 8.57807 21.5041 10.1104 21.5041C11.6375 21.5041 12.8851 22.7465 12.8851 24.2789C12.8851 25.806 11.6427 27.0536 10.1104 27.0536ZM10.1104 22.0218C8.86797 22.0218 7.85332 23.0364 7.85332 24.2789C7.85332 25.5213 8.86797 26.5359 10.1104 26.5359C11.3528 26.5359 12.3675 25.5213 12.3675 24.2789C12.3675 23.0313 11.358 22.0218 10.1104 22.0218Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M27.4111 27.0536C25.884 27.0536 24.6364 25.8112 24.6364 24.2789C24.6364 22.7465 25.8788 21.5041 27.4111 21.5041C28.9434 21.5041 30.1859 22.7465 30.1859 24.2789C30.1859 25.806 28.9434 27.0536 27.4111 27.0536ZM27.4111 22.0218C26.1687 22.0218 25.154 23.0364 25.154 24.2789C25.154 25.5213 26.1687 26.5359 27.4111 26.5359C28.6535 26.5359 29.6682 25.5213 29.6682 24.2789C29.6682 23.0313 28.6587 22.0218 27.4111 22.0218Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M11.2284 18.1392H0.916274C0.807561 18.1392 0.719555 18.0512 0.719555 17.9425C0.719555 17.8338 0.807561 17.7458 0.916274 17.7458H11.2336C11.3423 17.7458 11.4303 17.8338 11.4303 17.9425C11.4303 18.0512 11.3371 18.1392 11.2284 18.1392Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M-0.833511 18.1392H-1.57379C-1.6825 18.1392 -1.77051 18.0512 -1.77051 17.9425C-1.77051 17.8338 -1.6825 17.7458 -1.57379 17.7458H-0.833511C-0.724799 17.7458 -0.636793 17.8338 -0.636793 17.9425C-0.636793 18.0512 -0.724799 18.1392 -0.833511 18.1392Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M5.35311 15.5664C5.2444 15.5664 5.16157 15.4784 5.1564 15.3748C5.1564 15.2661 5.2444 15.1781 5.34794 15.1781L11.6584 15.1626C11.7671 15.1626 11.85 15.2506 11.8551 15.3541C11.8551 15.4628 11.7671 15.5509 11.6636 15.5509L5.35311 15.5664Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M3.60263 15.5663H2.86235C2.75363 15.5663 2.66563 15.4783 2.66563 15.3696C2.66563 15.2609 2.75363 15.1729 2.86235 15.1729H3.60263C3.71134 15.1729 3.79934 15.2609 3.79934 15.3696C3.79934 15.4783 3.71134 15.5663 3.60263 15.5663Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M12.2898 12.6621H1.40819C1.29947 12.6621 1.21147 12.5741 1.21147 12.4654C1.21147 12.3567 1.29947 12.2687 1.40819 12.2687H12.2846C12.3933 12.2687 12.4813 12.3567 12.4813 12.4654C12.4813 12.5741 12.3933 12.6621 12.2898 12.6621Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M-0.336436 12.6621H-1.07672C-1.18543 12.6621 -1.27343 12.5741 -1.27343 12.4654C-1.27343 12.3567 -1.18543 12.2687 -1.07672 12.2687H-0.336436C-0.227724 12.2687 -0.139719 12.3567 -0.139719 12.4654C-0.139719 12.5741 -0.227724 12.6621 -0.336436 12.6621Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M18.4706 20.1428C15.8874 20.1428 13.7856 18.041 13.7856 15.4578C13.7856 12.8746 15.8874 10.7728 18.4706 10.7728C21.0538 10.7728 23.1556 12.8746 23.1556 15.4578C23.1556 18.041 21.0538 20.1428 18.4706 20.1428ZM18.4706 11.2905C16.1721 11.2905 14.3033 13.1593 14.3033 15.4578C14.3033 17.7563 16.1721 19.6251 18.4706 19.6251C20.7691 19.6251 22.6379 17.7563 22.6379 15.4578C22.6379 13.1593 20.7639 11.2905 18.4706 11.2905Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M16.7056 15.7267C16.5658 15.7267 16.4467 15.6128 16.4467 15.473C16.4467 15.328 16.5606 15.2142 16.7004 15.209L18.2534 15.1831L18.8487 12.341C18.8798 12.2013 19.0144 12.1133 19.1542 12.1391C19.2939 12.1702 19.382 12.3048 19.3561 12.4446L18.7141 15.4885C18.6883 15.6076 18.5847 15.6904 18.4657 15.6956L16.7056 15.7267C16.7107 15.7267 16.7107 15.7267 16.7056 15.7267Z",
            fill: "#071114"
          }
        ),
        /* @__PURE__ */ jsx63(
          "path",
          {
            d: "M16.7056 15.7267C16.5658 15.7267 16.4467 15.6128 16.4467 15.473C16.4467 15.328 16.5606 15.2142 16.7004 15.209L18.2534 15.1831L18.8487 12.341C18.8798 12.2013 19.0144 12.1133 19.1542 12.1391C19.2939 12.1702 19.382 12.3048 19.3561 12.4446L18.7141 15.4885C18.6883 15.6076 18.5847 15.6904 18.4657 15.6956L16.7056 15.7267ZM16.7056 15.7267C16.7107 15.7267 16.7107 15.7267 16.7056 15.7267ZM31.1693 23.0003C31.1538 23.0003 31.1383 23.0003 31.1228 22.9952C30.983 22.9693 30.8898 22.8347 30.9157 22.6949L31.4178 19.8839L29.7354 13.941L25.3092 13.9617C25.1643 13.9617 25.0504 13.8478 25.0504 13.7028C25.0504 13.5579 25.1643 13.444 25.3092 13.444L29.9321 13.4233C30.046 13.4233 30.1495 13.501 30.1806 13.6097L31.9355 19.8011C31.9459 19.8373 31.9459 19.8787 31.9407 19.915L31.4282 22.7881C31.4023 22.9123 31.2936 23.0003 31.1693 23.0003ZM6.36257 24.4445H4.27115C4.1935 24.4445 4.12103 24.4083 4.07443 24.3513C4.02267 24.2944 4.00714 24.2168 4.01749 24.1391L4.79918 19.7751C4.82507 19.6353 4.95966 19.5369 5.09944 19.568C5.23921 19.5939 5.33239 19.7285 5.30651 19.8683L4.58176 23.9269H6.36257C6.50752 23.9269 6.62141 24.0407 6.62141 24.1857C6.62141 24.3306 6.50752 24.4445 6.36257 24.4445ZM23.2906 24.4448H13.9517C13.8068 24.4448 13.6929 24.3309 13.6929 24.1859C13.6929 24.041 13.8068 23.9271 13.9517 23.9271H23.0784L25.9153 8.07578H7.41345L6.83883 11.0887C6.81294 11.2284 6.67317 11.3216 6.53857 11.2957C6.3988 11.2699 6.30562 11.1353 6.3315 10.9955L6.94754 7.77035C6.97342 7.64611 7.07696 7.55811 7.2012 7.55811H26.2207C26.2983 7.55811 26.3708 7.59434 26.4174 7.65129C26.4692 7.70823 26.4847 7.78588 26.4743 7.86354L23.5443 24.2325C23.5236 24.3568 23.4149 24.4448 23.2906 24.4448ZM10.1104 27.0536C8.57807 27.0536 7.33564 25.8112 7.33564 24.2789C7.33564 22.7465 8.57807 21.5041 10.1104 21.5041C11.6375 21.5041 12.8851 22.7465 12.8851 24.2789C12.8851 25.806 11.6427 27.0536 10.1104 27.0536ZM10.1104 22.0218C8.86797 22.0218 7.85332 23.0364 7.85332 24.2789C7.85332 25.5213 8.86797 26.5359 10.1104 26.5359C11.3528 26.5359 12.3675 25.5213 12.3675 24.2789C12.3675 23.0313 11.358 22.0218 10.1104 22.0218ZM27.4111 27.0536C25.884 27.0536 24.6364 25.8112 24.6364 24.2789C24.6364 22.7465 25.8788 21.5041 27.4111 21.5041C28.9434 21.5041 30.1859 22.7465 30.1859 24.2789C30.1859 25.806 28.9434 27.0536 27.4111 27.0536ZM27.4111 22.0218C26.1687 22.0218 25.154 23.0364 25.154 24.2789C25.154 25.5213 26.1687 26.5359 27.4111 26.5359C28.6535 26.5359 29.6682 25.5213 29.6682 24.2789C29.6682 23.0313 28.6587 22.0218 27.4111 22.0218ZM11.2284 18.1392H0.916274C0.807561 18.1392 0.719555 18.0512 0.719555 17.9425C0.719555 17.8338 0.807561 17.7458 0.916274 17.7458H11.2336C11.3423 17.7458 11.4303 17.8338 11.4303 17.9425C11.4303 18.0512 11.3371 18.1392 11.2284 18.1392ZM-0.833511 18.1392H-1.57379C-1.6825 18.1392 -1.77051 18.0512 -1.77051 17.9425C-1.77051 17.8338 -1.6825 17.7458 -1.57379 17.7458H-0.833511C-0.724799 17.7458 -0.636793 17.8338 -0.636793 17.9425C-0.636793 18.0512 -0.724799 18.1392 -0.833511 18.1392ZM5.35311 15.5664C5.2444 15.5664 5.16157 15.4784 5.1564 15.3748C5.1564 15.2661 5.2444 15.1781 5.34794 15.1781L11.6584 15.1626C11.7671 15.1626 11.85 15.2506 11.8551 15.3541C11.8551 15.4628 11.7671 15.5509 11.6636 15.5509L5.35311 15.5664ZM3.60263 15.5663H2.86235C2.75363 15.5663 2.66563 15.4783 2.66563 15.3696C2.66563 15.2609 2.75363 15.1729 2.86235 15.1729H3.60263C3.71134 15.1729 3.79934 15.2609 3.79934 15.3696C3.79934 15.4783 3.71134 15.5663 3.60263 15.5663ZM12.2898 12.6621H1.40819C1.29947 12.6621 1.21147 12.5741 1.21147 12.4654C1.21147 12.3567 1.29947 12.2687 1.40819 12.2687H12.2846C12.3933 12.2687 12.4813 12.3567 12.4813 12.4654C12.4813 12.5741 12.3933 12.6621 12.2898 12.6621ZM-0.336436 12.6621H-1.07672C-1.18543 12.6621 -1.27343 12.5741 -1.27343 12.4654C-1.27343 12.3567 -1.18543 12.2687 -1.07672 12.2687H-0.336436C-0.227724 12.2687 -0.139719 12.3567 -0.139719 12.4654C-0.139719 12.5741 -0.227724 12.6621 -0.336436 12.6621ZM18.4706 20.1428C15.8874 20.1428 13.7856 18.041 13.7856 15.4578C13.7856 12.8746 15.8874 10.7728 18.4706 10.7728C21.0538 10.7728 23.1556 12.8746 23.1556 15.4578C23.1556 18.041 21.0538 20.1428 18.4706 20.1428ZM18.4706 11.2905C16.1721 11.2905 14.3033 13.1593 14.3033 15.4578C14.3033 17.7563 16.1721 19.6251 18.4706 19.6251C20.7691 19.6251 22.6379 17.7563 22.6379 15.4578C22.6379 13.1593 20.7639 11.2905 18.4706 11.2905Z",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        )
      ] }),
      /* @__PURE__ */ jsx63("defs", { children: /* @__PURE__ */ jsx63("clipPath", { id: "clip0_4454_84545", children: /* @__PURE__ */ jsx63("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/Financing.tsx
init_react_shim();
import { jsx as jsx64, jsxs as jsxs53 } from "react/jsx-runtime";
var Financing = (props) => /* @__PURE__ */ jsxs53(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M27.7001 2.99878H15.5658C15.2213 2.99981 14.8912 3.13711 14.6476 3.38071C14.404 3.6243 14.2667 3.95439 14.2657 4.29889V10.5957C13.2466 9.7765 12.0167 9.26208 10.7179 9.11186C9.419 8.96163 8.10413 9.18172 6.92498 9.74671C5.74583 10.3117 4.75046 11.1986 4.05373 12.305C3.357 13.4114 2.9873 14.6923 2.9873 15.9998C2.9873 17.3074 3.357 18.5882 4.05373 19.6947C4.75046 20.8011 5.74583 21.688 6.92498 22.253C8.10413 22.818 9.419 23.0381 10.7179 22.8878C12.0167 22.7376 13.2466 22.2232 14.2657 21.404V27.7008C14.2667 28.0453 14.404 28.3754 14.6476 28.619C14.8912 28.8626 15.2213 28.9999 15.5658 29.0009H27.7001C28.0446 28.9999 28.3747 28.8626 28.6183 28.619C28.8619 28.3754 28.9992 28.0453 29.0002 27.7008V4.29889C28.9992 3.95439 28.8619 3.6243 28.6183 3.38071C28.3747 3.13711 28.0446 2.99981 27.7001 2.99878V2.99878ZM25.8453 3.86552L25.6286 4.73225H17.6373L17.4206 3.86552H25.8453ZM9.93201 22.067C8.73203 22.067 7.55901 21.7112 6.56127 21.0445C5.56353 20.3778 4.78589 19.4303 4.32668 18.3216C3.86747 17.213 3.74732 15.9931 3.98142 14.8162C4.21553 13.6393 4.79337 12.5582 5.64187 11.7097C6.49038 10.8612 7.57145 10.2834 8.74836 10.0493C9.92528 9.81516 11.1452 9.93531 12.2538 10.3945C13.3624 10.8537 14.31 11.6314 14.9767 12.6291C15.6433 13.6268 15.9992 14.7999 15.9992 15.9998C15.9974 17.6084 15.3577 19.1506 14.2202 20.2881C13.0828 21.4255 11.5406 22.0653 9.93201 22.067ZM28.1335 27.7008C28.1335 27.8157 28.0878 27.926 28.0066 28.0072C27.9253 28.0885 27.8151 28.1342 27.7001 28.1342H15.5658C15.4509 28.1342 15.3406 28.0885 15.2594 28.0072C15.1781 27.926 15.1324 27.8157 15.1324 27.7008V20.5719C16.2493 19.3107 16.8659 17.6844 16.8659 15.9998C16.8659 14.3153 16.2493 12.6889 15.1324 11.4278V4.29889C15.1324 4.18395 15.1781 4.07372 15.2594 3.99245C15.3406 3.91118 15.4509 3.86552 15.5658 3.86552H16.5279L16.8789 5.26963C16.9021 5.36359 16.9561 5.44706 17.0323 5.50675C17.1085 5.56645 17.2025 5.59892 17.2993 5.59899H25.9667C26.0634 5.59892 26.1574 5.56645 26.2336 5.50675C26.3098 5.44706 26.3638 5.36359 26.387 5.26963L26.738 3.86552H27.7001C27.8151 3.86552 27.9253 3.91118 28.0066 3.99245C28.0878 4.07372 28.1335 4.18395 28.1335 4.29889V27.7008Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M12.9654 4.29886H7.33157V3.43212C7.3317 3.3497 7.30833 3.26895 7.26419 3.19935C7.22006 3.12974 7.15699 3.07416 7.08238 3.03913C7.00777 3.0041 6.92473 2.99108 6.84298 3.00158C6.76123 3.01208 6.68417 3.04568 6.62084 3.09843L4.02063 5.26527C3.97156 5.30594 3.93205 5.35692 3.90494 5.4146C3.87783 5.47228 3.86377 5.53523 3.86377 5.59896C3.86377 5.6627 3.87783 5.72565 3.90494 5.78333C3.93205 5.84101 3.97156 5.89199 4.02063 5.93266L6.62084 8.0995C6.69881 8.16411 6.79694 8.19938 6.8982 8.19918C6.96095 8.1992 7.02299 8.18591 7.08021 8.16017C7.15544 8.12536 7.2191 8.0697 7.26365 7.99981C7.3082 7.92991 7.33177 7.8487 7.33157 7.76581V6.89907H12.9654C13.0803 6.89907 13.1905 6.85341 13.2718 6.77214C13.3531 6.69087 13.3987 6.58064 13.3987 6.4657V4.73223C13.3987 4.61729 13.3531 4.50706 13.2718 4.42579C13.1905 4.34452 13.0803 4.29886 12.9654 4.29886ZM12.532 6.03233H6.8982C6.78326 6.03233 6.67303 6.07799 6.59176 6.15926C6.51049 6.24054 6.46483 6.35077 6.46483 6.4657V6.84273L4.97404 5.59896L6.46483 4.3552V4.73223C6.46483 4.84716 6.51049 4.95739 6.59176 5.03866C6.67303 5.11994 6.78326 5.1656 6.8982 5.1656H12.532V6.03233Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M13.2428 26.067L10.6426 23.9002C10.5793 23.8474 10.5022 23.8138 10.4205 23.8033C10.3387 23.7928 10.2557 23.8059 10.1811 23.8409C10.1065 23.8759 10.0434 23.9315 9.99928 24.0011C9.95515 24.0707 9.93177 24.1515 9.93191 24.2339V25.1006H4.29811C4.18318 25.1006 4.07295 25.1463 3.99168 25.2275C3.9104 25.3088 3.86475 25.419 3.86475 25.534V27.2675C3.86475 27.3824 3.9104 27.4926 3.99168 27.5739C4.07295 27.6552 4.18318 27.7008 4.29811 27.7008H9.93191V28.5676C9.9317 28.6505 9.95527 28.7317 9.99983 28.8016C10.0444 28.8715 10.108 28.9271 10.1833 28.9619C10.2405 28.9877 10.3025 29.001 10.3653 29.0009C10.4665 29.0011 10.5647 28.9659 10.6426 28.9013L13.2428 26.7344C13.2919 26.6938 13.3314 26.6428 13.3585 26.5851C13.3856 26.5274 13.3997 26.4645 13.3997 26.4007C13.3997 26.337 13.3856 26.274 13.3585 26.2164C13.3314 26.1587 13.2919 26.1077 13.2428 26.067V26.067ZM10.7986 27.6445V27.2675C10.7986 27.1525 10.753 27.0423 10.6717 26.961C10.5904 26.8797 10.4802 26.8341 10.3653 26.8341H4.73148V25.9674H10.3653C10.4802 25.9674 10.5904 25.9217 10.6717 25.8404C10.753 25.7591 10.7986 25.6489 10.7986 25.534V25.157L12.2894 26.4007L10.7986 27.6445Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M9.93221 13.8331C10.1621 13.8331 10.3825 13.9244 10.5451 14.0869C10.7076 14.2495 10.7989 14.4699 10.7989 14.6998H11.6657C11.6642 14.3166 11.5359 13.9447 11.3007 13.6422C11.0654 13.3397 10.7366 13.1237 10.3656 13.0279V12.0996H9.49884V13.0279C9.09076 13.1329 8.73505 13.3833 8.49847 13.732C8.26188 14.0806 8.16069 14.5037 8.21388 14.9217C8.26708 15.3397 8.471 15.7239 8.78738 16.0022C9.10376 16.2805 9.51083 16.4338 9.93221 16.4333C10.1036 16.4333 10.2712 16.4841 10.4137 16.5794C10.5563 16.6746 10.6674 16.81 10.733 16.9683C10.7986 17.1267 10.8157 17.301 10.7823 17.4691C10.7488 17.6373 10.6663 17.7917 10.5451 17.9129C10.4239 18.0341 10.2694 18.1167 10.1013 18.1501C9.93317 18.1836 9.75889 18.1664 9.60052 18.1008C9.44214 18.0352 9.30678 17.9241 9.21154 17.7816C9.1163 17.639 9.06547 17.4715 9.06547 17.3H8.19873C8.20017 17.6832 8.32853 18.0551 8.56376 18.3576C8.79898 18.6601 9.12781 18.8762 9.49884 18.972V19.9002H10.3656V18.972C10.7736 18.8669 11.1294 18.6166 11.3659 18.2679C11.6025 17.9192 11.7037 17.4962 11.6505 17.0782C11.5973 16.6602 11.3934 16.276 11.077 15.9976C10.7607 15.7193 10.3536 15.566 9.93221 15.5666C9.70233 15.5666 9.48187 15.4752 9.31933 15.3127C9.15678 15.1502 9.06547 14.9297 9.06547 14.6998C9.06547 14.4699 9.15678 14.2495 9.31933 14.0869C9.48187 13.9244 9.70233 13.8331 9.93221 13.8331V13.8331Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M6.25461 12.3228C5.28079 13.2987 4.73389 14.6212 4.73389 15.9999C4.73389 17.3786 5.28079 18.701 6.25461 19.677L6.86739 19.0642C6.05585 18.2509 5.60008 17.1489 5.60008 15.9999C5.60008 14.8509 6.05585 13.7489 6.86739 12.9355L6.25461 12.3228Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M13.6089 12.3228L12.9961 12.9355C13.8076 13.7489 14.2634 14.8509 14.2634 15.9999C14.2634 17.1489 13.8076 18.2509 12.9961 19.0642L13.6089 19.677C14.5827 18.701 15.1296 17.3786 15.1296 15.9999C15.1296 14.6212 14.5827 13.2987 13.6089 12.3228V12.3228Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M24.8373 13.4345L21.8037 12.1344C21.7497 12.1114 21.6917 12.0996 21.633 12.0996C21.5743 12.0996 21.5162 12.1114 21.4622 12.1344L18.4286 13.4345C18.3507 13.4679 18.2843 13.5235 18.2376 13.5943C18.1909 13.665 18.166 13.748 18.166 13.8328V15.3561C18.165 15.7546 18.243 16.1494 18.3955 16.5176C18.548 16.8858 18.7719 17.2201 19.0544 17.5012L21.3266 19.773C21.4079 19.8542 21.5181 19.8998 21.633 19.8998C21.7479 19.8998 21.8581 19.8542 21.9394 19.773L24.2115 17.5012C24.494 17.2201 24.718 16.8858 24.8705 16.5176C25.023 16.1494 25.101 15.7546 25.0999 15.3561V13.8328C25.0999 13.748 25.075 13.665 25.0283 13.5943C24.9817 13.5235 24.9152 13.4679 24.8373 13.4345ZM24.2332 15.3561C24.2339 15.6407 24.1782 15.9227 24.0693 16.1857C23.9604 16.4488 23.8005 16.6876 23.5987 16.8885L21.633 18.8538L19.6676 16.8885C19.4658 16.6877 19.3058 16.4489 19.1968 16.1858C19.0878 15.9228 19.0321 15.6408 19.0328 15.3561V14.1184L21.633 13.0042L24.2332 14.1184V15.3561Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx64(
        "path",
        {
          d: "M21.0727 15.26L20.46 15.8728L21.3267 16.7396C21.408 16.8208 21.5182 16.8665 21.6331 16.8665C21.748 16.8665 21.8582 16.8208 21.9395 16.7396L23.673 15.0061L23.0602 14.3933L21.6331 15.8204L21.0727 15.26Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      )
    ]
  }
);

// src/components/icons/furniture/FlatPack.tsx
init_react_shim();
import { jsx as jsx65, jsxs as jsxs54 } from "react/jsx-runtime";
var FlatPack = (props) => /* @__PURE__ */ jsxs54(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M20.558 28.3905C19.5409 28.3905 18.7188 27.563 18.7188 26.5512C18.7188 26.4141 18.8294 26.3035 18.9664 26.3035C19.1035 26.3035 19.2141 26.4141 19.2141 26.5512C19.2141 27.2943 19.8202 27.9003 20.5633 27.9003C21.3064 27.9003 21.9125 27.2943 21.9125 26.5512C21.9125 26.4141 22.0232 26.3035 22.1602 26.3035C22.2972 26.3035 22.4079 26.4141 22.4079 26.5512C22.4079 27.5683 21.5805 28.3905 20.5686 28.3905H20.558Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M22.1549 26.7461C22.1496 26.7514 21.9072 26.6354 21.9072 26.4984V11.1727C21.9072 11.0778 21.9599 10.9935 22.0495 10.9513C23.2616 10.3769 24.0469 9.1384 24.0469 7.79978C24.0469 6.46115 23.2352 5.18049 21.9915 4.62185V7.56262C21.9915 7.65221 21.944 7.73126 21.865 7.77869L20.6634 8.46382C20.5896 8.50598 20.4947 8.50598 20.4157 8.46382L19.2404 7.77869C19.1667 7.73653 19.1192 7.65221 19.1192 7.56789V4.62185C17.8755 5.18049 17.0639 6.41899 17.0639 7.79978C17.0639 9.18056 17.8491 10.3716 19.0613 10.9513C19.1456 10.9935 19.2036 11.0778 19.2036 11.1727V26.4984C19.2036 26.6354 19.0929 26.7461 18.9559 26.7461C18.8188 26.7461 18.7082 26.6354 18.7082 26.4984V11.3255C17.4064 10.6404 16.5737 9.27543 16.5737 7.79978C16.5737 6.08697 17.6647 4.57442 19.2879 4.02632C19.3617 3.99997 19.446 4.01578 19.5092 4.05794C19.5725 4.10538 19.6094 4.17916 19.6094 4.25821V7.42032L20.5422 7.96315L21.4961 7.42032V4.25821C21.4961 4.17916 21.533 4.10538 21.5962 4.05794C21.6595 4.01051 21.7438 3.99997 21.8176 4.02632C23.4408 4.57442 24.5317 6.08697 24.5317 7.79978C24.5317 9.27543 23.699 10.6404 22.3973 11.3255V26.5037C22.3973 26.6407 22.1496 26.7514 22.1496 26.7514L22.1549 26.7461Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M10.2023 26.4036L9.95459 26.1559V16.5062C9.95459 16.4535 9.9704 16.4008 10.002 16.3586L11.2511 14.7143C11.3301 14.6036 11.4882 14.5826 11.5936 14.6669C11.7043 14.7512 11.7254 14.904 11.641 15.0095L10.4447 16.5905V26.1612L10.2023 26.4036Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M14.0441 26.4194C14.0388 26.4141 13.7964 26.3087 13.7964 26.1717V16.58L12.6422 14.9989C12.5632 14.8883 12.5842 14.7354 12.6949 14.6564C12.8056 14.5773 12.9584 14.5984 13.0375 14.7091L14.2391 16.3534C14.2707 16.3955 14.2865 16.4482 14.2865 16.4957V26.1664C14.2865 26.3035 14.0441 26.4194 14.0388 26.4141L14.0441 26.4194Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M12.8429 15.2202H11.4358C11.2987 15.2202 11.1881 15.1095 11.1881 14.9725V7.47832L10.5451 6.50861C10.5029 6.44537 10.4924 6.36631 10.5135 6.2978L11.1986 4.16865C11.2302 4.06851 11.3251 4 11.4305 4H12.8376C12.943 4 13.0379 4.06851 13.0695 4.16865L13.7546 6.2978C13.7757 6.37158 13.7652 6.44537 13.723 6.50861L13.08 7.47832V14.9725C13.08 15.1095 12.9694 15.2202 12.8324 15.2202H12.8429ZM11.6835 14.7301H12.6005V7.40454C12.6005 7.35711 12.6163 7.30968 12.6426 7.26751L13.2645 6.33469L12.669 4.49013H11.6202L11.0247 6.33469L11.6466 7.26751C11.6729 7.30968 11.6887 7.35711 11.6887 7.40454V14.7301H11.6835Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M13.9547 16.7593H11.952C11.8519 16.7593 11.7676 16.675 11.7676 16.5748C11.7676 16.4747 11.8519 16.3904 11.952 16.3904H13.9547C14.0548 16.3904 14.1392 16.4747 14.1392 16.5748C14.1392 16.675 14.0548 16.7593 13.9547 16.7593Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M12.1261 28.3955C10.935 28.3955 9.96533 27.4258 9.96533 26.2348C9.96533 26.0977 10.076 25.9871 10.213 25.9871C10.3501 25.9871 10.4607 26.0977 10.4607 26.2348C10.4607 27.157 11.2091 27.9054 12.1314 27.9054C13.0537 27.9054 13.802 27.157 13.802 26.2348C13.802 26.0977 13.9127 25.9871 14.0497 25.9871C14.1867 25.9871 14.2974 26.0977 14.2974 26.2348C14.2974 27.4258 13.3277 28.3955 12.1366 28.3955H12.1261Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M17.4539 13.0911H14.3234C14.1864 13.0911 14.0757 12.9804 14.0757 12.8434C14.0757 12.7064 14.1864 12.5957 14.3234 12.5957H17.4539C17.5909 12.5957 17.7016 12.7064 17.7016 12.8434C17.7016 12.9804 17.5909 13.0911 17.4539 13.0911Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M8.78492 16.8117H1.83882C1.73869 16.8117 1.64909 16.7538 1.6122 16.6589C1.57531 16.5693 1.59639 16.4639 1.6649 16.3901L5.37511 12.6641C5.42254 12.6167 5.48579 12.5903 5.54903 12.5903H9.93382C10.0708 12.5903 10.1815 12.7063 10.1815 12.8433C10.1815 12.9803 10.0708 13.091 9.93382 13.091H5.64916L2.42908 16.3216H8.78492C8.92194 16.3216 9.03262 16.4323 9.03262 16.5693C9.03262 16.7063 8.92194 16.817 8.78492 16.817V16.8117Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M31.1982 16.8119H23.6935C23.5565 16.8119 23.4458 16.7012 23.4458 16.5642C23.4458 16.4272 23.5565 16.3165 23.6935 16.3165H30.608L27.3879 13.0806H23.6988C23.5617 13.0806 23.4511 12.9699 23.4511 12.8329C23.4511 12.6959 23.5617 12.5852 23.6988 12.5852H27.4933C27.5565 12.5852 27.6198 12.6116 27.6672 12.659L31.3774 16.385C31.4459 16.4535 31.467 16.5589 31.4301 16.6538C31.3932 16.7434 31.3036 16.8066 31.2035 16.8066L31.1982 16.8119Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M8.7843 20.601H1.79604C1.65901 20.601 1.54834 20.4904 1.54834 20.3533V16.601C1.54834 16.4639 1.65901 16.3533 1.79604 16.3533C1.93306 16.3533 2.04374 16.4639 2.04374 16.601V20.1056H8.78957C8.9266 20.1056 9.03727 20.2163 9.03727 20.3533C9.03727 20.4904 8.9266 20.601 8.78957 20.601H8.7843Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M31.1982 20.601H23.6935C23.5565 20.601 23.4458 20.4904 23.4458 20.3533C23.4458 20.2163 23.5565 20.1056 23.6935 20.1056H30.9558V16.601C30.9558 16.4639 31.0665 16.3533 31.2035 16.3533C31.3405 16.3533 31.4512 16.4639 31.4512 16.601V20.3533C31.4512 20.4904 31.3405 20.601 31.2035 20.601H31.1982Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M17.4541 16.7962H15.5831C15.4461 16.7962 15.3354 16.6855 15.3354 16.5485C15.3354 16.4115 15.4461 16.3008 15.5831 16.3008H17.4541C17.5911 16.3008 17.7018 16.4115 17.7018 16.5485C17.7018 16.6855 17.5911 16.7962 17.4541 16.7962Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          d: "M17.4541 20.6065H15.5831C15.4461 20.6065 15.3354 20.4958 15.3354 20.3588C15.3354 20.2218 15.4461 20.1111 15.5831 20.1111H17.4541C17.5911 20.1111 17.7018 20.2218 17.7018 20.3588C17.7018 20.4958 17.5911 20.6065 17.4541 20.6065Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.7"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Garden.tsx
init_react_shim();
import { jsx as jsx66, jsxs as jsxs55 } from "react/jsx-runtime";
var Garden = (props) => /* @__PURE__ */ jsxs55(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M2.875 20.6875L4.75 26.3125H8.5C8.99728 26.3125 9.47419 26.51 9.82583 26.8617C10.1775 27.2133 10.375 27.6902 10.375 28.1875V30.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M4.75 26.3125V30.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M29.125 20.6875L27.25 26.3125H23.5C23.0027 26.3125 22.5258 26.51 22.1742 26.8617C21.8225 27.2133 21.625 27.6902 21.625 28.1875V30.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M27.25 26.3125V30.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M16 15.645V30.0625",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M28.5752 12.5201C28.8302 12.7748 29.0063 13.0976 29.0826 13.4499C29.1589 13.8022 29.132 14.169 29.0052 14.5063C28.711 15.226 28.209 15.8416 27.5634 16.2747C26.9177 16.7077 26.1576 16.9385 25.3802 16.9376C24.7065 16.936 24.0458 16.7521 23.4682 16.4055C22.8905 16.0589 22.4174 15.5625 22.0989 14.9688C21.8153 15.5029 21.4055 15.9597 20.9052 16.2994C20.405 16.6392 19.8293 16.8516 19.2282 16.9183C18.6272 16.9849 18.0189 16.9038 17.4563 16.6819C16.8938 16.46 16.3939 16.1041 16.0002 15.6451C15.6063 16.103 15.1067 16.458 14.5447 16.6792C13.9827 16.9004 13.3752 16.9812 12.7749 16.9146C12.1746 16.848 11.5996 16.636 11.0997 16.2969C10.5999 15.9578 10.1903 15.502 9.90642 14.9688C9.58797 15.5625 9.11484 16.0589 8.53717 16.4055C7.95951 16.7521 7.29883 16.936 6.62517 16.9376C5.84777 16.9383 5.08776 16.7075 4.44213 16.2744C3.79649 15.8414 3.29449 15.2259 3.00017 14.5063C2.87273 14.1694 2.84504 13.8029 2.92041 13.4507C2.99578 13.0984 3.17102 12.7754 3.42517 12.5201L14.6752 2.48759C14.8493 2.31335 15.056 2.17513 15.2836 2.08083C15.5112 1.98653 15.7551 1.93799 16.0014 1.93799C16.2477 1.93799 16.4917 1.98653 16.7192 2.08083C16.9468 2.17513 17.1535 2.31335 17.3277 2.48759L28.5752 12.5201Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M9.90625 14.9688L16 1.9375",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          d: "M22.0938 14.9688L16 1.9375",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Hands.tsx
init_react_shim();
import { jsx as jsx67, jsxs as jsxs56 } from "react/jsx-runtime";
var Hands = (props) => /* @__PURE__ */ jsxs56(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx67(
        "path",
        {
          d: "M2.53042 15.7252L4.76193 16.6055C5.0568 16.7218 5.37831 16.6604 5.60827 16.4676L7.37543 17.5821L7.6785 17.7952C7.29405 18.4036 7.39254 19.2351 7.9771 19.7307C8.29827 20.0031 8.7064 20.1193 9.10589 20.0757C9.12935 20.4957 9.32032 20.8697 9.63111 21.1331C9.93654 21.3921 10.3353 21.5247 10.7599 21.4784C10.7835 21.8982 10.9743 22.2721 11.2851 22.5356C11.5934 22.797 11.9929 22.9268 12.4146 22.8808C12.4366 23.2763 12.614 23.6623 12.9391 23.938C13.5673 24.4707 14.5122 24.3935 15.0448 23.7654L15.3994 23.3491L15.997 23.7901C17.0301 24.5528 18.4904 23.928 18.6251 22.6604C19.6903 23.0475 20.8213 22.301 20.8377 21.1545C21.8418 21.3433 22.7327 20.614 22.7887 19.6467C24.0911 19.9946 25.2691 18.6785 24.694 17.3916L26.2909 16.3659C26.5195 16.6368 26.8995 16.7391 27.2383 16.6055L29.4698 15.7252C29.8993 15.5557 30.111 15.0684 29.9415 14.6388L28.9216 12.0535C28.8385 11.8427 28.6002 11.7394 28.3895 11.8225C28.1788 11.9056 28.0753 12.1438 28.1585 12.3546L29.1783 14.9398C29.1818 14.9486 29.1775 14.9586 29.1687 14.9621L26.9372 15.8424C26.9283 15.8458 26.9184 15.8416 26.9149 15.8328C26.8368 15.6347 24.3321 9.28551 24.1106 8.7241C24.1098 8.72213 24.108 8.71753 24.1108 8.71103C24.1136 8.70452 24.1183 8.70271 24.1202 8.70189L26.3518 7.82154C26.3537 7.82072 26.3582 7.81891 26.3649 7.82176C26.3714 7.8246 26.3732 7.82919 26.374 7.83116L27.4552 10.5718C27.5384 10.7825 27.7766 10.8859 27.9872 10.8028C28.198 10.7196 28.3014 10.4814 28.2183 10.2707L27.1371 7.53016C26.9677 7.10065 26.4803 6.88901 26.0508 7.05849L23.8192 7.93884C23.4205 8.09612 23.21 8.524 23.317 8.92961L22.1207 9.37115C21.7484 9.50858 21.3443 9.54845 20.9521 9.48627L19.7428 9.29459C19.5192 9.25921 19.3089 9.41184 19.2736 9.63546C19.2381 9.85918 19.3907 10.0693 19.6144 10.1048L20.8237 10.2965C21.3543 10.3805 21.9009 10.3266 22.4048 10.1407L23.6119 9.69507C23.7429 10.0272 25.8106 15.2683 25.9463 15.6123L24.1862 16.7427L24.1564 16.7207C24.1565 16.7207 24.1562 16.7206 24.1564 16.7207C23.9678 16.5815 20.9071 14.3228 20.7635 14.2167C20.6755 14.1518 20.5662 14.1227 20.4406 14.144C18.7414 14.4329 17.2191 13.8287 16.0992 12.6593C15.7507 12.2955 15.1822 12.276 14.8047 12.6149C13.7182 13.5907 12.1999 14.5422 11.1376 13.5326C11.0321 13.4324 11.0313 13.2472 11.1916 13.1438C12.5448 12.2733 13.9466 11.0511 15.0747 9.90988C15.3554 9.62578 15.7592 9.49371 16.1556 9.55654L17.7125 9.80335C17.9366 9.83884 18.1463 9.68615 18.1817 9.46248C18.2172 9.23876 18.0646 9.02859 17.8409 8.99316L16.284 8.74635C15.6275 8.64234 14.9574 8.86174 14.4913 9.33326C14.3608 9.46522 14.2065 9.61845 14.0325 9.7865C13.5073 9.60029 12.9599 9.48906 12.403 9.45778C10.7731 9.36623 10.6318 9.34895 10.2617 9.37274C9.97115 9.39128 9.67562 9.3419 9.40684 9.22946L8.68398 8.92699C8.78833 8.52372 8.57816 8.09536 8.18102 7.93873L5.94951 7.05849C5.51984 6.88896 5.03257 7.1006 4.86315 7.53016L2.05874 14.6388C1.88893 15.0693 2.09975 15.5553 2.53042 15.7252ZM9.45775 19.0268C9.2174 19.3103 8.79122 19.3454 8.50762 19.105C8.22215 18.863 8.18977 18.4375 8.42881 18.1556L9.44331 16.9649C9.67798 16.688 10.1053 16.6424 10.3934 16.8866C10.6776 17.1275 10.7127 17.5525 10.4717 17.8367C10.4718 17.8366 10.4715 17.8368 10.4717 17.8367L9.45775 19.0268ZM11.1117 20.4293C10.8708 20.7134 10.4459 20.7485 10.1616 20.5075C9.87616 20.2654 9.84379 19.84 10.0828 19.5581L11.0973 18.3673C11.3493 18.07 11.8162 18.0441 12.0974 18.336C12.0993 18.3379 12.1008 18.34 12.1027 18.342C12.3342 18.5882 12.3493 18.9754 12.1257 19.2392L11.1117 20.4293ZM12.7657 21.8317C12.524 22.1169 12.0986 22.1499 11.8156 21.9099C11.5302 21.6679 11.4977 21.2424 11.7368 20.9605L12.7513 19.7697C12.9923 19.4856 13.4201 19.4527 13.7015 19.6915C13.985 19.932 14.02 20.3581 13.7797 20.6416C13.7798 20.6415 13.7796 20.6417 13.7797 20.6416L12.7657 21.8317ZM15.4392 22.0369C15.4375 22.039 15.436 22.0412 15.4343 22.0433C15.2707 22.2353 14.8198 22.7645 14.4197 23.2341C14.1794 23.5176 13.7532 23.5527 13.4697 23.3123C13.1861 23.0719 13.151 22.6458 13.3908 22.363L14.4054 21.1722C14.6471 20.887 15.0728 20.8542 15.3554 21.094C15.6336 21.3297 15.6762 21.7503 15.4392 22.0369ZM8.38922 9.69304L9.09014 9.98633C9.47481 10.1473 9.89809 10.2182 10.3141 10.1915C10.6278 10.1713 10.7325 10.1856 12.3569 10.2769C12.6904 10.2956 13.0202 10.3473 13.3422 10.431C12.5397 11.1558 11.6385 11.8822 10.7357 12.4619C10.157 12.8334 10.0712 13.6511 10.5725 14.1275C11.2577 14.7786 12.79 15.527 15.3528 13.2254C15.3987 13.1842 15.4663 13.1847 15.5066 13.2269C16.748 14.5226 18.5076 15.2464 20.4078 14.9794C20.6231 15.1307 20.2062 14.8252 23.6687 17.3806C24.0393 17.654 24.143 18.1918 23.8528 18.563C23.5773 18.9155 23.0793 18.9839 22.7196 18.7182C22.2335 18.3595 22.5924 18.6325 20.8837 17.3159C20.7041 17.1776 20.4466 17.2111 20.3083 17.3905C20.1702 17.5699 20.2035 17.8274 20.3829 17.9657L21.8005 19.0581C22.0448 19.3798 22.0157 19.8448 21.7265 20.1333C21.4423 20.4169 20.9744 20.4437 20.6381 20.1957C20.313 19.9558 20.5831 20.1613 19.092 19.0133C18.9125 18.8751 18.6549 18.9087 18.5168 19.0881C18.3786 19.2676 18.4121 19.5251 18.5916 19.6633L19.8486 20.6311C20.086 20.9382 20.0743 21.3799 19.8151 21.6737C19.5362 21.99 19.0421 22.034 18.69 21.7741C18.1242 21.3566 18.4082 21.5722 17.3187 20.729C17.1396 20.5903 16.882 20.6232 16.7433 20.8023C16.6047 20.9815 16.6375 21.239 16.8166 21.3777L17.6881 22.0521C17.8863 22.3676 17.8475 22.7808 17.5868 23.0535C17.3022 23.3512 16.8282 23.3841 16.484 23.1301L15.9326 22.7233L16.0593 22.5746C16.3118 22.2768 16.4422 21.8912 16.4088 21.4855C16.3749 21.0745 16.1796 20.7174 15.8859 20.4683C15.5804 20.2092 15.1813 20.0765 14.7568 20.1225C14.7345 19.7263 14.5528 19.3381 14.2319 19.0658C13.9275 18.8078 13.5411 18.6837 13.1428 18.7163C13.1295 18.7174 13.1162 18.7186 13.103 18.7201C13.1023 18.707 13.1018 18.6938 13.1007 18.6807C13.0747 18.3635 12.9511 18.0698 12.7479 17.8329C12.7466 17.8314 12.7455 17.8299 12.7442 17.8284C12.421 17.4545 11.9399 17.2656 11.4495 17.3184C11.4264 16.9065 11.2397 16.5288 10.9239 16.261C10.2952 15.728 9.3504 15.8058 8.81813 16.4336L8.2 17.1592L7.83868 16.9052C7.8331 16.9013 7.82742 16.8974 7.82162 16.8938L6.0013 15.7458C7.37751 12.2574 6.86202 13.5641 8.38922 9.69304ZM2.82179 14.9399L5.62615 7.83127C5.62883 7.82449 5.63528 7.82039 5.64212 7.82039C5.64419 7.82039 5.64633 7.82077 5.64841 7.82159L7.87992 8.70195C7.88872 8.70539 7.89304 8.7154 7.8896 8.72415C7.75468 9.06616 5.17345 15.6091 5.08518 15.8328C5.08157 15.8417 5.07195 15.846 5.06298 15.8425L2.83147 14.9621C2.82261 14.9586 2.81823 14.9487 2.82179 14.9399Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx67(
        "path",
        {
          d: "M24.1564 16.7207L24.1862 16.7427L25.9463 15.6123C25.8106 15.2683 23.7429 10.0272 23.6119 9.69507L22.4048 10.1407C21.9009 10.3266 21.3543 10.3805 20.8237 10.2965L19.6144 10.1048C19.3907 10.0693 19.2381 9.85918 19.2736 9.63546C19.3089 9.41184 19.5192 9.25921 19.7428 9.29459L20.9521 9.48627C21.3443 9.54845 21.7484 9.50858 22.1207 9.37115L23.317 8.92961C23.21 8.524 23.4205 8.09612 23.8192 7.93884L26.0508 7.05849C26.4803 6.88901 26.9677 7.10065 27.1371 7.53016L28.2183 10.2707C28.3014 10.4814 28.198 10.7196 27.9872 10.8028C27.7766 10.8859 27.5384 10.7825 27.4552 10.5718L26.374 7.83116C26.3732 7.82919 26.3714 7.8246 26.3649 7.82176C26.3582 7.81891 26.3537 7.82072 26.3518 7.82154L24.1202 8.70189C24.1183 8.70271 24.1136 8.70452 24.1108 8.71103C24.108 8.71753 24.1098 8.72213 24.1106 8.7241C24.3321 9.28551 26.8368 15.6347 26.9149 15.8328C26.9184 15.8416 26.9283 15.8458 26.9372 15.8424L29.1687 14.9621C29.1775 14.9586 29.1818 14.9486 29.1783 14.9398L28.1585 12.3546C28.0753 12.1438 28.1788 11.9056 28.3895 11.8225C28.6002 11.7394 28.8385 11.8427 28.9216 12.0535L29.9415 14.6388C30.111 15.0684 29.8993 15.5557 29.4698 15.7252L27.2383 16.6055C26.8995 16.7391 26.5195 16.6368 26.2909 16.3659L24.694 17.3916C25.2691 18.6785 24.0911 19.9946 22.7887 19.6467C22.7327 20.614 21.8418 21.3433 20.8377 21.1545C20.8213 22.301 19.6903 23.0475 18.6251 22.6604C18.4904 23.928 17.0301 24.5528 15.997 23.7901L15.3994 23.3491L15.0448 23.7654C14.5122 24.3935 13.5673 24.4707 12.9391 23.938C12.614 23.6623 12.4366 23.2763 12.4146 22.8808C11.9929 22.9268 11.5934 22.797 11.2851 22.5356C10.9743 22.2721 10.7835 21.8982 10.7599 21.4784C10.3353 21.5247 9.93654 21.3921 9.63111 21.1331C9.32032 20.8697 9.12935 20.4957 9.10589 20.0757C8.7064 20.1193 8.29827 20.0031 7.9771 19.7307C7.39254 19.2351 7.29405 18.4036 7.6785 17.7952L7.37543 17.5821L5.60827 16.4676C5.37831 16.6604 5.0568 16.7218 4.76193 16.6055L2.53042 15.7252C2.09975 15.5553 1.88893 15.0693 2.05874 14.6388L4.86315 7.53016C5.03257 7.1006 5.51984 6.88896 5.94951 7.05849L8.18102 7.93873C8.57816 8.09536 8.78833 8.52372 8.68398 8.92699L9.40684 9.22946C9.67562 9.3419 9.97115 9.39128 10.2617 9.37274C10.6318 9.34895 10.7731 9.36623 12.403 9.45778C12.9599 9.48906 13.5073 9.60029 14.0325 9.7865C14.2065 9.61845 14.3608 9.46522 14.4913 9.33326C14.9574 8.86174 15.6275 8.64234 16.284 8.74635L17.8409 8.99316C18.0646 9.02859 18.2172 9.23876 18.1817 9.46248C18.1463 9.68615 17.9366 9.83884 17.7125 9.80335L16.1556 9.55654C15.7592 9.49371 15.3554 9.62578 15.0747 9.90988C13.9466 11.0511 12.5448 12.2733 11.1916 13.1438C11.0313 13.2472 11.0321 13.4324 11.1376 13.5326C12.1999 14.5422 13.7182 13.5907 14.8047 12.6149C15.1822 12.276 15.7507 12.2955 16.0992 12.6593C17.2191 13.8287 18.7414 14.4329 20.4406 14.144C20.5662 14.1227 20.6755 14.1518 20.7635 14.2167C20.9071 14.3228 23.9678 16.5815 24.1564 16.7207ZM24.1564 16.7207C24.1562 16.7206 24.1565 16.7207 24.1564 16.7207ZM10.4717 17.8367C10.7127 17.5525 10.6776 17.1275 10.3934 16.8866C10.1053 16.6424 9.67798 16.688 9.44331 16.9649L8.42881 18.1556C8.18977 18.4375 8.22215 18.863 8.50762 19.105C8.79122 19.3454 9.2174 19.3103 9.45775 19.0268L10.4717 17.8367ZM10.4717 17.8367C10.4715 17.8368 10.4718 17.8366 10.4717 17.8367ZM13.7797 20.6416C14.02 20.3581 13.985 19.932 13.7015 19.6915C13.4201 19.4527 12.9923 19.4856 12.7513 19.7697L11.7368 20.9605C11.4977 21.2424 11.5302 21.6679 11.8156 21.9099C12.0986 22.1499 12.524 22.1169 12.7657 21.8317L13.7797 20.6416ZM13.7797 20.6416C13.7796 20.6417 13.7798 20.6415 13.7797 20.6416ZM11.1117 20.4293C10.8708 20.7134 10.4459 20.7485 10.1616 20.5075C9.87616 20.2654 9.84379 19.84 10.0828 19.5581L11.0973 18.3673C11.3493 18.07 11.8162 18.0441 12.0974 18.336C12.0993 18.3379 12.1008 18.34 12.1027 18.342C12.3342 18.5882 12.3493 18.9754 12.1257 19.2392L11.1117 20.4293ZM15.4392 22.0369C15.4375 22.039 15.436 22.0412 15.4343 22.0433C15.2707 22.2353 14.8198 22.7645 14.4197 23.2341C14.1794 23.5176 13.7532 23.5527 13.4697 23.3123C13.1861 23.0719 13.151 22.6458 13.3908 22.363L14.4054 21.1722C14.6471 20.887 15.0728 20.8542 15.3554 21.094C15.6336 21.3297 15.6762 21.7503 15.4392 22.0369ZM8.38922 9.69304L9.09014 9.98633C9.47481 10.1473 9.89809 10.2182 10.3141 10.1915C10.6278 10.1713 10.7325 10.1856 12.3569 10.2769C12.6904 10.2956 13.0202 10.3473 13.3422 10.431C12.5397 11.1558 11.6385 11.8822 10.7357 12.4619C10.157 12.8334 10.0712 13.6511 10.5725 14.1275C11.2577 14.7786 12.79 15.527 15.3528 13.2254C15.3987 13.1842 15.4663 13.1847 15.5066 13.2269C16.748 14.5226 18.5076 15.2464 20.4078 14.9794C20.6231 15.1307 20.2062 14.8252 23.6687 17.3806C24.0393 17.654 24.143 18.1918 23.8528 18.563C23.5773 18.9155 23.0793 18.9839 22.7196 18.7182C22.2335 18.3595 22.5924 18.6325 20.8837 17.3159C20.7041 17.1776 20.4466 17.2111 20.3083 17.3905C20.1702 17.5699 20.2035 17.8274 20.3829 17.9657L21.8005 19.0581C22.0448 19.3798 22.0157 19.8448 21.7265 20.1333C21.4423 20.4169 20.9744 20.4437 20.6381 20.1957C20.313 19.9558 20.5831 20.1613 19.092 19.0133C18.9125 18.8751 18.6549 18.9087 18.5168 19.0881C18.3786 19.2676 18.4121 19.5251 18.5916 19.6633L19.8486 20.6311C20.086 20.9382 20.0743 21.3799 19.8151 21.6737C19.5362 21.99 19.0421 22.034 18.69 21.7741C18.1242 21.3566 18.4082 21.5722 17.3187 20.729C17.1396 20.5903 16.882 20.6232 16.7433 20.8023C16.6047 20.9815 16.6375 21.239 16.8166 21.3777L17.6881 22.0521C17.8863 22.3676 17.8475 22.7808 17.5868 23.0535C17.3022 23.3512 16.8282 23.3841 16.484 23.1301L15.9326 22.7233L16.0593 22.5746C16.3118 22.2768 16.4422 21.8912 16.4088 21.4855C16.3749 21.0745 16.1796 20.7174 15.8859 20.4683C15.5804 20.2092 15.1813 20.0765 14.7568 20.1225C14.7345 19.7263 14.5528 19.3381 14.2319 19.0658C13.9275 18.8078 13.5411 18.6837 13.1428 18.7163C13.1295 18.7174 13.1162 18.7186 13.103 18.7201C13.1023 18.707 13.1018 18.6938 13.1007 18.6807C13.0747 18.3635 12.9511 18.0698 12.7479 17.8329C12.7466 17.8314 12.7455 17.8299 12.7442 17.8284C12.421 17.4545 11.9399 17.2656 11.4495 17.3184C11.4264 16.9065 11.2397 16.5288 10.9239 16.261C10.2952 15.728 9.3504 15.8058 8.81813 16.4336L8.2 17.1592L7.83868 16.9052C7.8331 16.9013 7.82742 16.8974 7.82162 16.8938L6.0013 15.7458C7.37751 12.2574 6.86202 13.5641 8.38922 9.69304ZM2.82179 14.9399L5.62615 7.83127C5.62883 7.82449 5.63528 7.82039 5.64212 7.82039C5.64419 7.82039 5.64633 7.82077 5.64841 7.82159L7.87992 8.70195C7.88872 8.70539 7.89304 8.7154 7.8896 8.72415C7.75468 9.06616 5.17345 15.6091 5.08518 15.8328C5.08157 15.8417 5.07195 15.846 5.06298 15.8425L2.83147 14.9621C2.82261 14.9586 2.81823 14.9487 2.82179 14.9399Z",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Headboard.tsx
init_react_shim();
import { jsx as jsx68, jsxs as jsxs57 } from "react/jsx-runtime";
var Headboard = (props) => /* @__PURE__ */ jsxs57(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx68(
        "path",
        {
          d: "M5.42623 4.75H26.5738C28.6041 4.75 30.25 6.3959 30.25 8.42623V22.1967C30.25 22.869 29.705 23.4139 29.0328 23.4139H2.96721C2.29496 23.4139 1.75 22.869 1.75 22.1967V8.42623C1.75 6.3959 3.3959 4.75 5.42623 4.75Z",
          stroke: "#071114",
          "stroke-width": "1.5"
        }
      ),
      /* @__PURE__ */ jsx68(
        "path",
        {
          d: "M4.93457 26.1313L4.93457 24.1641",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      ),
      /* @__PURE__ */ jsx68(
        "path",
        {
          d: "M27.5576 26.1313L27.5576 24.1641",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Home.tsx
init_react_shim();
import { jsx as jsx69, jsxs as jsxs58 } from "react/jsx-runtime";
var Home = (props) => /* @__PURE__ */ jsxs58(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx69(
        "path",
        {
          d: "M5.6875 18.5V27.875C5.6875 28.3723 5.88504 28.8492 6.23667 29.2008C6.58831 29.5525 7.06522 29.75 7.5625 29.75H24.4375C24.9348 29.75 25.4117 29.5525 25.7633 29.2008C26.115 28.8492 26.3125 28.3723 26.3125 27.875V18.5",
          stroke: "#071114",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx69(
        "path",
        {
          d: "M1.9375 16.7864L14.6737 4.04887C14.8479 3.87463 15.0546 3.73641 15.2822 3.64211C15.5098 3.54781 15.7537 3.49927 16 3.49927C16.2463 3.49927 16.4902 3.54781 16.7178 3.64211C16.9454 3.73641 17.1521 3.87463 17.3263 4.04887L30.0625 16.7864",
          stroke: "#071114",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx69(
        "path",
        {
          d: "M21.625 8.34875V5.375H26.3125V13.0363",
          stroke: "#071114",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/House.tsx
init_react_shim();
import { jsx as jsx70, jsxs as jsxs59 } from "react/jsx-runtime";
var House = (props) => /* @__PURE__ */ jsxs59(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx70(
        "path",
        {
          d: "M5.69141 18.4299V28.7424H13.1914V21.2424C13.1914 20.7452 13.389 20.2682 13.7406 19.9166C14.0922 19.565 14.5691 19.3674 15.0664 19.3674H16.9414C17.4387 19.3674 17.9156 19.565 18.2672 19.9166C18.6189 20.2682 18.8164 20.7452 18.8164 21.2424V28.7424H26.3164V18.4299",
          stroke: "#071114",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx70(
        "path",
        {
          d: "M1.94141 16.5549L14.6777 3.81864C14.8518 3.64441 15.0585 3.50619 15.2861 3.41188C15.5137 3.31758 15.7576 3.26904 16.0039 3.26904C16.2502 3.26904 16.4942 3.31758 16.7217 3.41188C16.9493 3.50619 17.156 3.64441 17.3302 3.81864L30.0664 16.5549",
          stroke: "#071114",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Interior.tsx
init_react_shim();
import { jsx as jsx71, jsxs as jsxs60 } from "react/jsx-runtime";
var Interior = (props) => /* @__PURE__ */ jsxs60(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M14.685 27.5H13.815C13.334 27.4987 12.8732 27.307 12.5331 26.9669C12.193 26.6268 12.0013 26.166 12 25.685V20.315C12.0013 19.834 12.193 19.3732 12.5331 19.0331C12.8732 18.693 13.334 18.5013 13.815 18.5H14.685C14.8317 18.501 14.9777 18.5195 15.12 18.555C15.5144 18.6505 15.8651 18.8762 16.1154 19.1955C16.3658 19.5148 16.5013 19.9092 16.5 20.315V25.685C16.4987 26.166 16.307 26.6268 15.9669 26.9669C15.6268 27.307 15.166 27.4987 14.685 27.5ZM13.815 19.5C13.708 19.5 13.602 19.5211 13.5031 19.562C13.4042 19.603 13.3144 19.663 13.2387 19.7387C13.163 19.8144 13.103 19.9042 13.062 20.0031C13.0211 20.102 13 20.208 13 20.315V25.685C13 25.9012 13.0859 26.1084 13.2387 26.2613C13.3915 26.4141 13.5988 26.5 13.815 26.5H14.685C14.9012 26.5 15.1085 26.4141 15.2613 26.2613C15.4141 26.1084 15.5 25.9012 15.5 25.685V20.315C15.4997 20.133 15.4385 19.9563 15.3261 19.8132C15.2138 19.67 15.0567 19.5685 14.88 19.525C14.8152 19.518 14.7498 19.518 14.685 19.525L13.815 19.5Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M28.685 27.5H27.815C27.334 27.4987 26.8732 27.307 26.5331 26.9669C26.193 26.6268 26.0013 26.166 26 25.685V20.315C25.9987 19.9092 26.1342 19.5148 26.3846 19.1955C26.6349 18.8762 26.9856 18.6505 27.38 18.555C27.5223 18.5195 27.6683 18.501 27.815 18.5H28.685C29.166 18.5013 29.6268 18.693 29.9669 19.0331C30.307 19.3732 30.4987 19.834 30.5 20.315V25.685C30.4987 26.166 30.307 26.6268 29.9669 26.9669C29.6268 27.307 29.166 27.4987 28.685 27.5ZM27.815 19.5C27.7502 19.493 27.6848 19.493 27.62 19.5C27.4391 19.5445 27.2788 19.6497 27.166 19.798C27.0532 19.9463 26.9946 20.1287 27 20.315V25.685C27 25.9012 27.0859 26.1084 27.2387 26.2613C27.3916 26.4141 27.5988 26.5 27.815 26.5H28.685C28.9012 26.5 29.1084 26.4141 29.2613 26.2613C29.4141 26.1084 29.5 25.9012 29.5 25.685V20.315C29.5 20.208 29.4789 20.102 29.438 20.0031C29.397 19.9042 29.337 19.8144 29.2613 19.7387C29.1856 19.663 29.0958 19.603 28.9969 19.562C28.898 19.5211 28.792 19.5 28.685 19.5H27.815Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71("path", { d: "M11 25H1.5V19H11V25ZM2.5 24H10V20H2.5V24Z", fill: "#071114" }),
      /* @__PURE__ */ jsx71("path", { d: "M10 24H11V27.5H10V24Z", fill: "#071114" }),
      /* @__PURE__ */ jsx71("path", { d: "M1.5 24H2.5V27.5H1.5V24Z", fill: "#071114" }),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M25.5 27.5H17C16.6022 27.5 16.2206 27.342 15.9393 27.0607C15.658 26.7794 15.5 26.3978 15.5 26V23H27V26C27 26.3978 26.842 26.7794 26.5607 27.0607C26.2794 27.342 25.8978 27.5 25.5 27.5ZM16.5 24V26C16.5 26.1326 16.5527 26.2598 16.6464 26.3536C16.7402 26.4473 16.8674 26.5 17 26.5H25.5C25.6326 26.5 25.7598 26.4473 25.8536 26.3536C25.9473 26.2598 26 26.1326 26 26V24H16.5Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M27 24H15.5V22.5C15.5 21.837 15.7634 21.2011 16.2322 20.7322C16.7011 20.2634 17.337 20 18 20H24.5C25.163 20 25.7989 20.2634 26.2678 20.7322C26.7366 21.2011 27 21.837 27 22.5V24ZM16.5 23H26V22.5C26 22.1022 25.842 21.7206 25.5607 21.4393C25.2794 21.158 24.8978 21 24.5 21H18C17.6022 21 17.2206 21.158 16.9393 21.4393C16.658 21.7206 16.5 22.1022 16.5 22.5V23Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M27 22.5H26C26 22.1022 25.842 21.7206 25.5607 21.4393C25.2794 21.158 24.8978 21 24.5 21H18C17.6022 21 17.2206 21.158 16.9393 21.4393C16.658 21.7206 16.5 22.1022 16.5 22.5H15.5V20.315C15.4997 20.133 15.4385 19.9563 15.3261 19.8132C15.2138 19.67 15.0567 19.5685 14.88 19.525L14.5 19.435V15.5C14.5 14.5717 14.8687 13.6815 15.5251 13.0251C16.1815 12.3687 17.0717 12 18 12H24.5C25.4283 12 26.3185 12.3687 26.9749 13.0251C27.6313 13.6815 28 14.5717 28 15.5V19.435L27.62 19.525C27.4433 19.5685 27.2862 19.67 27.1739 19.8132C27.0615 19.9563 27.0003 20.133 27 20.315V22.5ZM18 20H24.5C25.0409 20 25.5673 20.1754 26 20.5V20.315C25.9986 19.9785 26.0915 19.6483 26.2683 19.362C26.4451 19.0756 26.6985 18.8446 27 18.695V15.5C27 14.837 26.7366 14.2011 26.2678 13.7322C25.7989 13.2634 25.163 13 24.5 13H18C17.337 13 16.7011 13.2634 16.2322 13.7322C15.7634 14.2011 15.5 14.837 15.5 15.5V18.695C15.8015 18.8446 16.0549 19.0756 16.2317 19.362C16.4085 19.6483 16.5014 19.9785 16.5 20.315V20.5C16.9327 20.1754 17.4591 20 18 20Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71("path", { d: "M5 21.5H7.5V22.5H5V21.5Z", fill: "#071114" }),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M7.875 20H4.625L3.335 15.5H9.165L7.875 20ZM5.375 19H7.125L7.835 16.5H4.665L5.375 19Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M6.25 16.5C6.12233 16.4991 5.99506 16.4857 5.87 16.46C4.93283 16.3004 4.08167 15.8162 3.46555 15.0923C2.84944 14.3683 2.50764 13.4506 2.5 12.5V12H3C3.93037 11.9952 4.83289 12.3172 5.55 12.91L5.735 13.055V13.29C5.7319 13.8987 5.91128 14.4943 6.25 15C6.59456 14.4978 6.78089 13.904 6.785 13.295V13.06L6.97 12.915C7.68113 12.3248 8.57588 12.0012 9.5 12H10V12.5C10.0036 13.4674 9.65903 14.4038 9.02929 15.1382C8.39955 15.8726 7.52664 16.356 6.57 16.5C6.4636 16.5106 6.3564 16.5106 6.25 16.5ZM7.775 13.525C7.73826 14.1236 7.56738 14.7063 7.275 15.23C7.7164 15.0279 8.10215 14.7216 8.39913 14.3375C8.6961 13.9535 8.89543 13.5031 8.98 13.025C8.54549 13.1007 8.13362 13.2733 7.775 13.53V13.525ZM3.53 13.025C3.62045 13.5008 3.82203 13.9486 4.11832 14.3318C4.41461 14.715 4.79722 15.0227 5.235 15.23C4.94403 14.7057 4.77324 14.1234 4.735 13.525C4.37548 13.2718 3.96368 13.1027 3.53 13.03V13.025Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M6.25 16.455L5.895 16.105C5.81 16.015 5.725 15.925 5.645 15.83C5.00337 15.0552 4.67348 14.0691 4.7197 13.0642C4.76593 12.0593 5.18495 11.1076 5.895 10.395L6.25 10.045L6.605 10.395C6.98113 10.7689 7.27916 11.2139 7.48174 11.704C7.68432 12.1941 7.7874 12.7197 7.785 13.25V13.275C7.78217 14.2027 7.45694 15.1006 6.865 15.815C6.775 15.925 6.69 16.015 6.605 16.105L6.25 16.455ZM6.25 11.525C5.90172 12.0328 5.71533 12.6342 5.71533 13.25C5.71533 13.8658 5.90172 14.4672 6.25 14.975C6.59456 14.4728 6.78089 13.879 6.785 13.27C6.79223 12.6469 6.60524 12.037 6.25 11.525Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71("path", { d: "M12 10H13V22H12V10Z", fill: "#071114" }),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M16.55 11H8.45L9.045 4.5H15.955L16.55 11ZM9.55 10H15.45L15.045 5.5H9.955L9.55 10Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx71(
        "path",
        {
          d: "M16.5 20.315C16.5013 19.9092 16.3658 19.5148 16.1154 19.1955C15.8651 18.8762 15.5144 18.6505 15.12 18.555C14.9777 18.5195 14.8317 18.501 14.685 18.5H13.815C13.334 18.5013 12.8732 18.693 12.5331 19.0331C12.193 19.3732 12.0013 19.834 12 20.315V25.685C12.0013 26.166 12.193 26.6268 12.5331 26.9669C12.8732 27.307 13.334 27.4987 13.815 27.5H14.685C15.166 27.4987 15.6268 27.307 15.9669 26.9669C16.307 26.6268 16.4987 26.166 16.5 25.685V20.315ZM16.5 20.315C16.5014 19.9785 16.4085 19.6483 16.2317 19.362C16.0549 19.0756 15.8015 18.8446 15.5 18.695V15.5C15.5 14.837 15.7634 14.2011 16.2322 13.7322C16.7011 13.2634 17.337 13 18 13H24.5C25.163 13 25.7989 13.2634 26.2678 13.7322C26.7366 14.2011 27 14.837 27 15.5V18.695C26.6985 18.8446 26.4451 19.0756 26.2683 19.362C26.0915 19.6483 25.9986 19.9785 26 20.315M16.5 20.315V20.5C16.9327 20.1754 17.4591 20 18 20M15.5 20.315V25.685C15.5 25.9012 15.4141 26.1084 15.2613 26.2613C15.1085 26.4141 14.9012 26.5 14.685 26.5H13.815C13.5988 26.5 13.3915 26.4141 13.2387 26.2613C13.0859 26.1084 13 25.9012 13 25.685V20.315C13 20.208 13.0211 20.102 13.062 20.0031C13.103 19.9042 13.163 19.8144 13.2387 19.7387C13.3144 19.663 13.4042 19.603 13.5031 19.562C13.602 19.5211 13.708 19.5 13.815 19.5L14.685 19.525C14.7498 19.518 14.8152 19.518 14.88 19.525M15.5 20.315C15.4997 20.133 15.4385 19.9563 15.3261 19.8132C15.2138 19.67 15.0567 19.5685 14.88 19.525M15.5 20.315V22.5M14.88 19.525L14.5 19.435V15.5C14.5 14.5717 14.8687 13.6815 15.5251 13.0251C16.1815 12.3687 17.0717 12 18 12H24.5C25.4283 12 26.3185 12.3687 26.9749 13.0251C27.6313 13.6815 28 14.5717 28 15.5V19.435L27.62 19.525C27.4433 19.5685 27.2862 19.67 27.1739 19.8132C27.0615 19.9563 27.0003 20.133 27 20.315M26 20.315V25.685C26.0013 26.166 26.193 26.6268 26.5331 26.9669C26.8732 27.307 27.334 27.4987 27.815 27.5H28.685C29.166 27.4987 29.6268 27.307 29.9669 26.9669C30.307 26.6268 30.4987 26.166 30.5 25.685V20.315C30.4987 19.834 30.307 19.3732 29.9669 19.0331C29.6268 18.693 29.166 18.5013 28.685 18.5H27.815C27.6683 18.501 27.5223 18.5195 27.38 18.555C26.9856 18.6505 26.6349 18.8762 26.3846 19.1955C26.1342 19.5148 25.9987 19.9092 26 20.315ZM26 20.315V20.5C25.5673 20.1754 25.0409 20 24.5 20M27 20.315C26.9946 20.1287 27.0532 19.9463 27.166 19.798C27.2788 19.6497 27.4391 19.5445 27.62 19.5C27.6848 19.493 27.7502 19.493 27.815 19.5H28.685C28.792 19.5 28.898 19.5211 28.9969 19.562C29.0958 19.603 29.1856 19.663 29.2613 19.7387C29.337 19.8144 29.397 19.9042 29.438 20.0031C29.4789 20.102 29.5 20.208 29.5 20.315V25.685C29.5 25.9012 29.4141 26.1084 29.2613 26.2613C29.1084 26.4141 28.9012 26.5 28.685 26.5H27.815C27.5988 26.5 27.3916 26.4141 27.2387 26.2613C27.0859 26.1084 27 25.9012 27 25.685V20.315ZM27 20.315V22.5M2.5 24H10M2.5 24V20H10V24M2.5 24H1.5V27.5H2.5V24ZM10 24H11V27.5H10V24ZM15.5 22.5V24H27V22.5M15.5 22.5C15.5 21.837 15.7634 21.2011 16.2322 20.7322C16.7011 20.2634 17.337 20 18 20M15.5 22.5H16.5M18 20H24.5M24.5 20C25.163 20 25.7989 20.2634 26.2678 20.7322C26.7366 21.2011 27 21.837 27 22.5M27 22.5H26M26 22.5V23H16.5V22.5M26 22.5C26 22.1022 25.842 21.7206 25.5607 21.4393C25.2794 21.158 24.8978 21 24.5 21H18C17.6022 21 17.2206 21.158 16.9393 21.4393C16.658 21.7206 16.5 22.1022 16.5 22.5M6.785 13.27C6.78089 13.879 6.59456 14.4728 6.25 14.975C5.90172 14.4672 5.71533 13.8658 5.71533 13.25C5.71533 12.6342 5.90172 12.0328 6.25 11.525C6.60524 12.037 6.79223 12.6469 6.785 13.27ZM6.785 13.27H7.285M11 25H1.5V19H11V25ZM25.5 27.5H17C16.6022 27.5 16.2206 27.342 15.9393 27.0607C15.658 26.7794 15.5 26.3978 15.5 26V23H27V26C27 26.3978 26.842 26.7794 26.5607 27.0607C26.2794 27.342 25.8978 27.5 25.5 27.5ZM16.5 24V26C16.5 26.1326 16.5527 26.2598 16.6464 26.3536C16.7402 26.4473 16.8674 26.5 17 26.5H25.5C25.6326 26.5 25.7598 26.4473 25.8536 26.3536C25.9473 26.2598 26 26.1326 26 26V24H16.5ZM5 21.5H7.5V22.5H5V21.5ZM7.875 20H4.625L3.335 15.5H9.165L7.875 20ZM5.375 19H7.125L7.835 16.5H4.665L5.375 19ZM6.25 16.5C6.12233 16.4991 5.99506 16.4857 5.87 16.46C4.93283 16.3004 4.08167 15.8162 3.46555 15.0923C2.84944 14.3683 2.50764 13.4506 2.5 12.5V12H3C3.93037 11.9952 4.83289 12.3172 5.55 12.91L5.735 13.055V13.29C5.7319 13.8987 5.91128 14.4943 6.25 15C6.59456 14.4978 6.78089 13.904 6.785 13.295V13.06L6.97 12.915C7.68113 12.3248 8.57588 12.0012 9.5 12H10V12.5C10.0036 13.4674 9.65903 14.4038 9.02929 15.1382C8.39955 15.8726 7.52664 16.356 6.57 16.5C6.4636 16.5106 6.3564 16.5106 6.25 16.5ZM7.775 13.525C7.73826 14.1236 7.56738 14.7063 7.275 15.23C7.7164 15.0279 8.10215 14.7216 8.39913 14.3375C8.6961 13.9535 8.89543 13.5031 8.98 13.025C8.54549 13.1007 8.13362 13.2733 7.775 13.53V13.525ZM3.53 13.025C3.62045 13.5008 3.82203 13.9486 4.11832 14.3318C4.41461 14.715 4.79722 15.0227 5.235 15.23C4.94403 14.7057 4.77324 14.1234 4.735 13.525C4.37548 13.2718 3.96368 13.1027 3.53 13.03V13.025ZM6.25 16.455L5.895 16.105C5.81 16.015 5.725 15.925 5.645 15.83C5.00337 15.0552 4.67348 14.0691 4.7197 13.0642C4.76593 12.0593 5.18495 11.1076 5.895 10.395L6.25 10.045L6.605 10.395C6.98113 10.7689 7.27916 11.2139 7.48174 11.704C7.68432 12.1941 7.7874 12.7197 7.785 13.25V13.275C7.78217 14.2027 7.45694 15.1006 6.865 15.815C6.775 15.925 6.69 16.015 6.605 16.105L6.25 16.455ZM12 10H13V22H12V10ZM16.55 11H8.45L9.045 4.5H15.955L16.55 11ZM9.55 10H15.45L15.045 5.5H9.955L9.55 10Z",
          stroke: "#071114",
          "stroke-width": "0.2"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Lamp.tsx
init_react_shim();
import { jsx as jsx72, jsxs as jsxs61 } from "react/jsx-runtime";
var Lamp = (props) => /* @__PURE__ */ jsxs61(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx72(
        "path",
        {
          d: "M19.75 11.0887V9.63873C19.7701 8.72515 19.468 7.83363 18.8966 7.12052C18.3252 6.40741 17.521 5.91821 16.625 5.73873C16.0871 5.64782 15.536 5.67533 15.0099 5.81935C14.4838 5.96336 13.9954 6.2204 13.5789 6.57256C13.1624 6.92471 12.8277 7.36349 12.5981 7.8583C12.3686 8.35311 12.2498 8.89203 12.25 9.43748V11.0887C10.4743 11.7821 8.9255 12.9537 7.77527 14.4738C6.62504 15.9938 5.91839 17.8028 5.73372 19.7C5.72579 19.8278 5.74435 19.9559 5.78823 20.0762C5.83212 20.1966 5.90038 20.3065 5.98875 20.3992C6.07712 20.4919 6.18368 20.5654 6.30176 20.615C6.41985 20.6646 6.5469 20.6893 6.67497 20.6875H25.325C25.453 20.6893 25.5801 20.6646 25.6982 20.615C25.8163 20.5654 25.9228 20.4919 26.0112 20.3992C26.0996 20.3065 26.1678 20.1966 26.2117 20.0762C26.2556 19.9559 26.2742 19.8278 26.2662 19.7C26.0815 17.8028 25.3749 15.9938 24.2247 14.4738C23.0744 12.9537 21.5256 11.7821 19.75 11.0887Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          d: "M16 1.9375V5.6875",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          d: "M19.75 20.6875C19.75 21.6821 19.3549 22.6359 18.6517 23.3392C17.9484 24.0424 16.9946 24.4375 16 24.4375C15.0054 24.4375 14.0516 24.0424 13.3483 23.3392C12.6451 22.6359 12.25 21.6821 12.25 20.6875",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          d: "M16 30.0625V28.1875",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          d: "M22.5625 26.3125L24.4375 29.125",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          d: "M9.4375 26.3125L7.5625 29.125",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Mattress.tsx
init_react_shim();
import { jsx as jsx73, jsxs as jsxs62 } from "react/jsx-runtime";
var Mattress = (props) => /* @__PURE__ */ jsxs62(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx73(
        "path",
        {
          d: "M29.3525 17.127L15.7497 22.8867L2.5 17.5",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx73(
        "path",
        {
          d: "M15.75 27.2426V22.8867",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx73(
        "path",
        {
          d: "M21.5 13.5L28.7636 16.6528C29.2546 16.775 29.5002 17.2639 29.5002 17.7528V20.6861C29.5002 21.175 29.2546 21.5418 28.7636 21.7861L16.2412 27.164C15.8728 27.2863 15.6273 27.2863 15.259 27.164L2.73661 21.7861C2.24554 21.664 2 21.175 2 20.6861V17.7528C2 17.2639 15.0089 12.744 15.5 12.4995",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx73(
        "path",
        {
          d: "M19.2212 5H22.7118L19.0029 10.2359H22.9299",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx73(
        "path",
        {
          d: "M17.1455 14H19.4725L17 17.4907H19.618",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Module.tsx
init_react_shim();
import { jsx as jsx74, jsxs as jsxs63 } from "react/jsx-runtime";
var Module = (props) => /* @__PURE__ */ jsxs63(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsxs63("g", { "clip-path": "url(#clip0_4454_84544)", children: [
        /* @__PURE__ */ jsxs63("g", { opacity: "0.2", children: [
          /* @__PURE__ */ jsx74(
            "mask",
            {
              id: "mask0_4454_84544",
              style: { maskType: "luminance" },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "2",
              width: "15",
              height: "18",
              children: /* @__PURE__ */ jsx74(
                "path",
                {
                  d: "M14 3.31079H1.25732V19H14V3.31079Z",
                  fill: "white",
                  stroke: "white",
                  "stroke-width": "0.8"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx74("g", { mask: "url(#mask0_4454_84544)", children: /* @__PURE__ */ jsx74(
            "path",
            {
              d: "M14 3.32151V8.95312L13.715 10.7374L11.8938 19H1.26788L1.25732 10.0891L1.50014 9.04421L2.58227 7.59746L6.21398 3.80912L7.73951 3.35902L11.0281 3.31079L14 3.32151Z",
              fill: "#071114",
              stroke: "#071114",
              "stroke-width": "0.8"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M16.7781 28.8169C14.0245 28.8169 11.378 28.0562 9.32611 26.6793C9.2029 26.599 9.17075 26.4329 9.25111 26.3097C9.33147 26.1865 9.49755 26.1543 9.62077 26.2347C11.5815 27.5526 14.1263 28.2812 16.7728 28.2812C19.4193 28.2812 21.9533 27.5526 23.9194 26.2347C24.0426 26.149 24.2087 26.1865 24.2891 26.3097C24.3694 26.4329 24.3373 26.599 24.2141 26.6793C22.1622 28.0562 19.5211 28.8169 16.7728 28.8169H16.7781Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M23.8497 28.8063C23.8497 28.8063 23.5174 29.0851 23.4906 29.0743C23.3513 29.0315 23.2709 28.8815 23.3138 28.7368L24.0103 26.5136L21.787 25.8171C21.6477 25.7742 21.5673 25.6242 21.6102 25.4796C21.653 25.3403 21.803 25.2599 21.9477 25.3028L24.4228 26.0796C24.5621 26.1225 24.6424 26.2725 24.5996 26.4171L23.8227 28.8922C23.7852 29.0047 23.5 29.0797 23.5656 29.0797L23.8497 28.8063Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M9.95209 29.0848C9.83959 29.0848 9.73244 29.0098 9.69494 28.8973L8.91813 26.4222C8.8967 26.3526 8.90206 26.2829 8.9342 26.2186C8.96635 26.1543 9.02528 26.1061 9.08957 26.0847L11.5646 25.3079C11.7039 25.265 11.8539 25.34 11.9022 25.4847C11.9504 25.6293 11.87 25.774 11.7254 25.8222L9.50208 26.5186L10.1985 28.7419C10.2414 28.8812 10.1664 29.0312 10.0217 29.0794C9.99495 29.0902 9.96816 29.0902 9.94138 29.0902L9.95209 29.0848Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M30.0686 17.9041C29.9401 17.9041 29.8276 17.813 29.8061 17.6844L29.3883 15.3486C29.3615 15.204 29.4579 15.0647 29.6025 15.0379C29.7472 15.0111 29.8865 15.1076 29.9133 15.2522L30.3311 17.588C30.3579 17.7326 30.2615 17.8719 30.1169 17.8987C30.1008 17.8987 30.0847 17.8987 30.0686 17.8987V17.9041Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M2.24305 22.8006C2.24305 22.8006 2.21091 22.8006 2.19484 22.8006C2.05019 22.7738 1.95376 22.6345 1.98054 22.4899L2.39841 20.1541C2.4252 20.0094 2.56449 19.913 2.70914 19.9398C2.85378 19.9666 2.95022 20.1058 2.92343 20.2505L2.50556 22.5863C2.48413 22.7149 2.37163 22.8059 2.24305 22.8059V22.8006Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M11.0721 22.8003C10.9435 22.8003 10.831 22.7092 10.8095 22.5807L10.3917 20.2449C10.3649 20.1002 10.4613 19.9609 10.606 19.9342C10.7506 19.9074 10.8899 20.0038 10.9167 20.1484L11.3346 22.4842C11.3613 22.6289 11.2649 22.7682 11.1203 22.795C11.1042 22.795 11.0881 22.795 11.0721 22.795V22.8003Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M12.0521 19.2648H1.26787C1.11786 19.2648 1 19.1469 1 18.9969V10.7895C1 9.67521 1.41251 8.60375 2.16789 7.77872L5.33942 4.31254C6.10016 3.4768 7.18769 3 8.31808 3H28.1991C29.3134 3 30.2188 3.91074 30.2188 5.02506V6.41261C30.2188 6.56261 30.1009 6.68047 29.9509 6.68047C29.8009 6.68047 29.683 6.56261 29.683 6.41261V5.02506C29.683 4.20539 29.0187 3.54109 28.1991 3.54109H8.31808C7.3377 3.54109 6.40017 3.9536 5.73586 4.67684L2.56433 8.14302C1.90003 8.86625 1.53573 9.80914 1.53573 10.7895V18.7291H11.7843V15.1343C11.7843 14.4057 11.1896 13.8057 10.4557 13.8057H4.79833C4.64833 13.8057 4.53047 13.6878 4.53047 13.5378V10.7895C4.53047 10.1842 4.03759 9.69128 3.43222 9.69128C3.28221 9.69128 3.16435 9.57342 3.16435 9.42341C3.16435 9.27341 3.28221 9.15555 3.43222 9.15555C4.33225 9.15555 5.0662 9.8895 5.0662 10.7895V13.27H10.4557C11.4843 13.27 12.32 14.1057 12.32 15.1343V18.9969C12.32 19.1469 12.2021 19.2648 12.0521 19.2648Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M14.179 9.48247C14.029 9.48247 13.9111 9.36461 13.9111 9.2146V4.64482C13.9111 4.49481 14.029 4.37695 14.179 4.37695C14.329 4.37695 14.4469 4.49481 14.4469 4.64482V9.2146C14.4469 9.36461 14.329 9.48247 14.179 9.48247Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M26.3461 9.67001H10.0491C9.89911 9.67001 9.78125 9.55215 9.78125 9.40214C9.78125 9.25214 9.89911 9.13428 10.0491 9.13428H26.3461C26.4961 9.13428 26.6139 9.25214 26.6139 9.40214C26.6139 9.55215 26.4961 9.67001 26.3461 9.67001Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M22.1346 9.55747C21.9846 9.55747 21.8667 9.43961 21.8667 9.28961V4.64482C21.8667 4.49481 21.9846 4.37695 22.1346 4.37695C22.2846 4.37695 22.4024 4.49481 22.4024 4.64482V9.28961C22.4024 9.43961 22.2846 9.55747 22.1346 9.55747Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M14.7098 14.2076C14.5598 14.2076 14.4419 14.0897 14.4419 13.9397C14.4419 13.7897 14.5598 13.6719 14.7098 13.6719H30.9585V8.57172C30.9585 8.06813 30.5513 7.66098 30.0477 7.66098H29.8549C29.3513 7.66098 28.9441 8.06813 28.9441 8.57172V11.7325C28.9441 11.8825 28.8263 12.0004 28.6763 12.0004H15.1116C14.9616 12.0004 14.8437 11.8825 14.8437 11.7325C14.8437 11.5825 14.9616 11.4647 15.1116 11.4647H28.4084V8.57172C28.4084 7.77348 29.0566 7.12524 29.8549 7.12524H30.0477C30.846 7.12524 31.4942 7.77348 31.4942 8.57172V13.8326C31.4942 14.0362 31.3281 14.1969 31.1246 14.1969H14.7098V14.2076Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M8.85406 8.81272C8.70405 8.81272 8.58619 8.69486 8.58619 8.54485V5.78048C8.58619 5.11617 8.07189 4.74116 7.88974 4.6608C7.75581 4.60187 7.69152 4.44115 7.75045 4.30722C7.80938 4.17329 7.96474 4.109 8.10403 4.16793C8.51119 4.34472 9.12192 4.92331 9.12192 5.77512V8.5395C9.12192 8.6895 9.00406 8.80736 8.85406 8.80736V8.81272Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M8.13089 10.2004L7.00586 12.0219",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M7.00569 12.2896C6.95747 12.2896 6.90926 12.2789 6.8664 12.2521C6.74318 12.1718 6.70032 12.011 6.78068 11.8825L7.90572 10.061C7.98608 9.93776 8.1468 9.8949 8.27537 9.97526C8.39859 10.0556 8.44145 10.2163 8.36109 10.3449L7.23605 12.1664C7.18784 12.2468 7.09676 12.295 7.00569 12.295V12.2896Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M7.00592 12.2895C6.85591 12.2895 6.73805 12.1716 6.73805 12.0216V7.68756C6.71662 6.96432 6.18625 6.56252 5.81659 6.51431C5.67195 6.49288 5.5648 6.35895 5.58623 6.2143C5.60766 6.06965 5.74159 5.96251 5.88624 5.98394C6.54519 6.06965 7.24164 6.7286 7.27378 7.6822V12.027C7.27378 12.177 7.15592 12.2948 7.00592 12.2948V12.2895Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M12.9791 15.3752C12.9791 15.3752 12.9416 15.3752 12.9255 15.3699C12.7809 15.3377 12.6898 15.1985 12.7166 15.0538L13.9113 9.4072C13.9434 9.26256 14.0881 9.17148 14.2273 9.19827C14.372 9.23041 14.4631 9.3697 14.4363 9.51435L13.2416 15.161C13.2148 15.2895 13.1023 15.3752 12.9791 15.3752Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        ),
        /* @__PURE__ */ jsx74(
          "path",
          {
            d: "M22.515 11.8073C22.3864 11.8073 22.2739 11.7162 22.2525 11.5877L21.8668 9.38581C21.84 9.24117 21.9364 9.10188 22.0864 9.07509C22.2311 9.0483 22.3704 9.15009 22.3971 9.29474L22.7829 11.4966C22.8097 11.6412 22.7132 11.7805 22.5632 11.8073C22.5471 11.8073 22.5311 11.8073 22.515 11.8073Z",
            fill: "#071114",
            stroke: "#071114",
            "stroke-width": "0.8"
          }
        )
      ] }),
      /* @__PURE__ */ jsx74("defs", { children: /* @__PURE__ */ jsx74("clipPath", { id: "clip0_4454_84544", children: /* @__PURE__ */ jsx74("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/ModulSofa.tsx
init_react_shim();
import { jsx as jsx75, jsxs as jsxs64 } from "react/jsx-runtime";
var ModulSofa = (props) => /* @__PURE__ */ jsxs64(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M30.8806 23.3768H27.0921C27.0259 23.3768 26.9727 23.3236 26.9727 23.2574V14.6112C26.9727 13.945 27.5209 13.4026 28.1942 13.4026H29.7784C30.4518 13.4026 31 13.945 31 14.6112V23.2574C31 23.3236 30.9468 23.3768 30.8806 23.3768ZM27.2101 23.1394H30.7612V14.6127C30.7612 14.0774 30.3194 13.6429 29.7784 13.6429H28.1942C27.6518 13.6429 27.2115 14.0774 27.2115 14.6127V23.1394H27.2101Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M4.90794 23.3768H1.11943C1.05324 23.3768 1 23.3236 1 23.2574V14.6112C1 13.945 1.5482 13.4026 2.22159 13.4026H3.80577C4.47916 13.4026 5.02736 13.945 5.02736 14.6112V23.2574C5.02736 23.3236 4.97412 23.3768 4.90794 23.3768ZM1.23741 23.1394H4.78851V14.6127C4.78851 14.0774 4.34678 13.6429 3.80577 13.6429H2.22159C1.67914 13.6429 1.23885 14.0774 1.23885 14.6127V23.1394H1.23741Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M27.0921 23.3768H4.90794C4.84175 23.3768 4.78857 23.3236 4.78857 23.2574C4.78857 23.1912 4.84181 23.1379 4.908 23.1379H27.0909C27.1571 23.1379 27.2103 23.1912 27.2103 23.2574C27.2103 23.3236 27.1571 23.3768 27.0909 23.3768L27.0921 23.3768Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M27.0923 21.1367C27.0261 21.1367 26.9729 21.0834 26.9729 21.0172V19.61C26.9729 19.0748 26.5311 18.6402 25.9901 18.6402H6.01016C5.46772 18.6402 5.02742 19.0748 5.02742 19.61V21.0172C5.02742 21.0834 4.97419 21.1367 4.908 21.1367C4.84181 21.1367 4.78857 21.0834 4.78857 21.0172V19.61C4.78857 18.9438 5.33678 18.4014 6.01016 18.4014H25.9887C26.6621 18.4014 27.2103 18.9438 27.2103 19.61V21.0172C27.2103 21.0834 27.1571 21.1367 27.0909 21.1367H27.0923Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M27.0923 16.2447C27.0261 16.2447 26.9729 16.1915 26.9729 16.1253L26.9844 9.20721C26.9844 8.67195 26.5426 8.23741 26.0016 8.23741H6.02165C5.4792 8.23741 5.03747 8.67195 5.03747 9.20721L5.02596 16.1253C5.02596 16.1915 4.97272 16.2447 4.90653 16.2447C4.84035 16.2447 4.78711 16.1915 4.78711 16.1253L4.79862 9.20721C4.79862 8.54101 5.34683 8 6.02021 8H25.9987C26.6721 8 27.2203 8.54245 27.2203 9.20865L27.1513 15.7339C27.1513 15.8001 27.1455 16.0217 27.0794 16.0217L27.0923 16.2447Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M2.28739 25.1855C2.22121 25.1855 2.16797 25.1322 2.16797 25.066V23.2588C2.16797 23.1926 2.22121 23.1394 2.28739 23.1394C2.35358 23.1394 2.40682 23.1926 2.40682 23.2588V24.9481H3.71186V23.2588C3.71186 23.1926 3.7651 23.1394 3.83129 23.1394C3.89748 23.1394 3.95071 23.1926 3.95071 23.2588V25.066C3.95071 25.1322 3.89748 25.1855 3.83129 25.1855H2.28739Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M28.2059 25.1855C28.1397 25.1855 28.0864 25.1322 28.0864 25.066V23.2588C28.0864 23.1926 28.1397 23.1394 28.2059 23.1394C28.272 23.1394 28.3253 23.1926 28.3253 23.2588V24.9481H29.6303V23.2588C29.6303 23.1926 29.6836 23.1394 29.7497 23.1394C29.8159 23.1394 29.8692 23.1926 29.8692 23.2588V25.066C29.8692 25.1322 29.8159 25.1855 29.7497 25.1855H28.2059Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M15.6586 18.3437C15.5924 18.3437 15.5392 18.2905 15.5392 18.2243V15.8084C15.5363 15.7538 15.519 15.2199 15.8428 15.0386C16.2255 14.8243 16.601 15.1048 16.7464 15.2832C16.7492 15.2876 16.7521 15.2904 16.755 15.2948C16.7795 15.312 16.8456 15.3538 17.0154 15.443C17.2255 15.5523 17.5564 15.6818 17.9737 15.6717C19.0989 15.6473 19.9924 14.6732 20.0068 13.4559C20.0154 12.7192 19.7608 12.0357 19.3104 11.5796C18.9507 11.2156 18.4888 11.0228 17.9766 11.0228C17.5651 11.0228 17.3018 11.0947 17.0039 11.2875C17.0039 11.2875 16.8327 11.4041 16.8111 11.4199C16.8082 11.4228 16.7996 11.4314 16.7881 11.4415C16.5866 11.6285 16.2845 11.8703 15.9953 11.8084C15.4687 11.6947 15.5377 10.9077 15.5406 10.8746L15.5507 8.15366C15.5507 8.08747 15.6111 8.03423 15.6701 8.03567C15.7363 8.03567 15.7881 8.08891 15.7881 8.1551L15.7766 10.8875C15.7766 10.9048 15.7291 11.5091 16.0442 11.5767C16.178 11.6055 16.3723 11.5019 16.6255 11.2674C16.6471 11.2472 16.6615 11.2343 16.6687 11.2285C16.6902 11.2127 16.8701 11.0889 16.8701 11.0889C17.2082 10.8688 17.5176 10.7839 17.9737 10.7839C18.5507 10.7839 19.0701 11.0012 19.4759 11.4113C19.9708 11.912 20.25 12.6573 20.2413 13.4573C20.2255 14.8041 19.2313 15.8804 17.9766 15.9077C17.5104 15.9178 17.1377 15.7739 16.9032 15.6516C16.66 15.525 16.5665 15.466 16.5406 15.4084C16.4687 15.3322 16.2212 15.0976 15.9579 15.2444C15.7924 15.3379 15.7708 15.6861 15.7751 15.8012V18.2229C15.7751 18.289 15.7219 18.3423 15.6557 18.3423L15.6586 18.3437Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M15.6731 23.2229C15.6069 23.2229 15.5537 23.1697 15.5537 23.1035V18.4876C15.5537 18.4214 15.6069 18.3682 15.6731 18.3682C15.7393 18.3682 15.7926 18.4214 15.7926 18.4876V23.1035C15.7926 23.1697 15.7393 23.2229 15.6731 23.2229Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          d: "M27.0921 23.3768H30.8806C30.9468 23.3768 31 23.3236 31 23.2574V14.6112C31 13.945 30.4518 13.4026 29.7784 13.4026H28.1942C27.5209 13.4026 26.9727 13.945 26.9727 14.6112V23.2574C26.9727 23.3236 27.0259 23.3768 27.0921 23.3768ZM27.0921 23.3768H4.90794M27.0921 23.3768L27.0909 23.3768C27.1571 23.3768 27.2103 23.3236 27.2103 23.2574C27.2103 23.1912 27.1571 23.1379 27.0909 23.1379H4.908C4.84181 23.1379 4.78857 23.1912 4.78857 23.2574C4.78857 23.3236 4.84175 23.3768 4.90794 23.3768M4.90794 23.3768H1.11943C1.05324 23.3768 1 23.3236 1 23.2574V14.6112C1 13.945 1.5482 13.4026 2.22159 13.4026H3.80577C4.47916 13.4026 5.02736 13.945 5.02736 14.6112V23.2574C5.02736 23.3236 4.97412 23.3768 4.90794 23.3768ZM27.2101 23.1394H30.7612V14.6127C30.7612 14.0774 30.3194 13.6429 29.7784 13.6429H28.1942C27.6518 13.6429 27.2115 14.0774 27.2115 14.6127V23.1394H27.2101ZM1.23741 23.1394H4.78851V14.6127C4.78851 14.0774 4.34678 13.6429 3.80577 13.6429H2.22159C1.67914 13.6429 1.23885 14.0774 1.23885 14.6127V23.1394H1.23741ZM27.0923 21.1367C27.0261 21.1367 26.9729 21.0834 26.9729 21.0172V19.61C26.9729 19.0748 26.5311 18.6402 25.9901 18.6402H6.01016C5.46772 18.6402 5.02742 19.0748 5.02742 19.61V21.0172C5.02742 21.0834 4.97419 21.1367 4.908 21.1367C4.84181 21.1367 4.78857 21.0834 4.78857 21.0172V19.61C4.78857 18.9438 5.33678 18.4014 6.01016 18.4014H25.9887C26.6621 18.4014 27.2103 18.9438 27.2103 19.61V21.0172C27.2103 21.0834 27.1571 21.1367 27.0909 21.1367H27.0923ZM27.0923 16.2447C27.0261 16.2447 26.9729 16.1915 26.9729 16.1253L26.9844 9.20721C26.9844 8.67195 26.5426 8.23741 26.0016 8.23741H6.02165C5.4792 8.23741 5.03747 8.67195 5.03747 9.20721L5.02596 16.1253C5.02596 16.1915 4.97272 16.2447 4.90653 16.2447C4.84035 16.2447 4.78711 16.1915 4.78711 16.1253L4.79862 9.20721C4.79862 8.54101 5.34683 8 6.02021 8H25.9987C26.6721 8 27.2203 8.54245 27.2203 9.20865L27.1513 15.7339C27.1513 15.8001 27.1455 16.0217 27.0794 16.0217L27.0923 16.2447ZM2.28739 25.1855C2.22121 25.1855 2.16797 25.1322 2.16797 25.066V23.2588C2.16797 23.1926 2.22121 23.1394 2.28739 23.1394C2.35358 23.1394 2.40682 23.1926 2.40682 23.2588V24.9481H3.71186V23.2588C3.71186 23.1926 3.7651 23.1394 3.83129 23.1394C3.89748 23.1394 3.95071 23.1926 3.95071 23.2588V25.066C3.95071 25.1322 3.89748 25.1855 3.83129 25.1855H2.28739ZM28.2059 25.1855C28.1397 25.1855 28.0864 25.1322 28.0864 25.066V23.2588C28.0864 23.1926 28.1397 23.1394 28.2059 23.1394C28.272 23.1394 28.3253 23.1926 28.3253 23.2588V24.9481H29.6303V23.2588C29.6303 23.1926 29.6836 23.1394 29.7497 23.1394C29.8159 23.1394 29.8692 23.1926 29.8692 23.2588V25.066C29.8692 25.1322 29.8159 25.1855 29.7497 25.1855H28.2059ZM15.6586 18.3437C15.5924 18.3437 15.5392 18.2905 15.5392 18.2243V15.8084C15.5363 15.7538 15.519 15.2199 15.8428 15.0386C16.2255 14.8243 16.601 15.1048 16.7464 15.2832C16.7492 15.2876 16.7521 15.2904 16.755 15.2948C16.7795 15.312 16.8456 15.3538 17.0154 15.443C17.2255 15.5523 17.5564 15.6818 17.9737 15.6717C19.0989 15.6473 19.9924 14.6732 20.0068 13.4559C20.0154 12.7192 19.7608 12.0357 19.3104 11.5796C18.9507 11.2156 18.4888 11.0228 17.9766 11.0228C17.5651 11.0228 17.3018 11.0947 17.0039 11.2875C17.0039 11.2875 16.8327 11.4041 16.8111 11.4199C16.8082 11.4228 16.7996 11.4314 16.7881 11.4415C16.5866 11.6285 16.2845 11.8703 15.9953 11.8084C15.4687 11.6947 15.5377 10.9077 15.5406 10.8746L15.5507 8.15366C15.5507 8.08747 15.6111 8.03423 15.6701 8.03567C15.7363 8.03567 15.7881 8.08891 15.7881 8.1551L15.7766 10.8875C15.7766 10.9048 15.7291 11.5091 16.0442 11.5767C16.178 11.6055 16.3723 11.5019 16.6255 11.2674C16.6471 11.2472 16.6615 11.2343 16.6687 11.2285C16.6902 11.2127 16.8701 11.0889 16.8701 11.0889C17.2082 10.8688 17.5176 10.7839 17.9737 10.7839C18.5507 10.7839 19.0701 11.0012 19.4759 11.4113C19.9708 11.912 20.25 12.6573 20.2413 13.4573C20.2255 14.8041 19.2313 15.8804 17.9766 15.9077C17.5104 15.9178 17.1377 15.7739 16.9032 15.6516C16.66 15.525 16.5665 15.466 16.5406 15.4084C16.4687 15.3322 16.2212 15.0976 15.9579 15.2444C15.7924 15.3379 15.7708 15.6861 15.7751 15.8012V18.2229C15.7751 18.289 15.7219 18.3423 15.6557 18.3423L15.6586 18.3437ZM15.6731 23.2229C15.6069 23.2229 15.5537 23.1697 15.5537 23.1035V18.4876C15.5537 18.4214 15.6069 18.3682 15.6731 18.3682C15.7393 18.3682 15.7926 18.4214 15.7926 18.4876V23.1035C15.7926 23.1697 15.7393 23.2229 15.6731 23.2229Z",
          stroke: "#071114",
          "stroke-width": "1.2",
          "stroke-miterlimit": "10"
        }
      )
    ]
  }
);

// src/components/icons/furniture/OnlineCart.tsx
init_react_shim();
import { jsx as jsx76, jsxs as jsxs65 } from "react/jsx-runtime";
var OnlineCart = (props) => /* @__PURE__ */ jsxs65(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M10.6772 27.2823C9.16242 27.2823 7.9354 26.0475 7.9354 24.523C7.9354 22.9984 9.16242 21.7637 10.6772 21.7637C12.1922 21.7637 13.4192 22.9984 13.4192 24.523C13.4192 26.0475 12.1922 27.2823 10.6772 27.2823ZM10.6772 22.8674C9.77252 22.8674 9.03209 23.6124 9.03209 24.523C9.03209 25.4335 9.77252 26.1787 10.6772 26.1787C11.5821 26.1787 12.3224 25.4335 12.3224 24.523C12.3224 23.6124 11.5821 22.8674 10.6772 22.8674Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M9.25158 19.0042H16.1611V20.1081H9.25158V19.0042Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx76("path", { d: "M12.8708 23.9711H16.1611V25.075H12.8708V23.9711Z", fill: "#071114" }),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M25.4698 16.8106L24.3935 16.5829L26.0662 8.5188H7.41447V7.41492H27.4165L25.4698 16.8106Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M18.3546 28.6138V13.2579L29 23.9711H22.9677L18.3546 28.6138ZM19.4513 15.9208V25.9509L22.5155 22.8674H26.354L19.4513 15.9208Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M24.5719 29L22.2411 23.6401L23.242 23.1985L25.5726 28.5586L24.5719 29Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M9.17607 22.6259L6.2491 4.10368H3V3H7.18814L10.2591 22.4466L9.17607 22.6259Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M10.6772 27.2823C9.16242 27.2823 7.9354 26.0475 7.9354 24.523C7.9354 22.9984 9.16242 21.7637 10.6772 21.7637C12.1922 21.7637 13.4192 22.9984 13.4192 24.523C13.4192 26.0475 12.1922 27.2823 10.6772 27.2823ZM10.6772 22.8674C9.77252 22.8674 9.03209 23.6124 9.03209 24.523C9.03209 25.4335 9.77252 26.1787 10.6772 26.1787C11.5821 26.1787 12.3224 25.4335 12.3224 24.523C12.3224 23.6124 11.5821 22.8674 10.6772 22.8674Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M9.25158 19.0042H16.1611V20.1081H9.25158V19.0042Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M12.8708 23.9711H16.1611V25.075H12.8708V23.9711Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M25.4698 16.8106L24.3935 16.5829L26.0662 8.5188H7.41447V7.41492H27.4165L25.4698 16.8106Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M18.3546 28.6138V13.2579L29 23.9711H22.9677L18.3546 28.6138ZM19.4513 15.9208V25.9509L22.5155 22.8674H26.354L19.4513 15.9208Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M24.5719 29L22.2411 23.6401L23.242 23.1985L25.5726 28.5586L24.5719 29Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          d: "M9.17607 22.6259L6.2491 4.10368H3V3H7.18814L10.2591 22.4466L9.17607 22.6259Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Plant.tsx
init_react_shim();
import { jsx as jsx77, jsxs as jsxs66 } from "react/jsx-runtime";
var Plant = (props) => /* @__PURE__ */ jsxs66(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx77(
        "path",
        {
          d: "M11.9999 28.7425C12.1111 29.5775 12.6249 30.1837 13.2274 30.1837H20.5749C21.1749 30.1837 21.6911 29.5775 21.8011 28.7425L23.2061 20.45C23.3 20.0435 23.252 19.6171 23.0701 19.2417C22.8882 18.8663 22.5833 18.5644 22.2061 18.3862C22.1307 18.3663 22.0529 18.3562 21.9749 18.3562H11.8174C11.1274 18.3562 10.5674 19.1475 10.5674 20.1237C10.5674 20.2328 10.5749 20.3418 10.5899 20.45L11.9999 28.7425Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx77(
        "path",
        {
          d: "M15.5287 17.9762C14.6004 13.7593 12.5052 9.88824 9.48242 6.80493",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx77(
        "path",
        {
          d: "M14.2851 5.50001C17.2463 8.84376 17.1713 11.9463 15.2201 13.6738C13.2688 15.4013 10.1801 15.1 7.22005 11.7563C4.26005 8.41251 3.44005 4.30626 5.3913 2.57876C7.34255 0.851261 11.3251 2.16126 14.2851 5.50001Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx77(
        "path",
        {
          d: "M19.564 18.3562C20.2027 16.3224 20.0715 14.5237 22.1427 11.3462",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx77(
        "path",
        {
          d: "M20.7676 7.915C18.5001 10.6162 18.6251 13.0612 20.2064 14.3825C21.7876 15.7037 24.2064 15.3987 26.4751 12.6975C28.7439 9.99625 29.2951 6.73625 27.7251 5.41625C26.1551 4.09625 23.0301 5.215 20.7676 7.915Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Receipt.tsx
init_react_shim();
import { jsx as jsx78, jsxs as jsxs67 } from "react/jsx-runtime";
var Receipt = (props) => /* @__PURE__ */ jsxs67(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx78(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 5.5C9.8674 5.5 9.74023 5.55267 9.64645 5.64644C9.64645 5.64644 9.64646 5.64643 9.64645 5.64644M9.64645 5.64644C9.55269 5.74021 9.5 5.8674 9.5 6V26.912L12.1747 24.6203C12.3526 24.4679 12.6125 24.4594 12.7999 24.6L16.4999 27.374L20.2001 24.6C20.3875 24.4594 20.6474 24.4679 20.8253 24.6203L23.5 26.912V6C23.5 5.86744 23.4473 5.74023 23.3535 5.64641C23.2598 5.5527 23.1326 5.5 23 5.5H10M8.93934 4.93934C9.22065 4.65804 9.60217 4.5 10 4.5H23C23.3978 4.5 23.7794 4.65802 24.0607 4.93937C24.3419 5.22063 24.5 5.60212 24.5 6V26.912C24.5 27.1031 24.4452 27.2903 24.3421 27.4513C24.2392 27.6119 24.0923 27.7402 23.9185 27.8203C23.7445 27.9005 23.5516 27.9287 23.3627 27.9026C23.1738 27.8762 22.9953 27.7963 22.85 27.672L20.4791 25.6406L17.1001 28.174C16.927 28.3038 16.7164 28.374 16.5 28.374C16.2836 28.374 16.073 28.3038 15.8999 28.174L12.5209 25.6406L10.1503 27.6717C10.0051 27.7959 9.82694 27.8762 9.63782 27.9025C9.44885 27.9287 9.25547 27.9004 9.0816 27.8203C8.90782 27.7403 8.76083 27.6121 8.65784 27.4512C8.65778 27.4511 8.6579 27.4513 8.65784 27.4512C8.55467 27.2902 8.49999 27.103 8.5 26.912V6C8.5 5.60217 8.65805 5.22064 8.93934 4.93934ZM21 10.25C21.1381 10.25 21.25 10.138 21.25 10C21.25 9.86197 21.1381 9.75 21 9.75C20.8619 9.75 20.75 9.86197 20.75 10C20.75 10.138 20.8619 10.25 21 10.25ZM20.25 10C20.25 9.58583 20.5857 9.25 21 9.25C21.4143 9.25 21.75 9.58583 21.75 10C21.75 10.4142 21.4143 10.75 21 10.75C20.5857 10.75 20.25 10.4142 20.25 10ZM11 10C11 9.72386 11.2239 9.5 11.5 9.5H15.5C15.7761 9.5 16 9.72386 16 10C16 10.2761 15.7761 10.5 15.5 10.5H11.5C11.2239 10.5 11 10.2761 11 10ZM21 13.25C21.1381 13.25 21.25 13.138 21.25 13C21.25 12.862 21.1381 12.75 21 12.75C20.8619 12.75 20.75 12.862 20.75 13C20.75 13.138 20.8619 13.25 21 13.25ZM20.25 13C20.25 12.5858 20.5857 12.25 21 12.25C21.4143 12.25 21.75 12.5858 21.75 13C21.75 13.4142 21.4143 13.75 21 13.75C20.5857 13.75 20.25 13.4142 20.25 13ZM11 13C11 12.7239 11.2239 12.5 11.5 12.5H17C17.2761 12.5 17.5 12.7239 17.5 13C17.5 13.2761 17.2761 13.5 17 13.5H11.5C11.2239 13.5 11 13.2761 11 13ZM21 16.25C21.138 16.25 21.25 16.138 21.25 16C21.25 15.862 21.138 15.75 21 15.75C20.862 15.75 20.75 15.862 20.75 16C20.75 16.138 20.862 16.25 21 16.25ZM20.25 16C20.25 15.5858 20.5858 15.25 21 15.25C21.4142 15.25 21.75 15.5858 21.75 16C21.75 16.4142 21.4142 16.75 21 16.75C20.5858 16.75 20.25 16.4142 20.25 16ZM11 16C11 15.7239 11.2239 15.5 11.5 15.5H17.5C17.7761 15.5 18 15.7239 18 16C18 16.2761 17.7761 16.5 17.5 16.5H11.5C11.2239 16.5 11 16.2761 11 16ZM21 19.25C21.138 19.25 21.25 19.138 21.25 19C21.25 18.862 21.138 18.75 21 18.75C20.862 18.75 20.75 18.862 20.75 19C20.75 19.138 20.862 19.25 21 19.25ZM20.25 19C20.25 18.5858 20.5858 18.25 21 18.25C21.4142 18.25 21.75 18.5858 21.75 19C21.75 19.4142 21.4142 19.75 21 19.75C20.5858 19.75 20.25 19.4142 20.25 19ZM11 19C11 18.7239 11.2239 18.5 11.5 18.5H16C16.2761 18.5 16.5 18.7239 16.5 19C16.5 19.2761 16.2761 19.5 16 19.5H11.5C11.2239 19.5 11 19.2761 11 19Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx78(
        "path",
        {
          d: "M9.64645 5.64644C9.74023 5.55267 9.8674 5.5 10 5.5M9.64645 5.64644C9.64646 5.64643 9.64645 5.64644 9.64645 5.64644ZM9.64645 5.64644L10 5.5M9.64645 5.64644C9.55269 5.74021 9.5 5.8674 9.5 6V26.912L12.1747 24.6203C12.3526 24.4679 12.6125 24.4594 12.7999 24.6L16.4999 27.374L20.2001 24.6C20.3875 24.4594 20.6474 24.4679 20.8253 24.6203L23.5 26.912V6C23.5 5.86744 23.4473 5.74023 23.3535 5.64641C23.2598 5.5527 23.1326 5.5 23 5.5H10M8.65784 27.4512C8.76083 27.6121 8.90782 27.7403 9.0816 27.8203C9.25547 27.9004 9.44885 27.9287 9.63782 27.9025C9.82694 27.8762 10.0051 27.7959 10.1503 27.6717L12.5209 25.6406L15.8999 28.174C16.073 28.3038 16.2836 28.374 16.5 28.374C16.7164 28.374 16.927 28.3038 17.1001 28.174L20.4791 25.6406L22.85 27.672C22.9953 27.7963 23.1738 27.8762 23.3627 27.9026C23.5516 27.9287 23.7445 27.9005 23.9185 27.8203C24.0923 27.7402 24.2392 27.6119 24.3421 27.4513C24.4452 27.2903 24.5 27.1031 24.5 26.912V6C24.5 5.60212 24.3419 5.22063 24.0607 4.93937C23.7794 4.65802 23.3978 4.5 23 4.5H10C9.60217 4.5 9.22065 4.65804 8.93934 4.93934C8.65805 5.22064 8.5 5.60217 8.5 6V26.912M8.65784 27.4512L9.07892 27.1816M8.65784 27.4512C8.6579 27.4513 8.65778 27.4511 8.65784 27.4512ZM8.65784 27.4512C8.55467 27.2902 8.49999 27.103 8.5 26.912M8.5 26.912H9M21.25 10C21.25 10.138 21.1381 10.25 21 10.25C20.8619 10.25 20.75 10.138 20.75 10C20.75 9.86197 20.8619 9.75 21 9.75C21.1381 9.75 21.25 9.86197 21.25 10ZM21 9.25C20.5857 9.25 20.25 9.58583 20.25 10C20.25 10.4142 20.5857 10.75 21 10.75C21.4143 10.75 21.75 10.4142 21.75 10C21.75 9.58583 21.4143 9.25 21 9.25ZM11.5 9.5C11.2239 9.5 11 9.72386 11 10C11 10.2761 11.2239 10.5 11.5 10.5H15.5C15.7761 10.5 16 10.2761 16 10C16 9.72386 15.7761 9.5 15.5 9.5H11.5ZM21.25 13C21.25 13.138 21.1381 13.25 21 13.25C20.8619 13.25 20.75 13.138 20.75 13C20.75 12.862 20.8619 12.75 21 12.75C21.1381 12.75 21.25 12.862 21.25 13ZM21 12.25C20.5857 12.25 20.25 12.5858 20.25 13C20.25 13.4142 20.5857 13.75 21 13.75C21.4143 13.75 21.75 13.4142 21.75 13C21.75 12.5858 21.4143 12.25 21 12.25ZM11.5 12.5C11.2239 12.5 11 12.7239 11 13C11 13.2761 11.2239 13.5 11.5 13.5H17C17.2761 13.5 17.5 13.2761 17.5 13C17.5 12.7239 17.2761 12.5 17 12.5H11.5ZM21.25 16C21.25 16.138 21.138 16.25 21 16.25C20.862 16.25 20.75 16.138 20.75 16C20.75 15.862 20.862 15.75 21 15.75C21.138 15.75 21.25 15.862 21.25 16ZM21 15.25C20.5858 15.25 20.25 15.5858 20.25 16C20.25 16.4142 20.5858 16.75 21 16.75C21.4142 16.75 21.75 16.4142 21.75 16C21.75 15.5858 21.4142 15.25 21 15.25ZM11.5 15.5C11.2239 15.5 11 15.7239 11 16C11 16.2761 11.2239 16.5 11.5 16.5H17.5C17.7761 16.5 18 16.2761 18 16C18 15.7239 17.7761 15.5 17.5 15.5H11.5ZM21.25 19C21.25 19.138 21.138 19.25 21 19.25C20.862 19.25 20.75 19.138 20.75 19C20.75 18.862 20.862 18.75 21 18.75C21.138 18.75 21.25 18.862 21.25 19ZM21 18.25C20.5858 18.25 20.25 18.5858 20.25 19C20.25 19.4142 20.5858 19.75 21 19.75C21.4142 19.75 21.75 19.4142 21.75 19C21.75 18.5858 21.4142 18.25 21 18.25ZM11.5 18.5C11.2239 18.5 11 18.7239 11 19C11 19.2761 11.2239 19.5 11.5 19.5H16C16.2761 19.5 16.5 19.2761 16.5 19C16.5 18.7239 16.2761 18.5 16 18.5H11.5Z",
          stroke: "#071114",
          "stroke-width": "0.5"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Room.tsx
init_react_shim();
import { jsx as jsx79, jsxs as jsxs68 } from "react/jsx-runtime";
var Room = (props) => /* @__PURE__ */ jsxs68(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx79(
        "path",
        {
          d: "M31.2915 24.4417L16.2707 19.5375C16.2321 19.5247 16.1911 19.5247 16.1525 19.5375L1.13109 24.4417C1.05268 24.4675 1 24.541 1 24.6231C1 24.7064 1.05391 24.7793 1.13231 24.8044L5.8448 26.3168C5.85888 26.3235 5.87359 26.3284 5.8889 26.3303L16.1531 29.6241C16.1715 29.6308 16.1917 29.6339 16.2107 29.6339C16.2303 29.6339 16.2499 29.6308 16.2689 29.6241L31.2896 24.8044C31.368 24.7793 31.4213 24.7064 31.4219 24.6231C31.4219 24.5404 31.3693 24.4675 31.2915 24.4417ZM20.7026 21.3856L25.3349 22.8981L21.2104 24.2972L16.6254 22.759L20.6775 21.4003C20.6867 21.3973 20.6934 21.3899 20.7026 21.3856ZM20.6144 24.4981L16.1096 26.0258L11.4816 24.4828L16.0263 22.9593L20.6144 24.4981ZM16.2107 19.9191L20.1048 21.1908L16.0257 22.5587L12.1279 21.2515L16.2107 19.9191ZM11.5245 21.4493C11.527 21.4506 11.5294 21.4524 11.5319 21.453L15.4272 22.759L10.8813 24.2831L6.90392 22.9575L11.5245 21.4493ZM1.80798 24.6212L6.30483 23.1535C6.31341 23.1578 6.31892 23.1639 6.3275 23.1664L10.2816 24.4846L5.92933 25.9437L1.80798 24.6212ZM6.54006 26.1404L10.8819 24.6849L15.5136 26.2292L11.2844 27.6638L6.54006 26.1404ZM16.2107 29.243L11.8927 27.8574L16.1102 26.4271L20.4625 27.8788L16.2107 29.243ZM21.0432 27.6932C21.023 27.673 21.0003 27.6559 20.9715 27.6473L16.7075 26.2255L21.2111 24.6978L25.6926 26.201L21.0432 27.6932ZM26.3045 26.005L21.8046 24.4956L25.8813 23.1131C25.896 23.1082 25.9088 23.0984 25.9211 23.0892L30.6133 24.6206L26.3045 26.005Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx79(
        "path",
        {
          d: "M26.4347 7.11579C26.0858 6.74799 25.5929 6.53706 25.0824 6.53706C24.8833 6.53706 24.6865 6.56899 24.4996 6.63016L24.7243 5.38784C24.8769 4.54623 24.6453 3.68747 24.0889 3.03187C23.5325 2.37609 22.7161 2 21.8492 2H9.33976C8.45353 2 7.62571 2.38992 7.0685 3.06978C6.51124 3.74967 6.29813 4.62999 6.48373 5.485L6.72011 6.57358C6.5996 6.54949 6.47617 6.53697 6.35119 6.53697C5.84059 6.53697 5.34768 6.7479 4.99876 7.11571C4.64979 7.4836 4.4691 7.98293 4.50297 8.4858L4.74987 12.1399C4.76004 13.6381 5.97233 14.8591 7.48097 14.9105L7.09591 16.4299C7.01768 16.7386 7.08667 17.0595 7.28519 17.3103C7.48371 17.5611 7.78253 17.705 8.10509 17.705C8.58328 17.705 8.99827 17.3853 9.11427 16.9277L9.62487 14.913H21.8087L22.3193 16.9277C22.4353 17.3853 22.8503 17.705 23.3285 17.705C23.651 17.705 23.9499 17.5611 24.1484 17.3103C24.3469 17.0595 24.4159 16.7386 24.3376 16.4299L23.9526 14.9106C24.6712 14.8864 25.3436 14.5996 25.8554 14.0952C26.3854 13.5718 26.6789 12.8779 26.6837 12.1394L26.9306 8.48567C26.9644 7.98302 26.7837 7.48368 26.4347 7.11579ZM7.61868 3.50869C8.04092 2.99352 8.66819 2.69805 9.33972 2.69805H21.8492C22.5061 2.69805 23.1247 2.98305 23.5464 3.47994C23.9679 3.9767 24.1434 4.62737 24.0278 5.26513L23.6837 7.16666C23.4734 7.40485 23.3298 7.69273 23.2659 8.00596L22.6339 11.1233C22.5578 11.4992 22.2203 11.7721 21.8317 11.7721H9.60178C9.21315 11.7721 8.87577 11.4992 8.79953 11.1232L8.16753 8.0057C8.08351 7.59288 7.85607 7.21892 7.52572 6.9515L7.17556 5.33885C7.03489 4.69102 7.19639 4.02395 7.61868 3.50869ZM8.42779 16.7586C8.39073 16.9049 8.25797 17.0071 8.10505 17.0071C8.00187 17.0071 7.90635 16.9612 7.84285 16.8809C7.77934 16.8008 7.75727 16.6981 7.7823 16.5994L8.20963 14.9131H8.89545L8.42779 16.7586ZM23.5906 16.8809C23.5271 16.9611 23.4316 17.0071 23.3284 17.0071C23.1755 17.0071 23.0427 16.9049 23.0056 16.7585L22.538 14.9131H23.2238L23.6512 16.5993C23.6762 16.6981 23.6541 16.8007 23.5906 16.8809ZM25.355 13.6018C24.9537 13.9973 24.4205 14.2151 23.8538 14.2151H7.57967C6.40922 14.2151 5.45696 13.2758 5.45696 12.1211C5.45696 12.1173 5.45651 12.1135 5.45638 12.1097C5.45625 12.1057 5.45647 12.1019 5.4562 12.0979L5.20899 8.43955C5.18777 8.12419 5.29656 7.82344 5.51542 7.59275C5.73419 7.3621 6.03102 7.23511 6.35115 7.23511C6.58598 7.23511 6.81209 7.30517 7.00517 7.43779L7.00619 7.4384L7.00738 7.43927C7.02794 7.45314 7.05045 7.46998 7.07699 7.49119C7.28081 7.65578 7.42175 7.88735 7.4738 8.14286L8.10575 11.2601C8.24789 11.9612 8.87705 12.4701 9.60183 12.4701H21.8317C22.5566 12.4701 23.1857 11.9612 23.3278 11.2601L23.9597 8.14325C24.0039 7.92657 24.1097 7.7296 24.2658 7.57355C24.2692 7.57006 24.2726 7.56653 24.276 7.56291C24.301 7.53821 24.3275 7.51461 24.3568 7.49097C24.5608 7.32593 24.8185 7.23502 25.0824 7.23502C25.4025 7.23502 25.6993 7.36201 25.9181 7.59266C26.1369 7.82339 26.2458 8.12414 26.2245 8.43942L25.9773 12.0978C25.9771 12.1018 25.9773 12.1057 25.9771 12.1097C25.977 12.1135 25.9766 12.1172 25.9766 12.1211C25.9766 12.6802 25.7557 13.2061 25.355 13.6018Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx79(
        "path",
        {
          d: "M31.2915 24.4417L16.2707 19.5375C16.2321 19.5247 16.1911 19.5247 16.1525 19.5375L1.13109 24.4417C1.05268 24.4675 1 24.541 1 24.6231C1 24.7064 1.05391 24.7793 1.13231 24.8044L5.8448 26.3168C5.85888 26.3235 5.87359 26.3284 5.8889 26.3303L16.1531 29.6241C16.1715 29.6308 16.1917 29.6339 16.2107 29.6339C16.2303 29.6339 16.2499 29.6308 16.2689 29.6241L31.2896 24.8044C31.368 24.7793 31.4213 24.7064 31.4219 24.6231C31.4219 24.5404 31.3693 24.4675 31.2915 24.4417ZM20.7026 21.3856L25.3349 22.8981L21.2104 24.2972L16.6254 22.759L20.6775 21.4003C20.6867 21.3973 20.6934 21.3899 20.7026 21.3856ZM20.6144 24.4981L16.1096 26.0258L11.4816 24.4828L16.0263 22.9593L20.6144 24.4981ZM16.2107 19.9191L20.1048 21.1908L16.0257 22.5587L12.1279 21.2515L16.2107 19.9191ZM11.5245 21.4493C11.527 21.4506 11.5294 21.4524 11.5319 21.453L15.4272 22.759L10.8813 24.2831L6.90392 22.9575L11.5245 21.4493ZM1.80798 24.6212L6.30483 23.1535C6.31341 23.1578 6.31892 23.1639 6.3275 23.1664L10.2816 24.4846L5.92933 25.9437L1.80798 24.6212ZM6.54006 26.1404L10.8819 24.6849L15.5136 26.2292L11.2844 27.6638L6.54006 26.1404ZM16.2107 29.243L11.8927 27.8574L16.1102 26.4271L20.4625 27.8788L16.2107 29.243ZM21.0432 27.6932C21.023 27.673 21.0003 27.6559 20.9715 27.6473L16.7075 26.2255L21.2111 24.6978L25.6926 26.201L21.0432 27.6932ZM26.3045 26.005L21.8046 24.4956L25.8813 23.1131C25.896 23.1082 25.9088 23.0984 25.9211 23.0892L30.6133 24.6206L26.3045 26.005Z",
          stroke: "#071114",
          "stroke-width": "0.6"
        }
      ),
      /* @__PURE__ */ jsx79(
        "path",
        {
          d: "M26.4347 7.11579C26.0858 6.74799 25.5929 6.53706 25.0824 6.53706C24.8833 6.53706 24.6865 6.56899 24.4996 6.63016L24.7243 5.38784C24.8769 4.54623 24.6453 3.68747 24.0889 3.03187C23.5325 2.37609 22.7161 2 21.8492 2H9.33976C8.45353 2 7.62571 2.38992 7.0685 3.06978C6.51124 3.74967 6.29813 4.62999 6.48373 5.485L6.72011 6.57358C6.5996 6.54949 6.47617 6.53697 6.35119 6.53697C5.84059 6.53697 5.34768 6.7479 4.99876 7.11571C4.64979 7.4836 4.4691 7.98293 4.50297 8.4858L4.74987 12.1399C4.76004 13.6381 5.97233 14.8591 7.48097 14.9105L7.09591 16.4299C7.01768 16.7386 7.08667 17.0595 7.28519 17.3103C7.48371 17.5611 7.78253 17.705 8.10509 17.705C8.58328 17.705 8.99827 17.3853 9.11427 16.9277L9.62487 14.913H21.8087L22.3193 16.9277C22.4353 17.3853 22.8503 17.705 23.3285 17.705C23.651 17.705 23.9499 17.5611 24.1484 17.3103C24.3469 17.0595 24.4159 16.7386 24.3376 16.4299L23.9526 14.9106C24.6712 14.8864 25.3436 14.5996 25.8554 14.0952C26.3854 13.5718 26.6789 12.8779 26.6837 12.1394L26.9306 8.48567C26.9644 7.98302 26.7837 7.48368 26.4347 7.11579ZM7.61868 3.50869C8.04092 2.99352 8.66819 2.69805 9.33972 2.69805H21.8492C22.5061 2.69805 23.1247 2.98305 23.5464 3.47994C23.9679 3.9767 24.1434 4.62737 24.0278 5.26513L23.6837 7.16666C23.4734 7.40485 23.3298 7.69273 23.2659 8.00596L22.6339 11.1233C22.5578 11.4992 22.2203 11.7721 21.8317 11.7721H9.60178C9.21315 11.7721 8.87577 11.4992 8.79953 11.1232L8.16753 8.0057C8.08351 7.59288 7.85607 7.21892 7.52572 6.9515L7.17556 5.33885C7.03489 4.69102 7.19639 4.02395 7.61868 3.50869ZM8.42779 16.7586C8.39073 16.9049 8.25797 17.0071 8.10505 17.0071C8.00187 17.0071 7.90635 16.9612 7.84285 16.8809C7.77934 16.8008 7.75727 16.6981 7.7823 16.5994L8.20963 14.9131H8.89545L8.42779 16.7586ZM23.5906 16.8809C23.5271 16.9611 23.4316 17.0071 23.3284 17.0071C23.1755 17.0071 23.0427 16.9049 23.0056 16.7585L22.538 14.9131H23.2238L23.6512 16.5993C23.6762 16.6981 23.6541 16.8007 23.5906 16.8809ZM25.355 13.6018C24.9537 13.9973 24.4205 14.2151 23.8538 14.2151H7.57967C6.40922 14.2151 5.45696 13.2758 5.45696 12.1211C5.45696 12.1173 5.45651 12.1135 5.45638 12.1097C5.45625 12.1057 5.45647 12.1019 5.4562 12.0979L5.20899 8.43955C5.18777 8.12419 5.29656 7.82344 5.51542 7.59275C5.73419 7.3621 6.03102 7.23511 6.35115 7.23511C6.58598 7.23511 6.81209 7.30517 7.00517 7.43779L7.00619 7.4384L7.00738 7.43927C7.02794 7.45314 7.05045 7.46998 7.07699 7.49119C7.28081 7.65578 7.42175 7.88735 7.4738 8.14286L8.10575 11.2601C8.24789 11.9612 8.87705 12.4701 9.60183 12.4701H21.8317C22.5566 12.4701 23.1857 11.9612 23.3278 11.2601L23.9597 8.14325C24.0039 7.92657 24.1097 7.7296 24.2658 7.57355C24.2692 7.57006 24.2726 7.56653 24.276 7.56291C24.301 7.53821 24.3275 7.51461 24.3568 7.49097C24.5608 7.32593 24.8185 7.23502 25.0824 7.23502C25.4025 7.23502 25.6993 7.36201 25.9181 7.59266C26.1369 7.82339 26.2458 8.12414 26.2245 8.43942L25.9773 12.0978C25.9771 12.1018 25.9773 12.1057 25.9771 12.1097C25.977 12.1135 25.9766 12.1172 25.9766 12.1211C25.9766 12.6802 25.7557 13.2061 25.355 13.6018Z",
          stroke: "#071114",
          "stroke-width": "0.6"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Rug.tsx
init_react_shim();
import { jsx as jsx80, jsxs as jsxs69 } from "react/jsx-runtime";
var Rug = (props) => /* @__PURE__ */ jsxs69(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx80("g", { "clip-path": "url(#clip0_4454_84564)", children: /* @__PURE__ */ jsx80(
        "path",
        {
          d: "M26.1614 0C25.8162 0 25.5364 0.279813 25.5364 0.625V1.36731H23.8831V0.625C23.8831 0.279813 23.6033 0 23.2581 0C22.9129 0 22.6331 0.279813 22.6331 0.625V1.36731H20.9799V0.625C20.9799 0.279813 20.7001 0 20.3549 0C20.0097 0 19.7299 0.279813 19.7299 0.625V1.36731H18.0767V0.625C18.0767 0.279813 17.7969 0 17.4517 0C17.1065 0 16.8267 0.279813 16.8267 0.625V1.36731H15.1735V0.625C15.1735 0.279813 14.8937 0 14.5485 0C14.2033 0 13.9235 0.279813 13.9235 0.625V1.36731H12.2702V0.625C12.2702 0.279813 11.9904 0 11.6452 0C11.3001 0 11.0202 0.279813 11.0202 0.625V1.36731H9.36705V0.625C9.36705 0.279813 9.08724 0 8.74205 0C8.39687 0 8.11705 0.279813 8.11705 0.625V1.36731H6.46387V0.625C6.46387 0.279813 6.18405 0 5.83887 0C5.49368 0 5.21387 0.279813 5.21387 0.625V31.375C5.21387 31.7202 5.49368 32 5.83887 32C6.18405 32 6.46387 31.7202 6.46387 31.375V30.6327H8.11712V31.375C8.11712 31.7202 8.39693 32 8.74212 32C9.0873 32 9.36712 31.7202 9.36712 31.375V30.6327H11.0203V31.375C11.0203 31.7202 11.3001 32 11.6453 32C11.9905 32 12.2703 31.7202 12.2703 31.375V30.6327H13.9236V31.375C13.9236 31.7202 14.2034 32 14.5486 32C14.8937 32 15.1736 31.7202 15.1736 31.375V30.6327H16.8267V31.375C16.8267 31.7202 17.1066 32 17.4517 32C17.7969 32 18.0767 31.7202 18.0767 31.375V30.6327H19.73V31.375C19.73 31.7202 20.0098 32 20.355 32C20.7002 32 20.98 31.7202 20.98 31.375V30.6327H22.6332V31.375C22.6332 31.7202 22.913 32 23.2582 32C23.6034 32 23.8832 31.7202 23.8832 31.375V30.6327H25.5364V31.375C25.5364 31.7202 25.8162 32 26.1614 32C26.5066 32 26.7864 31.7202 26.7864 31.375V0.625C26.7864 0.279813 26.5066 0 26.1614 0ZM25.5364 7.15306H6.46387V5.51206H25.5364V7.15306ZM6.46387 8.40306H25.5364V23.597H6.46387V8.40306ZM6.46387 24.8469H25.5364V26.4879H6.46387V24.8469ZM25.5364 4.26206H6.46387V2.61731H25.5364V4.26206ZM6.46387 27.7379H25.5364V29.3827H6.46387V27.7379Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.2"
        }
      ) }),
      /* @__PURE__ */ jsx80("defs", { children: /* @__PURE__ */ jsx80("clipPath", { id: "clip0_4454_84564", children: /* @__PURE__ */ jsx80("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/Sale.tsx
init_react_shim();
import { jsx as jsx81, jsxs as jsxs70 } from "react/jsx-runtime";
var Sale = (props) => /* @__PURE__ */ jsxs70(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M26.5888 23.2394C26.816 23.2394 27.0002 23.0552 27.0002 22.828V12.956C27.0002 12.465 26.8088 11.9628 26.4614 11.5419L23.4107 7.8457C23.2509 7.65204 23.0672 7.48882 22.8677 7.35884C22.8799 7.23314 22.8869 7.10617 22.8869 6.978V2.37105C22.8869 2.14388 22.7027 1.95972 22.4755 1.95972C22.2484 1.95972 22.0642 2.14388 22.0642 2.37105C22.0642 2.37105 22.0634 7.01721 22.063 7.03685C21.946 7.01612 21.8272 7.00542 21.7077 7.00542H16.3878C16.0132 7.00542 15.6461 7.1105 15.3174 7.30361C15.3032 7.30871 15.2891 7.31442 15.2753 7.32116L11.2656 9.27429C10.8213 9.49712 10.4661 9.87089 10.2652 10.3267C10.263 10.3317 10.2609 10.3367 10.259 10.3417L8.60111 14.5468C8.5178 14.7581 8.62157 14.997 8.83294 15.0804C8.88246 15.0999 8.93347 15.1091 8.9837 15.1091C9.14769 15.1091 9.30268 15.0103 9.36646 14.8485L11.0211 10.6516C11.1455 10.3736 11.3631 10.1458 11.6301 10.0118L13.7487 8.97988L11.6341 11.5419C11.3175 11.9255 11.1501 12.4146 11.1501 12.9561V27.1609C11.1501 27.3263 11.1647 27.4882 11.191 27.6461L6.95253 25.768C5.99506 25.3438 5.56113 24.2169 5.9854 23.256C5.98721 23.2518 5.98897 23.2476 5.99072 23.2434L8.67169 16.5807C8.75648 16.3699 8.65442 16.1304 8.44365 16.0455C8.23277 15.9607 7.99332 16.0628 7.90848 16.2736L5.22986 22.9301C4.62756 24.304 5.24972 25.9132 6.61924 26.52L11.5895 28.7224C11.5956 28.725 11.6018 28.727 11.6079 28.7294C12.1124 29.5176 12.9845 30.0401 13.9746 30.0401H24.1209C25.6816 30.0401 27.0002 28.7215 27.0002 27.1608V24.7476C27.0002 24.5204 26.816 24.3363 26.5889 24.3363C26.3617 24.3363 26.1775 24.5204 26.1775 24.7476V27.1608C26.1775 28.2756 25.2357 29.2174 24.1209 29.2174H13.9746C12.8708 29.2174 11.9728 28.2948 11.9728 27.1608V12.956C11.9728 12.6029 12.0723 12.3033 12.2686 12.0655L15.3192 8.36935C15.6031 8.02537 15.9926 7.82804 16.3878 7.82804H21.7077C21.7852 7.82804 21.8624 7.83588 21.9387 7.85069C21.6812 8.7288 21.0434 9.46153 20.182 9.82871C19.9568 9.45198 19.545 9.19915 19.0751 9.19915C18.3644 9.19915 17.7863 9.77732 17.7863 10.488C17.7863 11.1987 18.3644 11.7768 19.0751 11.7768C19.7323 11.7768 20.2758 11.2823 20.354 10.6458C21.4618 10.2268 22.2995 9.33895 22.6727 8.25527C22.7085 8.29131 22.7432 8.32921 22.7763 8.36935L25.8269 12.0656C26.053 12.3395 26.1775 12.6557 26.1775 12.9561V22.8281C26.1775 23.0552 26.3617 23.2394 26.5888 23.2394ZM19.0751 10.9542C18.8181 10.9542 18.6089 10.7451 18.6089 10.488C18.6089 10.2309 18.8181 10.0218 19.0751 10.0218C19.3322 10.0218 19.5413 10.2309 19.5413 10.488C19.5413 10.7451 19.3322 10.9542 19.0751 10.9542Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M15.51 23.8427C15.6153 23.8427 15.7206 23.8026 15.8009 23.7222L22.821 16.7021C22.9816 16.5415 22.9816 16.281 22.821 16.1204C22.6604 15.9598 22.3999 15.9598 22.2393 16.1204L15.2192 23.1405C14.9569 23.385 15.1582 23.8552 15.51 23.8427Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M16.3875 19.51C17.3704 19.51 18.17 18.7104 18.17 17.7275C18.17 16.7447 17.3704 15.9451 16.3875 15.9451H16.3327C15.3499 15.9451 14.5502 16.7447 14.5502 17.7275C14.5502 18.7104 15.3499 19.51 16.3327 19.51H16.3875ZM15.3729 17.7275C15.3729 17.1983 15.8035 16.7678 16.3327 16.7678H16.3875C16.9167 16.7678 17.3473 17.1983 17.3473 17.7275C17.3473 18.2567 16.9167 18.6873 16.3875 18.6873H16.3327C15.8035 18.6873 15.3729 18.2567 15.3729 17.7275Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M21.7075 23.8427H21.7623C22.7451 23.8427 23.5448 23.0431 23.5448 22.0603C23.5448 21.0775 22.7451 20.2778 21.7623 20.2778H21.7075C20.7247 20.2778 19.925 21.0775 19.925 22.0603C19.925 23.0431 20.7247 23.8427 21.7075 23.8427ZM21.7075 21.1005H21.7623C22.2915 21.1005 22.7221 21.5311 22.7221 22.0603C22.7221 22.5895 22.2915 23.02 21.7623 23.02H21.7075C21.1783 23.02 20.7477 22.5895 20.7477 22.0603C20.7477 21.5311 21.1783 21.1005 21.7075 21.1005Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M26.5888 23.2394C26.816 23.2394 27.0002 23.0552 27.0002 22.828V12.956C27.0002 12.465 26.8088 11.9628 26.4614 11.5419L23.4107 7.8457C23.2509 7.65204 23.0672 7.48882 22.8677 7.35884C22.8799 7.23314 22.8869 7.10617 22.8869 6.978V2.37105C22.8869 2.14388 22.7027 1.95972 22.4755 1.95972C22.2484 1.95972 22.0642 2.14388 22.0642 2.37105C22.0642 2.37105 22.0634 7.01721 22.063 7.03685C21.946 7.01612 21.8272 7.00542 21.7077 7.00542H16.3878C16.0132 7.00542 15.6461 7.1105 15.3174 7.30361C15.3032 7.30871 15.2891 7.31442 15.2753 7.32116L11.2656 9.27429C10.8213 9.49712 10.4661 9.87089 10.2652 10.3267C10.263 10.3317 10.2609 10.3367 10.259 10.3417L8.60111 14.5468C8.5178 14.7581 8.62157 14.997 8.83294 15.0804C8.88246 15.0999 8.93347 15.1091 8.9837 15.1091C9.14769 15.1091 9.30268 15.0103 9.36646 14.8485L11.0211 10.6516C11.1455 10.3736 11.3631 10.1458 11.6301 10.0118L13.7487 8.97988L11.6341 11.5419C11.3175 11.9255 11.1501 12.4146 11.1501 12.9561V27.1609C11.1501 27.3263 11.1647 27.4882 11.191 27.6461L6.95253 25.768C5.99506 25.3438 5.56113 24.2169 5.9854 23.256C5.98721 23.2518 5.98897 23.2476 5.99072 23.2434L8.67169 16.5807C8.75648 16.3699 8.65442 16.1304 8.44365 16.0455C8.23277 15.9607 7.99332 16.0628 7.90848 16.2736L5.22986 22.9301C4.62756 24.304 5.24972 25.9132 6.61924 26.52L11.5895 28.7224C11.5956 28.725 11.6018 28.727 11.6079 28.7294C12.1124 29.5176 12.9845 30.0401 13.9746 30.0401H24.1209C25.6816 30.0401 27.0002 28.7215 27.0002 27.1608V24.7476C27.0002 24.5204 26.816 24.3363 26.5889 24.3363C26.3617 24.3363 26.1775 24.5204 26.1775 24.7476V27.1608C26.1775 28.2756 25.2357 29.2174 24.1209 29.2174H13.9746C12.8708 29.2174 11.9728 28.2948 11.9728 27.1608V12.956C11.9728 12.6029 12.0723 12.3033 12.2686 12.0655L15.3192 8.36935C15.6031 8.02537 15.9926 7.82804 16.3878 7.82804H21.7077C21.7852 7.82804 21.8624 7.83588 21.9387 7.85069C21.6812 8.7288 21.0434 9.46153 20.182 9.82871C19.9568 9.45198 19.545 9.19915 19.0751 9.19915C18.3644 9.19915 17.7863 9.77732 17.7863 10.488C17.7863 11.1987 18.3644 11.7768 19.0751 11.7768C19.7323 11.7768 20.2758 11.2823 20.354 10.6458C21.4618 10.2268 22.2995 9.33895 22.6727 8.25527C22.7085 8.29131 22.7432 8.32921 22.7763 8.36935L25.8269 12.0656C26.053 12.3395 26.1775 12.6557 26.1775 12.9561V22.8281C26.1775 23.0552 26.3617 23.2394 26.5888 23.2394ZM19.0751 10.9542C18.8181 10.9542 18.6089 10.7451 18.6089 10.488C18.6089 10.2309 18.8181 10.0218 19.0751 10.0218C19.3322 10.0218 19.5413 10.2309 19.5413 10.488C19.5413 10.7451 19.3322 10.9542 19.0751 10.9542Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M15.51 23.8427C15.6153 23.8427 15.7206 23.8026 15.8009 23.7222L22.821 16.7021C22.9816 16.5415 22.9816 16.281 22.821 16.1204C22.6604 15.9598 22.3999 15.9598 22.2393 16.1204L15.2192 23.1405C14.9569 23.385 15.1582 23.8552 15.51 23.8427Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M16.3875 19.51C17.3704 19.51 18.17 18.7104 18.17 17.7275C18.17 16.7447 17.3704 15.9451 16.3875 15.9451H16.3327C15.3499 15.9451 14.5502 16.7447 14.5502 17.7275C14.5502 18.7104 15.3499 19.51 16.3327 19.51H16.3875ZM15.3729 17.7275C15.3729 17.1983 15.8035 16.7678 16.3327 16.7678H16.3875C16.9167 16.7678 17.3473 17.1983 17.3473 17.7275C17.3473 18.2567 16.9167 18.6873 16.3875 18.6873H16.3327C15.8035 18.6873 15.3729 18.2567 15.3729 17.7275Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          d: "M21.7075 23.8427H21.7623C22.7451 23.8427 23.5448 23.0431 23.5448 22.0603C23.5448 21.0775 22.7451 20.2778 21.7623 20.2778H21.7075C20.7247 20.2778 19.925 21.0775 19.925 22.0603C19.925 23.0431 20.7247 23.8427 21.7075 23.8427ZM21.7075 21.1005H21.7623C22.2915 21.1005 22.7221 21.5311 22.7221 22.0603C22.7221 22.5895 22.2915 23.02 21.7623 23.02H21.7075C21.1783 23.02 20.7477 22.5895 20.7477 22.0603C20.7477 21.5311 21.1783 21.1005 21.7075 21.1005Z",
          stroke: "#071114",
          "stroke-width": "0.4"
        }
      )
    ]
  }
);

// src/components/icons/furniture/Seng.tsx
init_react_shim();
import { jsx as jsx82, jsxs as jsxs71 } from "react/jsx-runtime";
var Seng = (props) => /* @__PURE__ */ jsxs71(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx82("g", { "clip-path": "url(#clip0_4454_84566)", children: /* @__PURE__ */ jsx82(
        "path",
        {
          d: "M31.9932 17.3629C31.9932 17.2795 31.9723 17.203 31.9444 17.1264C31.9375 17.1125 31.9306 17.0986 31.9236 17.0917C31.9027 17.0499 31.8818 17.0082 31.854 16.9735L27.1315 10.7348V4.7813C27.1385 2.49312 25.3997 0.69873 23.1811 0.69873H9.15982C6.83682 0.69873 4.87551 2.56961 4.87551 4.7813V11.1313L0.160009 16.9526C0.118279 17.0013 0.0904369 17.0569 0.0626603 17.1125L0.0556836 17.1195C0.0278418 17.196 0.00697675 17.2795 0.00697675 17.356C0.00697675 17.363 0 17.3769 0 17.3839V30.5775C0 30.9253 0.250381 31.2382 0.591198 31.287C1.02936 31.3565 1.39796 31.0227 1.39796 30.6054V25.7369H30.609V30.5845C30.609 30.9322 30.8594 31.2452 31.2002 31.2939C31.6314 31.3565 32.0001 31.0227 32.0001 30.6054V17.3907C32.0001 17.3838 31.9932 17.3768 31.9932 17.3629ZM6.26655 4.7813C6.26655 3.34859 7.61581 2.08971 9.15982 2.08971H23.1672C24.6069 2.08971 25.7406 3.27204 25.7406 4.7813V10.4357H6.26655V4.7813ZM6.09963 11.8267H26.2135L29.9066 16.6952H2.16305L6.09963 11.8267ZM30.6091 24.3457H1.39802V18.0862H30.6091V24.3457Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.2"
        }
      ) }),
      /* @__PURE__ */ jsx82("defs", { children: /* @__PURE__ */ jsx82("clipPath", { id: "clip0_4454_84566", children: /* @__PURE__ */ jsx82("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/Sofa.tsx
init_react_shim();
import { jsx as jsx83 } from "react/jsx-runtime";
var Sofa = (props) => /* @__PURE__ */ jsx83(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx83(
      "path",
      {
        d: "M29.1555 11.0221C28.6577 11.0221 28.1671 11.1643 27.7333 11.4203V11.0221C27.7333 8.66122 26.5387 7.46655 24.1778 7.46655H7.8222C5.46133 7.46655 4.26667 8.66122 4.26667 11.0221V11.4203C3.83287 11.1643 3.3422 11.0292 2.84447 11.0221C1.27287 11.0221 0 12.295 0 13.8666V19.5554C0 21.127 1.27287 22.3999 2.84447 22.3999H4.26667V23.8221C4.26667 24.2132 4.58667 24.5332 4.9778 24.5332C5.36893 24.5332 5.68893 24.2132 5.68893 23.8221V22.3999H26.3111V23.8221C26.3111 24.2132 26.6311 24.5332 27.0223 24.5332C27.4133 24.5332 27.7333 24.2132 27.7333 23.8221V22.3999H29.1485C30.72 22.3999 32 21.127 32 19.5554V13.8666C32 12.295 30.7271 11.0221 29.1555 11.0221ZM5.68887 11.0221C5.68887 9.45055 6.24353 8.88875 7.8222 8.88875H24.1777C25.7493 8.88875 26.3111 9.45055 26.3111 11.0221V15.9999H5.68887V11.0221ZM30.5778 19.5554C30.5778 20.3448 29.9307 20.9776 29.1485 20.9776H2.84447C2.06227 20.9776 1.42227 20.3376 1.42227 19.5554V13.8666C1.42227 13.0844 2.06227 12.4444 2.84447 12.4444C3.62667 12.4444 4.26667 13.0844 4.26667 13.8666V17.4221H27.7333V13.8666C27.7333 13.0844 28.3733 12.4444 29.1555 12.4444C29.9377 12.4444 30.5777 13.0844 30.5777 13.8666L30.5778 19.5554Z",
        fill: "#071114"
      }
    )
  }
);

// src/components/icons/furniture/Storage.tsx
init_react_shim();
import { jsx as jsx84, jsxs as jsxs72 } from "react/jsx-runtime";
var Storage = (props) => /* @__PURE__ */ jsxs72(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx84("path", { d: "M17 29H3V3H17V29ZM4 28H16V4H4V28Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84("path", { d: "M29 29H16V23H29V29ZM17 28H28V24H17V28Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84("path", { d: "M29 24H16V19H29V24ZM17 23H28V20H17V23Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84("path", { d: "M22 23H23V29H22V23Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84("path", { d: "M21.5 21H23.5V22H21.5V21Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84("path", { d: "M16 4.5H29V5.5H16V4.5Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M26.375 14H20.625C20.2294 13.9988 19.8477 13.8533 19.5517 13.5908C19.2557 13.3282 19.0657 12.9667 19.0172 12.5741C18.9687 12.1814 19.0652 11.7846 19.2885 11.4579C19.5118 11.1313 19.8465 10.8974 20.23 10.8L23.5 10L26.77 10.815C27.1535 10.9124 27.4882 11.1463 27.7115 11.4729C27.9348 11.7996 28.0313 12.1964 27.9828 12.5891C27.9343 12.9817 27.7443 13.3432 27.4483 13.6058C27.1523 13.8683 26.7706 14.0138 26.375 14.015V14ZM23.5 11L20.47 11.755C20.3049 11.7756 20.1547 11.8609 20.0525 11.9921C19.9503 12.1234 19.9044 12.2899 19.925 12.455C19.9456 12.6201 20.0309 12.7703 20.1621 12.8725C20.2934 12.9747 20.4599 13.0206 20.625 13H26.375C26.5269 12.9996 26.6735 12.9438 26.7872 12.8432C26.901 12.7425 26.9743 12.6039 26.9933 12.4531C27.0123 12.3024 26.9757 12.1499 26.8904 12.0242C26.8052 11.8985 26.6771 11.8081 26.53 11.77L23.5 11Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M24 11H23V9.295L23.795 8.5C23.9261 8.36657 23.9997 8.18707 24 8C24 7.86739 23.9473 7.74021 23.8536 7.64645C23.7598 7.55268 23.6326 7.5 23.5 7.5C23.3674 7.5 23.2402 7.55268 23.1464 7.64645C23.0527 7.74021 23 7.86739 23 8V8.5H22V8C22 7.60218 22.158 7.22064 22.4393 6.93934C22.7206 6.65804 23.1022 6.5 23.5 6.5C23.8978 6.5 24.2794 6.65804 24.5607 6.93934C24.842 7.22064 25 7.60218 25 8C25.0001 8.22388 24.956 8.44558 24.8702 8.65237C24.7844 8.85916 24.6586 9.04696 24.5 9.205L24 9.705V11Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx84("path", { d: "M23 4.5H24V7.5H23V4.5Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84("path", { d: "M14 14.5H15V18H14V14.5Z", fill: "#071114" }),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M17 29H3V3H17V29ZM4 28H16V4H4V28Z",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      ),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M29 29H16V23H29V29ZM17 28H28V24H17V28Z",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      ),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M29 24H16V19H29V24ZM17 23H28V20H17V23Z",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      ),
      /* @__PURE__ */ jsx84("path", { d: "M22 23H23V29H22V23Z", stroke: "#071114", "stroke-width": "0.3" }),
      /* @__PURE__ */ jsx84("path", { d: "M21.5 21H23.5V22H21.5V21Z", stroke: "#071114", "stroke-width": "0.3" }),
      /* @__PURE__ */ jsx84("path", { d: "M16 4.5H29V5.5H16V4.5Z", stroke: "#071114", "stroke-width": "0.3" }),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M26.375 14H20.625C20.2294 13.9988 19.8477 13.8533 19.5517 13.5908C19.2557 13.3282 19.0657 12.9667 19.0172 12.5741C18.9687 12.1814 19.0652 11.7846 19.2885 11.4579C19.5118 11.1313 19.8465 10.8974 20.23 10.8L23.5 10L26.77 10.815C27.1535 10.9124 27.4882 11.1463 27.7115 11.4729C27.9348 11.7996 28.0313 12.1964 27.9828 12.5891C27.9343 12.9817 27.7443 13.3432 27.4483 13.6058C27.1523 13.8683 26.7706 14.0138 26.375 14.015V14ZM23.5 11L20.47 11.755C20.3049 11.7756 20.1547 11.8609 20.0525 11.9921C19.9503 12.1234 19.9044 12.2899 19.925 12.455C19.9456 12.6201 20.0309 12.7703 20.1621 12.8725C20.2934 12.9747 20.4599 13.0206 20.625 13H26.375C26.5269 12.9996 26.6735 12.9438 26.7872 12.8432C26.901 12.7425 26.9743 12.6039 26.9933 12.4531C27.0123 12.3024 26.9757 12.1499 26.8904 12.0242C26.8052 11.8985 26.6771 11.8081 26.53 11.77L23.5 11Z",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      ),
      /* @__PURE__ */ jsx84(
        "path",
        {
          d: "M24 11H23V9.295L23.795 8.5C23.9261 8.36657 23.9997 8.18707 24 8C24 7.86739 23.9473 7.74021 23.8536 7.64645C23.7598 7.55268 23.6326 7.5 23.5 7.5C23.3674 7.5 23.2402 7.55268 23.1464 7.64645C23.0527 7.74021 23 7.86739 23 8V8.5H22V8C22 7.60218 22.158 7.22064 22.4393 6.93934C22.7206 6.65804 23.1022 6.5 23.5 6.5C23.8978 6.5 24.2794 6.65804 24.5607 6.93934C24.842 7.22064 25 7.60218 25 8C25.0001 8.22388 24.956 8.44558 24.8702 8.65237C24.7844 8.85916 24.6586 9.04696 24.5 9.205L24 9.705V11Z",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      ),
      /* @__PURE__ */ jsx84("path", { d: "M23 4.5H24V7.5H23V4.5Z", stroke: "#071114", "stroke-width": "0.3" }),
      /* @__PURE__ */ jsx84("path", { d: "M14 14.5H15V18H14V14.5Z", stroke: "#071114", "stroke-width": "0.3" })
    ]
  }
);

// src/components/icons/furniture/Table.tsx
init_react_shim();
import { jsx as jsx85, jsxs as jsxs73 } from "react/jsx-runtime";
var Table = (props) => /* @__PURE__ */ jsxs73(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx85("g", { "clip-path": "url(#clip0_4454_84562)", children: /* @__PURE__ */ jsx85(
        "path",
        {
          d: "M31.8267 11.8867L27.0265 6.55326C26.8998 6.41325 26.7198 6.33325 26.5332 6.33325H5.46594C5.27925 6.33325 5.09925 6.41325 4.97262 6.55326L0.172486 11.8867C-0.0742086 12.16 -0.054208 12.58 0.219174 12.8267C0.339178 12.9401 0.499182 13.0001 0.665874 13.0001H3.99928V25.0004C3.99928 25.3671 4.29929 25.6671 4.66598 25.6671C5.03268 25.6671 5.33269 25.3671 5.33269 25.0004V13.0001H7.99945V19.0002C7.99945 19.3669 8.29946 19.6669 8.66616 19.6669C9.03285 19.6669 9.33286 19.3669 9.33286 19.0002V13.0001H23.3332V19.0002C23.3332 19.3669 23.6333 19.6669 24 19.6669C24.3666 19.6669 24.6667 19.3669 24.6667 19.0002V13.0001H27.3334V25.0004C27.3334 25.3671 27.6334 25.6671 28.0001 25.6671C28.3668 25.6671 28.6668 25.3671 28.6668 25.0004V13.0001H31.3336C31.7003 13.0001 32.0003 12.7001 32.0003 12.3334C32 12.1667 31.94 12.0067 31.8267 11.8867ZM2.15917 11.6667L5.75926 7.6666H26.2331L29.8332 11.6667H2.15917Z",
          fill: "#071114",
          stroke: "#071114",
          "stroke-width": "0.3"
        }
      ) }),
      /* @__PURE__ */ jsx85("defs", { children: /* @__PURE__ */ jsx85("clipPath", { id: "clip0_4454_84562", children: /* @__PURE__ */ jsx85("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/furniture/Tools.tsx
init_react_shim();
import { jsx as jsx86, jsxs as jsxs74 } from "react/jsx-runtime";
var Tools = (props) => /* @__PURE__ */ jsxs74(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M6.73788 29.2378C6.21048 29.7652 5.49516 30.0615 4.74929 30.0615C4.00343 30.0615 3.28812 29.7652 2.76071 29.2378C2.23331 28.7104 1.93701 27.995 1.93701 27.2492C1.93701 26.5033 2.23331 25.788 2.76071 25.2607L10.7151 17.3113L14.6922 21.2884L6.73788 29.2378Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M23.9695 7.96216L12.7017 19.2299",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M26.7484 7.90201C26.3967 8.25356 25.9197 8.45099 25.4225 8.45087C24.9251 8.45075 24.4482 8.2531 24.0967 7.90139C23.7452 7.54966 23.5477 7.07271 23.5479 6.57543C23.548 6.07814 23.7456 5.60127 24.0974 5.24972L27.4121 1.9375L30.0631 4.58729L26.7484 7.90201Z",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M13.7985 11.1517L10.9363 8.28323C11.2694 7.43492 11.3479 6.50784 11.1621 5.61559C10.9763 4.72334 10.5342 3.90467 9.89011 3.25989C9.13604 2.51116 8.14759 2.04429 7.09034 1.9375C7.53912 2.65471 7.73153 3.50287 7.63617 4.34352C7.54081 5.18418 7.16331 5.96768 6.56528 6.56614C5.96724 7.16461 5.18402 7.54268 4.34343 7.63866C3.50284 7.73463 2.65454 7.54283 1.93701 7.09458C2.01164 7.80868 2.25059 8.49582 2.63516 9.10216C3.01971 9.70848 3.53943 10.2175 4.15359 10.5895C4.76777 10.9614 5.45969 11.186 6.17521 11.2459C6.89071 11.3057 7.61034 11.199 8.27774 10.9343L10.2476 12.9041",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M18.7856 21.4458L21.0043 23.6632C20.6109 24.6655 20.5746 25.7729 20.9018 26.7988C21.2288 27.8248 21.8991 28.7069 22.8 29.2968C23.701 29.8865 24.7775 30.1482 25.8488 30.0377C26.9199 29.927 27.9203 29.451 28.6818 28.6895C29.4431 27.9282 29.9191 26.9277 30.0298 25.8565C30.1404 24.7854 29.8788 23.7089 29.2889 22.8079C28.699 21.907 27.8169 21.2367 26.791 20.9095C25.765 20.5825 24.6576 20.6188 23.6553 21.012L20.5168 17.8735",
          stroke: "#071114",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M25.3641 25.8405C25.1053 25.8405 24.8955 25.6307 24.8955 25.3718C24.8955 25.113 25.1053 24.9031 25.3641 24.9031",
          stroke: "#071114",
          "stroke-width": "1.5"
        }
      ),
      /* @__PURE__ */ jsx86(
        "path",
        {
          d: "M25.3643 25.8405C25.6231 25.8405 25.833 25.6306 25.833 25.3718C25.833 25.113 25.6231 24.9031 25.3643 24.9031",
          stroke: "#071114",
          "stroke-width": "1.5"
        }
      )
    ]
  }
);

// src/components/icons/customer/CircleHelp.tsx
init_react_shim();
import { jsx as jsx87, jsxs as jsxs75 } from "react/jsx-runtime";
var CircleHelp = (props) => /* @__PURE__ */ jsxs75(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx87(
        "path",
        {
          d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx87(
        "path",
        {
          d: "M12 14C11.4477 14 11 13.5523 11 13V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V13C13 13.5523 12.5523 14 12 14Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx87(
        "path",
        {
          d: "M10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx87(
        "path",
        {
          d: "M12.3899 7.81137C11.4329 7.7658 10.6304 8.3004 10.4864 9.1644C10.3956 9.70917 9.88037 10.0772 9.3356 9.9864C8.79083 9.8956 8.42281 9.38037 8.51361 8.8356C8.86961 6.69961 10.8171 5.73421 12.4851 5.81363C13.3395 5.85432 14.2176 6.16099 14.8937 6.79278C15.5866 7.44027 16 8.36777 16 9.5C16 10.7913 15.4919 11.7489 14.6172 12.3321C13.8141 12.8675 12.8295 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.6705 11 13.1859 10.8825 13.5078 10.668C13.7581 10.5011 14 10.2087 14 9.5C14 8.88224 13.7884 8.49723 13.5282 8.2541C13.2512 7.99526 12.848 7.83318 12.3899 7.81137Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsxs75("mask", { id: "path-2-inside-1_7688_37874", fill: "white", children: [
        /* @__PURE__ */ jsx87("path", { d: "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z" }),
        /* @__PURE__ */ jsx87("path", { d: "M13 13V12H12V13H13Z" })
      ] }),
      /* @__PURE__ */ jsx87(
        "path",
        {
          d: "M13 13V14H14V13H13ZM12 12V11H11V12H12ZM12 12V14C13.1046 14 14 13.1046 14 12H12ZM12 12H10C10 13.1046 10.8954 14 12 14V12ZM12 12V10C10.8954 10 10 10.8954 10 12H12ZM12 12H14C14 10.8954 13.1046 10 12 10V12ZM12 12V13H14V12H12ZM13 12H12V14H13V12ZM13 13V12H11V13H13ZM12 13H13V11H12V13Z",
          fill: "#071114",
          mask: "url(#path-2-inside-1_7688_37874)"
        }
      )
    ]
  }
);

// src/components/icons/customer/CreditCard.tsx
init_react_shim();
import { jsx as jsx88, jsxs as jsxs76 } from "react/jsx-runtime";
var CreditCard = (props) => /* @__PURE__ */ jsxs76(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx88(
        "path",
        {
          d: "M2.86196 4.26563H21.1388C21.1388 4.26563 22.5447 4.26562 22.5447 5.67153V18.3247C22.5447 18.3247 22.5447 19.7306 21.1388 19.7306H2.86196C2.86196 19.7306 1.45605 19.7306 1.45605 18.3247V5.67153C1.45605 5.67153 1.45605 4.26563 2.86196 4.26563Z",
          stroke: "black",
          "stroke-width": "1.38",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx88(
        "path",
        {
          d: "M1.45605 8.48438H22.5447",
          stroke: "black",
          "stroke-width": "1.38",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx88(
        "path",
        {
          d: "M5.67383 12.7031H13.4063",
          stroke: "black",
          "stroke-width": "1.38",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ jsx88(
        "path",
        {
          d: "M5.67383 15.5156H10.5945",
          stroke: "black",
          "stroke-width": "1.38",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
);

// src/components/icons/customer/Heart.tsx
init_react_shim();
import { jsx as jsx89 } from "react/jsx-runtime";
var Heart = (props) => /* @__PURE__ */ jsx89(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx89(
      "path",
      {
        d: "M12 4.52765C9.64418 2.41689 6.02125 2.49347 3.75736 4.75736C1.41421 7.1005 1.41421 10.8995 3.75736 13.2426L10.5858 20.0711C11.3668 20.8521 12.6332 20.8521 13.4142 20.0711L20.2426 13.2426C22.5858 10.8995 22.5858 7.1005 20.2426 4.75736C17.9787 2.49347 14.3558 2.41689 12 4.52765ZM10.8284 6.17157L11.2929 6.63604C11.6834 7.02656 12.3166 7.02656 12.7071 6.63604L13.1716 6.17157C14.7337 4.60948 17.2663 4.60948 18.8284 6.17157C20.3905 7.73367 20.3905 10.2663 18.8284 11.8284L12 18.6569L5.17157 11.8284C3.60948 10.2663 3.60948 7.73367 5.17157 6.17157C6.73367 4.60948 9.26633 4.60948 10.8284 6.17157Z",
        fill: "#071114"
      }
    )
  }
);

// src/components/icons/customer/Logout.tsx
init_react_shim();
import { jsx as jsx90, jsxs as jsxs77 } from "react/jsx-runtime";
var Logout = (props) => /* @__PURE__ */ jsxs77(
  "svg",
  {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx90("g", { "clip-path": "url(#clip0_7688_20339)", children: /* @__PURE__ */ jsx90(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.16129 0.0747458C1.16834 0.0743945 1.17539 0.0742188 1.18245 0.0742188H7.31895C7.32601 0.0742188 7.33306 0.0743945 7.34011 0.0747457C7.64208 0.0897974 7.92579 0.223826 8.1292 0.447514C8.33021 0.668562 8.43662 0.959385 8.42595 1.25769V3.49922C8.42595 3.73394 8.23567 3.92422 8.00095 3.92422C7.76623 3.92422 7.57595 3.73394 7.57595 3.49922V1.24922C7.57595 1.24283 7.57609 1.23644 7.57638 1.23006C7.57988 1.15254 7.55254 1.07678 7.50033 1.01937C7.44997 0.963996 7.38045 0.930028 7.30603 0.924219H1.19537C1.12105 0.930024 1.05162 0.963963 1.00135 1.01929C0.949225 1.07665 0.921954 1.15233 0.925504 1.22975C0.925802 1.23624 0.92595 1.24273 0.92595 1.24922V10.2492C0.92595 10.2556 0.925806 10.262 0.925517 10.2684C0.922018 10.3459 0.949336 10.4216 1.0015 10.479C1.05179 10.5344 1.12122 10.5683 1.19555 10.5742H7.30604C7.38045 10.5684 7.44997 10.5344 7.50033 10.4791C7.55254 10.4217 7.57988 10.3459 7.57638 10.2684C7.57609 10.262 7.57595 10.2556 7.57595 10.2492V7.99922C7.57595 7.7645 7.76623 7.57422 8.00095 7.57422C8.23567 7.57422 8.42595 7.7645 8.42595 7.99922V10.2408C8.43662 10.5391 8.33021 10.8299 8.1292 11.0509C7.92579 11.2746 7.64208 11.4086 7.34011 11.4237C7.33306 11.424 7.32601 11.4242 7.31895 11.4242H1.18245C1.1753 11.4242 1.16814 11.424 1.161 11.4237C0.859171 11.4084 0.575656 11.2743 0.372418 11.0506C0.17158 10.8296 0.065275 10.5389 0.0759502 10.2407V1.25783C0.0651096 0.959586 0.17137 0.66875 0.372266 0.44766C0.5756 0.223889 0.859312 0.0897987 1.16129 0.0747458ZM6.05145 3.57565C6.21742 3.74162 6.21742 4.01072 6.05145 4.17669L4.90197 5.32617H11.2509C11.4856 5.32617 11.6759 5.51645 11.6759 5.75117C11.6759 5.98589 11.4856 6.17617 11.2509 6.17617H4.90197L6.05145 7.32565C6.21742 7.49162 6.21742 7.76072 6.05145 7.92669C5.88548 8.09266 5.61638 8.09266 5.45041 7.92669L3.57541 6.05169C3.40944 5.88572 3.40944 5.61662 3.57541 5.45065L5.45041 3.57565C5.61638 3.40968 5.88548 3.40968 6.05145 3.57565Z",
          fill: "black"
        }
      ) }),
      /* @__PURE__ */ jsx90("defs", { children: /* @__PURE__ */ jsx90("clipPath", { id: "clip0_7688_20339", children: /* @__PURE__ */ jsx90("rect", { width: "12", height: "12", fill: "white" }) }) })
    ]
  }
);

// src/components/icons/customer/CustomerReceipt.tsx
init_react_shim();
import { jsx as jsx91, jsxs as jsxs78 } from "react/jsx-runtime";
var CustomerReceipt = (props) => /* @__PURE__ */ jsxs78(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx91(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.61557 1.61655C4.98283 1.24929 5.48094 1.04297 6.00033 1.04297H18.0003C18.5197 1.04297 19.0178 1.24929 19.3851 1.61655C19.7523 1.98381 19.9587 2.48192 19.9587 3.0013V22.0013C19.9587 22.3697 19.7475 22.7055 19.4155 22.8651C19.0834 23.0246 18.6893 22.9798 18.4017 22.7496L16.5714 21.2855L15.178 22.6789C14.8327 23.0242 14.283 23.0547 13.9017 22.7496L12.0003 21.2286L10.099 22.7496C9.71768 23.0547 9.16797 23.0242 8.82268 22.6789L7.4292 21.2855L5.59899 22.7496C5.31133 22.9798 4.91722 23.0246 4.58519 22.8651C4.25316 22.7055 4.04199 22.3697 4.04199 22.0013V3.0013C4.04199 2.48192 4.24832 1.98381 4.61557 1.61655ZM6.00033 2.95964C5.98927 2.95964 5.97868 2.96403 5.97086 2.97184C5.96305 2.97965 5.95866 2.99025 5.95866 3.0013V20.0074L6.90166 19.253C7.28297 18.9479 7.83268 18.9784 8.17797 19.3237L9.57145 20.7171L11.4017 19.253C11.7517 18.973 12.249 18.973 12.599 19.253L14.4292 20.7171L15.8227 19.3237C16.168 18.9784 16.7177 18.9479 17.099 19.253L18.042 20.0074V3.0013C18.042 2.99025 18.0376 2.97965 18.0298 2.97184C18.022 2.96403 18.0114 2.95964 18.0003 2.95964H6.00033Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx91(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.04199 6.0013C8.04199 5.47203 8.47105 5.04297 9.00033 5.04297H15.0003C15.5296 5.04297 15.9587 5.47203 15.9587 6.0013C15.9587 6.53057 15.5296 6.95963 15.0003 6.95963H9.00033C8.47105 6.95963 8.04199 6.53057 8.04199 6.0013Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx91(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.04199 10.0013C8.04199 9.47203 8.47105 9.04297 9.00033 9.04297H15.0003C15.5296 9.04297 15.9587 9.47203 15.9587 10.0013C15.9587 10.5306 15.5296 10.9596 15.0003 10.9596H9.00033C8.47105 10.9596 8.04199 10.5306 8.04199 10.0013Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx91(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.04199 14.0013C8.04199 13.472 8.47105 13.043 9.00033 13.043H10.0003C10.5296 13.043 10.9587 13.472 10.9587 14.0013C10.9587 14.5306 10.5296 14.9596 10.0003 14.9596H9.00033C8.47105 14.9596 8.04199 14.5306 8.04199 14.0013Z",
          fill: "#071114"
        }
      )
    ]
  }
);

// src/components/icons/customer/Settings.tsx
init_react_shim();
import { jsx as jsx92, jsxs as jsxs79 } from "react/jsx-runtime";
var Settings = (props) => /* @__PURE__ */ jsxs79(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx92(
        "path",
        {
          d: "M12 4C11.4477 4 11 4.44772 11 5C11 6.69226 8.95399 7.53974 7.75738 6.34314C7.36686 5.95261 6.73369 5.95261 6.34317 6.34314C5.95265 6.73366 5.95265 7.36683 6.34317 7.75735C7.53982 8.954 6.69223 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C6.69236 13 7.53964 15.0461 6.34311 16.2426C5.95258 16.6332 5.95258 17.2663 6.34311 17.6569C6.73363 18.0474 7.3668 18.0474 7.75732 17.6569C8.9539 16.4603 11 17.3077 11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 17.3077 15.046 16.4602 16.2427 17.6568C16.6332 18.0474 17.2664 18.0474 17.6569 17.6568C18.0474 17.2663 18.0474 16.6332 17.6569 16.2426C16.4603 15.0461 17.3077 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C17.3078 11 16.4601 8.95405 17.6568 7.75737C18.0473 7.36684 18.0473 6.73368 17.6568 6.34315C17.2663 5.95263 16.6331 5.95263 16.2426 6.34315C15.046 7.53979 13 6.69219 13 5C13 4.44772 12.5523 4 12 4ZM9.00816 4.77703C9.12224 3.2243 10.4181 2 12 2C13.5819 2 14.8778 3.2243 14.9918 4.77703C16.1704 3.75977 17.9525 3.8104 19.071 4.92894C20.1896 6.04748 20.2402 7.82955 19.2229 9.00816C20.7757 9.12221 22 10.4181 22 12C22 13.5819 20.7757 14.8778 19.223 14.9918C20.2403 16.1704 20.1896 17.9525 19.0711 19.0711C17.9525 20.1896 16.1705 20.2402 14.9918 19.2229C14.8778 20.7757 13.5819 22 12 22C10.4181 22 9.12221 20.7757 9.00816 19.2229C7.82955 20.2402 6.04745 20.1896 4.92889 19.0711C3.81034 17.9525 3.75972 16.1704 4.77702 14.9918C3.2243 14.8778 2 13.5819 2 12C2 10.4181 3.22433 9.12221 4.77709 9.00816C3.75978 7.82955 3.81041 6.04747 4.92896 4.92892C6.0475 3.81038 7.82955 3.75975 9.00816 4.77703Z",
          fill: "#071114"
        }
      ),
      /* @__PURE__ */ jsx92(
        "path",
        {
          d: "M12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157Z",
          fill: "#071114"
        }
      )
    ]
  }
);

// src/components/icons/customer/User.tsx
init_react_shim();
import { jsx as jsx93 } from "react/jsx-runtime";
var User = (props) => /* @__PURE__ */ jsx93(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx93(
      "path",
      {
        d: "M12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4ZM6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8ZM8 18C6.34315 18 5 19.3431 5 21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21C3 18.2386 5.23858 16 8 16H16C18.7614 16 21 18.2386 21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 19.3431 17.6569 18 16 18H8Z",
        fill: "#071114"
      }
    )
  }
);

// src/components/stock-indicators/StockIndicators.tsx
import { jsx as jsx94, jsxs as jsxs80 } from "react/jsx-runtime";
function InfoIcon({ className }) {
  return /* @__PURE__ */ jsxs80(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx94(
          "path",
          {
            d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx94(
          "path",
          {
            d: "M12 10C12.5523 10 13 10.4477 13 11V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11C11 10.4477 11.4477 10 12 10Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx94(
          "path",
          {
            d: "M13.5 7.5C13.5 8.32843 12.8284 9 12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function shortenStoreName(store) {
  if (!store || !store.name)
    return null;
  if (store.name.includes("Fagm\xF8bler")) {
    return store.name.replace("Fagm\xF8bler", "").trim();
  }
  return store == null ? void 0 : store.name;
}
function StockIndicators({
  stock,
  cartQuanitity,
  inline,
  className,
  store,
  onStoreClick,
  notAvailable,
  isBackorder,
  deliveryTime,
  display = "product",
  algoliaProduct
}) {
  var _a;
  const inStock = (stock == null ? void 0 : stock.stock) ?? 0;
  const onDisplay = (stock == null ? void 0 : stock.display) ?? 0;
  const isAvailable = !isBackorder && !notAvailable;
  const stockCount = (stock == null ? void 0 : stock.stock) && (stock == null ? void 0 : stock.stock) > 20 ? "20+" : (stock == null ? void 0 : stock.stock) ?? 0;
  const storeName = store && shortenStoreName(store) || "butikk";
  const isOutdoorFurniture = (algoliaProduct == null ? void 0 : algoliaProduct.parentId) == "AG1501" || false;
  const isOutdoorFurnitureStore = !((_a = store == null ? void 0 : store.properties) == null ? void 0 : _a.find(
    (prop) => prop.key === "blockOutdoorFurniture" && prop.value === "true"
  ));
  const statusStates = [
    {
      type: "badge",
      variant: "successDark",
      text: `P\xE5 lager (${stockCount})`,
      active: inStock > 0,
      display: ["product"]
    },
    {
      type: "badge",
      variant: "warningNeutral",
      text: "Bestillingsvare",
      active: !inStock && isAvailable && !deliveryTime || !deliveryTime && (cartQuanitity ?? 0) > inStock && inStock > 0,
      display: ["product", "cart"]
    },
    {
      type: "badge",
      variant: "warningNeutral",
      text: `Estimert leveringstid: ${deliveryTime}`,
      active: !inStock && isAvailable && !!deliveryTime || !!deliveryTime && (cartQuanitity ?? 0) > inStock && inStock > 0,
      display: ["product", "cart"]
    },
    {
      type: "badge",
      variant: "primaryDark",
      text: "Utsolgt",
      active: inStock < 1 && !isAvailable,
      display: ["product"]
    },
    {
      type: "icon",
      icon: EyeIcon2,
      text: `Utstilt i ${storeName}`,
      active: onDisplay > 0,
      display: ["product"]
    },
    {
      type: "badge",
      variant: "successDark",
      text: "Alle varer p\xE5 lager",
      active: inStock > 0 && inStock >= (cartQuanitity ?? 0),
      display: ["cart"]
    },
    {
      type: "icon",
      icon: InfoIcon,
      text: `${stockCount} av ${cartQuanitity} p\xE5 lager. Resterende har bestillingstid`,
      active: (cartQuanitity ?? 0) > inStock && inStock > 0,
      display: ["cart"]
    },
    {
      type: "badge",
      variant: "primaryDark",
      text: "Hagem\xF8bler kan ikke bestilles p\xE5 nett hos denne butikken",
      active: isOutdoorFurniture && !isOutdoorFurnitureStore,
      display: ["product", "cart"],
      override: true
    }
  ];
  const currentStockState = statusStates.filter((state) => state.active && state.display.includes(display)).reduce((acc, state) => {
    if (state.override) {
      return acc.filter((s) => s.override).concat(state);
    }
    if (acc.some((s) => s.override)) {
      return acc;
    }
    return [...acc, state];
  }, []);
  return /* @__PURE__ */ jsx94(
    "div",
    {
      className: clsx30("body-xs", className, {
        "flex flex-col gap-1": !inline,
        "flex items-center gap-x-4": inline
      }),
      children: currentStockState.map((state) => /* @__PURE__ */ jsxs80(
        "span",
        {
          className: twMerge(
            clsx30(
              "flex gap-1 items-center leading-snug",
              state.additionalClassName
            )
          ),
          children: [
            state.type === "badge" && state.variant && /* @__PURE__ */ jsx94(
              Badge,
              {
                size: "xs",
                variant: state.variant,
                className: clsx30("h-3 w-3 gap-1 flex-shrink-0")
              }
            ),
            state.type === "icon" && state.icon && /* @__PURE__ */ jsx94(state.icon, { className: "w-4 h-4 text-neutral-70 gap-1" }),
            /* @__PURE__ */ jsx94("span", { children: state.text })
          ]
        }
      ))
    }
  );
}

// src/components/image/index.tsx
init_react_shim();

// src/components/image/ImageMissing.tsx
init_react_shim();
import clsx31 from "clsx";
import { jsx as jsx95, jsxs as jsxs81 } from "react/jsx-runtime";
var SvgComponent = (props) => /* @__PURE__ */ jsxs81(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx95(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.822 32.822A25 25 0 0 1 37.5 25.5h125a25.003 25.003 0 0 1 25 25v100c0 6.63-2.634 12.989-7.322 17.678A25.004 25.004 0 0 1 162.5 175.5h-125a25.001 25.001 0 0 1-25-25v-100a25 25 0 0 1 7.322-17.678ZM37.5 38A12.5 12.5 0 0 0 25 50.5v100A12.5 12.5 0 0 0 37.5 163h125a12.501 12.501 0 0 0 12.5-12.5v-100A12.5 12.5 0 0 0 162.5 38h-125Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx95(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M117.992 55.992A18.749 18.749 0 0 1 150 69.25 18.747 18.747 0 0 1 131.25 88a18.749 18.749 0 0 1-13.258-32.008ZM131.25 63a6.248 6.248 0 0 0-6.25 6.25 6.247 6.247 0 0 0 6.25 6.25 6.248 6.248 0 0 0 6.25-6.25 6.247 6.247 0 0 0-6.25-6.25ZM62.052 91.167a18.75 18.75 0 0 1 25.696.759l35.417 35.341a6.25 6.25 0 0 1-8.83 8.849l-35.416-35.342a6.252 6.252 0 0 0-8.568-.26c-.001.001 0 0 0 0l-47.448 42.182a6.25 6.25 0 0 1-8.305-9.342l47.454-42.187Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx95(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M148.519 125.121a6.251 6.251 0 0 0-8.413.395l-48.187 48.179a6.25 6.25 0 0 1-8.838-8.84l48.179-48.171a18.752 18.752 0 0 1 25.25-1.175l.009.007 28.734 23.959a6.249 6.249 0 0 1 .797 8.802 6.25 6.25 0 0 1-8.803.798l-28.728-23.954c-.001-.001.001.001 0 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var ImageMissing = ({
  size,
  title = "Bilde mangler"
}) => {
  return /* @__PURE__ */ jsx95(
    "div",
    {
      className: clsx31(
        "flex items-center justify-center w-full h-full text-center text-neutral-60 p-1",
        { "p-5": size === "md" || size === "lg" }
      ),
      title,
      children: /* @__PURE__ */ jsxs81("div", { children: [
        /* @__PURE__ */ jsx95(
          SvgComponent,
          {
            className: clsx31({
              "w-6 h-6": size === "sm"
            })
          }
        ),
        /* @__PURE__ */ jsx95(
          "span",
          {
            className: clsx31({
              hidden: size === "sm"
            }),
            children: title
          }
        )
      ] })
    }
  );
};

// src/components/capaigns/index.ts
init_react_shim();

// src/components/capaigns/CampaignTab.tsx
init_react_shim();
import clsx32 from "clsx";
import { jsx as jsx96, jsxs as jsxs82 } from "react/jsx-runtime";
var CampaignIcons = {
  Armchair,
  Armrest,
  Backrest,
  Bed,
  BedOpen,
  Box,
  Chair,
  ChristmasBells,
  ColorPallete,
  CustomerClub,
  Discount,
  DoubleBed,
  ExpressDelivery,
  Financing,
  FlatPack,
  Garden,
  Hands,
  Headboard,
  Home,
  House,
  Interior,
  Lamp,
  Mattress,
  Module,
  ModulSofa,
  OnlineCart,
  Plant,
  Receipt,
  Room,
  Rug,
  Sale,
  Seng,
  Sofa,
  Storage,
  Table,
  Tools
};
var CampaignTab = ({
  tab,
  active = false,
  NextLink
}) => {
  const Icon = CampaignIcons[tab.icon || "Sale"];
  return /* @__PURE__ */ jsxs82(
    NextLink,
    {
      href: `/kampanje${tab.tabSlug && tab.tabSlug.current !== "/" ? `/${tab.tabSlug.current}` : ""}`,
      className: twMerge(
        clsx32(
          "w-full bg-secondary-20 rounded pl-4 pt-4 pb-4 hover:bg-secondary-40 flex gap-3",
          "md:flex-col md:gap-4 md:items-center md:p-4 md:text-center",
          {
            "bg-secondary-40": active
          }
        )
      ),
      children: [
        /* @__PURE__ */ jsx96("div", { children: /* @__PURE__ */ jsx96(Icon, { className: "size-8" }) }),
        /* @__PURE__ */ jsxs82("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ jsx96("span", { className: "cap-sm text-neutral-80 md:hd-base", children: tab.title }),
          tab.subtitle && /* @__PURE__ */ jsx96("span", { className: "body-xs text-neutral-80", children: tab.subtitle })
        ] })
      ]
    }
  );
};

// src/components/capaigns/CampaignTabs.tsx
init_react_shim();
import { jsx as jsx97, jsxs as jsxs83 } from "react/jsx-runtime";
var CampaignTabs = ({
  title,
  subtitle,
  tabs,
  activeSlug = "none",
  NextLink
}) => {
  return /* @__PURE__ */ jsxs83("div", { className: "grid grid-cols-2 gap-2 md:grid-cols-[repeat(auto-fit,132px)]", children: [
    /* @__PURE__ */ jsx97(
      CampaignTab,
      {
        tab: { title, subtitle, tabSlug: { current: "/" } },
        active: activeSlug === "kampanje",
        NextLink
      }
    ),
    tabs.map((tab, index) => {
      return /* @__PURE__ */ jsx97(
        CampaignTab,
        {
          tab,
          active: activeSlug === tab.tabSlug.current,
          NextLink
        },
        index
      );
    })
  ] });
};

// src/hooks/index.ts
init_react_shim();

// src/hooks/use-is-mounted.ts
init_react_shim();
import { useRef as useRef8, useEffect as useEffect3 } from "react";
function useIsMounted() {
  const isMounted = useRef8(false);
  useEffect3(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}

// src/hooks/use-window-size.ts
init_react_shim();
import { useState as useState7, useEffect as useEffect4 } from "react";
function isBrowser() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function useWindowSize() {
  const [windowSize, setWindowSize] = useState7({
    width: void 0,
    height: void 0
  });
  useEffect4(() => {
    if (!isBrowser())
      return;
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
}
export {
  Alert,
  Armchair,
  Armrest,
  ArticleCard,
  Backrest,
  Badge,
  Bed,
  BedOpen,
  Box,
  Button,
  ButtonWrapper,
  CampaignBanner,
  CampaignCard,
  CampaignCardV2,
  CampaignTab,
  CampaignTabs,
  CategoryCollectionCard,
  CategoryHero,
  Chair,
  Checkbox,
  ChevronLeft,
  ChevronRight,
  Chip,
  ChristmasBells,
  CircleHelp,
  ColorPallete,
  ContentCard,
  CreditCard,
  CustomerClub,
  CustomerReceipt,
  DefaultModal,
  Discount,
  DoubleBed,
  DoubleRangeSlider,
  DrawerModal,
  ExpressDelivery,
  EyeIcon2 as EyeIcon,
  FilterSwitch,
  Financing,
  FlatPack,
  Garden,
  Hands,
  Headboard,
  Heart,
  Home,
  House,
  IconButton,
  ImageAndText,
  ImageCollectionBlock,
  ImageMissing,
  Input,
  Interior,
  Lamp,
  Loading,
  LocationIcon,
  LocationPinIcon,
  Logo,
  LogoIcon,
  Logout,
  Mattress,
  ModulSofa,
  Module,
  NumberStepper,
  OnlineCart,
  Plant,
  Price,
  PriceAmount2 as PriceAmount,
  ProductCollectionCard,
  ProductListGridItem,
  ProductListGridItemImage,
  ProductTags,
  Promotion,
  Radio,
  RangeInput,
  Receipt,
  Room,
  Rug,
  Sale,
  Select,
  Seng,
  Settings,
  Sofa,
  Spinner,
  StepperButton,
  Sticker,
  StockIndicators,
  Storage,
  StoreIcon,
  SuccessIcon,
  Switch,
  Table,
  TextboxCard,
  Tools,
  TopBanner,
  User,
  calculateDiscount2 as calculateDiscount,
  calculatePercentOff2 as calculatePercentOff,
  combineAriaBy,
  combineDescribedBy,
  formatPrice2 as formatPrice,
  mergeRefs,
  useIsMounted,
  useWindowSize
};
